/* eslint-disable */
/*eslint-disable*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader,
  $Writer = $protobuf.Writer,
  $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots.appliance || ($protobuf.roots.appliance = {});

export const appliancepb = ($root.appliancepb = (() => {
  /**
   * Namespace appliancepb.
   * @exports appliancepb
   * @namespace
   */
  const appliancepb = {};

  appliancepb.Pair = (function () {
    /**
     * Properties of a Pair.
     * @memberof appliancepb
     * @interface IPair
     * @property {string|null} [ID] Pair ID
     * @property {string|null} [name] Pair name
     */

    /**
     * Constructs a new Pair.
     * @memberof appliancepb
     * @classdesc Represents a Pair.
     * @implements IPair
     * @constructor
     * @param {appliancepb.IPair=} [p] Properties to set
     */
    function Pair(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * Pair ID.
     * @member {string} ID
     * @memberof appliancepb.Pair
     * @instance
     */
    Pair.prototype.ID = "";

    /**
     * Pair name.
     * @member {string} name
     * @memberof appliancepb.Pair
     * @instance
     */
    Pair.prototype.name = "";

    /**
     * Creates a new Pair instance using the specified properties.
     * @function create
     * @memberof appliancepb.Pair
     * @static
     * @param {appliancepb.IPair=} [properties] Properties to set
     * @returns {appliancepb.Pair} Pair instance
     */
    Pair.create = function create(properties) {
      return new Pair(properties);
    };

    /**
     * Encodes the specified Pair message. Does not implicitly {@link appliancepb.Pair.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.Pair
     * @static
     * @param {appliancepb.IPair} m Pair message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Pair.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
        w.uint32(10).string(m.ID);
      if (m.name != null && Object.hasOwnProperty.call(m, "name"))
        w.uint32(18).string(m.name);
      return w;
    };

    /**
     * Decodes a Pair message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.Pair
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.Pair} Pair
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Pair.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.Pair();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.ID = r.string();
            break;
          case 2:
            m.name = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return Pair;
  })();

  appliancepb.KeyValues = (function () {
    /**
     * Properties of a KeyValues.
     * @memberof appliancepb
     * @interface IKeyValues
     * @property {string|null} [key] KeyValues key
     * @property {Array.<string>|null} [values] KeyValues values
     */

    /**
     * Constructs a new KeyValues.
     * @memberof appliancepb
     * @classdesc Represents a KeyValues.
     * @implements IKeyValues
     * @constructor
     * @param {appliancepb.IKeyValues=} [p] Properties to set
     */
    function KeyValues(p) {
      this.values = [];
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * KeyValues key.
     * @member {string} key
     * @memberof appliancepb.KeyValues
     * @instance
     */
    KeyValues.prototype.key = "";

    /**
     * KeyValues values.
     * @member {Array.<string>} values
     * @memberof appliancepb.KeyValues
     * @instance
     */
    KeyValues.prototype.values = $util.emptyArray;

    /**
     * Creates a new KeyValues instance using the specified properties.
     * @function create
     * @memberof appliancepb.KeyValues
     * @static
     * @param {appliancepb.IKeyValues=} [properties] Properties to set
     * @returns {appliancepb.KeyValues} KeyValues instance
     */
    KeyValues.create = function create(properties) {
      return new KeyValues(properties);
    };

    /**
     * Encodes the specified KeyValues message. Does not implicitly {@link appliancepb.KeyValues.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.KeyValues
     * @static
     * @param {appliancepb.IKeyValues} m KeyValues message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    KeyValues.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.key != null && Object.hasOwnProperty.call(m, "key"))
        w.uint32(10).string(m.key);
      if (m.values != null && m.values.length) {
        for (var i = 0; i < m.values.length; ++i)
          w.uint32(18).string(m.values[i]);
      }
      return w;
    };

    /**
     * Decodes a KeyValues message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.KeyValues
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.KeyValues} KeyValues
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    KeyValues.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.KeyValues();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.key = r.string();
            break;
          case 2:
            if (!(m.values && m.values.length)) m.values = [];
            m.values.push(r.string());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return KeyValues;
  })();

  appliancepb.ReplacementOfferRequest = (function () {
    /**
     * Properties of a ReplacementOfferRequest.
     * @memberof appliancepb
     * @interface IReplacementOfferRequest
     * @property {string|null} [dispatchId] ReplacementOfferRequest dispatchId
     * @property {string|null} [likeForLikeProductId] ReplacementOfferRequest likeForLikeProductId
     * @property {string|null} [itemId] ReplacementOfferRequest itemId
     * @property {string|null} [addressId] ReplacementOfferRequest addressId
     * @property {string|null} [customerId] ReplacementOfferRequest customerId
     * @property {string|null} [contractId] ReplacementOfferRequest contractId
     * @property {string|null} [partRequestId] ReplacementOfferRequest partRequestId
     * @property {boolean|null} [hasDisposalCoverage] ReplacementOfferRequest hasDisposalCoverage
     * @property {appliancepb.ReplacementOfferRequest.ContractType|null} [contractType] ReplacementOfferRequest contractType
     * @property {appliancepb.INotification|null} [notification] ReplacementOfferRequest notification
     * @property {number|null} [serviceLimit] ReplacementOfferRequest serviceLimit
     * @property {Array.<appliancepb.IProductAccessory>|null} [productAccessories] ReplacementOfferRequest productAccessories
     * @property {appliancepb.IPriceSetter|null} [cashInLieu] ReplacementOfferRequest cashInLieu
     * @property {appliancepb.IPriceSetter|null} [repairCredit] ReplacementOfferRequest repairCredit
     */

    /**
     * Constructs a new ReplacementOfferRequest.
     * @memberof appliancepb
     * @classdesc Represents a ReplacementOfferRequest.
     * @implements IReplacementOfferRequest
     * @constructor
     * @param {appliancepb.IReplacementOfferRequest=} [p] Properties to set
     */
    function ReplacementOfferRequest(p) {
      this.productAccessories = [];
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * ReplacementOfferRequest dispatchId.
     * @member {string} dispatchId
     * @memberof appliancepb.ReplacementOfferRequest
     * @instance
     */
    ReplacementOfferRequest.prototype.dispatchId = "";

    /**
     * ReplacementOfferRequest likeForLikeProductId.
     * @member {string} likeForLikeProductId
     * @memberof appliancepb.ReplacementOfferRequest
     * @instance
     */
    ReplacementOfferRequest.prototype.likeForLikeProductId = "";

    /**
     * ReplacementOfferRequest itemId.
     * @member {string} itemId
     * @memberof appliancepb.ReplacementOfferRequest
     * @instance
     */
    ReplacementOfferRequest.prototype.itemId = "";

    /**
     * ReplacementOfferRequest addressId.
     * @member {string} addressId
     * @memberof appliancepb.ReplacementOfferRequest
     * @instance
     */
    ReplacementOfferRequest.prototype.addressId = "";

    /**
     * ReplacementOfferRequest customerId.
     * @member {string} customerId
     * @memberof appliancepb.ReplacementOfferRequest
     * @instance
     */
    ReplacementOfferRequest.prototype.customerId = "";

    /**
     * ReplacementOfferRequest contractId.
     * @member {string} contractId
     * @memberof appliancepb.ReplacementOfferRequest
     * @instance
     */
    ReplacementOfferRequest.prototype.contractId = "";

    /**
     * ReplacementOfferRequest partRequestId.
     * @member {string} partRequestId
     * @memberof appliancepb.ReplacementOfferRequest
     * @instance
     */
    ReplacementOfferRequest.prototype.partRequestId = "";

    /**
     * ReplacementOfferRequest hasDisposalCoverage.
     * @member {boolean} hasDisposalCoverage
     * @memberof appliancepb.ReplacementOfferRequest
     * @instance
     */
    ReplacementOfferRequest.prototype.hasDisposalCoverage = false;

    /**
     * ReplacementOfferRequest contractType.
     * @member {appliancepb.ReplacementOfferRequest.ContractType} contractType
     * @memberof appliancepb.ReplacementOfferRequest
     * @instance
     */
    ReplacementOfferRequest.prototype.contractType = 0;

    /**
     * ReplacementOfferRequest notification.
     * @member {appliancepb.INotification|null|undefined} notification
     * @memberof appliancepb.ReplacementOfferRequest
     * @instance
     */
    ReplacementOfferRequest.prototype.notification = null;

    /**
     * ReplacementOfferRequest serviceLimit.
     * @member {number} serviceLimit
     * @memberof appliancepb.ReplacementOfferRequest
     * @instance
     */
    ReplacementOfferRequest.prototype.serviceLimit = 0;

    /**
     * ReplacementOfferRequest productAccessories.
     * @member {Array.<appliancepb.IProductAccessory>} productAccessories
     * @memberof appliancepb.ReplacementOfferRequest
     * @instance
     */
    ReplacementOfferRequest.prototype.productAccessories = $util.emptyArray;

    /**
     * ReplacementOfferRequest cashInLieu.
     * @member {appliancepb.IPriceSetter|null|undefined} cashInLieu
     * @memberof appliancepb.ReplacementOfferRequest
     * @instance
     */
    ReplacementOfferRequest.prototype.cashInLieu = null;

    /**
     * ReplacementOfferRequest repairCredit.
     * @member {appliancepb.IPriceSetter|null|undefined} repairCredit
     * @memberof appliancepb.ReplacementOfferRequest
     * @instance
     */
    ReplacementOfferRequest.prototype.repairCredit = null;

    /**
     * Creates a new ReplacementOfferRequest instance using the specified properties.
     * @function create
     * @memberof appliancepb.ReplacementOfferRequest
     * @static
     * @param {appliancepb.IReplacementOfferRequest=} [properties] Properties to set
     * @returns {appliancepb.ReplacementOfferRequest} ReplacementOfferRequest instance
     */
    ReplacementOfferRequest.create = function create(properties) {
      return new ReplacementOfferRequest(properties);
    };

    /**
     * Encodes the specified ReplacementOfferRequest message. Does not implicitly {@link appliancepb.ReplacementOfferRequest.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.ReplacementOfferRequest
     * @static
     * @param {appliancepb.IReplacementOfferRequest} m ReplacementOfferRequest message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ReplacementOfferRequest.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.dispatchId != null && Object.hasOwnProperty.call(m, "dispatchId"))
        w.uint32(10).string(m.dispatchId);
      if (
        m.likeForLikeProductId != null &&
        Object.hasOwnProperty.call(m, "likeForLikeProductId")
      )
        w.uint32(18).string(m.likeForLikeProductId);
      if (m.itemId != null && Object.hasOwnProperty.call(m, "itemId"))
        w.uint32(26).string(m.itemId);
      if (m.addressId != null && Object.hasOwnProperty.call(m, "addressId"))
        w.uint32(34).string(m.addressId);
      if (m.customerId != null && Object.hasOwnProperty.call(m, "customerId"))
        w.uint32(42).string(m.customerId);
      if (m.contractId != null && Object.hasOwnProperty.call(m, "contractId"))
        w.uint32(50).string(m.contractId);
      if (
        m.partRequestId != null &&
        Object.hasOwnProperty.call(m, "partRequestId")
      )
        w.uint32(58).string(m.partRequestId);
      if (
        m.hasDisposalCoverage != null &&
        Object.hasOwnProperty.call(m, "hasDisposalCoverage")
      )
        w.uint32(64).bool(m.hasDisposalCoverage);
      if (
        m.contractType != null &&
        Object.hasOwnProperty.call(m, "contractType")
      )
        w.uint32(72).int32(m.contractType);
      if (
        m.notification != null &&
        Object.hasOwnProperty.call(m, "notification")
      )
        $root.appliancepb.Notification.encode(
          m.notification,
          w.uint32(82).fork()
        ).ldelim();
      if (
        m.serviceLimit != null &&
        Object.hasOwnProperty.call(m, "serviceLimit")
      )
        w.uint32(88).int32(m.serviceLimit);
      if (m.productAccessories != null && m.productAccessories.length) {
        for (var i = 0; i < m.productAccessories.length; ++i)
          $root.appliancepb.ProductAccessory.encode(
            m.productAccessories[i],
            w.uint32(98).fork()
          ).ldelim();
      }
      if (m.cashInLieu != null && Object.hasOwnProperty.call(m, "cashInLieu"))
        $root.appliancepb.PriceSetter.encode(
          m.cashInLieu,
          w.uint32(106).fork()
        ).ldelim();
      if (
        m.repairCredit != null &&
        Object.hasOwnProperty.call(m, "repairCredit")
      )
        $root.appliancepb.PriceSetter.encode(
          m.repairCredit,
          w.uint32(114).fork()
        ).ldelim();
      return w;
    };

    /**
     * Decodes a ReplacementOfferRequest message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.ReplacementOfferRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.ReplacementOfferRequest} ReplacementOfferRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ReplacementOfferRequest.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.ReplacementOfferRequest();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.dispatchId = r.string();
            break;
          case 2:
            m.likeForLikeProductId = r.string();
            break;
          case 3:
            m.itemId = r.string();
            break;
          case 4:
            m.addressId = r.string();
            break;
          case 5:
            m.customerId = r.string();
            break;
          case 6:
            m.contractId = r.string();
            break;
          case 7:
            m.partRequestId = r.string();
            break;
          case 8:
            m.hasDisposalCoverage = r.bool();
            break;
          case 9:
            m.contractType = r.int32();
            break;
          case 10:
            m.notification = $root.appliancepb.Notification.decode(
              r,
              r.uint32()
            );
            break;
          case 11:
            m.serviceLimit = r.int32();
            break;
          case 12:
            if (!(m.productAccessories && m.productAccessories.length))
              m.productAccessories = [];
            m.productAccessories.push(
              $root.appliancepb.ProductAccessory.decode(r, r.uint32())
            );
            break;
          case 13:
            m.cashInLieu = $root.appliancepb.PriceSetter.decode(r, r.uint32());
            break;
          case 14:
            m.repairCredit = $root.appliancepb.PriceSetter.decode(
              r,
              r.uint32()
            );
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    /**
     * ContractType enum.
     * @name appliancepb.ReplacementOfferRequest.ContractType
     * @enum {number}
     * @property {number} CONTRACT_TYPE_UNSPECIFIED=0 CONTRACT_TYPE_UNSPECIFIED value
     * @property {number} CONTRACT_TYPE_PLATINUM=1 CONTRACT_TYPE_PLATINUM value
     */
    ReplacementOfferRequest.ContractType = (function () {
      const valuesById = {},
        values = Object.create(valuesById);
      values[(valuesById[0] = "CONTRACT_TYPE_UNSPECIFIED")] = 0;
      values[(valuesById[1] = "CONTRACT_TYPE_PLATINUM")] = 1;
      return values;
    })();

    return ReplacementOfferRequest;
  })();

  appliancepb.ReplacementOfferResponse = (function () {
    /**
     * Properties of a ReplacementOfferResponse.
     * @memberof appliancepb
     * @interface IReplacementOfferResponse
     * @property {string|null} [uuid] ReplacementOfferResponse uuid
     */

    /**
     * Constructs a new ReplacementOfferResponse.
     * @memberof appliancepb
     * @classdesc Represents a ReplacementOfferResponse.
     * @implements IReplacementOfferResponse
     * @constructor
     * @param {appliancepb.IReplacementOfferResponse=} [p] Properties to set
     */
    function ReplacementOfferResponse(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * ReplacementOfferResponse uuid.
     * @member {string} uuid
     * @memberof appliancepb.ReplacementOfferResponse
     * @instance
     */
    ReplacementOfferResponse.prototype.uuid = "";

    /**
     * Creates a new ReplacementOfferResponse instance using the specified properties.
     * @function create
     * @memberof appliancepb.ReplacementOfferResponse
     * @static
     * @param {appliancepb.IReplacementOfferResponse=} [properties] Properties to set
     * @returns {appliancepb.ReplacementOfferResponse} ReplacementOfferResponse instance
     */
    ReplacementOfferResponse.create = function create(properties) {
      return new ReplacementOfferResponse(properties);
    };

    /**
     * Encodes the specified ReplacementOfferResponse message. Does not implicitly {@link appliancepb.ReplacementOfferResponse.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.ReplacementOfferResponse
     * @static
     * @param {appliancepb.IReplacementOfferResponse} m ReplacementOfferResponse message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ReplacementOfferResponse.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.uuid != null && Object.hasOwnProperty.call(m, "uuid"))
        w.uint32(10).string(m.uuid);
      return w;
    };

    /**
     * Decodes a ReplacementOfferResponse message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.ReplacementOfferResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.ReplacementOfferResponse} ReplacementOfferResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ReplacementOfferResponse.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.ReplacementOfferResponse();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.uuid = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ReplacementOfferResponse;
  })();

  appliancepb.ReplacementResponse = (function () {
    /**
     * Properties of a ReplacementResponse.
     * @memberof appliancepb
     * @interface IReplacementResponse
     * @property {appliancepb.ReplacementResponse.ICustomer|null} [customer] ReplacementResponse customer
     * @property {appliancepb.ReplacementResponse.IPaymentDetails|null} [paymentDetails] ReplacementResponse paymentDetails
     * @property {appliancepb.ReplacementResponse.IReplacementDetails|null} [replacementDetails] ReplacementResponse replacementDetails
     */

    /**
     * Constructs a new ReplacementResponse.
     * @memberof appliancepb
     * @classdesc Represents a ReplacementResponse.
     * @implements IReplacementResponse
     * @constructor
     * @param {appliancepb.IReplacementResponse=} [p] Properties to set
     */
    function ReplacementResponse(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * ReplacementResponse customer.
     * @member {appliancepb.ReplacementResponse.ICustomer|null|undefined} customer
     * @memberof appliancepb.ReplacementResponse
     * @instance
     */
    ReplacementResponse.prototype.customer = null;

    /**
     * ReplacementResponse paymentDetails.
     * @member {appliancepb.ReplacementResponse.IPaymentDetails|null|undefined} paymentDetails
     * @memberof appliancepb.ReplacementResponse
     * @instance
     */
    ReplacementResponse.prototype.paymentDetails = null;

    /**
     * ReplacementResponse replacementDetails.
     * @member {appliancepb.ReplacementResponse.IReplacementDetails|null|undefined} replacementDetails
     * @memberof appliancepb.ReplacementResponse
     * @instance
     */
    ReplacementResponse.prototype.replacementDetails = null;

    /**
     * Creates a new ReplacementResponse instance using the specified properties.
     * @function create
     * @memberof appliancepb.ReplacementResponse
     * @static
     * @param {appliancepb.IReplacementResponse=} [properties] Properties to set
     * @returns {appliancepb.ReplacementResponse} ReplacementResponse instance
     */
    ReplacementResponse.create = function create(properties) {
      return new ReplacementResponse(properties);
    };

    /**
     * Encodes the specified ReplacementResponse message. Does not implicitly {@link appliancepb.ReplacementResponse.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.ReplacementResponse
     * @static
     * @param {appliancepb.IReplacementResponse} m ReplacementResponse message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ReplacementResponse.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.customer != null && Object.hasOwnProperty.call(m, "customer"))
        $root.appliancepb.ReplacementResponse.Customer.encode(
          m.customer,
          w.uint32(10).fork()
        ).ldelim();
      if (
        m.paymentDetails != null &&
        Object.hasOwnProperty.call(m, "paymentDetails")
      )
        $root.appliancepb.ReplacementResponse.PaymentDetails.encode(
          m.paymentDetails,
          w.uint32(18).fork()
        ).ldelim();
      if (
        m.replacementDetails != null &&
        Object.hasOwnProperty.call(m, "replacementDetails")
      )
        $root.appliancepb.ReplacementResponse.ReplacementDetails.encode(
          m.replacementDetails,
          w.uint32(26).fork()
        ).ldelim();
      return w;
    };

    /**
     * Decodes a ReplacementResponse message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.ReplacementResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.ReplacementResponse} ReplacementResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ReplacementResponse.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.ReplacementResponse();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.customer = $root.appliancepb.ReplacementResponse.Customer.decode(
              r,
              r.uint32()
            );
            break;
          case 2:
            m.paymentDetails = $root.appliancepb.ReplacementResponse.PaymentDetails.decode(
              r,
              r.uint32()
            );
            break;
          case 3:
            m.replacementDetails = $root.appliancepb.ReplacementResponse.ReplacementDetails.decode(
              r,
              r.uint32()
            );
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    ReplacementResponse.Customer = (function () {
      /**
       * Properties of a Customer.
       * @memberof appliancepb.ReplacementResponse
       * @interface ICustomer
       * @property {string|null} [name] Customer name
       * @property {string|null} [email] Customer email
       * @property {string|null} [phone] Customer phone
       * @property {appliancepb.ReplacementResponse.Customer.IAddress|null} [address] Customer address
       */

      /**
       * Constructs a new Customer.
       * @memberof appliancepb.ReplacementResponse
       * @classdesc Represents a Customer.
       * @implements ICustomer
       * @constructor
       * @param {appliancepb.ReplacementResponse.ICustomer=} [p] Properties to set
       */
      function Customer(p) {
        if (p)
          for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
            if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
      }

      /**
       * Customer name.
       * @member {string} name
       * @memberof appliancepb.ReplacementResponse.Customer
       * @instance
       */
      Customer.prototype.name = "";

      /**
       * Customer email.
       * @member {string} email
       * @memberof appliancepb.ReplacementResponse.Customer
       * @instance
       */
      Customer.prototype.email = "";

      /**
       * Customer phone.
       * @member {string} phone
       * @memberof appliancepb.ReplacementResponse.Customer
       * @instance
       */
      Customer.prototype.phone = "";

      /**
       * Customer address.
       * @member {appliancepb.ReplacementResponse.Customer.IAddress|null|undefined} address
       * @memberof appliancepb.ReplacementResponse.Customer
       * @instance
       */
      Customer.prototype.address = null;

      /**
       * Creates a new Customer instance using the specified properties.
       * @function create
       * @memberof appliancepb.ReplacementResponse.Customer
       * @static
       * @param {appliancepb.ReplacementResponse.ICustomer=} [properties] Properties to set
       * @returns {appliancepb.ReplacementResponse.Customer} Customer instance
       */
      Customer.create = function create(properties) {
        return new Customer(properties);
      };

      /**
       * Encodes the specified Customer message. Does not implicitly {@link appliancepb.ReplacementResponse.Customer.verify|verify} messages.
       * @function encode
       * @memberof appliancepb.ReplacementResponse.Customer
       * @static
       * @param {appliancepb.ReplacementResponse.ICustomer} m Customer message or plain object to encode
       * @param {$protobuf.Writer} [w] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Customer.encode = function encode(m, w) {
        if (!w) w = $Writer.create();
        if (m.name != null && Object.hasOwnProperty.call(m, "name"))
          w.uint32(10).string(m.name);
        if (m.email != null && Object.hasOwnProperty.call(m, "email"))
          w.uint32(18).string(m.email);
        if (m.phone != null && Object.hasOwnProperty.call(m, "phone"))
          w.uint32(26).string(m.phone);
        if (m.address != null && Object.hasOwnProperty.call(m, "address"))
          $root.appliancepb.ReplacementResponse.Customer.Address.encode(
            m.address,
            w.uint32(34).fork()
          ).ldelim();
        return w;
      };

      /**
       * Decodes a Customer message from the specified reader or buffer.
       * @function decode
       * @memberof appliancepb.ReplacementResponse.Customer
       * @static
       * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
       * @param {number} [l] Message length if known beforehand
       * @returns {appliancepb.ReplacementResponse.Customer} Customer
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Customer.decode = function decode(r, l) {
        if (!(r instanceof $Reader)) r = $Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l,
          m = new $root.appliancepb.ReplacementResponse.Customer();
        while (r.pos < c) {
          var t = r.uint32();
          switch (t >>> 3) {
            case 1:
              m.name = r.string();
              break;
            case 2:
              m.email = r.string();
              break;
            case 3:
              m.phone = r.string();
              break;
            case 4:
              m.address = $root.appliancepb.ReplacementResponse.Customer.Address.decode(
                r,
                r.uint32()
              );
              break;
            default:
              r.skipType(t & 7);
              break;
          }
        }
        return m;
      };

      Customer.Address = (function () {
        /**
         * Properties of an Address.
         * @memberof appliancepb.ReplacementResponse.Customer
         * @interface IAddress
         * @property {string|null} [street1] Address street1
         * @property {string|null} [street2] Address street2
         * @property {string|null} [unitValue] Address unitValue
         * @property {string|null} [city] Address city
         * @property {string|null} [state] Address state
         * @property {string|null} [zip] Address zip
         * @property {string|null} [zipLocal] Address zipLocal
         * @property {string|null} [countryISO3] Address countryISO3
         * @property {string|null} [ID] Address ID
         * @property {string|null} [unitType] Address unitType
         */

        /**
         * Constructs a new Address.
         * @memberof appliancepb.ReplacementResponse.Customer
         * @classdesc Represents an Address.
         * @implements IAddress
         * @constructor
         * @param {appliancepb.ReplacementResponse.Customer.IAddress=} [p] Properties to set
         */
        function Address(p) {
          if (p)
            for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
              if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
        }

        /**
         * Address street1.
         * @member {string} street1
         * @memberof appliancepb.ReplacementResponse.Customer.Address
         * @instance
         */
        Address.prototype.street1 = "";

        /**
         * Address street2.
         * @member {string} street2
         * @memberof appliancepb.ReplacementResponse.Customer.Address
         * @instance
         */
        Address.prototype.street2 = "";

        /**
         * Address unitValue.
         * @member {string} unitValue
         * @memberof appliancepb.ReplacementResponse.Customer.Address
         * @instance
         */
        Address.prototype.unitValue = "";

        /**
         * Address city.
         * @member {string} city
         * @memberof appliancepb.ReplacementResponse.Customer.Address
         * @instance
         */
        Address.prototype.city = "";

        /**
         * Address state.
         * @member {string} state
         * @memberof appliancepb.ReplacementResponse.Customer.Address
         * @instance
         */
        Address.prototype.state = "";

        /**
         * Address zip.
         * @member {string} zip
         * @memberof appliancepb.ReplacementResponse.Customer.Address
         * @instance
         */
        Address.prototype.zip = "";

        /**
         * Address zipLocal.
         * @member {string} zipLocal
         * @memberof appliancepb.ReplacementResponse.Customer.Address
         * @instance
         */
        Address.prototype.zipLocal = "";

        /**
         * Address countryISO3.
         * @member {string} countryISO3
         * @memberof appliancepb.ReplacementResponse.Customer.Address
         * @instance
         */
        Address.prototype.countryISO3 = "";

        /**
         * Address ID.
         * @member {string} ID
         * @memberof appliancepb.ReplacementResponse.Customer.Address
         * @instance
         */
        Address.prototype.ID = "";

        /**
         * Address unitType.
         * @member {string} unitType
         * @memberof appliancepb.ReplacementResponse.Customer.Address
         * @instance
         */
        Address.prototype.unitType = "";

        /**
         * Creates a new Address instance using the specified properties.
         * @function create
         * @memberof appliancepb.ReplacementResponse.Customer.Address
         * @static
         * @param {appliancepb.ReplacementResponse.Customer.IAddress=} [properties] Properties to set
         * @returns {appliancepb.ReplacementResponse.Customer.Address} Address instance
         */
        Address.create = function create(properties) {
          return new Address(properties);
        };

        /**
         * Encodes the specified Address message. Does not implicitly {@link appliancepb.ReplacementResponse.Customer.Address.verify|verify} messages.
         * @function encode
         * @memberof appliancepb.ReplacementResponse.Customer.Address
         * @static
         * @param {appliancepb.ReplacementResponse.Customer.IAddress} m Address message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Address.encode = function encode(m, w) {
          if (!w) w = $Writer.create();
          if (m.street1 != null && Object.hasOwnProperty.call(m, "street1"))
            w.uint32(10).string(m.street1);
          if (m.street2 != null && Object.hasOwnProperty.call(m, "street2"))
            w.uint32(18).string(m.street2);
          if (m.unitValue != null && Object.hasOwnProperty.call(m, "unitValue"))
            w.uint32(26).string(m.unitValue);
          if (m.city != null && Object.hasOwnProperty.call(m, "city"))
            w.uint32(34).string(m.city);
          if (m.state != null && Object.hasOwnProperty.call(m, "state"))
            w.uint32(42).string(m.state);
          if (m.zip != null && Object.hasOwnProperty.call(m, "zip"))
            w.uint32(50).string(m.zip);
          if (m.zipLocal != null && Object.hasOwnProperty.call(m, "zipLocal"))
            w.uint32(58).string(m.zipLocal);
          if (
            m.countryISO3 != null &&
            Object.hasOwnProperty.call(m, "countryISO3")
          )
            w.uint32(66).string(m.countryISO3);
          if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
            w.uint32(74).string(m.ID);
          if (m.unitType != null && Object.hasOwnProperty.call(m, "unitType"))
            w.uint32(82).string(m.unitType);
          return w;
        };

        /**
         * Decodes an Address message from the specified reader or buffer.
         * @function decode
         * @memberof appliancepb.ReplacementResponse.Customer.Address
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {appliancepb.ReplacementResponse.Customer.Address} Address
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Address.decode = function decode(r, l) {
          if (!(r instanceof $Reader)) r = $Reader.create(r);
          var c = l === undefined ? r.len : r.pos + l,
            m = new $root.appliancepb.ReplacementResponse.Customer.Address();
          while (r.pos < c) {
            var t = r.uint32();
            switch (t >>> 3) {
              case 1:
                m.street1 = r.string();
                break;
              case 2:
                m.street2 = r.string();
                break;
              case 3:
                m.unitValue = r.string();
                break;
              case 4:
                m.city = r.string();
                break;
              case 5:
                m.state = r.string();
                break;
              case 6:
                m.zip = r.string();
                break;
              case 7:
                m.zipLocal = r.string();
                break;
              case 8:
                m.countryISO3 = r.string();
                break;
              case 9:
                m.ID = r.string();
                break;
              case 10:
                m.unitType = r.string();
                break;
              default:
                r.skipType(t & 7);
                break;
            }
          }
          return m;
        };

        return Address;
      })();

      return Customer;
    })();

    ReplacementResponse.PaymentDetails = (function () {
      /**
       * Properties of a PaymentDetails.
       * @memberof appliancepb.ReplacementResponse
       * @interface IPaymentDetails
       * @property {string|null} [expirationMonth] PaymentDetails expirationMonth
       * @property {string|null} [expirationYear] PaymentDetails expirationYear
       * @property {string|null} [last4] PaymentDetails last4
       */

      /**
       * Constructs a new PaymentDetails.
       * @memberof appliancepb.ReplacementResponse
       * @classdesc Represents a PaymentDetails.
       * @implements IPaymentDetails
       * @constructor
       * @param {appliancepb.ReplacementResponse.IPaymentDetails=} [p] Properties to set
       */
      function PaymentDetails(p) {
        if (p)
          for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
            if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
      }

      /**
       * PaymentDetails expirationMonth.
       * @member {string} expirationMonth
       * @memberof appliancepb.ReplacementResponse.PaymentDetails
       * @instance
       */
      PaymentDetails.prototype.expirationMonth = "";

      /**
       * PaymentDetails expirationYear.
       * @member {string} expirationYear
       * @memberof appliancepb.ReplacementResponse.PaymentDetails
       * @instance
       */
      PaymentDetails.prototype.expirationYear = "";

      /**
       * PaymentDetails last4.
       * @member {string} last4
       * @memberof appliancepb.ReplacementResponse.PaymentDetails
       * @instance
       */
      PaymentDetails.prototype.last4 = "";

      /**
       * Creates a new PaymentDetails instance using the specified properties.
       * @function create
       * @memberof appliancepb.ReplacementResponse.PaymentDetails
       * @static
       * @param {appliancepb.ReplacementResponse.IPaymentDetails=} [properties] Properties to set
       * @returns {appliancepb.ReplacementResponse.PaymentDetails} PaymentDetails instance
       */
      PaymentDetails.create = function create(properties) {
        return new PaymentDetails(properties);
      };

      /**
       * Encodes the specified PaymentDetails message. Does not implicitly {@link appliancepb.ReplacementResponse.PaymentDetails.verify|verify} messages.
       * @function encode
       * @memberof appliancepb.ReplacementResponse.PaymentDetails
       * @static
       * @param {appliancepb.ReplacementResponse.IPaymentDetails} m PaymentDetails message or plain object to encode
       * @param {$protobuf.Writer} [w] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      PaymentDetails.encode = function encode(m, w) {
        if (!w) w = $Writer.create();
        if (
          m.expirationMonth != null &&
          Object.hasOwnProperty.call(m, "expirationMonth")
        )
          w.uint32(10).string(m.expirationMonth);
        if (
          m.expirationYear != null &&
          Object.hasOwnProperty.call(m, "expirationYear")
        )
          w.uint32(18).string(m.expirationYear);
        if (m.last4 != null && Object.hasOwnProperty.call(m, "last4"))
          w.uint32(26).string(m.last4);
        return w;
      };

      /**
       * Decodes a PaymentDetails message from the specified reader or buffer.
       * @function decode
       * @memberof appliancepb.ReplacementResponse.PaymentDetails
       * @static
       * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
       * @param {number} [l] Message length if known beforehand
       * @returns {appliancepb.ReplacementResponse.PaymentDetails} PaymentDetails
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      PaymentDetails.decode = function decode(r, l) {
        if (!(r instanceof $Reader)) r = $Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l,
          m = new $root.appliancepb.ReplacementResponse.PaymentDetails();
        while (r.pos < c) {
          var t = r.uint32();
          switch (t >>> 3) {
            case 1:
              m.expirationMonth = r.string();
              break;
            case 2:
              m.expirationYear = r.string();
              break;
            case 3:
              m.last4 = r.string();
              break;
            default:
              r.skipType(t & 7);
              break;
          }
        }
        return m;
      };

      return PaymentDetails;
    })();

    ReplacementResponse.ReplacementDetails = (function () {
      /**
       * Properties of a ReplacementDetails.
       * @memberof appliancepb.ReplacementResponse
       * @interface IReplacementDetails
       * @property {string|null} [itemType] ReplacementDetails itemType
       * @property {number|Long|null} [cashInLieu] ReplacementDetails cashInLieu
       * @property {string|null} [likeForLikeProductID] ReplacementDetails likeForLikeProductID
       * @property {string|null} [ID] ReplacementDetails ID
       * @property {string|null} [dispatchID] ReplacementDetails dispatchID
       * @property {string|null} [partRequestID] ReplacementDetails partRequestID
       */

      /**
       * Constructs a new ReplacementDetails.
       * @memberof appliancepb.ReplacementResponse
       * @classdesc Represents a ReplacementDetails.
       * @implements IReplacementDetails
       * @constructor
       * @param {appliancepb.ReplacementResponse.IReplacementDetails=} [p] Properties to set
       */
      function ReplacementDetails(p) {
        if (p)
          for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
            if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
      }

      /**
       * ReplacementDetails itemType.
       * @member {string} itemType
       * @memberof appliancepb.ReplacementResponse.ReplacementDetails
       * @instance
       */
      ReplacementDetails.prototype.itemType = "";

      /**
       * ReplacementDetails cashInLieu.
       * @member {number|Long} cashInLieu
       * @memberof appliancepb.ReplacementResponse.ReplacementDetails
       * @instance
       */
      ReplacementDetails.prototype.cashInLieu = $util.Long
        ? $util.Long.fromBits(0, 0, false)
        : 0;

      /**
       * ReplacementDetails likeForLikeProductID.
       * @member {string} likeForLikeProductID
       * @memberof appliancepb.ReplacementResponse.ReplacementDetails
       * @instance
       */
      ReplacementDetails.prototype.likeForLikeProductID = "";

      /**
       * ReplacementDetails ID.
       * @member {string} ID
       * @memberof appliancepb.ReplacementResponse.ReplacementDetails
       * @instance
       */
      ReplacementDetails.prototype.ID = "";

      /**
       * ReplacementDetails dispatchID.
       * @member {string} dispatchID
       * @memberof appliancepb.ReplacementResponse.ReplacementDetails
       * @instance
       */
      ReplacementDetails.prototype.dispatchID = "";

      /**
       * ReplacementDetails partRequestID.
       * @member {string} partRequestID
       * @memberof appliancepb.ReplacementResponse.ReplacementDetails
       * @instance
       */
      ReplacementDetails.prototype.partRequestID = "";

      /**
       * Creates a new ReplacementDetails instance using the specified properties.
       * @function create
       * @memberof appliancepb.ReplacementResponse.ReplacementDetails
       * @static
       * @param {appliancepb.ReplacementResponse.IReplacementDetails=} [properties] Properties to set
       * @returns {appliancepb.ReplacementResponse.ReplacementDetails} ReplacementDetails instance
       */
      ReplacementDetails.create = function create(properties) {
        return new ReplacementDetails(properties);
      };

      /**
       * Encodes the specified ReplacementDetails message. Does not implicitly {@link appliancepb.ReplacementResponse.ReplacementDetails.verify|verify} messages.
       * @function encode
       * @memberof appliancepb.ReplacementResponse.ReplacementDetails
       * @static
       * @param {appliancepb.ReplacementResponse.IReplacementDetails} m ReplacementDetails message or plain object to encode
       * @param {$protobuf.Writer} [w] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      ReplacementDetails.encode = function encode(m, w) {
        if (!w) w = $Writer.create();
        if (m.itemType != null && Object.hasOwnProperty.call(m, "itemType"))
          w.uint32(10).string(m.itemType);
        if (m.cashInLieu != null && Object.hasOwnProperty.call(m, "cashInLieu"))
          w.uint32(16).int64(m.cashInLieu);
        if (
          m.likeForLikeProductID != null &&
          Object.hasOwnProperty.call(m, "likeForLikeProductID")
        )
          w.uint32(26).string(m.likeForLikeProductID);
        if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
          w.uint32(34).string(m.ID);
        if (m.dispatchID != null && Object.hasOwnProperty.call(m, "dispatchID"))
          w.uint32(42).string(m.dispatchID);
        if (
          m.partRequestID != null &&
          Object.hasOwnProperty.call(m, "partRequestID")
        )
          w.uint32(50).string(m.partRequestID);
        return w;
      };

      /**
       * Decodes a ReplacementDetails message from the specified reader or buffer.
       * @function decode
       * @memberof appliancepb.ReplacementResponse.ReplacementDetails
       * @static
       * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
       * @param {number} [l] Message length if known beforehand
       * @returns {appliancepb.ReplacementResponse.ReplacementDetails} ReplacementDetails
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      ReplacementDetails.decode = function decode(r, l) {
        if (!(r instanceof $Reader)) r = $Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l,
          m = new $root.appliancepb.ReplacementResponse.ReplacementDetails();
        while (r.pos < c) {
          var t = r.uint32();
          switch (t >>> 3) {
            case 1:
              m.itemType = r.string();
              break;
            case 2:
              m.cashInLieu = r.int64();
              break;
            case 3:
              m.likeForLikeProductID = r.string();
              break;
            case 4:
              m.ID = r.string();
              break;
            case 5:
              m.dispatchID = r.string();
              break;
            case 6:
              m.partRequestID = r.string();
              break;
            default:
              r.skipType(t & 7);
              break;
          }
        }
        return m;
      };

      return ReplacementDetails;
    })();

    return ReplacementResponse;
  })();

  appliancepb.Product = (function () {
    /**
     * Properties of a Product.
     * @memberof appliancepb
     * @interface IProduct
     * @property {string|null} [ID] Product ID
     * @property {number|null} [customerPrice] Product customerPrice
     * @property {string|null} [modelNumber] Product modelNumber
     * @property {string|null} [description] Product description
     * @property {Array.<appliancepb.Product.IFeature>|null} [bulletFeatures] Product bulletFeatures
     * @property {Array.<appliancepb.Product.IAttributeGroup>|null} [attributeGroups] Product attributeGroups
     * @property {Array.<appliancepb.Product.IImage>|null} [images] Product images
     * @property {Array.<string>|null} [marketClaimsAndCertifications] Product marketClaimsAndCertifications
     * @property {string|null} [applianceType] Product applianceType
     * @property {string|null} [color] Product color
     * @property {string|null} [fuel] Product fuel
     * @property {appliancepb.IDimensions|null} [dimensions] Product dimensions
     * @property {string|null} [itemID] Product itemID
     * @property {boolean|null} [IsAvailableForZip] Product IsAvailableForZip
     * @property {boolean|null} [IsCoupa] Product IsCoupa
     * @property {number|null} [basePrice] Product basePrice
     * @property {number|null} [defaultPriceWithTax] Product defaultPriceWithTax
     * @property {number|null} [upgradePriceWithTax] Product upgradePriceWithTax
     * @property {google.protobuf.ITimestamp|null} [shipDate] Product shipDate
     * @property {google.protobuf.ITimestamp|null} [deliveryDate] Product deliveryDate
     * @property {string|null} [category] Product category
     * @property {string|null} [subcategory] Product subcategory
     * @property {string|null} [warrantyCoverageMessage] Product warrantyCoverageMessage
     * @property {boolean|null} [IsPreferred] Product IsPreferred
     * @property {Array.<appliancepb.IMedia>|null} [documents] Product documents
     * @property {Array.<appliancepb.IMedia>|null} [videos] Product videos
     */

    /**
     * Constructs a new Product.
     * @memberof appliancepb
     * @classdesc Represents a Product.
     * @implements IProduct
     * @constructor
     * @param {appliancepb.IProduct=} [p] Properties to set
     */
    function Product(p) {
      this.bulletFeatures = [];
      this.attributeGroups = [];
      this.images = [];
      this.marketClaimsAndCertifications = [];
      this.documents = [];
      this.videos = [];
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * Product ID.
     * @member {string} ID
     * @memberof appliancepb.Product
     * @instance
     */
    Product.prototype.ID = "";

    /**
     * Product customerPrice.
     * @member {number} customerPrice
     * @memberof appliancepb.Product
     * @instance
     */
    Product.prototype.customerPrice = 0;

    /**
     * Product modelNumber.
     * @member {string} modelNumber
     * @memberof appliancepb.Product
     * @instance
     */
    Product.prototype.modelNumber = "";

    /**
     * Product description.
     * @member {string} description
     * @memberof appliancepb.Product
     * @instance
     */
    Product.prototype.description = "";

    /**
     * Product bulletFeatures.
     * @member {Array.<appliancepb.Product.IFeature>} bulletFeatures
     * @memberof appliancepb.Product
     * @instance
     */
    Product.prototype.bulletFeatures = $util.emptyArray;

    /**
     * Product attributeGroups.
     * @member {Array.<appliancepb.Product.IAttributeGroup>} attributeGroups
     * @memberof appliancepb.Product
     * @instance
     */
    Product.prototype.attributeGroups = $util.emptyArray;

    /**
     * Product images.
     * @member {Array.<appliancepb.Product.IImage>} images
     * @memberof appliancepb.Product
     * @instance
     */
    Product.prototype.images = $util.emptyArray;

    /**
     * Product marketClaimsAndCertifications.
     * @member {Array.<string>} marketClaimsAndCertifications
     * @memberof appliancepb.Product
     * @instance
     */
    Product.prototype.marketClaimsAndCertifications = $util.emptyArray;

    /**
     * Product applianceType.
     * @member {string} applianceType
     * @memberof appliancepb.Product
     * @instance
     */
    Product.prototype.applianceType = "";

    /**
     * Product color.
     * @member {string} color
     * @memberof appliancepb.Product
     * @instance
     */
    Product.prototype.color = "";

    /**
     * Product fuel.
     * @member {string} fuel
     * @memberof appliancepb.Product
     * @instance
     */
    Product.prototype.fuel = "";

    /**
     * Product dimensions.
     * @member {appliancepb.IDimensions|null|undefined} dimensions
     * @memberof appliancepb.Product
     * @instance
     */
    Product.prototype.dimensions = null;

    /**
     * Product itemID.
     * @member {string} itemID
     * @memberof appliancepb.Product
     * @instance
     */
    Product.prototype.itemID = "";

    /**
     * Product IsAvailableForZip.
     * @member {boolean} IsAvailableForZip
     * @memberof appliancepb.Product
     * @instance
     */
    Product.prototype.IsAvailableForZip = false;

    /**
     * Product IsCoupa.
     * @member {boolean} IsCoupa
     * @memberof appliancepb.Product
     * @instance
     */
    Product.prototype.IsCoupa = false;

    /**
     * Product basePrice.
     * @member {number} basePrice
     * @memberof appliancepb.Product
     * @instance
     */
    Product.prototype.basePrice = 0;

    /**
     * Product defaultPriceWithTax.
     * @member {number} defaultPriceWithTax
     * @memberof appliancepb.Product
     * @instance
     */
    Product.prototype.defaultPriceWithTax = 0;

    /**
     * Product upgradePriceWithTax.
     * @member {number} upgradePriceWithTax
     * @memberof appliancepb.Product
     * @instance
     */
    Product.prototype.upgradePriceWithTax = 0;

    /**
     * Product shipDate.
     * @member {google.protobuf.ITimestamp|null|undefined} shipDate
     * @memberof appliancepb.Product
     * @instance
     */
    Product.prototype.shipDate = null;

    /**
     * Product deliveryDate.
     * @member {google.protobuf.ITimestamp|null|undefined} deliveryDate
     * @memberof appliancepb.Product
     * @instance
     */
    Product.prototype.deliveryDate = null;

    /**
     * Product category.
     * @member {string} category
     * @memberof appliancepb.Product
     * @instance
     */
    Product.prototype.category = "";

    /**
     * Product subcategory.
     * @member {string} subcategory
     * @memberof appliancepb.Product
     * @instance
     */
    Product.prototype.subcategory = "";

    /**
     * Product warrantyCoverageMessage.
     * @member {string} warrantyCoverageMessage
     * @memberof appliancepb.Product
     * @instance
     */
    Product.prototype.warrantyCoverageMessage = "";

    /**
     * Product IsPreferred.
     * @member {boolean} IsPreferred
     * @memberof appliancepb.Product
     * @instance
     */
    Product.prototype.IsPreferred = false;

    /**
     * Product documents.
     * @member {Array.<appliancepb.IMedia>} documents
     * @memberof appliancepb.Product
     * @instance
     */
    Product.prototype.documents = $util.emptyArray;

    /**
     * Product videos.
     * @member {Array.<appliancepb.IMedia>} videos
     * @memberof appliancepb.Product
     * @instance
     */
    Product.prototype.videos = $util.emptyArray;

    /**
     * Creates a new Product instance using the specified properties.
     * @function create
     * @memberof appliancepb.Product
     * @static
     * @param {appliancepb.IProduct=} [properties] Properties to set
     * @returns {appliancepb.Product} Product instance
     */
    Product.create = function create(properties) {
      return new Product(properties);
    };

    /**
     * Encodes the specified Product message. Does not implicitly {@link appliancepb.Product.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.Product
     * @static
     * @param {appliancepb.IProduct} m Product message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Product.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
        w.uint32(10).string(m.ID);
      if (
        m.customerPrice != null &&
        Object.hasOwnProperty.call(m, "customerPrice")
      )
        w.uint32(16).int32(m.customerPrice);
      if (m.modelNumber != null && Object.hasOwnProperty.call(m, "modelNumber"))
        w.uint32(26).string(m.modelNumber);
      if (m.description != null && Object.hasOwnProperty.call(m, "description"))
        w.uint32(34).string(m.description);
      if (m.bulletFeatures != null && m.bulletFeatures.length) {
        for (var i = 0; i < m.bulletFeatures.length; ++i)
          $root.appliancepb.Product.Feature.encode(
            m.bulletFeatures[i],
            w.uint32(42).fork()
          ).ldelim();
      }
      if (m.attributeGroups != null && m.attributeGroups.length) {
        for (var i = 0; i < m.attributeGroups.length; ++i)
          $root.appliancepb.Product.AttributeGroup.encode(
            m.attributeGroups[i],
            w.uint32(50).fork()
          ).ldelim();
      }
      if (m.images != null && m.images.length) {
        for (var i = 0; i < m.images.length; ++i)
          $root.appliancepb.Product.Image.encode(
            m.images[i],
            w.uint32(58).fork()
          ).ldelim();
      }
      if (
        m.marketClaimsAndCertifications != null &&
        m.marketClaimsAndCertifications.length
      ) {
        for (var i = 0; i < m.marketClaimsAndCertifications.length; ++i)
          w.uint32(66).string(m.marketClaimsAndCertifications[i]);
      }
      if (
        m.applianceType != null &&
        Object.hasOwnProperty.call(m, "applianceType")
      )
        w.uint32(74).string(m.applianceType);
      if (m.color != null && Object.hasOwnProperty.call(m, "color"))
        w.uint32(82).string(m.color);
      if (m.fuel != null && Object.hasOwnProperty.call(m, "fuel"))
        w.uint32(90).string(m.fuel);
      if (m.dimensions != null && Object.hasOwnProperty.call(m, "dimensions"))
        $root.appliancepb.Dimensions.encode(
          m.dimensions,
          w.uint32(98).fork()
        ).ldelim();
      if (m.itemID != null && Object.hasOwnProperty.call(m, "itemID"))
        w.uint32(106).string(m.itemID);
      if (
        m.IsAvailableForZip != null &&
        Object.hasOwnProperty.call(m, "IsAvailableForZip")
      )
        w.uint32(112).bool(m.IsAvailableForZip);
      if (m.IsCoupa != null && Object.hasOwnProperty.call(m, "IsCoupa"))
        w.uint32(120).bool(m.IsCoupa);
      if (m.basePrice != null && Object.hasOwnProperty.call(m, "basePrice"))
        w.uint32(128).int32(m.basePrice);
      if (
        m.defaultPriceWithTax != null &&
        Object.hasOwnProperty.call(m, "defaultPriceWithTax")
      )
        w.uint32(136).int32(m.defaultPriceWithTax);
      if (
        m.upgradePriceWithTax != null &&
        Object.hasOwnProperty.call(m, "upgradePriceWithTax")
      )
        w.uint32(144).int32(m.upgradePriceWithTax);
      if (m.shipDate != null && Object.hasOwnProperty.call(m, "shipDate"))
        $root.google.protobuf.Timestamp.encode(
          m.shipDate,
          w.uint32(154).fork()
        ).ldelim();
      if (
        m.deliveryDate != null &&
        Object.hasOwnProperty.call(m, "deliveryDate")
      )
        $root.google.protobuf.Timestamp.encode(
          m.deliveryDate,
          w.uint32(162).fork()
        ).ldelim();
      if (m.category != null && Object.hasOwnProperty.call(m, "category"))
        w.uint32(170).string(m.category);
      if (m.subcategory != null && Object.hasOwnProperty.call(m, "subcategory"))
        w.uint32(178).string(m.subcategory);
      if (
        m.warrantyCoverageMessage != null &&
        Object.hasOwnProperty.call(m, "warrantyCoverageMessage")
      )
        w.uint32(186).string(m.warrantyCoverageMessage);
      if (m.IsPreferred != null && Object.hasOwnProperty.call(m, "IsPreferred"))
        w.uint32(192).bool(m.IsPreferred);
      if (m.documents != null && m.documents.length) {
        for (var i = 0; i < m.documents.length; ++i)
          $root.appliancepb.Media.encode(
            m.documents[i],
            w.uint32(202).fork()
          ).ldelim();
      }
      if (m.videos != null && m.videos.length) {
        for (var i = 0; i < m.videos.length; ++i)
          $root.appliancepb.Media.encode(
            m.videos[i],
            w.uint32(210).fork()
          ).ldelim();
      }
      return w;
    };

    /**
     * Decodes a Product message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.Product
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.Product} Product
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Product.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.Product();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.ID = r.string();
            break;
          case 2:
            m.customerPrice = r.int32();
            break;
          case 3:
            m.modelNumber = r.string();
            break;
          case 4:
            m.description = r.string();
            break;
          case 5:
            if (!(m.bulletFeatures && m.bulletFeatures.length))
              m.bulletFeatures = [];
            m.bulletFeatures.push(
              $root.appliancepb.Product.Feature.decode(r, r.uint32())
            );
            break;
          case 6:
            if (!(m.attributeGroups && m.attributeGroups.length))
              m.attributeGroups = [];
            m.attributeGroups.push(
              $root.appliancepb.Product.AttributeGroup.decode(r, r.uint32())
            );
            break;
          case 7:
            if (!(m.images && m.images.length)) m.images = [];
            m.images.push(
              $root.appliancepb.Product.Image.decode(r, r.uint32())
            );
            break;
          case 8:
            if (
              !(
                m.marketClaimsAndCertifications &&
                m.marketClaimsAndCertifications.length
              )
            )
              m.marketClaimsAndCertifications = [];
            m.marketClaimsAndCertifications.push(r.string());
            break;
          case 9:
            m.applianceType = r.string();
            break;
          case 10:
            m.color = r.string();
            break;
          case 11:
            m.fuel = r.string();
            break;
          case 12:
            m.dimensions = $root.appliancepb.Dimensions.decode(r, r.uint32());
            break;
          case 13:
            m.itemID = r.string();
            break;
          case 14:
            m.IsAvailableForZip = r.bool();
            break;
          case 15:
            m.IsCoupa = r.bool();
            break;
          case 16:
            m.basePrice = r.int32();
            break;
          case 17:
            m.defaultPriceWithTax = r.int32();
            break;
          case 18:
            m.upgradePriceWithTax = r.int32();
            break;
          case 19:
            m.shipDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
            break;
          case 20:
            m.deliveryDate = $root.google.protobuf.Timestamp.decode(
              r,
              r.uint32()
            );
            break;
          case 21:
            m.category = r.string();
            break;
          case 22:
            m.subcategory = r.string();
            break;
          case 23:
            m.warrantyCoverageMessage = r.string();
            break;
          case 24:
            m.IsPreferred = r.bool();
            break;
          case 25:
            if (!(m.documents && m.documents.length)) m.documents = [];
            m.documents.push($root.appliancepb.Media.decode(r, r.uint32()));
            break;
          case 26:
            if (!(m.videos && m.videos.length)) m.videos = [];
            m.videos.push($root.appliancepb.Media.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    Product.AttributeValuesPair = (function () {
      /**
       * Properties of an AttributeValuesPair.
       * @memberof appliancepb.Product
       * @interface IAttributeValuesPair
       * @property {string|null} [attribute] AttributeValuesPair attribute
       * @property {Array.<string>|null} [values] AttributeValuesPair values
       */

      /**
       * Constructs a new AttributeValuesPair.
       * @memberof appliancepb.Product
       * @classdesc Represents an AttributeValuesPair.
       * @implements IAttributeValuesPair
       * @constructor
       * @param {appliancepb.Product.IAttributeValuesPair=} [p] Properties to set
       */
      function AttributeValuesPair(p) {
        this.values = [];
        if (p)
          for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
            if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
      }

      /**
       * AttributeValuesPair attribute.
       * @member {string} attribute
       * @memberof appliancepb.Product.AttributeValuesPair
       * @instance
       */
      AttributeValuesPair.prototype.attribute = "";

      /**
       * AttributeValuesPair values.
       * @member {Array.<string>} values
       * @memberof appliancepb.Product.AttributeValuesPair
       * @instance
       */
      AttributeValuesPair.prototype.values = $util.emptyArray;

      /**
       * Creates a new AttributeValuesPair instance using the specified properties.
       * @function create
       * @memberof appliancepb.Product.AttributeValuesPair
       * @static
       * @param {appliancepb.Product.IAttributeValuesPair=} [properties] Properties to set
       * @returns {appliancepb.Product.AttributeValuesPair} AttributeValuesPair instance
       */
      AttributeValuesPair.create = function create(properties) {
        return new AttributeValuesPair(properties);
      };

      /**
       * Encodes the specified AttributeValuesPair message. Does not implicitly {@link appliancepb.Product.AttributeValuesPair.verify|verify} messages.
       * @function encode
       * @memberof appliancepb.Product.AttributeValuesPair
       * @static
       * @param {appliancepb.Product.IAttributeValuesPair} m AttributeValuesPair message or plain object to encode
       * @param {$protobuf.Writer} [w] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      AttributeValuesPair.encode = function encode(m, w) {
        if (!w) w = $Writer.create();
        if (m.attribute != null && Object.hasOwnProperty.call(m, "attribute"))
          w.uint32(10).string(m.attribute);
        if (m.values != null && m.values.length) {
          for (var i = 0; i < m.values.length; ++i)
            w.uint32(18).string(m.values[i]);
        }
        return w;
      };

      /**
       * Decodes an AttributeValuesPair message from the specified reader or buffer.
       * @function decode
       * @memberof appliancepb.Product.AttributeValuesPair
       * @static
       * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
       * @param {number} [l] Message length if known beforehand
       * @returns {appliancepb.Product.AttributeValuesPair} AttributeValuesPair
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      AttributeValuesPair.decode = function decode(r, l) {
        if (!(r instanceof $Reader)) r = $Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l,
          m = new $root.appliancepb.Product.AttributeValuesPair();
        while (r.pos < c) {
          var t = r.uint32();
          switch (t >>> 3) {
            case 1:
              m.attribute = r.string();
              break;
            case 2:
              if (!(m.values && m.values.length)) m.values = [];
              m.values.push(r.string());
              break;
            default:
              r.skipType(t & 7);
              break;
          }
        }
        return m;
      };

      return AttributeValuesPair;
    })();

    Product.AttributeGroup = (function () {
      /**
       * Properties of an AttributeGroup.
       * @memberof appliancepb.Product
       * @interface IAttributeGroup
       * @property {string|null} [attributeGroupName] AttributeGroup attributeGroupName
       * @property {Array.<appliancepb.Product.IAttributeValuesPair>|null} [attributes] AttributeGroup attributes
       */

      /**
       * Constructs a new AttributeGroup.
       * @memberof appliancepb.Product
       * @classdesc Represents an AttributeGroup.
       * @implements IAttributeGroup
       * @constructor
       * @param {appliancepb.Product.IAttributeGroup=} [p] Properties to set
       */
      function AttributeGroup(p) {
        this.attributes = [];
        if (p)
          for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
            if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
      }

      /**
       * AttributeGroup attributeGroupName.
       * @member {string} attributeGroupName
       * @memberof appliancepb.Product.AttributeGroup
       * @instance
       */
      AttributeGroup.prototype.attributeGroupName = "";

      /**
       * AttributeGroup attributes.
       * @member {Array.<appliancepb.Product.IAttributeValuesPair>} attributes
       * @memberof appliancepb.Product.AttributeGroup
       * @instance
       */
      AttributeGroup.prototype.attributes = $util.emptyArray;

      /**
       * Creates a new AttributeGroup instance using the specified properties.
       * @function create
       * @memberof appliancepb.Product.AttributeGroup
       * @static
       * @param {appliancepb.Product.IAttributeGroup=} [properties] Properties to set
       * @returns {appliancepb.Product.AttributeGroup} AttributeGroup instance
       */
      AttributeGroup.create = function create(properties) {
        return new AttributeGroup(properties);
      };

      /**
       * Encodes the specified AttributeGroup message. Does not implicitly {@link appliancepb.Product.AttributeGroup.verify|verify} messages.
       * @function encode
       * @memberof appliancepb.Product.AttributeGroup
       * @static
       * @param {appliancepb.Product.IAttributeGroup} m AttributeGroup message or plain object to encode
       * @param {$protobuf.Writer} [w] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      AttributeGroup.encode = function encode(m, w) {
        if (!w) w = $Writer.create();
        if (
          m.attributeGroupName != null &&
          Object.hasOwnProperty.call(m, "attributeGroupName")
        )
          w.uint32(10).string(m.attributeGroupName);
        if (m.attributes != null && m.attributes.length) {
          for (var i = 0; i < m.attributes.length; ++i)
            $root.appliancepb.Product.AttributeValuesPair.encode(
              m.attributes[i],
              w.uint32(18).fork()
            ).ldelim();
        }
        return w;
      };

      /**
       * Decodes an AttributeGroup message from the specified reader or buffer.
       * @function decode
       * @memberof appliancepb.Product.AttributeGroup
       * @static
       * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
       * @param {number} [l] Message length if known beforehand
       * @returns {appliancepb.Product.AttributeGroup} AttributeGroup
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      AttributeGroup.decode = function decode(r, l) {
        if (!(r instanceof $Reader)) r = $Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l,
          m = new $root.appliancepb.Product.AttributeGroup();
        while (r.pos < c) {
          var t = r.uint32();
          switch (t >>> 3) {
            case 1:
              m.attributeGroupName = r.string();
              break;
            case 2:
              if (!(m.attributes && m.attributes.length)) m.attributes = [];
              m.attributes.push(
                $root.appliancepb.Product.AttributeValuesPair.decode(
                  r,
                  r.uint32()
                )
              );
              break;
            default:
              r.skipType(t & 7);
              break;
          }
        }
        return m;
      };

      return AttributeGroup;
    })();

    Product.Feature = (function () {
      /**
       * Properties of a Feature.
       * @memberof appliancepb.Product
       * @interface IFeature
       * @property {string|null} [feature] Feature feature
       * @property {string|null} [description] Feature description
       */

      /**
       * Constructs a new Feature.
       * @memberof appliancepb.Product
       * @classdesc Represents a Feature.
       * @implements IFeature
       * @constructor
       * @param {appliancepb.Product.IFeature=} [p] Properties to set
       */
      function Feature(p) {
        if (p)
          for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
            if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
      }

      /**
       * Feature feature.
       * @member {string} feature
       * @memberof appliancepb.Product.Feature
       * @instance
       */
      Feature.prototype.feature = "";

      /**
       * Feature description.
       * @member {string} description
       * @memberof appliancepb.Product.Feature
       * @instance
       */
      Feature.prototype.description = "";

      /**
       * Creates a new Feature instance using the specified properties.
       * @function create
       * @memberof appliancepb.Product.Feature
       * @static
       * @param {appliancepb.Product.IFeature=} [properties] Properties to set
       * @returns {appliancepb.Product.Feature} Feature instance
       */
      Feature.create = function create(properties) {
        return new Feature(properties);
      };

      /**
       * Encodes the specified Feature message. Does not implicitly {@link appliancepb.Product.Feature.verify|verify} messages.
       * @function encode
       * @memberof appliancepb.Product.Feature
       * @static
       * @param {appliancepb.Product.IFeature} m Feature message or plain object to encode
       * @param {$protobuf.Writer} [w] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Feature.encode = function encode(m, w) {
        if (!w) w = $Writer.create();
        if (m.feature != null && Object.hasOwnProperty.call(m, "feature"))
          w.uint32(10).string(m.feature);
        if (
          m.description != null &&
          Object.hasOwnProperty.call(m, "description")
        )
          w.uint32(18).string(m.description);
        return w;
      };

      /**
       * Decodes a Feature message from the specified reader or buffer.
       * @function decode
       * @memberof appliancepb.Product.Feature
       * @static
       * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
       * @param {number} [l] Message length if known beforehand
       * @returns {appliancepb.Product.Feature} Feature
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Feature.decode = function decode(r, l) {
        if (!(r instanceof $Reader)) r = $Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l,
          m = new $root.appliancepb.Product.Feature();
        while (r.pos < c) {
          var t = r.uint32();
          switch (t >>> 3) {
            case 1:
              m.feature = r.string();
              break;
            case 2:
              m.description = r.string();
              break;
            default:
              r.skipType(t & 7);
              break;
          }
        }
        return m;
      };

      return Feature;
    })();

    Product.Image = (function () {
      /**
       * Properties of an Image.
       * @memberof appliancepb.Product
       * @interface IImage
       * @property {string|null} [imageName] Image imageName
       * @property {string|null} [fileName] Image fileName
       * @property {string|null} [url] Image url
       */

      /**
       * Constructs a new Image.
       * @memberof appliancepb.Product
       * @classdesc Represents an Image.
       * @implements IImage
       * @constructor
       * @param {appliancepb.Product.IImage=} [p] Properties to set
       */
      function Image(p) {
        if (p)
          for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
            if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
      }

      /**
       * Image imageName.
       * @member {string} imageName
       * @memberof appliancepb.Product.Image
       * @instance
       */
      Image.prototype.imageName = "";

      /**
       * Image fileName.
       * @member {string} fileName
       * @memberof appliancepb.Product.Image
       * @instance
       */
      Image.prototype.fileName = "";

      /**
       * Image url.
       * @member {string} url
       * @memberof appliancepb.Product.Image
       * @instance
       */
      Image.prototype.url = "";

      /**
       * Creates a new Image instance using the specified properties.
       * @function create
       * @memberof appliancepb.Product.Image
       * @static
       * @param {appliancepb.Product.IImage=} [properties] Properties to set
       * @returns {appliancepb.Product.Image} Image instance
       */
      Image.create = function create(properties) {
        return new Image(properties);
      };

      /**
       * Encodes the specified Image message. Does not implicitly {@link appliancepb.Product.Image.verify|verify} messages.
       * @function encode
       * @memberof appliancepb.Product.Image
       * @static
       * @param {appliancepb.Product.IImage} m Image message or plain object to encode
       * @param {$protobuf.Writer} [w] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Image.encode = function encode(m, w) {
        if (!w) w = $Writer.create();
        if (m.imageName != null && Object.hasOwnProperty.call(m, "imageName"))
          w.uint32(10).string(m.imageName);
        if (m.fileName != null && Object.hasOwnProperty.call(m, "fileName"))
          w.uint32(18).string(m.fileName);
        if (m.url != null && Object.hasOwnProperty.call(m, "url"))
          w.uint32(26).string(m.url);
        return w;
      };

      /**
       * Decodes an Image message from the specified reader or buffer.
       * @function decode
       * @memberof appliancepb.Product.Image
       * @static
       * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
       * @param {number} [l] Message length if known beforehand
       * @returns {appliancepb.Product.Image} Image
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Image.decode = function decode(r, l) {
        if (!(r instanceof $Reader)) r = $Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l,
          m = new $root.appliancepb.Product.Image();
        while (r.pos < c) {
          var t = r.uint32();
          switch (t >>> 3) {
            case 1:
              m.imageName = r.string();
              break;
            case 2:
              m.fileName = r.string();
              break;
            case 3:
              m.url = r.string();
              break;
            default:
              r.skipType(t & 7);
              break;
          }
        }
        return m;
      };

      return Image;
    })();

    return Product;
  })();

  appliancepb.Dimensions = (function () {
    /**
     * Properties of a Dimensions.
     * @memberof appliancepb
     * @interface IDimensions
     * @property {string|null} [unit] Dimensions unit
     * @property {string|null} [height] Dimensions height
     * @property {string|null} [width] Dimensions width
     * @property {string|null} [depth] Dimensions depth
     */

    /**
     * Constructs a new Dimensions.
     * @memberof appliancepb
     * @classdesc Represents a Dimensions.
     * @implements IDimensions
     * @constructor
     * @param {appliancepb.IDimensions=} [p] Properties to set
     */
    function Dimensions(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * Dimensions unit.
     * @member {string} unit
     * @memberof appliancepb.Dimensions
     * @instance
     */
    Dimensions.prototype.unit = "";

    /**
     * Dimensions height.
     * @member {string} height
     * @memberof appliancepb.Dimensions
     * @instance
     */
    Dimensions.prototype.height = "";

    /**
     * Dimensions width.
     * @member {string} width
     * @memberof appliancepb.Dimensions
     * @instance
     */
    Dimensions.prototype.width = "";

    /**
     * Dimensions depth.
     * @member {string} depth
     * @memberof appliancepb.Dimensions
     * @instance
     */
    Dimensions.prototype.depth = "";

    /**
     * Creates a new Dimensions instance using the specified properties.
     * @function create
     * @memberof appliancepb.Dimensions
     * @static
     * @param {appliancepb.IDimensions=} [properties] Properties to set
     * @returns {appliancepb.Dimensions} Dimensions instance
     */
    Dimensions.create = function create(properties) {
      return new Dimensions(properties);
    };

    /**
     * Encodes the specified Dimensions message. Does not implicitly {@link appliancepb.Dimensions.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.Dimensions
     * @static
     * @param {appliancepb.IDimensions} m Dimensions message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Dimensions.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.unit != null && Object.hasOwnProperty.call(m, "unit"))
        w.uint32(10).string(m.unit);
      if (m.height != null && Object.hasOwnProperty.call(m, "height"))
        w.uint32(18).string(m.height);
      if (m.width != null && Object.hasOwnProperty.call(m, "width"))
        w.uint32(26).string(m.width);
      if (m.depth != null && Object.hasOwnProperty.call(m, "depth"))
        w.uint32(34).string(m.depth);
      return w;
    };

    /**
     * Decodes a Dimensions message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.Dimensions
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.Dimensions} Dimensions
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Dimensions.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.Dimensions();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.unit = r.string();
            break;
          case 2:
            m.height = r.string();
            break;
          case 3:
            m.width = r.string();
            break;
          case 4:
            m.depth = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return Dimensions;
  })();

  appliancepb.Pagination = (function () {
    /**
     * Properties of a Pagination.
     * @memberof appliancepb
     * @interface IPagination
     * @property {number|null} [itemsPerPage] Pagination itemsPerPage
     * @property {number|null} [totalItems] Pagination totalItems
     * @property {number|null} [page] Pagination page
     */

    /**
     * Constructs a new Pagination.
     * @memberof appliancepb
     * @classdesc Represents a Pagination.
     * @implements IPagination
     * @constructor
     * @param {appliancepb.IPagination=} [p] Properties to set
     */
    function Pagination(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * Pagination itemsPerPage.
     * @member {number} itemsPerPage
     * @memberof appliancepb.Pagination
     * @instance
     */
    Pagination.prototype.itemsPerPage = 0;

    /**
     * Pagination totalItems.
     * @member {number} totalItems
     * @memberof appliancepb.Pagination
     * @instance
     */
    Pagination.prototype.totalItems = 0;

    /**
     * Pagination page.
     * @member {number} page
     * @memberof appliancepb.Pagination
     * @instance
     */
    Pagination.prototype.page = 0;

    /**
     * Creates a new Pagination instance using the specified properties.
     * @function create
     * @memberof appliancepb.Pagination
     * @static
     * @param {appliancepb.IPagination=} [properties] Properties to set
     * @returns {appliancepb.Pagination} Pagination instance
     */
    Pagination.create = function create(properties) {
      return new Pagination(properties);
    };

    /**
     * Encodes the specified Pagination message. Does not implicitly {@link appliancepb.Pagination.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.Pagination
     * @static
     * @param {appliancepb.IPagination} m Pagination message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Pagination.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (
        m.itemsPerPage != null &&
        Object.hasOwnProperty.call(m, "itemsPerPage")
      )
        w.uint32(8).uint32(m.itemsPerPage);
      if (m.totalItems != null && Object.hasOwnProperty.call(m, "totalItems"))
        w.uint32(16).uint32(m.totalItems);
      if (m.page != null && Object.hasOwnProperty.call(m, "page"))
        w.uint32(24).uint32(m.page);
      return w;
    };

    /**
     * Decodes a Pagination message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.Pagination
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.Pagination} Pagination
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Pagination.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.Pagination();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.itemsPerPage = r.uint32();
            break;
          case 2:
            m.totalItems = r.uint32();
            break;
          case 3:
            m.page = r.uint32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return Pagination;
  })();

  appliancepb.ProductsResponse = (function () {
    /**
     * Properties of a ProductsResponse.
     * @memberof appliancepb
     * @interface IProductsResponse
     * @property {Array.<appliancepb.IProduct>|null} [products] ProductsResponse products
     * @property {appliancepb.IPagination|null} [pagination] ProductsResponse pagination
     */

    /**
     * Constructs a new ProductsResponse.
     * @memberof appliancepb
     * @classdesc Represents a ProductsResponse.
     * @implements IProductsResponse
     * @constructor
     * @param {appliancepb.IProductsResponse=} [p] Properties to set
     */
    function ProductsResponse(p) {
      this.products = [];
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * ProductsResponse products.
     * @member {Array.<appliancepb.IProduct>} products
     * @memberof appliancepb.ProductsResponse
     * @instance
     */
    ProductsResponse.prototype.products = $util.emptyArray;

    /**
     * ProductsResponse pagination.
     * @member {appliancepb.IPagination|null|undefined} pagination
     * @memberof appliancepb.ProductsResponse
     * @instance
     */
    ProductsResponse.prototype.pagination = null;

    /**
     * Creates a new ProductsResponse instance using the specified properties.
     * @function create
     * @memberof appliancepb.ProductsResponse
     * @static
     * @param {appliancepb.IProductsResponse=} [properties] Properties to set
     * @returns {appliancepb.ProductsResponse} ProductsResponse instance
     */
    ProductsResponse.create = function create(properties) {
      return new ProductsResponse(properties);
    };

    /**
     * Encodes the specified ProductsResponse message. Does not implicitly {@link appliancepb.ProductsResponse.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.ProductsResponse
     * @static
     * @param {appliancepb.IProductsResponse} m ProductsResponse message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ProductsResponse.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.products != null && m.products.length) {
        for (var i = 0; i < m.products.length; ++i)
          $root.appliancepb.Product.encode(
            m.products[i],
            w.uint32(10).fork()
          ).ldelim();
      }
      if (m.pagination != null && Object.hasOwnProperty.call(m, "pagination"))
        $root.appliancepb.Pagination.encode(
          m.pagination,
          w.uint32(26).fork()
        ).ldelim();
      return w;
    };

    /**
     * Decodes a ProductsResponse message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.ProductsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.ProductsResponse} ProductsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ProductsResponse.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.ProductsResponse();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.products && m.products.length)) m.products = [];
            m.products.push($root.appliancepb.Product.decode(r, r.uint32()));
            break;
          case 3:
            m.pagination = $root.appliancepb.Pagination.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ProductsResponse;
  })();

  appliancepb.FilterRange = (function () {
    /**
     * Properties of a FilterRange.
     * @memberof appliancepb
     * @interface IFilterRange
     * @property {string|null} [label] FilterRange label
     * @property {number|Long|null} [min] FilterRange min
     * @property {number|Long|null} [max] FilterRange max
     */

    /**
     * Constructs a new FilterRange.
     * @memberof appliancepb
     * @classdesc Represents a FilterRange.
     * @implements IFilterRange
     * @constructor
     * @param {appliancepb.IFilterRange=} [p] Properties to set
     */
    function FilterRange(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * FilterRange label.
     * @member {string} label
     * @memberof appliancepb.FilterRange
     * @instance
     */
    FilterRange.prototype.label = "";

    /**
     * FilterRange min.
     * @member {number|Long} min
     * @memberof appliancepb.FilterRange
     * @instance
     */
    FilterRange.prototype.min = $util.Long
      ? $util.Long.fromBits(0, 0, true)
      : 0;

    /**
     * FilterRange max.
     * @member {number|Long} max
     * @memberof appliancepb.FilterRange
     * @instance
     */
    FilterRange.prototype.max = $util.Long
      ? $util.Long.fromBits(0, 0, true)
      : 0;

    /**
     * Creates a new FilterRange instance using the specified properties.
     * @function create
     * @memberof appliancepb.FilterRange
     * @static
     * @param {appliancepb.IFilterRange=} [properties] Properties to set
     * @returns {appliancepb.FilterRange} FilterRange instance
     */
    FilterRange.create = function create(properties) {
      return new FilterRange(properties);
    };

    /**
     * Encodes the specified FilterRange message. Does not implicitly {@link appliancepb.FilterRange.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.FilterRange
     * @static
     * @param {appliancepb.IFilterRange} m FilterRange message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FilterRange.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.label != null && Object.hasOwnProperty.call(m, "label"))
        w.uint32(10).string(m.label);
      if (m.min != null && Object.hasOwnProperty.call(m, "min"))
        w.uint32(16).uint64(m.min);
      if (m.max != null && Object.hasOwnProperty.call(m, "max"))
        w.uint32(24).uint64(m.max);
      return w;
    };

    /**
     * Decodes a FilterRange message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.FilterRange
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.FilterRange} FilterRange
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FilterRange.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.FilterRange();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.label = r.string();
            break;
          case 2:
            m.min = r.uint64();
            break;
          case 3:
            m.max = r.uint64();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return FilterRange;
  })();

  appliancepb.ValueApplianceFilter = (function () {
    /**
     * Properties of a ValueApplianceFilter.
     * @memberof appliancepb
     * @interface IValueApplianceFilter
     * @property {string|null} [name] ValueApplianceFilter name
     * @property {Array.<string>|null} [values] ValueApplianceFilter values
     */

    /**
     * Constructs a new ValueApplianceFilter.
     * @memberof appliancepb
     * @classdesc Represents a ValueApplianceFilter.
     * @implements IValueApplianceFilter
     * @constructor
     * @param {appliancepb.IValueApplianceFilter=} [p] Properties to set
     */
    function ValueApplianceFilter(p) {
      this.values = [];
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * ValueApplianceFilter name.
     * @member {string} name
     * @memberof appliancepb.ValueApplianceFilter
     * @instance
     */
    ValueApplianceFilter.prototype.name = "";

    /**
     * ValueApplianceFilter values.
     * @member {Array.<string>} values
     * @memberof appliancepb.ValueApplianceFilter
     * @instance
     */
    ValueApplianceFilter.prototype.values = $util.emptyArray;

    /**
     * Creates a new ValueApplianceFilter instance using the specified properties.
     * @function create
     * @memberof appliancepb.ValueApplianceFilter
     * @static
     * @param {appliancepb.IValueApplianceFilter=} [properties] Properties to set
     * @returns {appliancepb.ValueApplianceFilter} ValueApplianceFilter instance
     */
    ValueApplianceFilter.create = function create(properties) {
      return new ValueApplianceFilter(properties);
    };

    /**
     * Encodes the specified ValueApplianceFilter message. Does not implicitly {@link appliancepb.ValueApplianceFilter.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.ValueApplianceFilter
     * @static
     * @param {appliancepb.IValueApplianceFilter} m ValueApplianceFilter message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ValueApplianceFilter.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.name != null && Object.hasOwnProperty.call(m, "name"))
        w.uint32(10).string(m.name);
      if (m.values != null && m.values.length) {
        for (var i = 0; i < m.values.length; ++i)
          w.uint32(18).string(m.values[i]);
      }
      return w;
    };

    /**
     * Decodes a ValueApplianceFilter message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.ValueApplianceFilter
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.ValueApplianceFilter} ValueApplianceFilter
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ValueApplianceFilter.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.ValueApplianceFilter();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.name = r.string();
            break;
          case 2:
            if (!(m.values && m.values.length)) m.values = [];
            m.values.push(r.string());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ValueApplianceFilter;
  })();

  appliancepb.RangeApplianceFilter = (function () {
    /**
     * Properties of a RangeApplianceFilter.
     * @memberof appliancepb
     * @interface IRangeApplianceFilter
     * @property {string|null} [name] RangeApplianceFilter name
     * @property {Array.<appliancepb.IFilterRange>|null} [values] RangeApplianceFilter values
     */

    /**
     * Constructs a new RangeApplianceFilter.
     * @memberof appliancepb
     * @classdesc Represents a RangeApplianceFilter.
     * @implements IRangeApplianceFilter
     * @constructor
     * @param {appliancepb.IRangeApplianceFilter=} [p] Properties to set
     */
    function RangeApplianceFilter(p) {
      this.values = [];
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * RangeApplianceFilter name.
     * @member {string} name
     * @memberof appliancepb.RangeApplianceFilter
     * @instance
     */
    RangeApplianceFilter.prototype.name = "";

    /**
     * RangeApplianceFilter values.
     * @member {Array.<appliancepb.IFilterRange>} values
     * @memberof appliancepb.RangeApplianceFilter
     * @instance
     */
    RangeApplianceFilter.prototype.values = $util.emptyArray;

    /**
     * Creates a new RangeApplianceFilter instance using the specified properties.
     * @function create
     * @memberof appliancepb.RangeApplianceFilter
     * @static
     * @param {appliancepb.IRangeApplianceFilter=} [properties] Properties to set
     * @returns {appliancepb.RangeApplianceFilter} RangeApplianceFilter instance
     */
    RangeApplianceFilter.create = function create(properties) {
      return new RangeApplianceFilter(properties);
    };

    /**
     * Encodes the specified RangeApplianceFilter message. Does not implicitly {@link appliancepb.RangeApplianceFilter.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.RangeApplianceFilter
     * @static
     * @param {appliancepb.IRangeApplianceFilter} m RangeApplianceFilter message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RangeApplianceFilter.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.name != null && Object.hasOwnProperty.call(m, "name"))
        w.uint32(10).string(m.name);
      if (m.values != null && m.values.length) {
        for (var i = 0; i < m.values.length; ++i)
          $root.appliancepb.FilterRange.encode(
            m.values[i],
            w.uint32(18).fork()
          ).ldelim();
      }
      return w;
    };

    /**
     * Decodes a RangeApplianceFilter message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.RangeApplianceFilter
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.RangeApplianceFilter} RangeApplianceFilter
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RangeApplianceFilter.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.RangeApplianceFilter();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.name = r.string();
            break;
          case 2:
            if (!(m.values && m.values.length)) m.values = [];
            m.values.push($root.appliancepb.FilterRange.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return RangeApplianceFilter;
  })();

  appliancepb.ApplianceFilter = (function () {
    /**
     * Properties of an ApplianceFilter.
     * @memberof appliancepb
     * @interface IApplianceFilter
     * @property {appliancepb.IValueApplianceFilter|null} [enumFilter] ApplianceFilter enumFilter
     * @property {appliancepb.IRangeApplianceFilter|null} [rangeFilter] ApplianceFilter rangeFilter
     */

    /**
     * Constructs a new ApplianceFilter.
     * @memberof appliancepb
     * @classdesc Represents an ApplianceFilter.
     * @implements IApplianceFilter
     * @constructor
     * @param {appliancepb.IApplianceFilter=} [p] Properties to set
     */
    function ApplianceFilter(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * ApplianceFilter enumFilter.
     * @member {appliancepb.IValueApplianceFilter|null|undefined} enumFilter
     * @memberof appliancepb.ApplianceFilter
     * @instance
     */
    ApplianceFilter.prototype.enumFilter = null;

    /**
     * ApplianceFilter rangeFilter.
     * @member {appliancepb.IRangeApplianceFilter|null|undefined} rangeFilter
     * @memberof appliancepb.ApplianceFilter
     * @instance
     */
    ApplianceFilter.prototype.rangeFilter = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * ApplianceFilter filter.
     * @member {"enumFilter"|"rangeFilter"|undefined} filter
     * @memberof appliancepb.ApplianceFilter
     * @instance
     */
    Object.defineProperty(ApplianceFilter.prototype, "filter", {
      get: $util.oneOfGetter(($oneOfFields = ["enumFilter", "rangeFilter"])),
      set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * Creates a new ApplianceFilter instance using the specified properties.
     * @function create
     * @memberof appliancepb.ApplianceFilter
     * @static
     * @param {appliancepb.IApplianceFilter=} [properties] Properties to set
     * @returns {appliancepb.ApplianceFilter} ApplianceFilter instance
     */
    ApplianceFilter.create = function create(properties) {
      return new ApplianceFilter(properties);
    };

    /**
     * Encodes the specified ApplianceFilter message. Does not implicitly {@link appliancepb.ApplianceFilter.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.ApplianceFilter
     * @static
     * @param {appliancepb.IApplianceFilter} m ApplianceFilter message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ApplianceFilter.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.enumFilter != null && Object.hasOwnProperty.call(m, "enumFilter"))
        $root.appliancepb.ValueApplianceFilter.encode(
          m.enumFilter,
          w.uint32(10).fork()
        ).ldelim();
      if (m.rangeFilter != null && Object.hasOwnProperty.call(m, "rangeFilter"))
        $root.appliancepb.RangeApplianceFilter.encode(
          m.rangeFilter,
          w.uint32(18).fork()
        ).ldelim();
      return w;
    };

    /**
     * Decodes an ApplianceFilter message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.ApplianceFilter
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.ApplianceFilter} ApplianceFilter
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ApplianceFilter.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.ApplianceFilter();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.enumFilter = $root.appliancepb.ValueApplianceFilter.decode(
              r,
              r.uint32()
            );
            break;
          case 2:
            m.rangeFilter = $root.appliancepb.RangeApplianceFilter.decode(
              r,
              r.uint32()
            );
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ApplianceFilter;
  })();

  appliancepb.ApplianceFiltersResponse = (function () {
    /**
     * Properties of an ApplianceFiltersResponse.
     * @memberof appliancepb
     * @interface IApplianceFiltersResponse
     * @property {string|null} [applianceType] ApplianceFiltersResponse applianceType
     * @property {Array.<appliancepb.IApplianceFilter>|null} [filters] ApplianceFiltersResponse filters
     */

    /**
     * Constructs a new ApplianceFiltersResponse.
     * @memberof appliancepb
     * @classdesc Represents an ApplianceFiltersResponse.
     * @implements IApplianceFiltersResponse
     * @constructor
     * @param {appliancepb.IApplianceFiltersResponse=} [p] Properties to set
     */
    function ApplianceFiltersResponse(p) {
      this.filters = [];
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * ApplianceFiltersResponse applianceType.
     * @member {string} applianceType
     * @memberof appliancepb.ApplianceFiltersResponse
     * @instance
     */
    ApplianceFiltersResponse.prototype.applianceType = "";

    /**
     * ApplianceFiltersResponse filters.
     * @member {Array.<appliancepb.IApplianceFilter>} filters
     * @memberof appliancepb.ApplianceFiltersResponse
     * @instance
     */
    ApplianceFiltersResponse.prototype.filters = $util.emptyArray;

    /**
     * Creates a new ApplianceFiltersResponse instance using the specified properties.
     * @function create
     * @memberof appliancepb.ApplianceFiltersResponse
     * @static
     * @param {appliancepb.IApplianceFiltersResponse=} [properties] Properties to set
     * @returns {appliancepb.ApplianceFiltersResponse} ApplianceFiltersResponse instance
     */
    ApplianceFiltersResponse.create = function create(properties) {
      return new ApplianceFiltersResponse(properties);
    };

    /**
     * Encodes the specified ApplianceFiltersResponse message. Does not implicitly {@link appliancepb.ApplianceFiltersResponse.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.ApplianceFiltersResponse
     * @static
     * @param {appliancepb.IApplianceFiltersResponse} m ApplianceFiltersResponse message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ApplianceFiltersResponse.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (
        m.applianceType != null &&
        Object.hasOwnProperty.call(m, "applianceType")
      )
        w.uint32(10).string(m.applianceType);
      if (m.filters != null && m.filters.length) {
        for (var i = 0; i < m.filters.length; ++i)
          $root.appliancepb.ApplianceFilter.encode(
            m.filters[i],
            w.uint32(18).fork()
          ).ldelim();
      }
      return w;
    };

    /**
     * Decodes an ApplianceFiltersResponse message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.ApplianceFiltersResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.ApplianceFiltersResponse} ApplianceFiltersResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ApplianceFiltersResponse.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.ApplianceFiltersResponse();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.applianceType = r.string();
            break;
          case 2:
            if (!(m.filters && m.filters.length)) m.filters = [];
            m.filters.push(
              $root.appliancepb.ApplianceFilter.decode(r, r.uint32())
            );
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ApplianceFiltersResponse;
  })();

  appliancepb.ConfirmationResponse = (function () {
    /**
     * Properties of a ConfirmationResponse.
     * @memberof appliancepb
     * @interface IConfirmationResponse
     * @property {number|null} [basePrice] ConfirmationResponse basePrice
     * @property {number|null} [moveApplianceFee] ConfirmationResponse moveApplianceFee
     * @property {number|null} [disconnectFee] ConfirmationResponse disconnectFee
     * @property {number|null} [installFee] ConfirmationResponse installFee
     * @property {number|null} [deliveryFee] ConfirmationResponse deliveryFee
     * @property {number|null} [disposalFee] ConfirmationResponse disposalFee
     * @property {number|null} [taxes] ConfirmationResponse taxes
     * @property {number|null} [total] ConfirmationResponse total
     * @property {appliancepb.ConfirmationResponse.WarrantyMessage|null} [warrantyMessage] ConfirmationResponse warrantyMessage
     */

    /**
     * Constructs a new ConfirmationResponse.
     * @memberof appliancepb
     * @classdesc Represents a ConfirmationResponse.
     * @implements IConfirmationResponse
     * @constructor
     * @param {appliancepb.IConfirmationResponse=} [p] Properties to set
     */
    function ConfirmationResponse(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * ConfirmationResponse basePrice.
     * @member {number} basePrice
     * @memberof appliancepb.ConfirmationResponse
     * @instance
     */
    ConfirmationResponse.prototype.basePrice = 0;

    /**
     * ConfirmationResponse moveApplianceFee.
     * @member {number} moveApplianceFee
     * @memberof appliancepb.ConfirmationResponse
     * @instance
     */
    ConfirmationResponse.prototype.moveApplianceFee = 0;

    /**
     * ConfirmationResponse disconnectFee.
     * @member {number} disconnectFee
     * @memberof appliancepb.ConfirmationResponse
     * @instance
     */
    ConfirmationResponse.prototype.disconnectFee = 0;

    /**
     * ConfirmationResponse installFee.
     * @member {number} installFee
     * @memberof appliancepb.ConfirmationResponse
     * @instance
     */
    ConfirmationResponse.prototype.installFee = 0;

    /**
     * ConfirmationResponse deliveryFee.
     * @member {number} deliveryFee
     * @memberof appliancepb.ConfirmationResponse
     * @instance
     */
    ConfirmationResponse.prototype.deliveryFee = 0;

    /**
     * ConfirmationResponse disposalFee.
     * @member {number} disposalFee
     * @memberof appliancepb.ConfirmationResponse
     * @instance
     */
    ConfirmationResponse.prototype.disposalFee = 0;

    /**
     * ConfirmationResponse taxes.
     * @member {number} taxes
     * @memberof appliancepb.ConfirmationResponse
     * @instance
     */
    ConfirmationResponse.prototype.taxes = 0;

    /**
     * ConfirmationResponse total.
     * @member {number} total
     * @memberof appliancepb.ConfirmationResponse
     * @instance
     */
    ConfirmationResponse.prototype.total = 0;

    /**
     * ConfirmationResponse warrantyMessage.
     * @member {appliancepb.ConfirmationResponse.WarrantyMessage} warrantyMessage
     * @memberof appliancepb.ConfirmationResponse
     * @instance
     */
    ConfirmationResponse.prototype.warrantyMessage = 0;

    /**
     * Creates a new ConfirmationResponse instance using the specified properties.
     * @function create
     * @memberof appliancepb.ConfirmationResponse
     * @static
     * @param {appliancepb.IConfirmationResponse=} [properties] Properties to set
     * @returns {appliancepb.ConfirmationResponse} ConfirmationResponse instance
     */
    ConfirmationResponse.create = function create(properties) {
      return new ConfirmationResponse(properties);
    };

    /**
     * Encodes the specified ConfirmationResponse message. Does not implicitly {@link appliancepb.ConfirmationResponse.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.ConfirmationResponse
     * @static
     * @param {appliancepb.IConfirmationResponse} m ConfirmationResponse message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ConfirmationResponse.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.basePrice != null && Object.hasOwnProperty.call(m, "basePrice"))
        w.uint32(8).uint32(m.basePrice);
      if (
        m.moveApplianceFee != null &&
        Object.hasOwnProperty.call(m, "moveApplianceFee")
      )
        w.uint32(16).uint32(m.moveApplianceFee);
      if (
        m.disconnectFee != null &&
        Object.hasOwnProperty.call(m, "disconnectFee")
      )
        w.uint32(24).uint32(m.disconnectFee);
      if (m.installFee != null && Object.hasOwnProperty.call(m, "installFee"))
        w.uint32(32).uint32(m.installFee);
      if (m.deliveryFee != null && Object.hasOwnProperty.call(m, "deliveryFee"))
        w.uint32(40).uint32(m.deliveryFee);
      if (m.disposalFee != null && Object.hasOwnProperty.call(m, "disposalFee"))
        w.uint32(48).uint32(m.disposalFee);
      if (m.taxes != null && Object.hasOwnProperty.call(m, "taxes"))
        w.uint32(56).uint32(m.taxes);
      if (m.total != null && Object.hasOwnProperty.call(m, "total"))
        w.uint32(64).uint32(m.total);
      if (
        m.warrantyMessage != null &&
        Object.hasOwnProperty.call(m, "warrantyMessage")
      )
        w.uint32(72).int32(m.warrantyMessage);
      return w;
    };

    /**
     * Decodes a ConfirmationResponse message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.ConfirmationResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.ConfirmationResponse} ConfirmationResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ConfirmationResponse.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.ConfirmationResponse();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.basePrice = r.uint32();
            break;
          case 2:
            m.moveApplianceFee = r.uint32();
            break;
          case 3:
            m.disconnectFee = r.uint32();
            break;
          case 4:
            m.installFee = r.uint32();
            break;
          case 5:
            m.deliveryFee = r.uint32();
            break;
          case 6:
            m.disposalFee = r.uint32();
            break;
          case 7:
            m.taxes = r.uint32();
            break;
          case 8:
            m.total = r.uint32();
            break;
          case 9:
            m.warrantyMessage = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    /**
     * WarrantyMessage enum.
     * @name appliancepb.ConfirmationResponse.WarrantyMessage
     * @enum {number}
     * @property {number} WARRANTY_MESSAGE_UNSPECIFIED=0 WARRANTY_MESSAGE_UNSPECIFIED value
     * @property {number} WARRANTY_MESSAGE_COVERED=1 WARRANTY_MESSAGE_COVERED value
     * @property {number} WARRANTY_MESSAGE_INSTALLATION_OVER_3K=2 WARRANTY_MESSAGE_INSTALLATION_OVER_3K value
     * @property {number} WARRANTY_MESSAGE_INSTALLATION_PLATINUM_OVER_6K=3 WARRANTY_MESSAGE_INSTALLATION_PLATINUM_OVER_6K value
     */
    ConfirmationResponse.WarrantyMessage = (function () {
      const valuesById = {},
        values = Object.create(valuesById);
      values[(valuesById[0] = "WARRANTY_MESSAGE_UNSPECIFIED")] = 0;
      values[(valuesById[1] = "WARRANTY_MESSAGE_COVERED")] = 1;
      values[(valuesById[2] = "WARRANTY_MESSAGE_INSTALLATION_OVER_3K")] = 2;
      values[
        (valuesById[3] = "WARRANTY_MESSAGE_INSTALLATION_PLATINUM_OVER_6K")
      ] = 3;
      return values;
    })();

    return ConfirmationResponse;
  })();

  appliancepb.HealthCheck = (function () {
    /**
     * Properties of a HealthCheck.
     * @memberof appliancepb
     * @interface IHealthCheck
     * @property {string|null} [status] HealthCheck status
     * @property {string|null} [version] HealthCheck version
     * @property {string|null} [releaseID] HealthCheck releaseID
     * @property {Array.<string>|null} [notes] HealthCheck notes
     * @property {string|null} [output] HealthCheck output
     * @property {Array.<appliancepb.HealthCheck.INamedHealthCheckDetail>|null} [details] HealthCheck details
     */

    /**
     * Constructs a new HealthCheck.
     * @memberof appliancepb
     * @classdesc Represents a HealthCheck.
     * @implements IHealthCheck
     * @constructor
     * @param {appliancepb.IHealthCheck=} [p] Properties to set
     */
    function HealthCheck(p) {
      this.notes = [];
      this.details = [];
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * HealthCheck status.
     * @member {string} status
     * @memberof appliancepb.HealthCheck
     * @instance
     */
    HealthCheck.prototype.status = "";

    /**
     * HealthCheck version.
     * @member {string} version
     * @memberof appliancepb.HealthCheck
     * @instance
     */
    HealthCheck.prototype.version = "";

    /**
     * HealthCheck releaseID.
     * @member {string} releaseID
     * @memberof appliancepb.HealthCheck
     * @instance
     */
    HealthCheck.prototype.releaseID = "";

    /**
     * HealthCheck notes.
     * @member {Array.<string>} notes
     * @memberof appliancepb.HealthCheck
     * @instance
     */
    HealthCheck.prototype.notes = $util.emptyArray;

    /**
     * HealthCheck output.
     * @member {string} output
     * @memberof appliancepb.HealthCheck
     * @instance
     */
    HealthCheck.prototype.output = "";

    /**
     * HealthCheck details.
     * @member {Array.<appliancepb.HealthCheck.INamedHealthCheckDetail>} details
     * @memberof appliancepb.HealthCheck
     * @instance
     */
    HealthCheck.prototype.details = $util.emptyArray;

    /**
     * Creates a new HealthCheck instance using the specified properties.
     * @function create
     * @memberof appliancepb.HealthCheck
     * @static
     * @param {appliancepb.IHealthCheck=} [properties] Properties to set
     * @returns {appliancepb.HealthCheck} HealthCheck instance
     */
    HealthCheck.create = function create(properties) {
      return new HealthCheck(properties);
    };

    /**
     * Encodes the specified HealthCheck message. Does not implicitly {@link appliancepb.HealthCheck.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.HealthCheck
     * @static
     * @param {appliancepb.IHealthCheck} m HealthCheck message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    HealthCheck.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.status != null && Object.hasOwnProperty.call(m, "status"))
        w.uint32(10).string(m.status);
      if (m.version != null && Object.hasOwnProperty.call(m, "version"))
        w.uint32(18).string(m.version);
      if (m.releaseID != null && Object.hasOwnProperty.call(m, "releaseID"))
        w.uint32(26).string(m.releaseID);
      if (m.notes != null && m.notes.length) {
        for (var i = 0; i < m.notes.length; ++i)
          w.uint32(34).string(m.notes[i]);
      }
      if (m.output != null && Object.hasOwnProperty.call(m, "output"))
        w.uint32(42).string(m.output);
      if (m.details != null && m.details.length) {
        for (var i = 0; i < m.details.length; ++i)
          $root.appliancepb.HealthCheck.NamedHealthCheckDetail.encode(
            m.details[i],
            w.uint32(50).fork()
          ).ldelim();
      }
      return w;
    };

    /**
     * Decodes a HealthCheck message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.HealthCheck
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.HealthCheck} HealthCheck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    HealthCheck.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.HealthCheck();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.status = r.string();
            break;
          case 2:
            m.version = r.string();
            break;
          case 3:
            m.releaseID = r.string();
            break;
          case 4:
            if (!(m.notes && m.notes.length)) m.notes = [];
            m.notes.push(r.string());
            break;
          case 5:
            m.output = r.string();
            break;
          case 6:
            if (!(m.details && m.details.length)) m.details = [];
            m.details.push(
              $root.appliancepb.HealthCheck.NamedHealthCheckDetail.decode(
                r,
                r.uint32()
              )
            );
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    HealthCheck.NamedHealthCheckDetail = (function () {
      /**
       * Properties of a NamedHealthCheckDetail.
       * @memberof appliancepb.HealthCheck
       * @interface INamedHealthCheckDetail
       * @property {string|null} [name] NamedHealthCheckDetail name
       * @property {Array.<appliancepb.HealthCheck.NamedHealthCheckDetail.IHealthCheckDetail>|null} [details] NamedHealthCheckDetail details
       */

      /**
       * Constructs a new NamedHealthCheckDetail.
       * @memberof appliancepb.HealthCheck
       * @classdesc Represents a NamedHealthCheckDetail.
       * @implements INamedHealthCheckDetail
       * @constructor
       * @param {appliancepb.HealthCheck.INamedHealthCheckDetail=} [p] Properties to set
       */
      function NamedHealthCheckDetail(p) {
        this.details = [];
        if (p)
          for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
            if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
      }

      /**
       * NamedHealthCheckDetail name.
       * @member {string} name
       * @memberof appliancepb.HealthCheck.NamedHealthCheckDetail
       * @instance
       */
      NamedHealthCheckDetail.prototype.name = "";

      /**
       * NamedHealthCheckDetail details.
       * @member {Array.<appliancepb.HealthCheck.NamedHealthCheckDetail.IHealthCheckDetail>} details
       * @memberof appliancepb.HealthCheck.NamedHealthCheckDetail
       * @instance
       */
      NamedHealthCheckDetail.prototype.details = $util.emptyArray;

      /**
       * Creates a new NamedHealthCheckDetail instance using the specified properties.
       * @function create
       * @memberof appliancepb.HealthCheck.NamedHealthCheckDetail
       * @static
       * @param {appliancepb.HealthCheck.INamedHealthCheckDetail=} [properties] Properties to set
       * @returns {appliancepb.HealthCheck.NamedHealthCheckDetail} NamedHealthCheckDetail instance
       */
      NamedHealthCheckDetail.create = function create(properties) {
        return new NamedHealthCheckDetail(properties);
      };

      /**
       * Encodes the specified NamedHealthCheckDetail message. Does not implicitly {@link appliancepb.HealthCheck.NamedHealthCheckDetail.verify|verify} messages.
       * @function encode
       * @memberof appliancepb.HealthCheck.NamedHealthCheckDetail
       * @static
       * @param {appliancepb.HealthCheck.INamedHealthCheckDetail} m NamedHealthCheckDetail message or plain object to encode
       * @param {$protobuf.Writer} [w] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      NamedHealthCheckDetail.encode = function encode(m, w) {
        if (!w) w = $Writer.create();
        if (m.name != null && Object.hasOwnProperty.call(m, "name"))
          w.uint32(10).string(m.name);
        if (m.details != null && m.details.length) {
          for (var i = 0; i < m.details.length; ++i)
            $root.appliancepb.HealthCheck.NamedHealthCheckDetail.HealthCheckDetail.encode(
              m.details[i],
              w.uint32(18).fork()
            ).ldelim();
        }
        return w;
      };

      /**
       * Decodes a NamedHealthCheckDetail message from the specified reader or buffer.
       * @function decode
       * @memberof appliancepb.HealthCheck.NamedHealthCheckDetail
       * @static
       * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
       * @param {number} [l] Message length if known beforehand
       * @returns {appliancepb.HealthCheck.NamedHealthCheckDetail} NamedHealthCheckDetail
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      NamedHealthCheckDetail.decode = function decode(r, l) {
        if (!(r instanceof $Reader)) r = $Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l,
          m = new $root.appliancepb.HealthCheck.NamedHealthCheckDetail();
        while (r.pos < c) {
          var t = r.uint32();
          switch (t >>> 3) {
            case 1:
              m.name = r.string();
              break;
            case 2:
              if (!(m.details && m.details.length)) m.details = [];
              m.details.push(
                $root.appliancepb.HealthCheck.NamedHealthCheckDetail.HealthCheckDetail.decode(
                  r,
                  r.uint32()
                )
              );
              break;
            default:
              r.skipType(t & 7);
              break;
          }
        }
        return m;
      };

      NamedHealthCheckDetail.HealthCheckDetail = (function () {
        /**
         * Properties of a HealthCheckDetail.
         * @memberof appliancepb.HealthCheck.NamedHealthCheckDetail
         * @interface IHealthCheckDetail
         * @property {string|null} [componentID] HealthCheckDetail componentID
         * @property {string|null} [type] HealthCheckDetail type
         * @property {number|null} [observedValue] HealthCheckDetail observedValue
         * @property {string|null} [observedUnit] HealthCheckDetail observedUnit
         * @property {string|null} [status] HealthCheckDetail status
         * @property {google.protobuf.ITimestamp|null} [time] HealthCheckDetail time
         * @property {string|null} [output] HealthCheckDetail output
         */

        /**
         * Constructs a new HealthCheckDetail.
         * @memberof appliancepb.HealthCheck.NamedHealthCheckDetail
         * @classdesc Represents a HealthCheckDetail.
         * @implements IHealthCheckDetail
         * @constructor
         * @param {appliancepb.HealthCheck.NamedHealthCheckDetail.IHealthCheckDetail=} [p] Properties to set
         */
        function HealthCheckDetail(p) {
          if (p)
            for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
              if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
        }

        /**
         * HealthCheckDetail componentID.
         * @member {string} componentID
         * @memberof appliancepb.HealthCheck.NamedHealthCheckDetail.HealthCheckDetail
         * @instance
         */
        HealthCheckDetail.prototype.componentID = "";

        /**
         * HealthCheckDetail type.
         * @member {string} type
         * @memberof appliancepb.HealthCheck.NamedHealthCheckDetail.HealthCheckDetail
         * @instance
         */
        HealthCheckDetail.prototype.type = "";

        /**
         * HealthCheckDetail observedValue.
         * @member {number} observedValue
         * @memberof appliancepb.HealthCheck.NamedHealthCheckDetail.HealthCheckDetail
         * @instance
         */
        HealthCheckDetail.prototype.observedValue = 0;

        /**
         * HealthCheckDetail observedUnit.
         * @member {string} observedUnit
         * @memberof appliancepb.HealthCheck.NamedHealthCheckDetail.HealthCheckDetail
         * @instance
         */
        HealthCheckDetail.prototype.observedUnit = "";

        /**
         * HealthCheckDetail status.
         * @member {string} status
         * @memberof appliancepb.HealthCheck.NamedHealthCheckDetail.HealthCheckDetail
         * @instance
         */
        HealthCheckDetail.prototype.status = "";

        /**
         * HealthCheckDetail time.
         * @member {google.protobuf.ITimestamp|null|undefined} time
         * @memberof appliancepb.HealthCheck.NamedHealthCheckDetail.HealthCheckDetail
         * @instance
         */
        HealthCheckDetail.prototype.time = null;

        /**
         * HealthCheckDetail output.
         * @member {string} output
         * @memberof appliancepb.HealthCheck.NamedHealthCheckDetail.HealthCheckDetail
         * @instance
         */
        HealthCheckDetail.prototype.output = "";

        /**
         * Creates a new HealthCheckDetail instance using the specified properties.
         * @function create
         * @memberof appliancepb.HealthCheck.NamedHealthCheckDetail.HealthCheckDetail
         * @static
         * @param {appliancepb.HealthCheck.NamedHealthCheckDetail.IHealthCheckDetail=} [properties] Properties to set
         * @returns {appliancepb.HealthCheck.NamedHealthCheckDetail.HealthCheckDetail} HealthCheckDetail instance
         */
        HealthCheckDetail.create = function create(properties) {
          return new HealthCheckDetail(properties);
        };

        /**
         * Encodes the specified HealthCheckDetail message. Does not implicitly {@link appliancepb.HealthCheck.NamedHealthCheckDetail.HealthCheckDetail.verify|verify} messages.
         * @function encode
         * @memberof appliancepb.HealthCheck.NamedHealthCheckDetail.HealthCheckDetail
         * @static
         * @param {appliancepb.HealthCheck.NamedHealthCheckDetail.IHealthCheckDetail} m HealthCheckDetail message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        HealthCheckDetail.encode = function encode(m, w) {
          if (!w) w = $Writer.create();
          if (
            m.componentID != null &&
            Object.hasOwnProperty.call(m, "componentID")
          )
            w.uint32(10).string(m.componentID);
          if (m.type != null && Object.hasOwnProperty.call(m, "type"))
            w.uint32(18).string(m.type);
          if (
            m.observedValue != null &&
            Object.hasOwnProperty.call(m, "observedValue")
          )
            w.uint32(25).double(m.observedValue);
          if (
            m.observedUnit != null &&
            Object.hasOwnProperty.call(m, "observedUnit")
          )
            w.uint32(34).string(m.observedUnit);
          if (m.status != null && Object.hasOwnProperty.call(m, "status"))
            w.uint32(42).string(m.status);
          if (m.time != null && Object.hasOwnProperty.call(m, "time"))
            $root.google.protobuf.Timestamp.encode(
              m.time,
              w.uint32(50).fork()
            ).ldelim();
          if (m.output != null && Object.hasOwnProperty.call(m, "output"))
            w.uint32(58).string(m.output);
          return w;
        };

        /**
         * Decodes a HealthCheckDetail message from the specified reader or buffer.
         * @function decode
         * @memberof appliancepb.HealthCheck.NamedHealthCheckDetail.HealthCheckDetail
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {appliancepb.HealthCheck.NamedHealthCheckDetail.HealthCheckDetail} HealthCheckDetail
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        HealthCheckDetail.decode = function decode(r, l) {
          if (!(r instanceof $Reader)) r = $Reader.create(r);
          var c = l === undefined ? r.len : r.pos + l,
            m = new $root.appliancepb.HealthCheck.NamedHealthCheckDetail.HealthCheckDetail();
          while (r.pos < c) {
            var t = r.uint32();
            switch (t >>> 3) {
              case 1:
                m.componentID = r.string();
                break;
              case 2:
                m.type = r.string();
                break;
              case 3:
                m.observedValue = r.double();
                break;
              case 4:
                m.observedUnit = r.string();
                break;
              case 5:
                m.status = r.string();
                break;
              case 6:
                m.time = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                break;
              case 7:
                m.output = r.string();
                break;
              default:
                r.skipType(t & 7);
                break;
            }
          }
          return m;
        };

        return HealthCheckDetail;
      })();

      return NamedHealthCheckDetail;
    })();

    return HealthCheck;
  })();

  appliancepb.DeliveryInstructionsRequest = (function () {
    /**
     * Properties of a DeliveryInstructionsRequest.
     * @memberof appliancepb
     * @interface IDeliveryInstructionsRequest
     * @property {string|null} [deliveryInstructions] DeliveryInstructionsRequest deliveryInstructions
     * @property {boolean|null} [confirmedDimensions] DeliveryInstructionsRequest confirmedDimensions
     * @property {boolean|null} [agreesToTermsAndConditions] DeliveryInstructionsRequest agreesToTermsAndConditions
     */

    /**
     * Constructs a new DeliveryInstructionsRequest.
     * @memberof appliancepb
     * @classdesc Represents a DeliveryInstructionsRequest.
     * @implements IDeliveryInstructionsRequest
     * @constructor
     * @param {appliancepb.IDeliveryInstructionsRequest=} [p] Properties to set
     */
    function DeliveryInstructionsRequest(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * DeliveryInstructionsRequest deliveryInstructions.
     * @member {string} deliveryInstructions
     * @memberof appliancepb.DeliveryInstructionsRequest
     * @instance
     */
    DeliveryInstructionsRequest.prototype.deliveryInstructions = "";

    /**
     * DeliveryInstructionsRequest confirmedDimensions.
     * @member {boolean} confirmedDimensions
     * @memberof appliancepb.DeliveryInstructionsRequest
     * @instance
     */
    DeliveryInstructionsRequest.prototype.confirmedDimensions = false;

    /**
     * DeliveryInstructionsRequest agreesToTermsAndConditions.
     * @member {boolean} agreesToTermsAndConditions
     * @memberof appliancepb.DeliveryInstructionsRequest
     * @instance
     */
    DeliveryInstructionsRequest.prototype.agreesToTermsAndConditions = false;

    /**
     * Creates a new DeliveryInstructionsRequest instance using the specified properties.
     * @function create
     * @memberof appliancepb.DeliveryInstructionsRequest
     * @static
     * @param {appliancepb.IDeliveryInstructionsRequest=} [properties] Properties to set
     * @returns {appliancepb.DeliveryInstructionsRequest} DeliveryInstructionsRequest instance
     */
    DeliveryInstructionsRequest.create = function create(properties) {
      return new DeliveryInstructionsRequest(properties);
    };

    /**
     * Encodes the specified DeliveryInstructionsRequest message. Does not implicitly {@link appliancepb.DeliveryInstructionsRequest.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.DeliveryInstructionsRequest
     * @static
     * @param {appliancepb.IDeliveryInstructionsRequest} m DeliveryInstructionsRequest message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeliveryInstructionsRequest.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (
        m.deliveryInstructions != null &&
        Object.hasOwnProperty.call(m, "deliveryInstructions")
      )
        w.uint32(10).string(m.deliveryInstructions);
      if (
        m.confirmedDimensions != null &&
        Object.hasOwnProperty.call(m, "confirmedDimensions")
      )
        w.uint32(16).bool(m.confirmedDimensions);
      if (
        m.agreesToTermsAndConditions != null &&
        Object.hasOwnProperty.call(m, "agreesToTermsAndConditions")
      )
        w.uint32(24).bool(m.agreesToTermsAndConditions);
      return w;
    };

    /**
     * Decodes a DeliveryInstructionsRequest message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.DeliveryInstructionsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.DeliveryInstructionsRequest} DeliveryInstructionsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeliveryInstructionsRequest.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.DeliveryInstructionsRequest();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.deliveryInstructions = r.string();
            break;
          case 2:
            m.confirmedDimensions = r.bool();
            break;
          case 3:
            m.agreesToTermsAndConditions = r.bool();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return DeliveryInstructionsRequest;
  })();

  appliancepb.WorldpayPaymentDetails = (function () {
    /**
     * Properties of a WorldpayPaymentDetails.
     * @memberof appliancepb
     * @interface IWorldpayPaymentDetails
     * @property {string|null} [ID] WorldpayPaymentDetails ID
     * @property {string|null} [iframeToken] WorldpayPaymentDetails iframeToken
     * @property {string|null} [brand] WorldpayPaymentDetails brand
     * @property {string|null} [expMonth] WorldpayPaymentDetails expMonth
     * @property {string|null} [expYear] WorldpayPaymentDetails expYear
     * @property {string|null} [bin] WorldpayPaymentDetails bin
     * @property {string|null} [targetServer] WorldpayPaymentDetails targetServer
     * @property {string|null} [worldpayTxnID] WorldpayPaymentDetails worldpayTxnID
     * @property {string|null} [orderID] WorldpayPaymentDetails orderID
     * @property {string|null} [response] WorldpayPaymentDetails response
     * @property {string|null} [responseTime] WorldpayPaymentDetails responseTime
     * @property {string|null} [transactionMessage] WorldpayPaymentDetails transactionMessage
     * @property {string|null} [reportGroup] WorldpayPaymentDetails reportGroup
     * @property {string|null} [firstSix] WorldpayPaymentDetails firstSix
     * @property {string|null} [lastFour] WorldpayPaymentDetails lastFour
     * @property {boolean|null} [invokeMerchantCallback] WorldpayPaymentDetails invokeMerchantCallback
     */

    /**
     * Constructs a new WorldpayPaymentDetails.
     * @memberof appliancepb
     * @classdesc Represents a WorldpayPaymentDetails.
     * @implements IWorldpayPaymentDetails
     * @constructor
     * @param {appliancepb.IWorldpayPaymentDetails=} [p] Properties to set
     */
    function WorldpayPaymentDetails(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * WorldpayPaymentDetails ID.
     * @member {string} ID
     * @memberof appliancepb.WorldpayPaymentDetails
     * @instance
     */
    WorldpayPaymentDetails.prototype.ID = "";

    /**
     * WorldpayPaymentDetails iframeToken.
     * @member {string} iframeToken
     * @memberof appliancepb.WorldpayPaymentDetails
     * @instance
     */
    WorldpayPaymentDetails.prototype.iframeToken = "";

    /**
     * WorldpayPaymentDetails brand.
     * @member {string} brand
     * @memberof appliancepb.WorldpayPaymentDetails
     * @instance
     */
    WorldpayPaymentDetails.prototype.brand = "";

    /**
     * WorldpayPaymentDetails expMonth.
     * @member {string} expMonth
     * @memberof appliancepb.WorldpayPaymentDetails
     * @instance
     */
    WorldpayPaymentDetails.prototype.expMonth = "";

    /**
     * WorldpayPaymentDetails expYear.
     * @member {string} expYear
     * @memberof appliancepb.WorldpayPaymentDetails
     * @instance
     */
    WorldpayPaymentDetails.prototype.expYear = "";

    /**
     * WorldpayPaymentDetails bin.
     * @member {string} bin
     * @memberof appliancepb.WorldpayPaymentDetails
     * @instance
     */
    WorldpayPaymentDetails.prototype.bin = "";

    /**
     * WorldpayPaymentDetails targetServer.
     * @member {string} targetServer
     * @memberof appliancepb.WorldpayPaymentDetails
     * @instance
     */
    WorldpayPaymentDetails.prototype.targetServer = "";

    /**
     * WorldpayPaymentDetails worldpayTxnID.
     * @member {string} worldpayTxnID
     * @memberof appliancepb.WorldpayPaymentDetails
     * @instance
     */
    WorldpayPaymentDetails.prototype.worldpayTxnID = "";

    /**
     * WorldpayPaymentDetails orderID.
     * @member {string} orderID
     * @memberof appliancepb.WorldpayPaymentDetails
     * @instance
     */
    WorldpayPaymentDetails.prototype.orderID = "";

    /**
     * WorldpayPaymentDetails response.
     * @member {string} response
     * @memberof appliancepb.WorldpayPaymentDetails
     * @instance
     */
    WorldpayPaymentDetails.prototype.response = "";

    /**
     * WorldpayPaymentDetails responseTime.
     * @member {string} responseTime
     * @memberof appliancepb.WorldpayPaymentDetails
     * @instance
     */
    WorldpayPaymentDetails.prototype.responseTime = "";

    /**
     * WorldpayPaymentDetails transactionMessage.
     * @member {string} transactionMessage
     * @memberof appliancepb.WorldpayPaymentDetails
     * @instance
     */
    WorldpayPaymentDetails.prototype.transactionMessage = "";

    /**
     * WorldpayPaymentDetails reportGroup.
     * @member {string} reportGroup
     * @memberof appliancepb.WorldpayPaymentDetails
     * @instance
     */
    WorldpayPaymentDetails.prototype.reportGroup = "";

    /**
     * WorldpayPaymentDetails firstSix.
     * @member {string} firstSix
     * @memberof appliancepb.WorldpayPaymentDetails
     * @instance
     */
    WorldpayPaymentDetails.prototype.firstSix = "";

    /**
     * WorldpayPaymentDetails lastFour.
     * @member {string} lastFour
     * @memberof appliancepb.WorldpayPaymentDetails
     * @instance
     */
    WorldpayPaymentDetails.prototype.lastFour = "";

    /**
     * WorldpayPaymentDetails invokeMerchantCallback.
     * @member {boolean} invokeMerchantCallback
     * @memberof appliancepb.WorldpayPaymentDetails
     * @instance
     */
    WorldpayPaymentDetails.prototype.invokeMerchantCallback = false;

    /**
     * Creates a new WorldpayPaymentDetails instance using the specified properties.
     * @function create
     * @memberof appliancepb.WorldpayPaymentDetails
     * @static
     * @param {appliancepb.IWorldpayPaymentDetails=} [properties] Properties to set
     * @returns {appliancepb.WorldpayPaymentDetails} WorldpayPaymentDetails instance
     */
    WorldpayPaymentDetails.create = function create(properties) {
      return new WorldpayPaymentDetails(properties);
    };

    /**
     * Encodes the specified WorldpayPaymentDetails message. Does not implicitly {@link appliancepb.WorldpayPaymentDetails.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.WorldpayPaymentDetails
     * @static
     * @param {appliancepb.IWorldpayPaymentDetails} m WorldpayPaymentDetails message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WorldpayPaymentDetails.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
        w.uint32(10).string(m.ID);
      if (m.iframeToken != null && Object.hasOwnProperty.call(m, "iframeToken"))
        w.uint32(18).string(m.iframeToken);
      if (m.brand != null && Object.hasOwnProperty.call(m, "brand"))
        w.uint32(26).string(m.brand);
      if (m.expMonth != null && Object.hasOwnProperty.call(m, "expMonth"))
        w.uint32(34).string(m.expMonth);
      if (m.expYear != null && Object.hasOwnProperty.call(m, "expYear"))
        w.uint32(42).string(m.expYear);
      if (m.bin != null && Object.hasOwnProperty.call(m, "bin"))
        w.uint32(50).string(m.bin);
      if (
        m.targetServer != null &&
        Object.hasOwnProperty.call(m, "targetServer")
      )
        w.uint32(58).string(m.targetServer);
      if (
        m.worldpayTxnID != null &&
        Object.hasOwnProperty.call(m, "worldpayTxnID")
      )
        w.uint32(66).string(m.worldpayTxnID);
      if (m.orderID != null && Object.hasOwnProperty.call(m, "orderID"))
        w.uint32(74).string(m.orderID);
      if (m.response != null && Object.hasOwnProperty.call(m, "response"))
        w.uint32(82).string(m.response);
      if (
        m.responseTime != null &&
        Object.hasOwnProperty.call(m, "responseTime")
      )
        w.uint32(90).string(m.responseTime);
      if (
        m.transactionMessage != null &&
        Object.hasOwnProperty.call(m, "transactionMessage")
      )
        w.uint32(98).string(m.transactionMessage);
      if (m.reportGroup != null && Object.hasOwnProperty.call(m, "reportGroup"))
        w.uint32(106).string(m.reportGroup);
      if (m.firstSix != null && Object.hasOwnProperty.call(m, "firstSix"))
        w.uint32(114).string(m.firstSix);
      if (m.lastFour != null && Object.hasOwnProperty.call(m, "lastFour"))
        w.uint32(122).string(m.lastFour);
      if (
        m.invokeMerchantCallback != null &&
        Object.hasOwnProperty.call(m, "invokeMerchantCallback")
      )
        w.uint32(128).bool(m.invokeMerchantCallback);
      return w;
    };

    /**
     * Decodes a WorldpayPaymentDetails message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.WorldpayPaymentDetails
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.WorldpayPaymentDetails} WorldpayPaymentDetails
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WorldpayPaymentDetails.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.WorldpayPaymentDetails();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.ID = r.string();
            break;
          case 2:
            m.iframeToken = r.string();
            break;
          case 3:
            m.brand = r.string();
            break;
          case 4:
            m.expMonth = r.string();
            break;
          case 5:
            m.expYear = r.string();
            break;
          case 6:
            m.bin = r.string();
            break;
          case 7:
            m.targetServer = r.string();
            break;
          case 8:
            m.worldpayTxnID = r.string();
            break;
          case 9:
            m.orderID = r.string();
            break;
          case 10:
            m.response = r.string();
            break;
          case 11:
            m.responseTime = r.string();
            break;
          case 12:
            m.transactionMessage = r.string();
            break;
          case 13:
            m.reportGroup = r.string();
            break;
          case 14:
            m.firstSix = r.string();
            break;
          case 15:
            m.lastFour = r.string();
            break;
          case 16:
            m.invokeMerchantCallback = r.bool();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return WorldpayPaymentDetails;
  })();

  appliancepb.PaymentDetails = (function () {
    /**
     * Properties of a PaymentDetails.
     * @memberof appliancepb
     * @interface IPaymentDetails
     * @property {string|null} [ID] PaymentDetails ID
     * @property {string|null} [iframeToken] PaymentDetails iframeToken
     * @property {string|null} [brand] PaymentDetails brand
     * @property {string|null} [expMonth] PaymentDetails expMonth
     * @property {string|null} [expYear] PaymentDetails expYear
     * @property {string|null} [bin] PaymentDetails bin
     * @property {string|null} [targetServer] PaymentDetails targetServer
     * @property {string|null} [worldpayTxnID] PaymentDetails worldpayTxnID
     * @property {string|null} [orderID] PaymentDetails orderID
     * @property {string|null} [response] PaymentDetails response
     * @property {string|null} [responseTime] PaymentDetails responseTime
     * @property {string|null} [transactionMessage] PaymentDetails transactionMessage
     * @property {string|null} [reportGroup] PaymentDetails reportGroup
     * @property {string|null} [firstSix] PaymentDetails firstSix
     * @property {string|null} [lastFour] PaymentDetails lastFour
     * @property {boolean|null} [invokeMerchantCallback] PaymentDetails invokeMerchantCallback
     * @property {appliancepb.PaymentDetails.processor|null} [paymentProcessor] PaymentDetails paymentProcessor
     * @property {string|null} [country] PaymentDetails country
     * @property {appliancepb.IPriceSetter|null} [totalPrice] PaymentDetails totalPrice
     */

    /**
     * Constructs a new PaymentDetails.
     * @memberof appliancepb
     * @classdesc Represents a PaymentDetails.
     * @implements IPaymentDetails
     * @constructor
     * @param {appliancepb.IPaymentDetails=} [p] Properties to set
     */
    function PaymentDetails(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * PaymentDetails ID.
     * @member {string} ID
     * @memberof appliancepb.PaymentDetails
     * @instance
     */
    PaymentDetails.prototype.ID = "";

    /**
     * PaymentDetails iframeToken.
     * @member {string} iframeToken
     * @memberof appliancepb.PaymentDetails
     * @instance
     */
    PaymentDetails.prototype.iframeToken = "";

    /**
     * PaymentDetails brand.
     * @member {string} brand
     * @memberof appliancepb.PaymentDetails
     * @instance
     */
    PaymentDetails.prototype.brand = "";

    /**
     * PaymentDetails expMonth.
     * @member {string} expMonth
     * @memberof appliancepb.PaymentDetails
     * @instance
     */
    PaymentDetails.prototype.expMonth = "";

    /**
     * PaymentDetails expYear.
     * @member {string} expYear
     * @memberof appliancepb.PaymentDetails
     * @instance
     */
    PaymentDetails.prototype.expYear = "";

    /**
     * PaymentDetails bin.
     * @member {string} bin
     * @memberof appliancepb.PaymentDetails
     * @instance
     */
    PaymentDetails.prototype.bin = "";

    /**
     * PaymentDetails targetServer.
     * @member {string} targetServer
     * @memberof appliancepb.PaymentDetails
     * @instance
     */
    PaymentDetails.prototype.targetServer = "";

    /**
     * PaymentDetails worldpayTxnID.
     * @member {string} worldpayTxnID
     * @memberof appliancepb.PaymentDetails
     * @instance
     */
    PaymentDetails.prototype.worldpayTxnID = "";

    /**
     * PaymentDetails orderID.
     * @member {string} orderID
     * @memberof appliancepb.PaymentDetails
     * @instance
     */
    PaymentDetails.prototype.orderID = "";

    /**
     * PaymentDetails response.
     * @member {string} response
     * @memberof appliancepb.PaymentDetails
     * @instance
     */
    PaymentDetails.prototype.response = "";

    /**
     * PaymentDetails responseTime.
     * @member {string} responseTime
     * @memberof appliancepb.PaymentDetails
     * @instance
     */
    PaymentDetails.prototype.responseTime = "";

    /**
     * PaymentDetails transactionMessage.
     * @member {string} transactionMessage
     * @memberof appliancepb.PaymentDetails
     * @instance
     */
    PaymentDetails.prototype.transactionMessage = "";

    /**
     * PaymentDetails reportGroup.
     * @member {string} reportGroup
     * @memberof appliancepb.PaymentDetails
     * @instance
     */
    PaymentDetails.prototype.reportGroup = "";

    /**
     * PaymentDetails firstSix.
     * @member {string} firstSix
     * @memberof appliancepb.PaymentDetails
     * @instance
     */
    PaymentDetails.prototype.firstSix = "";

    /**
     * PaymentDetails lastFour.
     * @member {string} lastFour
     * @memberof appliancepb.PaymentDetails
     * @instance
     */
    PaymentDetails.prototype.lastFour = "";

    /**
     * PaymentDetails invokeMerchantCallback.
     * @member {boolean} invokeMerchantCallback
     * @memberof appliancepb.PaymentDetails
     * @instance
     */
    PaymentDetails.prototype.invokeMerchantCallback = false;

    /**
     * PaymentDetails paymentProcessor.
     * @member {appliancepb.PaymentDetails.processor} paymentProcessor
     * @memberof appliancepb.PaymentDetails
     * @instance
     */
    PaymentDetails.prototype.paymentProcessor = 0;

    /**
     * PaymentDetails country.
     * @member {string} country
     * @memberof appliancepb.PaymentDetails
     * @instance
     */
    PaymentDetails.prototype.country = "";

    /**
     * PaymentDetails totalPrice.
     * @member {appliancepb.IPriceSetter|null|undefined} totalPrice
     * @memberof appliancepb.PaymentDetails
     * @instance
     */
    PaymentDetails.prototype.totalPrice = null;

    /**
     * Creates a new PaymentDetails instance using the specified properties.
     * @function create
     * @memberof appliancepb.PaymentDetails
     * @static
     * @param {appliancepb.IPaymentDetails=} [properties] Properties to set
     * @returns {appliancepb.PaymentDetails} PaymentDetails instance
     */
    PaymentDetails.create = function create(properties) {
      return new PaymentDetails(properties);
    };

    /**
     * Encodes the specified PaymentDetails message. Does not implicitly {@link appliancepb.PaymentDetails.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.PaymentDetails
     * @static
     * @param {appliancepb.IPaymentDetails} m PaymentDetails message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PaymentDetails.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
        w.uint32(10).string(m.ID);
      if (m.iframeToken != null && Object.hasOwnProperty.call(m, "iframeToken"))
        w.uint32(18).string(m.iframeToken);
      if (m.brand != null && Object.hasOwnProperty.call(m, "brand"))
        w.uint32(26).string(m.brand);
      if (m.expMonth != null && Object.hasOwnProperty.call(m, "expMonth"))
        w.uint32(34).string(m.expMonth);
      if (m.expYear != null && Object.hasOwnProperty.call(m, "expYear"))
        w.uint32(42).string(m.expYear);
      if (m.bin != null && Object.hasOwnProperty.call(m, "bin"))
        w.uint32(50).string(m.bin);
      if (
        m.targetServer != null &&
        Object.hasOwnProperty.call(m, "targetServer")
      )
        w.uint32(58).string(m.targetServer);
      if (
        m.worldpayTxnID != null &&
        Object.hasOwnProperty.call(m, "worldpayTxnID")
      )
        w.uint32(66).string(m.worldpayTxnID);
      if (m.orderID != null && Object.hasOwnProperty.call(m, "orderID"))
        w.uint32(74).string(m.orderID);
      if (m.response != null && Object.hasOwnProperty.call(m, "response"))
        w.uint32(82).string(m.response);
      if (
        m.responseTime != null &&
        Object.hasOwnProperty.call(m, "responseTime")
      )
        w.uint32(90).string(m.responseTime);
      if (
        m.transactionMessage != null &&
        Object.hasOwnProperty.call(m, "transactionMessage")
      )
        w.uint32(98).string(m.transactionMessage);
      if (m.reportGroup != null && Object.hasOwnProperty.call(m, "reportGroup"))
        w.uint32(106).string(m.reportGroup);
      if (m.firstSix != null && Object.hasOwnProperty.call(m, "firstSix"))
        w.uint32(114).string(m.firstSix);
      if (m.lastFour != null && Object.hasOwnProperty.call(m, "lastFour"))
        w.uint32(122).string(m.lastFour);
      if (
        m.invokeMerchantCallback != null &&
        Object.hasOwnProperty.call(m, "invokeMerchantCallback")
      )
        w.uint32(128).bool(m.invokeMerchantCallback);
      if (
        m.paymentProcessor != null &&
        Object.hasOwnProperty.call(m, "paymentProcessor")
      )
        w.uint32(160).int32(m.paymentProcessor);
      if (m.country != null && Object.hasOwnProperty.call(m, "country"))
        w.uint32(242).string(m.country);
      if (m.totalPrice != null && Object.hasOwnProperty.call(m, "totalPrice"))
        $root.appliancepb.PriceSetter.encode(
          m.totalPrice,
          w.uint32(250).fork()
        ).ldelim();
      return w;
    };

    /**
     * Decodes a PaymentDetails message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.PaymentDetails
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.PaymentDetails} PaymentDetails
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PaymentDetails.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.PaymentDetails();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.ID = r.string();
            break;
          case 2:
            m.iframeToken = r.string();
            break;
          case 3:
            m.brand = r.string();
            break;
          case 4:
            m.expMonth = r.string();
            break;
          case 5:
            m.expYear = r.string();
            break;
          case 6:
            m.bin = r.string();
            break;
          case 7:
            m.targetServer = r.string();
            break;
          case 8:
            m.worldpayTxnID = r.string();
            break;
          case 9:
            m.orderID = r.string();
            break;
          case 10:
            m.response = r.string();
            break;
          case 11:
            m.responseTime = r.string();
            break;
          case 12:
            m.transactionMessage = r.string();
            break;
          case 13:
            m.reportGroup = r.string();
            break;
          case 14:
            m.firstSix = r.string();
            break;
          case 15:
            m.lastFour = r.string();
            break;
          case 16:
            m.invokeMerchantCallback = r.bool();
            break;
          case 20:
            m.paymentProcessor = r.int32();
            break;
          case 30:
            m.country = r.string();
            break;
          case 31:
            m.totalPrice = $root.appliancepb.PriceSetter.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    /**
     * processor enum.
     * @name appliancepb.PaymentDetails.processor
     * @enum {number}
     * @property {number} WORLDPAY=0 WORLDPAY value
     * @property {number} STRIPE=1 STRIPE value
     */
    PaymentDetails.processor = (function () {
      const valuesById = {},
        values = Object.create(valuesById);
      values[(valuesById[0] = "WORLDPAY")] = 0;
      values[(valuesById[1] = "STRIPE")] = 1;
      return values;
    })();

    return PaymentDetails;
  })();

  appliancepb.Payment = (function () {
    /**
     * Properties of a Payment.
     * @memberof appliancepb
     * @interface IPayment
     * @property {string|null} [ID] Payment ID
     * @property {appliancepb.IPaymentDetails|null} [paymentDetails] Payment paymentDetails
     * @property {google.protobuf.ITimestamp|null} [created] Payment created
     * @property {google.protobuf.ITimestamp|null} [updated] Payment updated
     * @property {string|null} [location] Payment location
     */

    /**
     * Constructs a new Payment.
     * @memberof appliancepb
     * @classdesc Represents a Payment.
     * @implements IPayment
     * @constructor
     * @param {appliancepb.IPayment=} [p] Properties to set
     */
    function Payment(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * Payment ID.
     * @member {string} ID
     * @memberof appliancepb.Payment
     * @instance
     */
    Payment.prototype.ID = "";

    /**
     * Payment paymentDetails.
     * @member {appliancepb.IPaymentDetails|null|undefined} paymentDetails
     * @memberof appliancepb.Payment
     * @instance
     */
    Payment.prototype.paymentDetails = null;

    /**
     * Payment created.
     * @member {google.protobuf.ITimestamp|null|undefined} created
     * @memberof appliancepb.Payment
     * @instance
     */
    Payment.prototype.created = null;

    /**
     * Payment updated.
     * @member {google.protobuf.ITimestamp|null|undefined} updated
     * @memberof appliancepb.Payment
     * @instance
     */
    Payment.prototype.updated = null;

    /**
     * Payment location.
     * @member {string} location
     * @memberof appliancepb.Payment
     * @instance
     */
    Payment.prototype.location = "";

    /**
     * Creates a new Payment instance using the specified properties.
     * @function create
     * @memberof appliancepb.Payment
     * @static
     * @param {appliancepb.IPayment=} [properties] Properties to set
     * @returns {appliancepb.Payment} Payment instance
     */
    Payment.create = function create(properties) {
      return new Payment(properties);
    };

    /**
     * Encodes the specified Payment message. Does not implicitly {@link appliancepb.Payment.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.Payment
     * @static
     * @param {appliancepb.IPayment} m Payment message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Payment.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
        w.uint32(10).string(m.ID);
      if (
        m.paymentDetails != null &&
        Object.hasOwnProperty.call(m, "paymentDetails")
      )
        $root.appliancepb.PaymentDetails.encode(
          m.paymentDetails,
          w.uint32(18).fork()
        ).ldelim();
      if (m.created != null && Object.hasOwnProperty.call(m, "created"))
        $root.google.protobuf.Timestamp.encode(
          m.created,
          w.uint32(26).fork()
        ).ldelim();
      if (m.updated != null && Object.hasOwnProperty.call(m, "updated"))
        $root.google.protobuf.Timestamp.encode(
          m.updated,
          w.uint32(34).fork()
        ).ldelim();
      if (m.location != null && Object.hasOwnProperty.call(m, "location"))
        w.uint32(42).string(m.location);
      return w;
    };

    /**
     * Decodes a Payment message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.Payment
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.Payment} Payment
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Payment.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.Payment();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.ID = r.string();
            break;
          case 2:
            m.paymentDetails = $root.appliancepb.PaymentDetails.decode(
              r,
              r.uint32()
            );
            break;
          case 3:
            m.created = $root.google.protobuf.Timestamp.decode(r, r.uint32());
            break;
          case 4:
            m.updated = $root.google.protobuf.Timestamp.decode(r, r.uint32());
            break;
          case 5:
            m.location = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return Payment;
  })();

  appliancepb.PostPurchaseRequest = (function () {
    /**
     * Properties of a PostPurchaseRequest.
     * @memberof appliancepb
     * @interface IPostPurchaseRequest
     * @property {string|null} [deliveryInstructions] PostPurchaseRequest deliveryInstructions
     * @property {boolean|null} [confirmedDimensions] PostPurchaseRequest confirmedDimensions
     * @property {boolean|null} [agreesToTermsAndConditions] PostPurchaseRequest agreesToTermsAndConditions
     * @property {appliancepb.IWorldpayPaymentDetails|null} [worldpayPaymentDetails] PostPurchaseRequest worldpayPaymentDetails
     * @property {appliancepb.IPaymentDetails|null} [paymentDetails] PostPurchaseRequest paymentDetails
     */

    /**
     * Constructs a new PostPurchaseRequest.
     * @memberof appliancepb
     * @classdesc Represents a PostPurchaseRequest.
     * @implements IPostPurchaseRequest
     * @constructor
     * @param {appliancepb.IPostPurchaseRequest=} [p] Properties to set
     */
    function PostPurchaseRequest(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * PostPurchaseRequest deliveryInstructions.
     * @member {string} deliveryInstructions
     * @memberof appliancepb.PostPurchaseRequest
     * @instance
     */
    PostPurchaseRequest.prototype.deliveryInstructions = "";

    /**
     * PostPurchaseRequest confirmedDimensions.
     * @member {boolean} confirmedDimensions
     * @memberof appliancepb.PostPurchaseRequest
     * @instance
     */
    PostPurchaseRequest.prototype.confirmedDimensions = false;

    /**
     * PostPurchaseRequest agreesToTermsAndConditions.
     * @member {boolean} agreesToTermsAndConditions
     * @memberof appliancepb.PostPurchaseRequest
     * @instance
     */
    PostPurchaseRequest.prototype.agreesToTermsAndConditions = false;

    /**
     * PostPurchaseRequest worldpayPaymentDetails.
     * @member {appliancepb.IWorldpayPaymentDetails|null|undefined} worldpayPaymentDetails
     * @memberof appliancepb.PostPurchaseRequest
     * @instance
     */
    PostPurchaseRequest.prototype.worldpayPaymentDetails = null;

    /**
     * PostPurchaseRequest paymentDetails.
     * @member {appliancepb.IPaymentDetails|null|undefined} paymentDetails
     * @memberof appliancepb.PostPurchaseRequest
     * @instance
     */
    PostPurchaseRequest.prototype.paymentDetails = null;

    /**
     * Creates a new PostPurchaseRequest instance using the specified properties.
     * @function create
     * @memberof appliancepb.PostPurchaseRequest
     * @static
     * @param {appliancepb.IPostPurchaseRequest=} [properties] Properties to set
     * @returns {appliancepb.PostPurchaseRequest} PostPurchaseRequest instance
     */
    PostPurchaseRequest.create = function create(properties) {
      return new PostPurchaseRequest(properties);
    };

    /**
     * Encodes the specified PostPurchaseRequest message. Does not implicitly {@link appliancepb.PostPurchaseRequest.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.PostPurchaseRequest
     * @static
     * @param {appliancepb.IPostPurchaseRequest} m PostPurchaseRequest message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PostPurchaseRequest.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (
        m.deliveryInstructions != null &&
        Object.hasOwnProperty.call(m, "deliveryInstructions")
      )
        w.uint32(10).string(m.deliveryInstructions);
      if (
        m.confirmedDimensions != null &&
        Object.hasOwnProperty.call(m, "confirmedDimensions")
      )
        w.uint32(16).bool(m.confirmedDimensions);
      if (
        m.agreesToTermsAndConditions != null &&
        Object.hasOwnProperty.call(m, "agreesToTermsAndConditions")
      )
        w.uint32(24).bool(m.agreesToTermsAndConditions);
      if (
        m.worldpayPaymentDetails != null &&
        Object.hasOwnProperty.call(m, "worldpayPaymentDetails")
      )
        $root.appliancepb.WorldpayPaymentDetails.encode(
          m.worldpayPaymentDetails,
          w.uint32(34).fork()
        ).ldelim();
      if (
        m.paymentDetails != null &&
        Object.hasOwnProperty.call(m, "paymentDetails")
      )
        $root.appliancepb.PaymentDetails.encode(
          m.paymentDetails,
          w.uint32(42).fork()
        ).ldelim();
      return w;
    };

    /**
     * Decodes a PostPurchaseRequest message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.PostPurchaseRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.PostPurchaseRequest} PostPurchaseRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PostPurchaseRequest.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.PostPurchaseRequest();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.deliveryInstructions = r.string();
            break;
          case 2:
            m.confirmedDimensions = r.bool();
            break;
          case 3:
            m.agreesToTermsAndConditions = r.bool();
            break;
          case 4:
            m.worldpayPaymentDetails = $root.appliancepb.WorldpayPaymentDetails.decode(
              r,
              r.uint32()
            );
            break;
          case 5:
            m.paymentDetails = $root.appliancepb.PaymentDetails.decode(
              r,
              r.uint32()
            );
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return PostPurchaseRequest;
  })();

  appliancepb.HealthCheckResponse = (function () {
    /**
     * Properties of a HealthCheckResponse.
     * @memberof appliancepb
     * @interface IHealthCheckResponse
     * @property {appliancepb.IHealthCheck|null} [health] HealthCheckResponse health
     */

    /**
     * Constructs a new HealthCheckResponse.
     * @memberof appliancepb
     * @classdesc Represents a HealthCheckResponse.
     * @implements IHealthCheckResponse
     * @constructor
     * @param {appliancepb.IHealthCheckResponse=} [p] Properties to set
     */
    function HealthCheckResponse(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * HealthCheckResponse health.
     * @member {appliancepb.IHealthCheck|null|undefined} health
     * @memberof appliancepb.HealthCheckResponse
     * @instance
     */
    HealthCheckResponse.prototype.health = null;

    /**
     * Creates a new HealthCheckResponse instance using the specified properties.
     * @function create
     * @memberof appliancepb.HealthCheckResponse
     * @static
     * @param {appliancepb.IHealthCheckResponse=} [properties] Properties to set
     * @returns {appliancepb.HealthCheckResponse} HealthCheckResponse instance
     */
    HealthCheckResponse.create = function create(properties) {
      return new HealthCheckResponse(properties);
    };

    /**
     * Encodes the specified HealthCheckResponse message. Does not implicitly {@link appliancepb.HealthCheckResponse.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.HealthCheckResponse
     * @static
     * @param {appliancepb.IHealthCheckResponse} m HealthCheckResponse message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    HealthCheckResponse.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.health != null && Object.hasOwnProperty.call(m, "health"))
        $root.appliancepb.HealthCheck.encode(
          m.health,
          w.uint32(10).fork()
        ).ldelim();
      return w;
    };

    /**
     * Decodes a HealthCheckResponse message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.HealthCheckResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.HealthCheckResponse} HealthCheckResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    HealthCheckResponse.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.HealthCheckResponse();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.health = $root.appliancepb.HealthCheck.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return HealthCheckResponse;
  })();

  appliancepb.Installer = (function () {
    /**
     * Properties of an Installer.
     * @memberof appliancepb
     * @interface IInstaller
     * @property {string|null} [name] Installer name
     * @property {string|null} [phone] Installer phone
     * @property {string|null} [street1] Installer street1
     * @property {string|null} [street2] Installer street2
     * @property {string|null} [city] Installer city
     * @property {string|null} [state] Installer state
     * @property {string|null} [zip] Installer zip
     */

    /**
     * Constructs a new Installer.
     * @memberof appliancepb
     * @classdesc Represents an Installer.
     * @implements IInstaller
     * @constructor
     * @param {appliancepb.IInstaller=} [p] Properties to set
     */
    function Installer(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * Installer name.
     * @member {string} name
     * @memberof appliancepb.Installer
     * @instance
     */
    Installer.prototype.name = "";

    /**
     * Installer phone.
     * @member {string} phone
     * @memberof appliancepb.Installer
     * @instance
     */
    Installer.prototype.phone = "";

    /**
     * Installer street1.
     * @member {string} street1
     * @memberof appliancepb.Installer
     * @instance
     */
    Installer.prototype.street1 = "";

    /**
     * Installer street2.
     * @member {string} street2
     * @memberof appliancepb.Installer
     * @instance
     */
    Installer.prototype.street2 = "";

    /**
     * Installer city.
     * @member {string} city
     * @memberof appliancepb.Installer
     * @instance
     */
    Installer.prototype.city = "";

    /**
     * Installer state.
     * @member {string} state
     * @memberof appliancepb.Installer
     * @instance
     */
    Installer.prototype.state = "";

    /**
     * Installer zip.
     * @member {string} zip
     * @memberof appliancepb.Installer
     * @instance
     */
    Installer.prototype.zip = "";

    /**
     * Creates a new Installer instance using the specified properties.
     * @function create
     * @memberof appliancepb.Installer
     * @static
     * @param {appliancepb.IInstaller=} [properties] Properties to set
     * @returns {appliancepb.Installer} Installer instance
     */
    Installer.create = function create(properties) {
      return new Installer(properties);
    };

    /**
     * Encodes the specified Installer message. Does not implicitly {@link appliancepb.Installer.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.Installer
     * @static
     * @param {appliancepb.IInstaller} m Installer message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Installer.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.name != null && Object.hasOwnProperty.call(m, "name"))
        w.uint32(10).string(m.name);
      if (m.phone != null && Object.hasOwnProperty.call(m, "phone"))
        w.uint32(18).string(m.phone);
      if (m.street1 != null && Object.hasOwnProperty.call(m, "street1"))
        w.uint32(26).string(m.street1);
      if (m.street2 != null && Object.hasOwnProperty.call(m, "street2"))
        w.uint32(34).string(m.street2);
      if (m.city != null && Object.hasOwnProperty.call(m, "city"))
        w.uint32(42).string(m.city);
      if (m.state != null && Object.hasOwnProperty.call(m, "state"))
        w.uint32(50).string(m.state);
      if (m.zip != null && Object.hasOwnProperty.call(m, "zip"))
        w.uint32(58).string(m.zip);
      return w;
    };

    /**
     * Decodes an Installer message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.Installer
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.Installer} Installer
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Installer.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.Installer();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.name = r.string();
            break;
          case 2:
            m.phone = r.string();
            break;
          case 3:
            m.street1 = r.string();
            break;
          case 4:
            m.street2 = r.string();
            break;
          case 5:
            m.city = r.string();
            break;
          case 6:
            m.state = r.string();
            break;
          case 7:
            m.zip = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return Installer;
  })();

  appliancepb.Address = (function () {
    /**
     * Properties of an Address.
     * @memberof appliancepb
     * @interface IAddress
     * @property {string|null} [street1] Address street1
     * @property {string|null} [street2] Address street2
     * @property {string|null} [unitType] Address unitType
     * @property {string|null} [unitValue] Address unitValue
     * @property {string|null} [city] Address city
     * @property {string|null} [state] Address state
     * @property {string|null} [zip] Address zip
     * @property {string|null} [zipLocal] Address zipLocal
     * @property {string|null} [countryISO3] Address countryISO3
     * @property {string|null} [id] Address id
     */

    /**
     * Constructs a new Address.
     * @memberof appliancepb
     * @classdesc Represents an Address.
     * @implements IAddress
     * @constructor
     * @param {appliancepb.IAddress=} [p] Properties to set
     */
    function Address(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * Address street1.
     * @member {string} street1
     * @memberof appliancepb.Address
     * @instance
     */
    Address.prototype.street1 = "";

    /**
     * Address street2.
     * @member {string} street2
     * @memberof appliancepb.Address
     * @instance
     */
    Address.prototype.street2 = "";

    /**
     * Address unitType.
     * @member {string} unitType
     * @memberof appliancepb.Address
     * @instance
     */
    Address.prototype.unitType = "";

    /**
     * Address unitValue.
     * @member {string} unitValue
     * @memberof appliancepb.Address
     * @instance
     */
    Address.prototype.unitValue = "";

    /**
     * Address city.
     * @member {string} city
     * @memberof appliancepb.Address
     * @instance
     */
    Address.prototype.city = "";

    /**
     * Address state.
     * @member {string} state
     * @memberof appliancepb.Address
     * @instance
     */
    Address.prototype.state = "";

    /**
     * Address zip.
     * @member {string} zip
     * @memberof appliancepb.Address
     * @instance
     */
    Address.prototype.zip = "";

    /**
     * Address zipLocal.
     * @member {string} zipLocal
     * @memberof appliancepb.Address
     * @instance
     */
    Address.prototype.zipLocal = "";

    /**
     * Address countryISO3.
     * @member {string} countryISO3
     * @memberof appliancepb.Address
     * @instance
     */
    Address.prototype.countryISO3 = "";

    /**
     * Address id.
     * @member {string} id
     * @memberof appliancepb.Address
     * @instance
     */
    Address.prototype.id = "";

    /**
     * Creates a new Address instance using the specified properties.
     * @function create
     * @memberof appliancepb.Address
     * @static
     * @param {appliancepb.IAddress=} [properties] Properties to set
     * @returns {appliancepb.Address} Address instance
     */
    Address.create = function create(properties) {
      return new Address(properties);
    };

    /**
     * Encodes the specified Address message. Does not implicitly {@link appliancepb.Address.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.Address
     * @static
     * @param {appliancepb.IAddress} m Address message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Address.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.street1 != null && Object.hasOwnProperty.call(m, "street1"))
        w.uint32(10).string(m.street1);
      if (m.street2 != null && Object.hasOwnProperty.call(m, "street2"))
        w.uint32(18).string(m.street2);
      if (m.unitType != null && Object.hasOwnProperty.call(m, "unitType"))
        w.uint32(26).string(m.unitType);
      if (m.unitValue != null && Object.hasOwnProperty.call(m, "unitValue"))
        w.uint32(34).string(m.unitValue);
      if (m.city != null && Object.hasOwnProperty.call(m, "city"))
        w.uint32(42).string(m.city);
      if (m.state != null && Object.hasOwnProperty.call(m, "state"))
        w.uint32(50).string(m.state);
      if (m.zip != null && Object.hasOwnProperty.call(m, "zip"))
        w.uint32(58).string(m.zip);
      if (m.zipLocal != null && Object.hasOwnProperty.call(m, "zipLocal"))
        w.uint32(66).string(m.zipLocal);
      if (m.countryISO3 != null && Object.hasOwnProperty.call(m, "countryISO3"))
        w.uint32(74).string(m.countryISO3);
      if (m.id != null && Object.hasOwnProperty.call(m, "id"))
        w.uint32(82).string(m.id);
      return w;
    };

    /**
     * Decodes an Address message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.Address
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.Address} Address
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Address.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.Address();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.street1 = r.string();
            break;
          case 2:
            m.street2 = r.string();
            break;
          case 3:
            m.unitType = r.string();
            break;
          case 4:
            m.unitValue = r.string();
            break;
          case 5:
            m.city = r.string();
            break;
          case 6:
            m.state = r.string();
            break;
          case 7:
            m.zip = r.string();
            break;
          case 8:
            m.zipLocal = r.string();
            break;
          case 9:
            m.countryISO3 = r.string();
            break;
          case 10:
            m.id = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return Address;
  })();

  appliancepb.Customer = (function () {
    /**
     * Properties of a Customer.
     * @memberof appliancepb
     * @interface ICustomer
     * @property {string|null} [firstName] Customer firstName
     * @property {string|null} [lastName] Customer lastName
     * @property {string|null} [email] Customer email
     * @property {string|null} [phone] Customer phone
     * @property {appliancepb.IAddress|null} [deliveryAddress] Customer deliveryAddress
     * @property {string|null} [businessName] Customer businessName
     * @property {appliancepb.IAddress|null} [billingAddress] Customer billingAddress
     * @property {string|null} [id] Customer id
     */

    /**
     * Constructs a new Customer.
     * @memberof appliancepb
     * @classdesc Represents a Customer.
     * @implements ICustomer
     * @constructor
     * @param {appliancepb.ICustomer=} [p] Properties to set
     */
    function Customer(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * Customer firstName.
     * @member {string} firstName
     * @memberof appliancepb.Customer
     * @instance
     */
    Customer.prototype.firstName = "";

    /**
     * Customer lastName.
     * @member {string} lastName
     * @memberof appliancepb.Customer
     * @instance
     */
    Customer.prototype.lastName = "";

    /**
     * Customer email.
     * @member {string} email
     * @memberof appliancepb.Customer
     * @instance
     */
    Customer.prototype.email = "";

    /**
     * Customer phone.
     * @member {string} phone
     * @memberof appliancepb.Customer
     * @instance
     */
    Customer.prototype.phone = "";

    /**
     * Customer deliveryAddress.
     * @member {appliancepb.IAddress|null|undefined} deliveryAddress
     * @memberof appliancepb.Customer
     * @instance
     */
    Customer.prototype.deliveryAddress = null;

    /**
     * Customer businessName.
     * @member {string} businessName
     * @memberof appliancepb.Customer
     * @instance
     */
    Customer.prototype.businessName = "";

    /**
     * Customer billingAddress.
     * @member {appliancepb.IAddress|null|undefined} billingAddress
     * @memberof appliancepb.Customer
     * @instance
     */
    Customer.prototype.billingAddress = null;

    /**
     * Customer id.
     * @member {string} id
     * @memberof appliancepb.Customer
     * @instance
     */
    Customer.prototype.id = "";

    /**
     * Creates a new Customer instance using the specified properties.
     * @function create
     * @memberof appliancepb.Customer
     * @static
     * @param {appliancepb.ICustomer=} [properties] Properties to set
     * @returns {appliancepb.Customer} Customer instance
     */
    Customer.create = function create(properties) {
      return new Customer(properties);
    };

    /**
     * Encodes the specified Customer message. Does not implicitly {@link appliancepb.Customer.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.Customer
     * @static
     * @param {appliancepb.ICustomer} m Customer message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Customer.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.firstName != null && Object.hasOwnProperty.call(m, "firstName"))
        w.uint32(10).string(m.firstName);
      if (m.lastName != null && Object.hasOwnProperty.call(m, "lastName"))
        w.uint32(18).string(m.lastName);
      if (m.email != null && Object.hasOwnProperty.call(m, "email"))
        w.uint32(26).string(m.email);
      if (m.phone != null && Object.hasOwnProperty.call(m, "phone"))
        w.uint32(34).string(m.phone);
      if (
        m.deliveryAddress != null &&
        Object.hasOwnProperty.call(m, "deliveryAddress")
      )
        $root.appliancepb.Address.encode(
          m.deliveryAddress,
          w.uint32(42).fork()
        ).ldelim();
      if (
        m.businessName != null &&
        Object.hasOwnProperty.call(m, "businessName")
      )
        w.uint32(50).string(m.businessName);
      if (
        m.billingAddress != null &&
        Object.hasOwnProperty.call(m, "billingAddress")
      )
        $root.appliancepb.Address.encode(
          m.billingAddress,
          w.uint32(58).fork()
        ).ldelim();
      if (m.id != null && Object.hasOwnProperty.call(m, "id"))
        w.uint32(66).string(m.id);
      return w;
    };

    /**
     * Decodes a Customer message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.Customer
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.Customer} Customer
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Customer.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.Customer();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.firstName = r.string();
            break;
          case 2:
            m.lastName = r.string();
            break;
          case 3:
            m.email = r.string();
            break;
          case 4:
            m.phone = r.string();
            break;
          case 5:
            m.deliveryAddress = $root.appliancepb.Address.decode(r, r.uint32());
            break;
          case 6:
            m.businessName = r.string();
            break;
          case 7:
            m.billingAddress = $root.appliancepb.Address.decode(r, r.uint32());
            break;
          case 8:
            m.id = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return Customer;
  })();

  appliancepb.CreateReplacementNoteRequest = (function () {
    /**
     * Properties of a CreateReplacementNoteRequest.
     * @memberof appliancepb
     * @interface ICreateReplacementNoteRequest
     * @property {string|null} [message] CreateReplacementNoteRequest message
     */

    /**
     * Constructs a new CreateReplacementNoteRequest.
     * @memberof appliancepb
     * @classdesc Represents a CreateReplacementNoteRequest.
     * @implements ICreateReplacementNoteRequest
     * @constructor
     * @param {appliancepb.ICreateReplacementNoteRequest=} [p] Properties to set
     */
    function CreateReplacementNoteRequest(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * CreateReplacementNoteRequest message.
     * @member {string} message
     * @memberof appliancepb.CreateReplacementNoteRequest
     * @instance
     */
    CreateReplacementNoteRequest.prototype.message = "";

    /**
     * Creates a new CreateReplacementNoteRequest instance using the specified properties.
     * @function create
     * @memberof appliancepb.CreateReplacementNoteRequest
     * @static
     * @param {appliancepb.ICreateReplacementNoteRequest=} [properties] Properties to set
     * @returns {appliancepb.CreateReplacementNoteRequest} CreateReplacementNoteRequest instance
     */
    CreateReplacementNoteRequest.create = function create(properties) {
      return new CreateReplacementNoteRequest(properties);
    };

    /**
     * Encodes the specified CreateReplacementNoteRequest message. Does not implicitly {@link appliancepb.CreateReplacementNoteRequest.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.CreateReplacementNoteRequest
     * @static
     * @param {appliancepb.ICreateReplacementNoteRequest} m CreateReplacementNoteRequest message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CreateReplacementNoteRequest.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.message != null && Object.hasOwnProperty.call(m, "message"))
        w.uint32(10).string(m.message);
      return w;
    };

    /**
     * Decodes a CreateReplacementNoteRequest message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.CreateReplacementNoteRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.CreateReplacementNoteRequest} CreateReplacementNoteRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CreateReplacementNoteRequest.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.CreateReplacementNoteRequest();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.message = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return CreateReplacementNoteRequest;
  })();

  appliancepb.Note = (function () {
    /**
     * Properties of a Note.
     * @memberof appliancepb
     * @interface INote
     * @property {google.protobuf.ITimestamp|null} [created] Note created
     * @property {string|null} [message] Note message
     * @property {string|null} [creator] Note creator
     */

    /**
     * Constructs a new Note.
     * @memberof appliancepb
     * @classdesc Represents a Note.
     * @implements INote
     * @constructor
     * @param {appliancepb.INote=} [p] Properties to set
     */
    function Note(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * Note created.
     * @member {google.protobuf.ITimestamp|null|undefined} created
     * @memberof appliancepb.Note
     * @instance
     */
    Note.prototype.created = null;

    /**
     * Note message.
     * @member {string} message
     * @memberof appliancepb.Note
     * @instance
     */
    Note.prototype.message = "";

    /**
     * Note creator.
     * @member {string} creator
     * @memberof appliancepb.Note
     * @instance
     */
    Note.prototype.creator = "";

    /**
     * Creates a new Note instance using the specified properties.
     * @function create
     * @memberof appliancepb.Note
     * @static
     * @param {appliancepb.INote=} [properties] Properties to set
     * @returns {appliancepb.Note} Note instance
     */
    Note.create = function create(properties) {
      return new Note(properties);
    };

    /**
     * Encodes the specified Note message. Does not implicitly {@link appliancepb.Note.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.Note
     * @static
     * @param {appliancepb.INote} m Note message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Note.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.created != null && Object.hasOwnProperty.call(m, "created"))
        $root.google.protobuf.Timestamp.encode(
          m.created,
          w.uint32(10).fork()
        ).ldelim();
      if (m.message != null && Object.hasOwnProperty.call(m, "message"))
        w.uint32(18).string(m.message);
      if (m.creator != null && Object.hasOwnProperty.call(m, "creator"))
        w.uint32(26).string(m.creator);
      return w;
    };

    /**
     * Decodes a Note message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.Note
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.Note} Note
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Note.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.Note();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.created = $root.google.protobuf.Timestamp.decode(r, r.uint32());
            break;
          case 2:
            m.message = r.string();
            break;
          case 3:
            m.creator = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return Note;
  })();

  appliancepb.FullReplacementDetails = (function () {
    /**
     * Properties of a FullReplacementDetails.
     * @memberof appliancepb
     * @interface IFullReplacementDetails
     * @property {string|null} [ID] FullReplacementDetails ID
     * @property {string|null} [tenantID] FullReplacementDetails tenantID
     * @property {string|null} [userID] FullReplacementDetails userID
     * @property {string|null} [paymentID] FullReplacementDetails paymentID
     * @property {string|null} [addressID] FullReplacementDetails addressID
     * @property {string|null} [transactionID] FullReplacementDetails transactionID
     * @property {string|null} [serviceRequestID] FullReplacementDetails serviceRequestID
     * @property {number|null} [discount] FullReplacementDetails discount
     * @property {appliancepb.IPair|null} [item] FullReplacementDetails item
     * @property {appliancepb.IPair|null} [brand] FullReplacementDetails brand
     * @property {appliancepb.IPair|null} [style] FullReplacementDetails style
     * @property {appliancepb.FullReplacementDetails.IPurchase|null} [purchase] FullReplacementDetails purchase
     * @property {google.protobuf.ITimestamp|null} [createdAt] FullReplacementDetails createdAt
     * @property {google.protobuf.ITimestamp|null} [lastUpdated] FullReplacementDetails lastUpdated
     * @property {string|null} [status] FullReplacementDetails status
     * @property {string|null} [location] FullReplacementDetails location
     * @property {string|null} [deliveryInstructions] FullReplacementDetails deliveryInstructions
     * @property {boolean|null} [confirmedDimensions] FullReplacementDetails confirmedDimensions
     * @property {boolean|null} [agreesToTermsAndConditions] FullReplacementDetails agreesToTermsAndConditions
     * @property {appliancepb.IInstaller|null} [installer] FullReplacementDetails installer
     * @property {string|null} [dispatchID] FullReplacementDetails dispatchID
     * @property {string|null} [likeForLikeProductID] FullReplacementDetails likeForLikeProductID
     * @property {boolean|null} [hasDisposalCoverage] FullReplacementDetails hasDisposalCoverage
     * @property {number|Long|null} [cashInLieu] FullReplacementDetails cashInLieu
     * @property {string|null} [contractID] FullReplacementDetails contractID
     * @property {string|null} [partRequestID] FullReplacementDetails partRequestID
     * @property {appliancepb.IPayment|null} [payment] FullReplacementDetails payment
     * @property {google.protobuf.ITimestamp|null} [orderDate] FullReplacementDetails orderDate
     * @property {google.protobuf.ITimestamp|null} [deliveryDate] FullReplacementDetails deliveryDate
     * @property {appliancepb.ICustomer|null} [customer] FullReplacementDetails customer
     * @property {appliancepb.IProduct|null} [product] FullReplacementDetails product
     * @property {string|null} [vendorOrderNumber] FullReplacementDetails vendorOrderNumber
     * @property {string|null} [shopLink] FullReplacementDetails shopLink
     * @property {string|null} [orderStatusLink] FullReplacementDetails orderStatusLink
     * @property {Array.<appliancepb.INote>|null} [notes] FullReplacementDetails notes
     * @property {appliancepb.IPriceInformation|null} [likeForLikePrice] FullReplacementDetails likeForLikePrice
     * @property {appliancepb.ICart|null} [cart] FullReplacementDetails cart
     */

    /**
     * Constructs a new FullReplacementDetails.
     * @memberof appliancepb
     * @classdesc Represents a FullReplacementDetails.
     * @implements IFullReplacementDetails
     * @constructor
     * @param {appliancepb.IFullReplacementDetails=} [p] Properties to set
     */
    function FullReplacementDetails(p) {
      this.notes = [];
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * FullReplacementDetails ID.
     * @member {string} ID
     * @memberof appliancepb.FullReplacementDetails
     * @instance
     */
    FullReplacementDetails.prototype.ID = "";

    /**
     * FullReplacementDetails tenantID.
     * @member {string} tenantID
     * @memberof appliancepb.FullReplacementDetails
     * @instance
     */
    FullReplacementDetails.prototype.tenantID = "";

    /**
     * FullReplacementDetails userID.
     * @member {string} userID
     * @memberof appliancepb.FullReplacementDetails
     * @instance
     */
    FullReplacementDetails.prototype.userID = "";

    /**
     * FullReplacementDetails paymentID.
     * @member {string} paymentID
     * @memberof appliancepb.FullReplacementDetails
     * @instance
     */
    FullReplacementDetails.prototype.paymentID = "";

    /**
     * FullReplacementDetails addressID.
     * @member {string} addressID
     * @memberof appliancepb.FullReplacementDetails
     * @instance
     */
    FullReplacementDetails.prototype.addressID = "";

    /**
     * FullReplacementDetails transactionID.
     * @member {string} transactionID
     * @memberof appliancepb.FullReplacementDetails
     * @instance
     */
    FullReplacementDetails.prototype.transactionID = "";

    /**
     * FullReplacementDetails serviceRequestID.
     * @member {string} serviceRequestID
     * @memberof appliancepb.FullReplacementDetails
     * @instance
     */
    FullReplacementDetails.prototype.serviceRequestID = "";

    /**
     * FullReplacementDetails discount.
     * @member {number} discount
     * @memberof appliancepb.FullReplacementDetails
     * @instance
     */
    FullReplacementDetails.prototype.discount = 0;

    /**
     * FullReplacementDetails item.
     * @member {appliancepb.IPair|null|undefined} item
     * @memberof appliancepb.FullReplacementDetails
     * @instance
     */
    FullReplacementDetails.prototype.item = null;

    /**
     * FullReplacementDetails brand.
     * @member {appliancepb.IPair|null|undefined} brand
     * @memberof appliancepb.FullReplacementDetails
     * @instance
     */
    FullReplacementDetails.prototype.brand = null;

    /**
     * FullReplacementDetails style.
     * @member {appliancepb.IPair|null|undefined} style
     * @memberof appliancepb.FullReplacementDetails
     * @instance
     */
    FullReplacementDetails.prototype.style = null;

    /**
     * FullReplacementDetails purchase.
     * @member {appliancepb.FullReplacementDetails.IPurchase|null|undefined} purchase
     * @memberof appliancepb.FullReplacementDetails
     * @instance
     */
    FullReplacementDetails.prototype.purchase = null;

    /**
     * FullReplacementDetails createdAt.
     * @member {google.protobuf.ITimestamp|null|undefined} createdAt
     * @memberof appliancepb.FullReplacementDetails
     * @instance
     */
    FullReplacementDetails.prototype.createdAt = null;

    /**
     * FullReplacementDetails lastUpdated.
     * @member {google.protobuf.ITimestamp|null|undefined} lastUpdated
     * @memberof appliancepb.FullReplacementDetails
     * @instance
     */
    FullReplacementDetails.prototype.lastUpdated = null;

    /**
     * FullReplacementDetails status.
     * @member {string} status
     * @memberof appliancepb.FullReplacementDetails
     * @instance
     */
    FullReplacementDetails.prototype.status = "";

    /**
     * FullReplacementDetails location.
     * @member {string} location
     * @memberof appliancepb.FullReplacementDetails
     * @instance
     */
    FullReplacementDetails.prototype.location = "";

    /**
     * FullReplacementDetails deliveryInstructions.
     * @member {string} deliveryInstructions
     * @memberof appliancepb.FullReplacementDetails
     * @instance
     */
    FullReplacementDetails.prototype.deliveryInstructions = "";

    /**
     * FullReplacementDetails confirmedDimensions.
     * @member {boolean} confirmedDimensions
     * @memberof appliancepb.FullReplacementDetails
     * @instance
     */
    FullReplacementDetails.prototype.confirmedDimensions = false;

    /**
     * FullReplacementDetails agreesToTermsAndConditions.
     * @member {boolean} agreesToTermsAndConditions
     * @memberof appliancepb.FullReplacementDetails
     * @instance
     */
    FullReplacementDetails.prototype.agreesToTermsAndConditions = false;

    /**
     * FullReplacementDetails installer.
     * @member {appliancepb.IInstaller|null|undefined} installer
     * @memberof appliancepb.FullReplacementDetails
     * @instance
     */
    FullReplacementDetails.prototype.installer = null;

    /**
     * FullReplacementDetails dispatchID.
     * @member {string} dispatchID
     * @memberof appliancepb.FullReplacementDetails
     * @instance
     */
    FullReplacementDetails.prototype.dispatchID = "";

    /**
     * FullReplacementDetails likeForLikeProductID.
     * @member {string} likeForLikeProductID
     * @memberof appliancepb.FullReplacementDetails
     * @instance
     */
    FullReplacementDetails.prototype.likeForLikeProductID = "";

    /**
     * FullReplacementDetails hasDisposalCoverage.
     * @member {boolean} hasDisposalCoverage
     * @memberof appliancepb.FullReplacementDetails
     * @instance
     */
    FullReplacementDetails.prototype.hasDisposalCoverage = false;

    /**
     * FullReplacementDetails cashInLieu.
     * @member {number|Long} cashInLieu
     * @memberof appliancepb.FullReplacementDetails
     * @instance
     */
    FullReplacementDetails.prototype.cashInLieu = $util.Long
      ? $util.Long.fromBits(0, 0, false)
      : 0;

    /**
     * FullReplacementDetails contractID.
     * @member {string} contractID
     * @memberof appliancepb.FullReplacementDetails
     * @instance
     */
    FullReplacementDetails.prototype.contractID = "";

    /**
     * FullReplacementDetails partRequestID.
     * @member {string} partRequestID
     * @memberof appliancepb.FullReplacementDetails
     * @instance
     */
    FullReplacementDetails.prototype.partRequestID = "";

    /**
     * FullReplacementDetails payment.
     * @member {appliancepb.IPayment|null|undefined} payment
     * @memberof appliancepb.FullReplacementDetails
     * @instance
     */
    FullReplacementDetails.prototype.payment = null;

    /**
     * FullReplacementDetails orderDate.
     * @member {google.protobuf.ITimestamp|null|undefined} orderDate
     * @memberof appliancepb.FullReplacementDetails
     * @instance
     */
    FullReplacementDetails.prototype.orderDate = null;

    /**
     * FullReplacementDetails deliveryDate.
     * @member {google.protobuf.ITimestamp|null|undefined} deliveryDate
     * @memberof appliancepb.FullReplacementDetails
     * @instance
     */
    FullReplacementDetails.prototype.deliveryDate = null;

    /**
     * FullReplacementDetails customer.
     * @member {appliancepb.ICustomer|null|undefined} customer
     * @memberof appliancepb.FullReplacementDetails
     * @instance
     */
    FullReplacementDetails.prototype.customer = null;

    /**
     * FullReplacementDetails product.
     * @member {appliancepb.IProduct|null|undefined} product
     * @memberof appliancepb.FullReplacementDetails
     * @instance
     */
    FullReplacementDetails.prototype.product = null;

    /**
     * FullReplacementDetails vendorOrderNumber.
     * @member {string} vendorOrderNumber
     * @memberof appliancepb.FullReplacementDetails
     * @instance
     */
    FullReplacementDetails.prototype.vendorOrderNumber = "";

    /**
     * FullReplacementDetails shopLink.
     * @member {string} shopLink
     * @memberof appliancepb.FullReplacementDetails
     * @instance
     */
    FullReplacementDetails.prototype.shopLink = "";

    /**
     * FullReplacementDetails orderStatusLink.
     * @member {string} orderStatusLink
     * @memberof appliancepb.FullReplacementDetails
     * @instance
     */
    FullReplacementDetails.prototype.orderStatusLink = "";

    /**
     * FullReplacementDetails notes.
     * @member {Array.<appliancepb.INote>} notes
     * @memberof appliancepb.FullReplacementDetails
     * @instance
     */
    FullReplacementDetails.prototype.notes = $util.emptyArray;

    /**
     * FullReplacementDetails likeForLikePrice.
     * @member {appliancepb.IPriceInformation|null|undefined} likeForLikePrice
     * @memberof appliancepb.FullReplacementDetails
     * @instance
     */
    FullReplacementDetails.prototype.likeForLikePrice = null;

    /**
     * FullReplacementDetails cart.
     * @member {appliancepb.ICart|null|undefined} cart
     * @memberof appliancepb.FullReplacementDetails
     * @instance
     */
    FullReplacementDetails.prototype.cart = null;

    /**
     * Creates a new FullReplacementDetails instance using the specified properties.
     * @function create
     * @memberof appliancepb.FullReplacementDetails
     * @static
     * @param {appliancepb.IFullReplacementDetails=} [properties] Properties to set
     * @returns {appliancepb.FullReplacementDetails} FullReplacementDetails instance
     */
    FullReplacementDetails.create = function create(properties) {
      return new FullReplacementDetails(properties);
    };

    /**
     * Encodes the specified FullReplacementDetails message. Does not implicitly {@link appliancepb.FullReplacementDetails.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.FullReplacementDetails
     * @static
     * @param {appliancepb.IFullReplacementDetails} m FullReplacementDetails message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FullReplacementDetails.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
        w.uint32(10).string(m.ID);
      if (m.tenantID != null && Object.hasOwnProperty.call(m, "tenantID"))
        w.uint32(18).string(m.tenantID);
      if (m.userID != null && Object.hasOwnProperty.call(m, "userID"))
        w.uint32(26).string(m.userID);
      if (m.paymentID != null && Object.hasOwnProperty.call(m, "paymentID"))
        w.uint32(34).string(m.paymentID);
      if (m.addressID != null && Object.hasOwnProperty.call(m, "addressID"))
        w.uint32(42).string(m.addressID);
      if (
        m.transactionID != null &&
        Object.hasOwnProperty.call(m, "transactionID")
      )
        w.uint32(50).string(m.transactionID);
      if (
        m.serviceRequestID != null &&
        Object.hasOwnProperty.call(m, "serviceRequestID")
      )
        w.uint32(58).string(m.serviceRequestID);
      if (m.discount != null && Object.hasOwnProperty.call(m, "discount"))
        w.uint32(64).int32(m.discount);
      if (m.item != null && Object.hasOwnProperty.call(m, "item"))
        $root.appliancepb.Pair.encode(m.item, w.uint32(74).fork()).ldelim();
      if (m.brand != null && Object.hasOwnProperty.call(m, "brand"))
        $root.appliancepb.Pair.encode(m.brand, w.uint32(82).fork()).ldelim();
      if (m.style != null && Object.hasOwnProperty.call(m, "style"))
        $root.appliancepb.Pair.encode(m.style, w.uint32(90).fork()).ldelim();
      if (m.purchase != null && Object.hasOwnProperty.call(m, "purchase"))
        $root.appliancepb.FullReplacementDetails.Purchase.encode(
          m.purchase,
          w.uint32(98).fork()
        ).ldelim();
      if (m.createdAt != null && Object.hasOwnProperty.call(m, "createdAt"))
        $root.google.protobuf.Timestamp.encode(
          m.createdAt,
          w.uint32(106).fork()
        ).ldelim();
      if (m.lastUpdated != null && Object.hasOwnProperty.call(m, "lastUpdated"))
        $root.google.protobuf.Timestamp.encode(
          m.lastUpdated,
          w.uint32(114).fork()
        ).ldelim();
      if (m.status != null && Object.hasOwnProperty.call(m, "status"))
        w.uint32(122).string(m.status);
      if (m.location != null && Object.hasOwnProperty.call(m, "location"))
        w.uint32(130).string(m.location);
      if (
        m.deliveryInstructions != null &&
        Object.hasOwnProperty.call(m, "deliveryInstructions")
      )
        w.uint32(138).string(m.deliveryInstructions);
      if (
        m.confirmedDimensions != null &&
        Object.hasOwnProperty.call(m, "confirmedDimensions")
      )
        w.uint32(144).bool(m.confirmedDimensions);
      if (
        m.agreesToTermsAndConditions != null &&
        Object.hasOwnProperty.call(m, "agreesToTermsAndConditions")
      )
        w.uint32(152).bool(m.agreesToTermsAndConditions);
      if (m.installer != null && Object.hasOwnProperty.call(m, "installer"))
        $root.appliancepb.Installer.encode(
          m.installer,
          w.uint32(162).fork()
        ).ldelim();
      if (m.dispatchID != null && Object.hasOwnProperty.call(m, "dispatchID"))
        w.uint32(170).string(m.dispatchID);
      if (
        m.likeForLikeProductID != null &&
        Object.hasOwnProperty.call(m, "likeForLikeProductID")
      )
        w.uint32(178).string(m.likeForLikeProductID);
      if (
        m.hasDisposalCoverage != null &&
        Object.hasOwnProperty.call(m, "hasDisposalCoverage")
      )
        w.uint32(184).bool(m.hasDisposalCoverage);
      if (m.cashInLieu != null && Object.hasOwnProperty.call(m, "cashInLieu"))
        w.uint32(192).int64(m.cashInLieu);
      if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
        w.uint32(202).string(m.contractID);
      if (
        m.partRequestID != null &&
        Object.hasOwnProperty.call(m, "partRequestID")
      )
        w.uint32(210).string(m.partRequestID);
      if (m.payment != null && Object.hasOwnProperty.call(m, "payment"))
        $root.appliancepb.Payment.encode(
          m.payment,
          w.uint32(218).fork()
        ).ldelim();
      if (m.orderDate != null && Object.hasOwnProperty.call(m, "orderDate"))
        $root.google.protobuf.Timestamp.encode(
          m.orderDate,
          w.uint32(226).fork()
        ).ldelim();
      if (
        m.deliveryDate != null &&
        Object.hasOwnProperty.call(m, "deliveryDate")
      )
        $root.google.protobuf.Timestamp.encode(
          m.deliveryDate,
          w.uint32(234).fork()
        ).ldelim();
      if (m.customer != null && Object.hasOwnProperty.call(m, "customer"))
        $root.appliancepb.Customer.encode(
          m.customer,
          w.uint32(242).fork()
        ).ldelim();
      if (m.product != null && Object.hasOwnProperty.call(m, "product"))
        $root.appliancepb.Product.encode(
          m.product,
          w.uint32(250).fork()
        ).ldelim();
      if (
        m.vendorOrderNumber != null &&
        Object.hasOwnProperty.call(m, "vendorOrderNumber")
      )
        w.uint32(258).string(m.vendorOrderNumber);
      if (m.shopLink != null && Object.hasOwnProperty.call(m, "shopLink"))
        w.uint32(266).string(m.shopLink);
      if (
        m.orderStatusLink != null &&
        Object.hasOwnProperty.call(m, "orderStatusLink")
      )
        w.uint32(274).string(m.orderStatusLink);
      if (m.notes != null && m.notes.length) {
        for (var i = 0; i < m.notes.length; ++i)
          $root.appliancepb.Note.encode(
            m.notes[i],
            w.uint32(282).fork()
          ).ldelim();
      }
      if (
        m.likeForLikePrice != null &&
        Object.hasOwnProperty.call(m, "likeForLikePrice")
      )
        $root.appliancepb.PriceInformation.encode(
          m.likeForLikePrice,
          w.uint32(290).fork()
        ).ldelim();
      if (m.cart != null && Object.hasOwnProperty.call(m, "cart"))
        $root.appliancepb.Cart.encode(m.cart, w.uint32(298).fork()).ldelim();
      return w;
    };

    /**
     * Decodes a FullReplacementDetails message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.FullReplacementDetails
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.FullReplacementDetails} FullReplacementDetails
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FullReplacementDetails.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.FullReplacementDetails();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.ID = r.string();
            break;
          case 2:
            m.tenantID = r.string();
            break;
          case 3:
            m.userID = r.string();
            break;
          case 4:
            m.paymentID = r.string();
            break;
          case 5:
            m.addressID = r.string();
            break;
          case 6:
            m.transactionID = r.string();
            break;
          case 7:
            m.serviceRequestID = r.string();
            break;
          case 8:
            m.discount = r.int32();
            break;
          case 9:
            m.item = $root.appliancepb.Pair.decode(r, r.uint32());
            break;
          case 10:
            m.brand = $root.appliancepb.Pair.decode(r, r.uint32());
            break;
          case 11:
            m.style = $root.appliancepb.Pair.decode(r, r.uint32());
            break;
          case 12:
            m.purchase = $root.appliancepb.FullReplacementDetails.Purchase.decode(
              r,
              r.uint32()
            );
            break;
          case 13:
            m.createdAt = $root.google.protobuf.Timestamp.decode(r, r.uint32());
            break;
          case 14:
            m.lastUpdated = $root.google.protobuf.Timestamp.decode(
              r,
              r.uint32()
            );
            break;
          case 15:
            m.status = r.string();
            break;
          case 16:
            m.location = r.string();
            break;
          case 17:
            m.deliveryInstructions = r.string();
            break;
          case 18:
            m.confirmedDimensions = r.bool();
            break;
          case 19:
            m.agreesToTermsAndConditions = r.bool();
            break;
          case 20:
            m.installer = $root.appliancepb.Installer.decode(r, r.uint32());
            break;
          case 21:
            m.dispatchID = r.string();
            break;
          case 22:
            m.likeForLikeProductID = r.string();
            break;
          case 23:
            m.hasDisposalCoverage = r.bool();
            break;
          case 24:
            m.cashInLieu = r.int64();
            break;
          case 25:
            m.contractID = r.string();
            break;
          case 26:
            m.partRequestID = r.string();
            break;
          case 27:
            m.payment = $root.appliancepb.Payment.decode(r, r.uint32());
            break;
          case 28:
            m.orderDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
            break;
          case 29:
            m.deliveryDate = $root.google.protobuf.Timestamp.decode(
              r,
              r.uint32()
            );
            break;
          case 30:
            m.customer = $root.appliancepb.Customer.decode(r, r.uint32());
            break;
          case 31:
            m.product = $root.appliancepb.Product.decode(r, r.uint32());
            break;
          case 32:
            m.vendorOrderNumber = r.string();
            break;
          case 33:
            m.shopLink = r.string();
            break;
          case 34:
            m.orderStatusLink = r.string();
            break;
          case 35:
            if (!(m.notes && m.notes.length)) m.notes = [];
            m.notes.push($root.appliancepb.Note.decode(r, r.uint32()));
            break;
          case 36:
            m.likeForLikePrice = $root.appliancepb.PriceInformation.decode(
              r,
              r.uint32()
            );
            break;
          case 37:
            m.cart = $root.appliancepb.Cart.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    FullReplacementDetails.Purchase = (function () {
      /**
       * Properties of a Purchase.
       * @memberof appliancepb.FullReplacementDetails
       * @interface IPurchase
       * @property {string|null} [productID] Purchase productID
       * @property {number|Long|null} [basePrice] Purchase basePrice
       * @property {number|Long|null} [moveApplianceFee] Purchase moveApplianceFee
       * @property {number|Long|null} [disconnectFee] Purchase disconnectFee
       * @property {number|Long|null} [installFee] Purchase installFee
       * @property {number|Long|null} [deliveryFee] Purchase deliveryFee
       * @property {number|Long|null} [disposalFee] Purchase disposalFee
       * @property {number|Long|null} [adminFee] Purchase adminFee
       * @property {number|Long|null} [basePlusFees] Purchase basePlusFees
       * @property {number|Long|null} [taxes] Purchase taxes
       * @property {number|Long|null} [total] Purchase total
       */

      /**
       * Constructs a new Purchase.
       * @memberof appliancepb.FullReplacementDetails
       * @classdesc Represents a Purchase.
       * @implements IPurchase
       * @constructor
       * @param {appliancepb.FullReplacementDetails.IPurchase=} [p] Properties to set
       */
      function Purchase(p) {
        if (p)
          for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
            if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
      }

      /**
       * Purchase productID.
       * @member {string} productID
       * @memberof appliancepb.FullReplacementDetails.Purchase
       * @instance
       */
      Purchase.prototype.productID = "";

      /**
       * Purchase basePrice.
       * @member {number|Long} basePrice
       * @memberof appliancepb.FullReplacementDetails.Purchase
       * @instance
       */
      Purchase.prototype.basePrice = $util.Long
        ? $util.Long.fromBits(0, 0, false)
        : 0;

      /**
       * Purchase moveApplianceFee.
       * @member {number|Long} moveApplianceFee
       * @memberof appliancepb.FullReplacementDetails.Purchase
       * @instance
       */
      Purchase.prototype.moveApplianceFee = $util.Long
        ? $util.Long.fromBits(0, 0, false)
        : 0;

      /**
       * Purchase disconnectFee.
       * @member {number|Long} disconnectFee
       * @memberof appliancepb.FullReplacementDetails.Purchase
       * @instance
       */
      Purchase.prototype.disconnectFee = $util.Long
        ? $util.Long.fromBits(0, 0, false)
        : 0;

      /**
       * Purchase installFee.
       * @member {number|Long} installFee
       * @memberof appliancepb.FullReplacementDetails.Purchase
       * @instance
       */
      Purchase.prototype.installFee = $util.Long
        ? $util.Long.fromBits(0, 0, false)
        : 0;

      /**
       * Purchase deliveryFee.
       * @member {number|Long} deliveryFee
       * @memberof appliancepb.FullReplacementDetails.Purchase
       * @instance
       */
      Purchase.prototype.deliveryFee = $util.Long
        ? $util.Long.fromBits(0, 0, false)
        : 0;

      /**
       * Purchase disposalFee.
       * @member {number|Long} disposalFee
       * @memberof appliancepb.FullReplacementDetails.Purchase
       * @instance
       */
      Purchase.prototype.disposalFee = $util.Long
        ? $util.Long.fromBits(0, 0, false)
        : 0;

      /**
       * Purchase adminFee.
       * @member {number|Long} adminFee
       * @memberof appliancepb.FullReplacementDetails.Purchase
       * @instance
       */
      Purchase.prototype.adminFee = $util.Long
        ? $util.Long.fromBits(0, 0, false)
        : 0;

      /**
       * Purchase basePlusFees.
       * @member {number|Long} basePlusFees
       * @memberof appliancepb.FullReplacementDetails.Purchase
       * @instance
       */
      Purchase.prototype.basePlusFees = $util.Long
        ? $util.Long.fromBits(0, 0, false)
        : 0;

      /**
       * Purchase taxes.
       * @member {number|Long} taxes
       * @memberof appliancepb.FullReplacementDetails.Purchase
       * @instance
       */
      Purchase.prototype.taxes = $util.Long
        ? $util.Long.fromBits(0, 0, false)
        : 0;

      /**
       * Purchase total.
       * @member {number|Long} total
       * @memberof appliancepb.FullReplacementDetails.Purchase
       * @instance
       */
      Purchase.prototype.total = $util.Long
        ? $util.Long.fromBits(0, 0, false)
        : 0;

      /**
       * Creates a new Purchase instance using the specified properties.
       * @function create
       * @memberof appliancepb.FullReplacementDetails.Purchase
       * @static
       * @param {appliancepb.FullReplacementDetails.IPurchase=} [properties] Properties to set
       * @returns {appliancepb.FullReplacementDetails.Purchase} Purchase instance
       */
      Purchase.create = function create(properties) {
        return new Purchase(properties);
      };

      /**
       * Encodes the specified Purchase message. Does not implicitly {@link appliancepb.FullReplacementDetails.Purchase.verify|verify} messages.
       * @function encode
       * @memberof appliancepb.FullReplacementDetails.Purchase
       * @static
       * @param {appliancepb.FullReplacementDetails.IPurchase} m Purchase message or plain object to encode
       * @param {$protobuf.Writer} [w] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Purchase.encode = function encode(m, w) {
        if (!w) w = $Writer.create();
        if (m.productID != null && Object.hasOwnProperty.call(m, "productID"))
          w.uint32(10).string(m.productID);
        if (m.basePrice != null && Object.hasOwnProperty.call(m, "basePrice"))
          w.uint32(16).int64(m.basePrice);
        if (
          m.moveApplianceFee != null &&
          Object.hasOwnProperty.call(m, "moveApplianceFee")
        )
          w.uint32(24).int64(m.moveApplianceFee);
        if (
          m.disconnectFee != null &&
          Object.hasOwnProperty.call(m, "disconnectFee")
        )
          w.uint32(32).int64(m.disconnectFee);
        if (m.installFee != null && Object.hasOwnProperty.call(m, "installFee"))
          w.uint32(40).int64(m.installFee);
        if (
          m.deliveryFee != null &&
          Object.hasOwnProperty.call(m, "deliveryFee")
        )
          w.uint32(48).int64(m.deliveryFee);
        if (
          m.disposalFee != null &&
          Object.hasOwnProperty.call(m, "disposalFee")
        )
          w.uint32(56).int64(m.disposalFee);
        if (m.adminFee != null && Object.hasOwnProperty.call(m, "adminFee"))
          w.uint32(64).int64(m.adminFee);
        if (
          m.basePlusFees != null &&
          Object.hasOwnProperty.call(m, "basePlusFees")
        )
          w.uint32(72).int64(m.basePlusFees);
        if (m.taxes != null && Object.hasOwnProperty.call(m, "taxes"))
          w.uint32(80).int64(m.taxes);
        if (m.total != null && Object.hasOwnProperty.call(m, "total"))
          w.uint32(88).int64(m.total);
        return w;
      };

      /**
       * Decodes a Purchase message from the specified reader or buffer.
       * @function decode
       * @memberof appliancepb.FullReplacementDetails.Purchase
       * @static
       * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
       * @param {number} [l] Message length if known beforehand
       * @returns {appliancepb.FullReplacementDetails.Purchase} Purchase
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Purchase.decode = function decode(r, l) {
        if (!(r instanceof $Reader)) r = $Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l,
          m = new $root.appliancepb.FullReplacementDetails.Purchase();
        while (r.pos < c) {
          var t = r.uint32();
          switch (t >>> 3) {
            case 1:
              m.productID = r.string();
              break;
            case 2:
              m.basePrice = r.int64();
              break;
            case 3:
              m.moveApplianceFee = r.int64();
              break;
            case 4:
              m.disconnectFee = r.int64();
              break;
            case 5:
              m.installFee = r.int64();
              break;
            case 6:
              m.deliveryFee = r.int64();
              break;
            case 7:
              m.disposalFee = r.int64();
              break;
            case 8:
              m.adminFee = r.int64();
              break;
            case 9:
              m.basePlusFees = r.int64();
              break;
            case 10:
              m.taxes = r.int64();
              break;
            case 11:
              m.total = r.int64();
              break;
            default:
              r.skipType(t & 7);
              break;
          }
        }
        return m;
      };

      return Purchase;
    })();

    return FullReplacementDetails;
  })();

  appliancepb.FullReplacements = (function () {
    /**
     * Properties of a FullReplacements.
     * @memberof appliancepb
     * @interface IFullReplacements
     * @property {Array.<appliancepb.IFullReplacementDetails>|null} [replacements] FullReplacements replacements
     * @property {appliancepb.IPagination|null} [pagination] FullReplacements pagination
     */

    /**
     * Constructs a new FullReplacements.
     * @memberof appliancepb
     * @classdesc Represents a FullReplacements.
     * @implements IFullReplacements
     * @constructor
     * @param {appliancepb.IFullReplacements=} [p] Properties to set
     */
    function FullReplacements(p) {
      this.replacements = [];
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * FullReplacements replacements.
     * @member {Array.<appliancepb.IFullReplacementDetails>} replacements
     * @memberof appliancepb.FullReplacements
     * @instance
     */
    FullReplacements.prototype.replacements = $util.emptyArray;

    /**
     * FullReplacements pagination.
     * @member {appliancepb.IPagination|null|undefined} pagination
     * @memberof appliancepb.FullReplacements
     * @instance
     */
    FullReplacements.prototype.pagination = null;

    /**
     * Creates a new FullReplacements instance using the specified properties.
     * @function create
     * @memberof appliancepb.FullReplacements
     * @static
     * @param {appliancepb.IFullReplacements=} [properties] Properties to set
     * @returns {appliancepb.FullReplacements} FullReplacements instance
     */
    FullReplacements.create = function create(properties) {
      return new FullReplacements(properties);
    };

    /**
     * Encodes the specified FullReplacements message. Does not implicitly {@link appliancepb.FullReplacements.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.FullReplacements
     * @static
     * @param {appliancepb.IFullReplacements} m FullReplacements message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FullReplacements.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.replacements != null && m.replacements.length) {
        for (var i = 0; i < m.replacements.length; ++i)
          $root.appliancepb.FullReplacementDetails.encode(
            m.replacements[i],
            w.uint32(10).fork()
          ).ldelim();
      }
      if (m.pagination != null && Object.hasOwnProperty.call(m, "pagination"))
        $root.appliancepb.Pagination.encode(
          m.pagination,
          w.uint32(18).fork()
        ).ldelim();
      return w;
    };

    /**
     * Decodes a FullReplacements message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.FullReplacements
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.FullReplacements} FullReplacements
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FullReplacements.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.FullReplacements();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.replacements && m.replacements.length)) m.replacements = [];
            m.replacements.push(
              $root.appliancepb.FullReplacementDetails.decode(r, r.uint32())
            );
            break;
          case 2:
            m.pagination = $root.appliancepb.Pagination.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return FullReplacements;
  })();

  appliancepb.InstallerUpdateRequest = (function () {
    /**
     * Properties of an InstallerUpdateRequest.
     * @memberof appliancepb
     * @interface IInstallerUpdateRequest
     * @property {appliancepb.IInstaller|null} [installer] InstallerUpdateRequest installer
     */

    /**
     * Constructs a new InstallerUpdateRequest.
     * @memberof appliancepb
     * @classdesc Represents an InstallerUpdateRequest.
     * @implements IInstallerUpdateRequest
     * @constructor
     * @param {appliancepb.IInstallerUpdateRequest=} [p] Properties to set
     */
    function InstallerUpdateRequest(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * InstallerUpdateRequest installer.
     * @member {appliancepb.IInstaller|null|undefined} installer
     * @memberof appliancepb.InstallerUpdateRequest
     * @instance
     */
    InstallerUpdateRequest.prototype.installer = null;

    /**
     * Creates a new InstallerUpdateRequest instance using the specified properties.
     * @function create
     * @memberof appliancepb.InstallerUpdateRequest
     * @static
     * @param {appliancepb.IInstallerUpdateRequest=} [properties] Properties to set
     * @returns {appliancepb.InstallerUpdateRequest} InstallerUpdateRequest instance
     */
    InstallerUpdateRequest.create = function create(properties) {
      return new InstallerUpdateRequest(properties);
    };

    /**
     * Encodes the specified InstallerUpdateRequest message. Does not implicitly {@link appliancepb.InstallerUpdateRequest.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.InstallerUpdateRequest
     * @static
     * @param {appliancepb.IInstallerUpdateRequest} m InstallerUpdateRequest message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    InstallerUpdateRequest.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.installer != null && Object.hasOwnProperty.call(m, "installer"))
        $root.appliancepb.Installer.encode(
          m.installer,
          w.uint32(10).fork()
        ).ldelim();
      return w;
    };

    /**
     * Decodes an InstallerUpdateRequest message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.InstallerUpdateRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.InstallerUpdateRequest} InstallerUpdateRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    InstallerUpdateRequest.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.InstallerUpdateRequest();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.installer = $root.appliancepb.Installer.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return InstallerUpdateRequest;
  })();

  appliancepb.DispatchInfoResponse = (function () {
    /**
     * Properties of a DispatchInfoResponse.
     * @memberof appliancepb
     * @interface IDispatchInfoResponse
     * @property {string|null} [contractID] DispatchInfoResponse contractID
     * @property {string|null} [addressID] DispatchInfoResponse addressID
     * @property {string|null} [firstName] DispatchInfoResponse firstName
     * @property {string|null} [lastName] DispatchInfoResponse lastName
     * @property {string|null} [phone] DispatchInfoResponse phone
     * @property {string|null} [customerID] DispatchInfoResponse customerID
     * @property {string|null} [dispatchID] DispatchInfoResponse dispatchID
     * @property {Array.<appliancepb.IServiceItem>|null} [serviceItems] DispatchInfoResponse serviceItems
     * @property {Array.<string>|null} [messages] DispatchInfoResponse messages
     * @property {string|null} [tenantAbbreviation] DispatchInfoResponse tenantAbbreviation
     * @property {appliancepb.IAddress|null} [address] DispatchInfoResponse address
     */

    /**
     * Constructs a new DispatchInfoResponse.
     * @memberof appliancepb
     * @classdesc Represents a DispatchInfoResponse.
     * @implements IDispatchInfoResponse
     * @constructor
     * @param {appliancepb.IDispatchInfoResponse=} [p] Properties to set
     */
    function DispatchInfoResponse(p) {
      this.serviceItems = [];
      this.messages = [];
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * DispatchInfoResponse contractID.
     * @member {string} contractID
     * @memberof appliancepb.DispatchInfoResponse
     * @instance
     */
    DispatchInfoResponse.prototype.contractID = "";

    /**
     * DispatchInfoResponse addressID.
     * @member {string} addressID
     * @memberof appliancepb.DispatchInfoResponse
     * @instance
     */
    DispatchInfoResponse.prototype.addressID = "";

    /**
     * DispatchInfoResponse firstName.
     * @member {string} firstName
     * @memberof appliancepb.DispatchInfoResponse
     * @instance
     */
    DispatchInfoResponse.prototype.firstName = "";

    /**
     * DispatchInfoResponse lastName.
     * @member {string} lastName
     * @memberof appliancepb.DispatchInfoResponse
     * @instance
     */
    DispatchInfoResponse.prototype.lastName = "";

    /**
     * DispatchInfoResponse phone.
     * @member {string} phone
     * @memberof appliancepb.DispatchInfoResponse
     * @instance
     */
    DispatchInfoResponse.prototype.phone = "";

    /**
     * DispatchInfoResponse customerID.
     * @member {string} customerID
     * @memberof appliancepb.DispatchInfoResponse
     * @instance
     */
    DispatchInfoResponse.prototype.customerID = "";

    /**
     * DispatchInfoResponse dispatchID.
     * @member {string} dispatchID
     * @memberof appliancepb.DispatchInfoResponse
     * @instance
     */
    DispatchInfoResponse.prototype.dispatchID = "";

    /**
     * DispatchInfoResponse serviceItems.
     * @member {Array.<appliancepb.IServiceItem>} serviceItems
     * @memberof appliancepb.DispatchInfoResponse
     * @instance
     */
    DispatchInfoResponse.prototype.serviceItems = $util.emptyArray;

    /**
     * DispatchInfoResponse messages.
     * @member {Array.<string>} messages
     * @memberof appliancepb.DispatchInfoResponse
     * @instance
     */
    DispatchInfoResponse.prototype.messages = $util.emptyArray;

    /**
     * DispatchInfoResponse tenantAbbreviation.
     * @member {string} tenantAbbreviation
     * @memberof appliancepb.DispatchInfoResponse
     * @instance
     */
    DispatchInfoResponse.prototype.tenantAbbreviation = "";

    /**
     * DispatchInfoResponse address.
     * @member {appliancepb.IAddress|null|undefined} address
     * @memberof appliancepb.DispatchInfoResponse
     * @instance
     */
    DispatchInfoResponse.prototype.address = null;

    /**
     * Creates a new DispatchInfoResponse instance using the specified properties.
     * @function create
     * @memberof appliancepb.DispatchInfoResponse
     * @static
     * @param {appliancepb.IDispatchInfoResponse=} [properties] Properties to set
     * @returns {appliancepb.DispatchInfoResponse} DispatchInfoResponse instance
     */
    DispatchInfoResponse.create = function create(properties) {
      return new DispatchInfoResponse(properties);
    };

    /**
     * Encodes the specified DispatchInfoResponse message. Does not implicitly {@link appliancepb.DispatchInfoResponse.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.DispatchInfoResponse
     * @static
     * @param {appliancepb.IDispatchInfoResponse} m DispatchInfoResponse message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DispatchInfoResponse.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
        w.uint32(10).string(m.contractID);
      if (m.addressID != null && Object.hasOwnProperty.call(m, "addressID"))
        w.uint32(18).string(m.addressID);
      if (m.firstName != null && Object.hasOwnProperty.call(m, "firstName"))
        w.uint32(26).string(m.firstName);
      if (m.lastName != null && Object.hasOwnProperty.call(m, "lastName"))
        w.uint32(34).string(m.lastName);
      if (m.phone != null && Object.hasOwnProperty.call(m, "phone"))
        w.uint32(42).string(m.phone);
      if (m.customerID != null && Object.hasOwnProperty.call(m, "customerID"))
        w.uint32(50).string(m.customerID);
      if (m.dispatchID != null && Object.hasOwnProperty.call(m, "dispatchID"))
        w.uint32(58).string(m.dispatchID);
      if (m.serviceItems != null && m.serviceItems.length) {
        for (var i = 0; i < m.serviceItems.length; ++i)
          $root.appliancepb.ServiceItem.encode(
            m.serviceItems[i],
            w.uint32(66).fork()
          ).ldelim();
      }
      if (m.messages != null && m.messages.length) {
        for (var i = 0; i < m.messages.length; ++i)
          w.uint32(74).string(m.messages[i]);
      }
      if (
        m.tenantAbbreviation != null &&
        Object.hasOwnProperty.call(m, "tenantAbbreviation")
      )
        w.uint32(82).string(m.tenantAbbreviation);
      if (m.address != null && Object.hasOwnProperty.call(m, "address"))
        $root.appliancepb.Address.encode(
          m.address,
          w.uint32(90).fork()
        ).ldelim();
      return w;
    };

    /**
     * Decodes a DispatchInfoResponse message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.DispatchInfoResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.DispatchInfoResponse} DispatchInfoResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DispatchInfoResponse.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.DispatchInfoResponse();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.contractID = r.string();
            break;
          case 2:
            m.addressID = r.string();
            break;
          case 3:
            m.firstName = r.string();
            break;
          case 4:
            m.lastName = r.string();
            break;
          case 5:
            m.phone = r.string();
            break;
          case 6:
            m.customerID = r.string();
            break;
          case 7:
            m.dispatchID = r.string();
            break;
          case 8:
            if (!(m.serviceItems && m.serviceItems.length)) m.serviceItems = [];
            m.serviceItems.push(
              $root.appliancepb.ServiceItem.decode(r, r.uint32())
            );
            break;
          case 9:
            if (!(m.messages && m.messages.length)) m.messages = [];
            m.messages.push(r.string());
            break;
          case 10:
            m.tenantAbbreviation = r.string();
            break;
          case 11:
            m.address = $root.appliancepb.Address.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return DispatchInfoResponse;
  })();

  appliancepb.ServiceItem = (function () {
    /**
     * Properties of a ServiceItem.
     * @memberof appliancepb
     * @interface IServiceItem
     * @property {string|null} [itemID] ServiceItem itemID
     * @property {Array.<string>|null} [partRequestIDs] ServiceItem partRequestIDs
     * @property {number|null} [serviceLimit] ServiceItem serviceLimit
     */

    /**
     * Constructs a new ServiceItem.
     * @memberof appliancepb
     * @classdesc Represents a ServiceItem.
     * @implements IServiceItem
     * @constructor
     * @param {appliancepb.IServiceItem=} [p] Properties to set
     */
    function ServiceItem(p) {
      this.partRequestIDs = [];
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * ServiceItem itemID.
     * @member {string} itemID
     * @memberof appliancepb.ServiceItem
     * @instance
     */
    ServiceItem.prototype.itemID = "";

    /**
     * ServiceItem partRequestIDs.
     * @member {Array.<string>} partRequestIDs
     * @memberof appliancepb.ServiceItem
     * @instance
     */
    ServiceItem.prototype.partRequestIDs = $util.emptyArray;

    /**
     * ServiceItem serviceLimit.
     * @member {number} serviceLimit
     * @memberof appliancepb.ServiceItem
     * @instance
     */
    ServiceItem.prototype.serviceLimit = 0;

    /**
     * Creates a new ServiceItem instance using the specified properties.
     * @function create
     * @memberof appliancepb.ServiceItem
     * @static
     * @param {appliancepb.IServiceItem=} [properties] Properties to set
     * @returns {appliancepb.ServiceItem} ServiceItem instance
     */
    ServiceItem.create = function create(properties) {
      return new ServiceItem(properties);
    };

    /**
     * Encodes the specified ServiceItem message. Does not implicitly {@link appliancepb.ServiceItem.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.ServiceItem
     * @static
     * @param {appliancepb.IServiceItem} m ServiceItem message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ServiceItem.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.itemID != null && Object.hasOwnProperty.call(m, "itemID"))
        w.uint32(10).string(m.itemID);
      if (m.partRequestIDs != null && m.partRequestIDs.length) {
        for (var i = 0; i < m.partRequestIDs.length; ++i)
          w.uint32(18).string(m.partRequestIDs[i]);
      }
      if (
        m.serviceLimit != null &&
        Object.hasOwnProperty.call(m, "serviceLimit")
      )
        w.uint32(24).int32(m.serviceLimit);
      return w;
    };

    /**
     * Decodes a ServiceItem message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.ServiceItem
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.ServiceItem} ServiceItem
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ServiceItem.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.ServiceItem();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.itemID = r.string();
            break;
          case 2:
            if (!(m.partRequestIDs && m.partRequestIDs.length))
              m.partRequestIDs = [];
            m.partRequestIDs.push(r.string());
            break;
          case 3:
            m.serviceLimit = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ServiceItem;
  })();

  appliancepb.CartItem = (function () {
    /**
     * Properties of a CartItem.
     * @memberof appliancepb
     * @interface ICartItem
     * @property {string|null} [vendor] CartItem vendor
     * @property {string|null} [sku] CartItem sku
     * @property {number|null} [quantity] CartItem quantity
     * @property {number|null} [unitPrice] CartItem unitPrice
     * @property {number|null} [unitTax] CartItem unitTax
     * @property {string|null} [category] CartItem category
     * @property {string|null} [subcategory] CartItem subcategory
     * @property {string|null} [description] CartItem description
     * @property {boolean|null} [isAvailableForZip] CartItem isAvailableForZip
     * @property {number|null} [originalPrice] CartItem originalPrice
     * @property {string|null} [overrideReason] CartItem overrideReason
     */

    /**
     * Constructs a new CartItem.
     * @memberof appliancepb
     * @classdesc Represents a CartItem.
     * @implements ICartItem
     * @constructor
     * @param {appliancepb.ICartItem=} [p] Properties to set
     */
    function CartItem(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * CartItem vendor.
     * @member {string} vendor
     * @memberof appliancepb.CartItem
     * @instance
     */
    CartItem.prototype.vendor = "";

    /**
     * CartItem sku.
     * @member {string} sku
     * @memberof appliancepb.CartItem
     * @instance
     */
    CartItem.prototype.sku = "";

    /**
     * CartItem quantity.
     * @member {number} quantity
     * @memberof appliancepb.CartItem
     * @instance
     */
    CartItem.prototype.quantity = 0;

    /**
     * CartItem unitPrice.
     * @member {number} unitPrice
     * @memberof appliancepb.CartItem
     * @instance
     */
    CartItem.prototype.unitPrice = 0;

    /**
     * CartItem unitTax.
     * @member {number} unitTax
     * @memberof appliancepb.CartItem
     * @instance
     */
    CartItem.prototype.unitTax = 0;

    /**
     * CartItem category.
     * @member {string} category
     * @memberof appliancepb.CartItem
     * @instance
     */
    CartItem.prototype.category = "";

    /**
     * CartItem subcategory.
     * @member {string} subcategory
     * @memberof appliancepb.CartItem
     * @instance
     */
    CartItem.prototype.subcategory = "";

    /**
     * CartItem description.
     * @member {string} description
     * @memberof appliancepb.CartItem
     * @instance
     */
    CartItem.prototype.description = "";

    /**
     * CartItem isAvailableForZip.
     * @member {boolean} isAvailableForZip
     * @memberof appliancepb.CartItem
     * @instance
     */
    CartItem.prototype.isAvailableForZip = false;

    /**
     * CartItem originalPrice.
     * @member {number} originalPrice
     * @memberof appliancepb.CartItem
     * @instance
     */
    CartItem.prototype.originalPrice = 0;

    /**
     * CartItem overrideReason.
     * @member {string} overrideReason
     * @memberof appliancepb.CartItem
     * @instance
     */
    CartItem.prototype.overrideReason = "";

    /**
     * Creates a new CartItem instance using the specified properties.
     * @function create
     * @memberof appliancepb.CartItem
     * @static
     * @param {appliancepb.ICartItem=} [properties] Properties to set
     * @returns {appliancepb.CartItem} CartItem instance
     */
    CartItem.create = function create(properties) {
      return new CartItem(properties);
    };

    /**
     * Encodes the specified CartItem message. Does not implicitly {@link appliancepb.CartItem.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.CartItem
     * @static
     * @param {appliancepb.ICartItem} m CartItem message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CartItem.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.vendor != null && Object.hasOwnProperty.call(m, "vendor"))
        w.uint32(10).string(m.vendor);
      if (m.sku != null && Object.hasOwnProperty.call(m, "sku"))
        w.uint32(18).string(m.sku);
      if (m.quantity != null && Object.hasOwnProperty.call(m, "quantity"))
        w.uint32(24).int32(m.quantity);
      if (m.unitPrice != null && Object.hasOwnProperty.call(m, "unitPrice"))
        w.uint32(32).int32(m.unitPrice);
      if (m.unitTax != null && Object.hasOwnProperty.call(m, "unitTax"))
        w.uint32(40).int32(m.unitTax);
      if (m.category != null && Object.hasOwnProperty.call(m, "category"))
        w.uint32(50).string(m.category);
      if (m.subcategory != null && Object.hasOwnProperty.call(m, "subcategory"))
        w.uint32(58).string(m.subcategory);
      if (m.description != null && Object.hasOwnProperty.call(m, "description"))
        w.uint32(66).string(m.description);
      if (
        m.isAvailableForZip != null &&
        Object.hasOwnProperty.call(m, "isAvailableForZip")
      )
        w.uint32(72).bool(m.isAvailableForZip);
      if (
        m.originalPrice != null &&
        Object.hasOwnProperty.call(m, "originalPrice")
      )
        w.uint32(80).int32(m.originalPrice);
      if (
        m.overrideReason != null &&
        Object.hasOwnProperty.call(m, "overrideReason")
      )
        w.uint32(90).string(m.overrideReason);
      return w;
    };

    /**
     * Decodes a CartItem message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.CartItem
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.CartItem} CartItem
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CartItem.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.CartItem();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.vendor = r.string();
            break;
          case 2:
            m.sku = r.string();
            break;
          case 3:
            m.quantity = r.int32();
            break;
          case 4:
            m.unitPrice = r.int32();
            break;
          case 5:
            m.unitTax = r.int32();
            break;
          case 6:
            m.category = r.string();
            break;
          case 7:
            m.subcategory = r.string();
            break;
          case 8:
            m.description = r.string();
            break;
          case 9:
            m.isAvailableForZip = r.bool();
            break;
          case 10:
            m.originalPrice = r.int32();
            break;
          case 11:
            m.overrideReason = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return CartItem;
  })();

  appliancepb.Cart = (function () {
    /**
     * Properties of a Cart.
     * @memberof appliancepb
     * @interface ICart
     * @property {Array.<appliancepb.ICartItem>|null} [cartItems] Cart cartItems
     * @property {appliancepb.ITaxDetail|null} [taxDetail] Cart taxDetail
     */

    /**
     * Constructs a new Cart.
     * @memberof appliancepb
     * @classdesc Represents a Cart.
     * @implements ICart
     * @constructor
     * @param {appliancepb.ICart=} [p] Properties to set
     */
    function Cart(p) {
      this.cartItems = [];
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * Cart cartItems.
     * @member {Array.<appliancepb.ICartItem>} cartItems
     * @memberof appliancepb.Cart
     * @instance
     */
    Cart.prototype.cartItems = $util.emptyArray;

    /**
     * Cart taxDetail.
     * @member {appliancepb.ITaxDetail|null|undefined} taxDetail
     * @memberof appliancepb.Cart
     * @instance
     */
    Cart.prototype.taxDetail = null;

    /**
     * Creates a new Cart instance using the specified properties.
     * @function create
     * @memberof appliancepb.Cart
     * @static
     * @param {appliancepb.ICart=} [properties] Properties to set
     * @returns {appliancepb.Cart} Cart instance
     */
    Cart.create = function create(properties) {
      return new Cart(properties);
    };

    /**
     * Encodes the specified Cart message. Does not implicitly {@link appliancepb.Cart.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.Cart
     * @static
     * @param {appliancepb.ICart} m Cart message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Cart.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.cartItems != null && m.cartItems.length) {
        for (var i = 0; i < m.cartItems.length; ++i)
          $root.appliancepb.CartItem.encode(
            m.cartItems[i],
            w.uint32(10).fork()
          ).ldelim();
      }
      if (m.taxDetail != null && Object.hasOwnProperty.call(m, "taxDetail"))
        $root.appliancepb.TaxDetail.encode(
          m.taxDetail,
          w.uint32(18).fork()
        ).ldelim();
      return w;
    };

    /**
     * Decodes a Cart message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.Cart
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.Cart} Cart
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Cart.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.Cart();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.cartItems && m.cartItems.length)) m.cartItems = [];
            m.cartItems.push($root.appliancepb.CartItem.decode(r, r.uint32()));
            break;
          case 2:
            m.taxDetail = $root.appliancepb.TaxDetail.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return Cart;
  })();

  appliancepb.PriceInformation = (function () {
    /**
     * Properties of a PriceInformation.
     * @memberof appliancepb
     * @interface IPriceInformation
     * @property {string|null} [productId] PriceInformation productId
     * @property {number|null} [basePrice] PriceInformation basePrice
     * @property {number|null} [accessoriesFee] PriceInformation accessoriesFee
     * @property {number|null} [moveApplianceFee] PriceInformation moveApplianceFee
     * @property {number|null} [disconnectFee] PriceInformation disconnectFee
     * @property {number|null} [installFee] PriceInformation installFee
     * @property {number|null} [deliveryFee] PriceInformation deliveryFee
     * @property {number|null} [disposalFee] PriceInformation disposalFee
     * @property {number|null} [adminFee] PriceInformation adminFee
     * @property {number|null} [upgradeFee] PriceInformation upgradeFee
     * @property {number|null} [taxes] PriceInformation taxes
     * @property {number|null} [discount] PriceInformation discount
     * @property {number|null} [miscellaneous] PriceInformation miscellaneous
     */

    /**
     * Constructs a new PriceInformation.
     * @memberof appliancepb
     * @classdesc Represents a PriceInformation.
     * @implements IPriceInformation
     * @constructor
     * @param {appliancepb.IPriceInformation=} [p] Properties to set
     */
    function PriceInformation(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * PriceInformation productId.
     * @member {string} productId
     * @memberof appliancepb.PriceInformation
     * @instance
     */
    PriceInformation.prototype.productId = "";

    /**
     * PriceInformation basePrice.
     * @member {number} basePrice
     * @memberof appliancepb.PriceInformation
     * @instance
     */
    PriceInformation.prototype.basePrice = 0;

    /**
     * PriceInformation accessoriesFee.
     * @member {number} accessoriesFee
     * @memberof appliancepb.PriceInformation
     * @instance
     */
    PriceInformation.prototype.accessoriesFee = 0;

    /**
     * PriceInformation moveApplianceFee.
     * @member {number} moveApplianceFee
     * @memberof appliancepb.PriceInformation
     * @instance
     */
    PriceInformation.prototype.moveApplianceFee = 0;

    /**
     * PriceInformation disconnectFee.
     * @member {number} disconnectFee
     * @memberof appliancepb.PriceInformation
     * @instance
     */
    PriceInformation.prototype.disconnectFee = 0;

    /**
     * PriceInformation installFee.
     * @member {number} installFee
     * @memberof appliancepb.PriceInformation
     * @instance
     */
    PriceInformation.prototype.installFee = 0;

    /**
     * PriceInformation deliveryFee.
     * @member {number} deliveryFee
     * @memberof appliancepb.PriceInformation
     * @instance
     */
    PriceInformation.prototype.deliveryFee = 0;

    /**
     * PriceInformation disposalFee.
     * @member {number} disposalFee
     * @memberof appliancepb.PriceInformation
     * @instance
     */
    PriceInformation.prototype.disposalFee = 0;

    /**
     * PriceInformation adminFee.
     * @member {number} adminFee
     * @memberof appliancepb.PriceInformation
     * @instance
     */
    PriceInformation.prototype.adminFee = 0;

    /**
     * PriceInformation upgradeFee.
     * @member {number} upgradeFee
     * @memberof appliancepb.PriceInformation
     * @instance
     */
    PriceInformation.prototype.upgradeFee = 0;

    /**
     * PriceInformation taxes.
     * @member {number} taxes
     * @memberof appliancepb.PriceInformation
     * @instance
     */
    PriceInformation.prototype.taxes = 0;

    /**
     * PriceInformation discount.
     * @member {number} discount
     * @memberof appliancepb.PriceInformation
     * @instance
     */
    PriceInformation.prototype.discount = 0;

    /**
     * PriceInformation miscellaneous.
     * @member {number} miscellaneous
     * @memberof appliancepb.PriceInformation
     * @instance
     */
    PriceInformation.prototype.miscellaneous = 0;

    /**
     * Creates a new PriceInformation instance using the specified properties.
     * @function create
     * @memberof appliancepb.PriceInformation
     * @static
     * @param {appliancepb.IPriceInformation=} [properties] Properties to set
     * @returns {appliancepb.PriceInformation} PriceInformation instance
     */
    PriceInformation.create = function create(properties) {
      return new PriceInformation(properties);
    };

    /**
     * Encodes the specified PriceInformation message. Does not implicitly {@link appliancepb.PriceInformation.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.PriceInformation
     * @static
     * @param {appliancepb.IPriceInformation} m PriceInformation message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PriceInformation.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.productId != null && Object.hasOwnProperty.call(m, "productId"))
        w.uint32(10).string(m.productId);
      if (m.basePrice != null && Object.hasOwnProperty.call(m, "basePrice"))
        w.uint32(16).int32(m.basePrice);
      if (
        m.accessoriesFee != null &&
        Object.hasOwnProperty.call(m, "accessoriesFee")
      )
        w.uint32(24).int32(m.accessoriesFee);
      if (
        m.moveApplianceFee != null &&
        Object.hasOwnProperty.call(m, "moveApplianceFee")
      )
        w.uint32(32).int32(m.moveApplianceFee);
      if (
        m.disconnectFee != null &&
        Object.hasOwnProperty.call(m, "disconnectFee")
      )
        w.uint32(40).int32(m.disconnectFee);
      if (m.installFee != null && Object.hasOwnProperty.call(m, "installFee"))
        w.uint32(48).int32(m.installFee);
      if (m.deliveryFee != null && Object.hasOwnProperty.call(m, "deliveryFee"))
        w.uint32(56).int32(m.deliveryFee);
      if (m.disposalFee != null && Object.hasOwnProperty.call(m, "disposalFee"))
        w.uint32(64).int32(m.disposalFee);
      if (m.adminFee != null && Object.hasOwnProperty.call(m, "adminFee"))
        w.uint32(72).int32(m.adminFee);
      if (m.upgradeFee != null && Object.hasOwnProperty.call(m, "upgradeFee"))
        w.uint32(80).int32(m.upgradeFee);
      if (m.taxes != null && Object.hasOwnProperty.call(m, "taxes"))
        w.uint32(88).int32(m.taxes);
      if (m.discount != null && Object.hasOwnProperty.call(m, "discount"))
        w.uint32(96).int32(m.discount);
      if (
        m.miscellaneous != null &&
        Object.hasOwnProperty.call(m, "miscellaneous")
      )
        w.uint32(104).int32(m.miscellaneous);
      return w;
    };

    /**
     * Decodes a PriceInformation message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.PriceInformation
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.PriceInformation} PriceInformation
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PriceInformation.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.PriceInformation();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.productId = r.string();
            break;
          case 2:
            m.basePrice = r.int32();
            break;
          case 3:
            m.accessoriesFee = r.int32();
            break;
          case 4:
            m.moveApplianceFee = r.int32();
            break;
          case 5:
            m.disconnectFee = r.int32();
            break;
          case 6:
            m.installFee = r.int32();
            break;
          case 7:
            m.deliveryFee = r.int32();
            break;
          case 8:
            m.disposalFee = r.int32();
            break;
          case 9:
            m.adminFee = r.int32();
            break;
          case 10:
            m.upgradeFee = r.int32();
            break;
          case 11:
            m.taxes = r.int32();
            break;
          case 12:
            m.discount = r.int32();
            break;
          case 13:
            m.miscellaneous = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return PriceInformation;
  })();

  appliancepb.ApplianceOrder = (function () {
    /**
     * Properties of an ApplianceOrder.
     * @memberof appliancepb
     * @interface IApplianceOrder
     * @property {string|null} [recordId] ApplianceOrder recordId
     * @property {string|null} [recordType] ApplianceOrder recordType
     * @property {google.protobuf.ITimestamp|null} [recordCreateDate] ApplianceOrder recordCreateDate
     * @property {string|null} [companyCode] ApplianceOrder companyCode
     * @property {appliancepb.IContract|null} [contract] ApplianceOrder contract
     * @property {string|null} [dispatchId] ApplianceOrder dispatchId
     * @property {string|null} [partRequestId] ApplianceOrder partRequestId
     * @property {appliancepb.ICustomer|null} [customer] ApplianceOrder customer
     * @property {string|null} [replacementCategory] ApplianceOrder replacementCategory
     * @property {string|null} [recommendedModel] ApplianceOrder recommendedModel
     * @property {appliancepb.IAgent|null} [offerAgent] ApplianceOrder offerAgent
     * @property {number|null} [cilValue] ApplianceOrder cilValue
     * @property {boolean|null} [agentModifiedPrice] ApplianceOrder agentModifiedPrice
     * @property {string|null} [billingState] ApplianceOrder billingState
     * @property {string|null} [paymentAttemptId] ApplianceOrder paymentAttemptId
     * @property {google.protobuf.ITimestamp|null} [paymentDate] ApplianceOrder paymentDate
     * @property {string|null} [purchasedBrand] ApplianceOrder purchasedBrand
     * @property {string|null} [purchasedModel] ApplianceOrder purchasedModel
     * @property {appliancepb.IPriceInformation|null} [purchasePrice] ApplianceOrder purchasePrice
     * @property {number|null} [customerPaidAmount] ApplianceOrder customerPaidAmount
     * @property {string|null} [orderedBy] ApplianceOrder orderedBy
     * @property {google.protobuf.ITimestamp|null} [orderDate] ApplianceOrder orderDate
     * @property {string|null} [vendor] ApplianceOrder vendor
     * @property {string|null} [vendorOrderNumber] ApplianceOrder vendorOrderNumber
     * @property {appliancepb.ICart|null} [cart] ApplianceOrder cart
     * @property {string|null} [comments] ApplianceOrder comments
     */

    /**
     * Constructs a new ApplianceOrder.
     * @memberof appliancepb
     * @classdesc Represents an ApplianceOrder.
     * @implements IApplianceOrder
     * @constructor
     * @param {appliancepb.IApplianceOrder=} [p] Properties to set
     */
    function ApplianceOrder(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * ApplianceOrder recordId.
     * @member {string} recordId
     * @memberof appliancepb.ApplianceOrder
     * @instance
     */
    ApplianceOrder.prototype.recordId = "";

    /**
     * ApplianceOrder recordType.
     * @member {string} recordType
     * @memberof appliancepb.ApplianceOrder
     * @instance
     */
    ApplianceOrder.prototype.recordType = "";

    /**
     * ApplianceOrder recordCreateDate.
     * @member {google.protobuf.ITimestamp|null|undefined} recordCreateDate
     * @memberof appliancepb.ApplianceOrder
     * @instance
     */
    ApplianceOrder.prototype.recordCreateDate = null;

    /**
     * ApplianceOrder companyCode.
     * @member {string} companyCode
     * @memberof appliancepb.ApplianceOrder
     * @instance
     */
    ApplianceOrder.prototype.companyCode = "";

    /**
     * ApplianceOrder contract.
     * @member {appliancepb.IContract|null|undefined} contract
     * @memberof appliancepb.ApplianceOrder
     * @instance
     */
    ApplianceOrder.prototype.contract = null;

    /**
     * ApplianceOrder dispatchId.
     * @member {string} dispatchId
     * @memberof appliancepb.ApplianceOrder
     * @instance
     */
    ApplianceOrder.prototype.dispatchId = "";

    /**
     * ApplianceOrder partRequestId.
     * @member {string} partRequestId
     * @memberof appliancepb.ApplianceOrder
     * @instance
     */
    ApplianceOrder.prototype.partRequestId = "";

    /**
     * ApplianceOrder customer.
     * @member {appliancepb.ICustomer|null|undefined} customer
     * @memberof appliancepb.ApplianceOrder
     * @instance
     */
    ApplianceOrder.prototype.customer = null;

    /**
     * ApplianceOrder replacementCategory.
     * @member {string} replacementCategory
     * @memberof appliancepb.ApplianceOrder
     * @instance
     */
    ApplianceOrder.prototype.replacementCategory = "";

    /**
     * ApplianceOrder recommendedModel.
     * @member {string} recommendedModel
     * @memberof appliancepb.ApplianceOrder
     * @instance
     */
    ApplianceOrder.prototype.recommendedModel = "";

    /**
     * ApplianceOrder offerAgent.
     * @member {appliancepb.IAgent|null|undefined} offerAgent
     * @memberof appliancepb.ApplianceOrder
     * @instance
     */
    ApplianceOrder.prototype.offerAgent = null;

    /**
     * ApplianceOrder cilValue.
     * @member {number} cilValue
     * @memberof appliancepb.ApplianceOrder
     * @instance
     */
    ApplianceOrder.prototype.cilValue = 0;

    /**
     * ApplianceOrder agentModifiedPrice.
     * @member {boolean} agentModifiedPrice
     * @memberof appliancepb.ApplianceOrder
     * @instance
     */
    ApplianceOrder.prototype.agentModifiedPrice = false;

    /**
     * ApplianceOrder billingState.
     * @member {string} billingState
     * @memberof appliancepb.ApplianceOrder
     * @instance
     */
    ApplianceOrder.prototype.billingState = "";

    /**
     * ApplianceOrder paymentAttemptId.
     * @member {string} paymentAttemptId
     * @memberof appliancepb.ApplianceOrder
     * @instance
     */
    ApplianceOrder.prototype.paymentAttemptId = "";

    /**
     * ApplianceOrder paymentDate.
     * @member {google.protobuf.ITimestamp|null|undefined} paymentDate
     * @memberof appliancepb.ApplianceOrder
     * @instance
     */
    ApplianceOrder.prototype.paymentDate = null;

    /**
     * ApplianceOrder purchasedBrand.
     * @member {string} purchasedBrand
     * @memberof appliancepb.ApplianceOrder
     * @instance
     */
    ApplianceOrder.prototype.purchasedBrand = "";

    /**
     * ApplianceOrder purchasedModel.
     * @member {string} purchasedModel
     * @memberof appliancepb.ApplianceOrder
     * @instance
     */
    ApplianceOrder.prototype.purchasedModel = "";

    /**
     * ApplianceOrder purchasePrice.
     * @member {appliancepb.IPriceInformation|null|undefined} purchasePrice
     * @memberof appliancepb.ApplianceOrder
     * @instance
     */
    ApplianceOrder.prototype.purchasePrice = null;

    /**
     * ApplianceOrder customerPaidAmount.
     * @member {number} customerPaidAmount
     * @memberof appliancepb.ApplianceOrder
     * @instance
     */
    ApplianceOrder.prototype.customerPaidAmount = 0;

    /**
     * ApplianceOrder orderedBy.
     * @member {string} orderedBy
     * @memberof appliancepb.ApplianceOrder
     * @instance
     */
    ApplianceOrder.prototype.orderedBy = "";

    /**
     * ApplianceOrder orderDate.
     * @member {google.protobuf.ITimestamp|null|undefined} orderDate
     * @memberof appliancepb.ApplianceOrder
     * @instance
     */
    ApplianceOrder.prototype.orderDate = null;

    /**
     * ApplianceOrder vendor.
     * @member {string} vendor
     * @memberof appliancepb.ApplianceOrder
     * @instance
     */
    ApplianceOrder.prototype.vendor = "";

    /**
     * ApplianceOrder vendorOrderNumber.
     * @member {string} vendorOrderNumber
     * @memberof appliancepb.ApplianceOrder
     * @instance
     */
    ApplianceOrder.prototype.vendorOrderNumber = "";

    /**
     * ApplianceOrder cart.
     * @member {appliancepb.ICart|null|undefined} cart
     * @memberof appliancepb.ApplianceOrder
     * @instance
     */
    ApplianceOrder.prototype.cart = null;

    /**
     * ApplianceOrder comments.
     * @member {string} comments
     * @memberof appliancepb.ApplianceOrder
     * @instance
     */
    ApplianceOrder.prototype.comments = "";

    /**
     * Creates a new ApplianceOrder instance using the specified properties.
     * @function create
     * @memberof appliancepb.ApplianceOrder
     * @static
     * @param {appliancepb.IApplianceOrder=} [properties] Properties to set
     * @returns {appliancepb.ApplianceOrder} ApplianceOrder instance
     */
    ApplianceOrder.create = function create(properties) {
      return new ApplianceOrder(properties);
    };

    /**
     * Encodes the specified ApplianceOrder message. Does not implicitly {@link appliancepb.ApplianceOrder.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.ApplianceOrder
     * @static
     * @param {appliancepb.IApplianceOrder} m ApplianceOrder message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ApplianceOrder.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.recordId != null && Object.hasOwnProperty.call(m, "recordId"))
        w.uint32(10).string(m.recordId);
      if (m.recordType != null && Object.hasOwnProperty.call(m, "recordType"))
        w.uint32(18).string(m.recordType);
      if (
        m.recordCreateDate != null &&
        Object.hasOwnProperty.call(m, "recordCreateDate")
      )
        $root.google.protobuf.Timestamp.encode(
          m.recordCreateDate,
          w.uint32(26).fork()
        ).ldelim();
      if (m.companyCode != null && Object.hasOwnProperty.call(m, "companyCode"))
        w.uint32(34).string(m.companyCode);
      if (m.contract != null && Object.hasOwnProperty.call(m, "contract"))
        $root.appliancepb.Contract.encode(
          m.contract,
          w.uint32(42).fork()
        ).ldelim();
      if (m.dispatchId != null && Object.hasOwnProperty.call(m, "dispatchId"))
        w.uint32(50).string(m.dispatchId);
      if (
        m.partRequestId != null &&
        Object.hasOwnProperty.call(m, "partRequestId")
      )
        w.uint32(58).string(m.partRequestId);
      if (m.customer != null && Object.hasOwnProperty.call(m, "customer"))
        $root.appliancepb.Customer.encode(
          m.customer,
          w.uint32(66).fork()
        ).ldelim();
      if (
        m.replacementCategory != null &&
        Object.hasOwnProperty.call(m, "replacementCategory")
      )
        w.uint32(74).string(m.replacementCategory);
      if (
        m.recommendedModel != null &&
        Object.hasOwnProperty.call(m, "recommendedModel")
      )
        w.uint32(82).string(m.recommendedModel);
      if (m.offerAgent != null && Object.hasOwnProperty.call(m, "offerAgent"))
        $root.appliancepb.Agent.encode(
          m.offerAgent,
          w.uint32(90).fork()
        ).ldelim();
      if (m.cilValue != null && Object.hasOwnProperty.call(m, "cilValue"))
        w.uint32(96).int32(m.cilValue);
      if (
        m.agentModifiedPrice != null &&
        Object.hasOwnProperty.call(m, "agentModifiedPrice")
      )
        w.uint32(104).bool(m.agentModifiedPrice);
      if (
        m.billingState != null &&
        Object.hasOwnProperty.call(m, "billingState")
      )
        w.uint32(114).string(m.billingState);
      if (
        m.paymentAttemptId != null &&
        Object.hasOwnProperty.call(m, "paymentAttemptId")
      )
        w.uint32(122).string(m.paymentAttemptId);
      if (m.paymentDate != null && Object.hasOwnProperty.call(m, "paymentDate"))
        $root.google.protobuf.Timestamp.encode(
          m.paymentDate,
          w.uint32(130).fork()
        ).ldelim();
      if (
        m.purchasedBrand != null &&
        Object.hasOwnProperty.call(m, "purchasedBrand")
      )
        w.uint32(138).string(m.purchasedBrand);
      if (
        m.purchasedModel != null &&
        Object.hasOwnProperty.call(m, "purchasedModel")
      )
        w.uint32(146).string(m.purchasedModel);
      if (
        m.purchasePrice != null &&
        Object.hasOwnProperty.call(m, "purchasePrice")
      )
        $root.appliancepb.PriceInformation.encode(
          m.purchasePrice,
          w.uint32(154).fork()
        ).ldelim();
      if (
        m.customerPaidAmount != null &&
        Object.hasOwnProperty.call(m, "customerPaidAmount")
      )
        w.uint32(160).int32(m.customerPaidAmount);
      if (m.orderedBy != null && Object.hasOwnProperty.call(m, "orderedBy"))
        w.uint32(170).string(m.orderedBy);
      if (m.orderDate != null && Object.hasOwnProperty.call(m, "orderDate"))
        $root.google.protobuf.Timestamp.encode(
          m.orderDate,
          w.uint32(178).fork()
        ).ldelim();
      if (m.vendor != null && Object.hasOwnProperty.call(m, "vendor"))
        w.uint32(186).string(m.vendor);
      if (
        m.vendorOrderNumber != null &&
        Object.hasOwnProperty.call(m, "vendorOrderNumber")
      )
        w.uint32(194).string(m.vendorOrderNumber);
      if (m.cart != null && Object.hasOwnProperty.call(m, "cart"))
        $root.appliancepb.Cart.encode(m.cart, w.uint32(202).fork()).ldelim();
      if (m.comments != null && Object.hasOwnProperty.call(m, "comments"))
        w.uint32(210).string(m.comments);
      return w;
    };

    /**
     * Decodes an ApplianceOrder message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.ApplianceOrder
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.ApplianceOrder} ApplianceOrder
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ApplianceOrder.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.ApplianceOrder();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.recordId = r.string();
            break;
          case 2:
            m.recordType = r.string();
            break;
          case 3:
            m.recordCreateDate = $root.google.protobuf.Timestamp.decode(
              r,
              r.uint32()
            );
            break;
          case 4:
            m.companyCode = r.string();
            break;
          case 5:
            m.contract = $root.appliancepb.Contract.decode(r, r.uint32());
            break;
          case 6:
            m.dispatchId = r.string();
            break;
          case 7:
            m.partRequestId = r.string();
            break;
          case 8:
            m.customer = $root.appliancepb.Customer.decode(r, r.uint32());
            break;
          case 9:
            m.replacementCategory = r.string();
            break;
          case 10:
            m.recommendedModel = r.string();
            break;
          case 11:
            m.offerAgent = $root.appliancepb.Agent.decode(r, r.uint32());
            break;
          case 12:
            m.cilValue = r.int32();
            break;
          case 13:
            m.agentModifiedPrice = r.bool();
            break;
          case 14:
            m.billingState = r.string();
            break;
          case 15:
            m.paymentAttemptId = r.string();
            break;
          case 16:
            m.paymentDate = $root.google.protobuf.Timestamp.decode(
              r,
              r.uint32()
            );
            break;
          case 17:
            m.purchasedBrand = r.string();
            break;
          case 18:
            m.purchasedModel = r.string();
            break;
          case 19:
            m.purchasePrice = $root.appliancepb.PriceInformation.decode(
              r,
              r.uint32()
            );
            break;
          case 20:
            m.customerPaidAmount = r.int32();
            break;
          case 21:
            m.orderedBy = r.string();
            break;
          case 22:
            m.orderDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
            break;
          case 23:
            m.vendor = r.string();
            break;
          case 24:
            m.vendorOrderNumber = r.string();
            break;
          case 25:
            m.cart = $root.appliancepb.Cart.decode(r, r.uint32());
            break;
          case 26:
            m.comments = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ApplianceOrder;
  })();

  appliancepb.WPApplianceOrder = (function () {
    /**
     * Properties of a WPApplianceOrder.
     * @memberof appliancepb
     * @interface IWPApplianceOrder
     * @property {string|null} [wpOrderNumber] WPApplianceOrder wpOrderNumber
     * @property {string|null} [isUpgradeOrder] WPApplianceOrder isUpgradeOrder
     * @property {string|null} [disposalSelected] WPApplianceOrder disposalSelected
     * @property {string|null} [orderState] WPApplianceOrder orderState
     * @property {string|null} [dispatchID] WPApplianceOrder dispatchID
     * @property {string|null} [itemID] WPApplianceOrder itemID
     * @property {string|null} [partRequestID] WPApplianceOrder partRequestID
     * @property {string|null} [replacementBrand] WPApplianceOrder replacementBrand
     * @property {string|null} [contractNumber] WPApplianceOrder contractNumber
     * @property {string|null} [recommendedModel] WPApplianceOrder recommendedModel
     * @property {string|null} [customerBoughtModel] WPApplianceOrder customerBoughtModel
     * @property {string|null} [replacementItem] WPApplianceOrder replacementItem
     * @property {string|null} [orderCreatedDate] WPApplianceOrder orderCreatedDate
     * @property {string|null} [recommendationDate] WPApplianceOrder recommendationDate
     * @property {string|null} [phoneNumber] WPApplianceOrder phoneNumber
     * @property {string|null} [transactionAmount] WPApplianceOrder transactionAmount
     * @property {string|null} [adminFee] WPApplianceOrder adminFee
     * @property {string|null} [disposalFee] WPApplianceOrder disposalFee
     * @property {string|null} [transactionID] WPApplianceOrder transactionID
     * @property {string|null} [transactionDate] WPApplianceOrder transactionDate
     * @property {string|null} [companyCode] WPApplianceOrder companyCode
     * @property {string|null} [customerFirstName] WPApplianceOrder customerFirstName
     * @property {string|null} [customerLastName] WPApplianceOrder customerLastName
     * @property {string|null} [email] WPApplianceOrder email
     * @property {string|null} [billingState] WPApplianceOrder billingState
     * @property {string|null} [orderedBy] WPApplianceOrder orderedBy
     * @property {string|null} [comments] WPApplianceOrder comments
     * @property {string|null} [replacementID] WPApplianceOrder replacementID
     * @property {string|null} [orderStatus] WPApplianceOrder orderStatus
     * @property {string|null} [cilValue] WPApplianceOrder cilValue
     * @property {string|null} [basePrice] WPApplianceOrder basePrice
     * @property {string|null} [homeOwnerCost] WPApplianceOrder homeOwnerCost
     * @property {string|null} [disconnectFee] WPApplianceOrder disconnectFee
     * @property {string|null} [installFee] WPApplianceOrder installFee
     * @property {string|null} [deliveryFee] WPApplianceOrder deliveryFee
     * @property {string|null} [moveApplianceFee] WPApplianceOrder moveApplianceFee
     * @property {string|null} [restockingFee] WPApplianceOrder restockingFee
     * @property {string|null} [taxes] WPApplianceOrder taxes
     * @property {string|null} [serviceCodes] WPApplianceOrder serviceCodes
     * @property {string|null} [serviceFees] WPApplianceOrder serviceFees
     * @property {string|null} [recordID] WPApplianceOrder recordID
     */

    /**
     * Constructs a new WPApplianceOrder.
     * @memberof appliancepb
     * @classdesc Represents a WPApplianceOrder.
     * @implements IWPApplianceOrder
     * @constructor
     * @param {appliancepb.IWPApplianceOrder=} [p] Properties to set
     */
    function WPApplianceOrder(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * WPApplianceOrder wpOrderNumber.
     * @member {string} wpOrderNumber
     * @memberof appliancepb.WPApplianceOrder
     * @instance
     */
    WPApplianceOrder.prototype.wpOrderNumber = "";

    /**
     * WPApplianceOrder isUpgradeOrder.
     * @member {string} isUpgradeOrder
     * @memberof appliancepb.WPApplianceOrder
     * @instance
     */
    WPApplianceOrder.prototype.isUpgradeOrder = "";

    /**
     * WPApplianceOrder disposalSelected.
     * @member {string} disposalSelected
     * @memberof appliancepb.WPApplianceOrder
     * @instance
     */
    WPApplianceOrder.prototype.disposalSelected = "";

    /**
     * WPApplianceOrder orderState.
     * @member {string} orderState
     * @memberof appliancepb.WPApplianceOrder
     * @instance
     */
    WPApplianceOrder.prototype.orderState = "";

    /**
     * WPApplianceOrder dispatchID.
     * @member {string} dispatchID
     * @memberof appliancepb.WPApplianceOrder
     * @instance
     */
    WPApplianceOrder.prototype.dispatchID = "";

    /**
     * WPApplianceOrder itemID.
     * @member {string} itemID
     * @memberof appliancepb.WPApplianceOrder
     * @instance
     */
    WPApplianceOrder.prototype.itemID = "";

    /**
     * WPApplianceOrder partRequestID.
     * @member {string} partRequestID
     * @memberof appliancepb.WPApplianceOrder
     * @instance
     */
    WPApplianceOrder.prototype.partRequestID = "";

    /**
     * WPApplianceOrder replacementBrand.
     * @member {string} replacementBrand
     * @memberof appliancepb.WPApplianceOrder
     * @instance
     */
    WPApplianceOrder.prototype.replacementBrand = "";

    /**
     * WPApplianceOrder contractNumber.
     * @member {string} contractNumber
     * @memberof appliancepb.WPApplianceOrder
     * @instance
     */
    WPApplianceOrder.prototype.contractNumber = "";

    /**
     * WPApplianceOrder recommendedModel.
     * @member {string} recommendedModel
     * @memberof appliancepb.WPApplianceOrder
     * @instance
     */
    WPApplianceOrder.prototype.recommendedModel = "";

    /**
     * WPApplianceOrder customerBoughtModel.
     * @member {string} customerBoughtModel
     * @memberof appliancepb.WPApplianceOrder
     * @instance
     */
    WPApplianceOrder.prototype.customerBoughtModel = "";

    /**
     * WPApplianceOrder replacementItem.
     * @member {string} replacementItem
     * @memberof appliancepb.WPApplianceOrder
     * @instance
     */
    WPApplianceOrder.prototype.replacementItem = "";

    /**
     * WPApplianceOrder orderCreatedDate.
     * @member {string} orderCreatedDate
     * @memberof appliancepb.WPApplianceOrder
     * @instance
     */
    WPApplianceOrder.prototype.orderCreatedDate = "";

    /**
     * WPApplianceOrder recommendationDate.
     * @member {string} recommendationDate
     * @memberof appliancepb.WPApplianceOrder
     * @instance
     */
    WPApplianceOrder.prototype.recommendationDate = "";

    /**
     * WPApplianceOrder phoneNumber.
     * @member {string} phoneNumber
     * @memberof appliancepb.WPApplianceOrder
     * @instance
     */
    WPApplianceOrder.prototype.phoneNumber = "";

    /**
     * WPApplianceOrder transactionAmount.
     * @member {string} transactionAmount
     * @memberof appliancepb.WPApplianceOrder
     * @instance
     */
    WPApplianceOrder.prototype.transactionAmount = "";

    /**
     * WPApplianceOrder adminFee.
     * @member {string} adminFee
     * @memberof appliancepb.WPApplianceOrder
     * @instance
     */
    WPApplianceOrder.prototype.adminFee = "";

    /**
     * WPApplianceOrder disposalFee.
     * @member {string} disposalFee
     * @memberof appliancepb.WPApplianceOrder
     * @instance
     */
    WPApplianceOrder.prototype.disposalFee = "";

    /**
     * WPApplianceOrder transactionID.
     * @member {string} transactionID
     * @memberof appliancepb.WPApplianceOrder
     * @instance
     */
    WPApplianceOrder.prototype.transactionID = "";

    /**
     * WPApplianceOrder transactionDate.
     * @member {string} transactionDate
     * @memberof appliancepb.WPApplianceOrder
     * @instance
     */
    WPApplianceOrder.prototype.transactionDate = "";

    /**
     * WPApplianceOrder companyCode.
     * @member {string} companyCode
     * @memberof appliancepb.WPApplianceOrder
     * @instance
     */
    WPApplianceOrder.prototype.companyCode = "";

    /**
     * WPApplianceOrder customerFirstName.
     * @member {string} customerFirstName
     * @memberof appliancepb.WPApplianceOrder
     * @instance
     */
    WPApplianceOrder.prototype.customerFirstName = "";

    /**
     * WPApplianceOrder customerLastName.
     * @member {string} customerLastName
     * @memberof appliancepb.WPApplianceOrder
     * @instance
     */
    WPApplianceOrder.prototype.customerLastName = "";

    /**
     * WPApplianceOrder email.
     * @member {string} email
     * @memberof appliancepb.WPApplianceOrder
     * @instance
     */
    WPApplianceOrder.prototype.email = "";

    /**
     * WPApplianceOrder billingState.
     * @member {string} billingState
     * @memberof appliancepb.WPApplianceOrder
     * @instance
     */
    WPApplianceOrder.prototype.billingState = "";

    /**
     * WPApplianceOrder orderedBy.
     * @member {string} orderedBy
     * @memberof appliancepb.WPApplianceOrder
     * @instance
     */
    WPApplianceOrder.prototype.orderedBy = "";

    /**
     * WPApplianceOrder comments.
     * @member {string} comments
     * @memberof appliancepb.WPApplianceOrder
     * @instance
     */
    WPApplianceOrder.prototype.comments = "";

    /**
     * WPApplianceOrder replacementID.
     * @member {string} replacementID
     * @memberof appliancepb.WPApplianceOrder
     * @instance
     */
    WPApplianceOrder.prototype.replacementID = "";

    /**
     * WPApplianceOrder orderStatus.
     * @member {string} orderStatus
     * @memberof appliancepb.WPApplianceOrder
     * @instance
     */
    WPApplianceOrder.prototype.orderStatus = "";

    /**
     * WPApplianceOrder cilValue.
     * @member {string} cilValue
     * @memberof appliancepb.WPApplianceOrder
     * @instance
     */
    WPApplianceOrder.prototype.cilValue = "";

    /**
     * WPApplianceOrder basePrice.
     * @member {string} basePrice
     * @memberof appliancepb.WPApplianceOrder
     * @instance
     */
    WPApplianceOrder.prototype.basePrice = "";

    /**
     * WPApplianceOrder homeOwnerCost.
     * @member {string} homeOwnerCost
     * @memberof appliancepb.WPApplianceOrder
     * @instance
     */
    WPApplianceOrder.prototype.homeOwnerCost = "";

    /**
     * WPApplianceOrder disconnectFee.
     * @member {string} disconnectFee
     * @memberof appliancepb.WPApplianceOrder
     * @instance
     */
    WPApplianceOrder.prototype.disconnectFee = "";

    /**
     * WPApplianceOrder installFee.
     * @member {string} installFee
     * @memberof appliancepb.WPApplianceOrder
     * @instance
     */
    WPApplianceOrder.prototype.installFee = "";

    /**
     * WPApplianceOrder deliveryFee.
     * @member {string} deliveryFee
     * @memberof appliancepb.WPApplianceOrder
     * @instance
     */
    WPApplianceOrder.prototype.deliveryFee = "";

    /**
     * WPApplianceOrder moveApplianceFee.
     * @member {string} moveApplianceFee
     * @memberof appliancepb.WPApplianceOrder
     * @instance
     */
    WPApplianceOrder.prototype.moveApplianceFee = "";

    /**
     * WPApplianceOrder restockingFee.
     * @member {string} restockingFee
     * @memberof appliancepb.WPApplianceOrder
     * @instance
     */
    WPApplianceOrder.prototype.restockingFee = "";

    /**
     * WPApplianceOrder taxes.
     * @member {string} taxes
     * @memberof appliancepb.WPApplianceOrder
     * @instance
     */
    WPApplianceOrder.prototype.taxes = "";

    /**
     * WPApplianceOrder serviceCodes.
     * @member {string} serviceCodes
     * @memberof appliancepb.WPApplianceOrder
     * @instance
     */
    WPApplianceOrder.prototype.serviceCodes = "";

    /**
     * WPApplianceOrder serviceFees.
     * @member {string} serviceFees
     * @memberof appliancepb.WPApplianceOrder
     * @instance
     */
    WPApplianceOrder.prototype.serviceFees = "";

    /**
     * WPApplianceOrder recordID.
     * @member {string} recordID
     * @memberof appliancepb.WPApplianceOrder
     * @instance
     */
    WPApplianceOrder.prototype.recordID = "";

    /**
     * Creates a new WPApplianceOrder instance using the specified properties.
     * @function create
     * @memberof appliancepb.WPApplianceOrder
     * @static
     * @param {appliancepb.IWPApplianceOrder=} [properties] Properties to set
     * @returns {appliancepb.WPApplianceOrder} WPApplianceOrder instance
     */
    WPApplianceOrder.create = function create(properties) {
      return new WPApplianceOrder(properties);
    };

    /**
     * Encodes the specified WPApplianceOrder message. Does not implicitly {@link appliancepb.WPApplianceOrder.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.WPApplianceOrder
     * @static
     * @param {appliancepb.IWPApplianceOrder} m WPApplianceOrder message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WPApplianceOrder.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (
        m.wpOrderNumber != null &&
        Object.hasOwnProperty.call(m, "wpOrderNumber")
      )
        w.uint32(10).string(m.wpOrderNumber);
      if (
        m.isUpgradeOrder != null &&
        Object.hasOwnProperty.call(m, "isUpgradeOrder")
      )
        w.uint32(18).string(m.isUpgradeOrder);
      if (
        m.disposalSelected != null &&
        Object.hasOwnProperty.call(m, "disposalSelected")
      )
        w.uint32(26).string(m.disposalSelected);
      if (m.orderState != null && Object.hasOwnProperty.call(m, "orderState"))
        w.uint32(34).string(m.orderState);
      if (m.dispatchID != null && Object.hasOwnProperty.call(m, "dispatchID"))
        w.uint32(42).string(m.dispatchID);
      if (m.itemID != null && Object.hasOwnProperty.call(m, "itemID"))
        w.uint32(50).string(m.itemID);
      if (
        m.partRequestID != null &&
        Object.hasOwnProperty.call(m, "partRequestID")
      )
        w.uint32(58).string(m.partRequestID);
      if (
        m.replacementBrand != null &&
        Object.hasOwnProperty.call(m, "replacementBrand")
      )
        w.uint32(66).string(m.replacementBrand);
      if (
        m.contractNumber != null &&
        Object.hasOwnProperty.call(m, "contractNumber")
      )
        w.uint32(74).string(m.contractNumber);
      if (
        m.recommendedModel != null &&
        Object.hasOwnProperty.call(m, "recommendedModel")
      )
        w.uint32(82).string(m.recommendedModel);
      if (
        m.customerBoughtModel != null &&
        Object.hasOwnProperty.call(m, "customerBoughtModel")
      )
        w.uint32(90).string(m.customerBoughtModel);
      if (
        m.replacementItem != null &&
        Object.hasOwnProperty.call(m, "replacementItem")
      )
        w.uint32(98).string(m.replacementItem);
      if (
        m.orderCreatedDate != null &&
        Object.hasOwnProperty.call(m, "orderCreatedDate")
      )
        w.uint32(106).string(m.orderCreatedDate);
      if (
        m.recommendationDate != null &&
        Object.hasOwnProperty.call(m, "recommendationDate")
      )
        w.uint32(114).string(m.recommendationDate);
      if (m.phoneNumber != null && Object.hasOwnProperty.call(m, "phoneNumber"))
        w.uint32(122).string(m.phoneNumber);
      if (
        m.transactionAmount != null &&
        Object.hasOwnProperty.call(m, "transactionAmount")
      )
        w.uint32(130).string(m.transactionAmount);
      if (m.adminFee != null && Object.hasOwnProperty.call(m, "adminFee"))
        w.uint32(138).string(m.adminFee);
      if (m.disposalFee != null && Object.hasOwnProperty.call(m, "disposalFee"))
        w.uint32(146).string(m.disposalFee);
      if (
        m.transactionID != null &&
        Object.hasOwnProperty.call(m, "transactionID")
      )
        w.uint32(154).string(m.transactionID);
      if (
        m.transactionDate != null &&
        Object.hasOwnProperty.call(m, "transactionDate")
      )
        w.uint32(162).string(m.transactionDate);
      if (m.companyCode != null && Object.hasOwnProperty.call(m, "companyCode"))
        w.uint32(170).string(m.companyCode);
      if (
        m.customerFirstName != null &&
        Object.hasOwnProperty.call(m, "customerFirstName")
      )
        w.uint32(178).string(m.customerFirstName);
      if (
        m.customerLastName != null &&
        Object.hasOwnProperty.call(m, "customerLastName")
      )
        w.uint32(186).string(m.customerLastName);
      if (m.email != null && Object.hasOwnProperty.call(m, "email"))
        w.uint32(194).string(m.email);
      if (
        m.billingState != null &&
        Object.hasOwnProperty.call(m, "billingState")
      )
        w.uint32(202).string(m.billingState);
      if (m.orderedBy != null && Object.hasOwnProperty.call(m, "orderedBy"))
        w.uint32(210).string(m.orderedBy);
      if (m.comments != null && Object.hasOwnProperty.call(m, "comments"))
        w.uint32(218).string(m.comments);
      if (
        m.replacementID != null &&
        Object.hasOwnProperty.call(m, "replacementID")
      )
        w.uint32(226).string(m.replacementID);
      if (m.orderStatus != null && Object.hasOwnProperty.call(m, "orderStatus"))
        w.uint32(234).string(m.orderStatus);
      if (m.cilValue != null && Object.hasOwnProperty.call(m, "cilValue"))
        w.uint32(242).string(m.cilValue);
      if (m.basePrice != null && Object.hasOwnProperty.call(m, "basePrice"))
        w.uint32(250).string(m.basePrice);
      if (
        m.homeOwnerCost != null &&
        Object.hasOwnProperty.call(m, "homeOwnerCost")
      )
        w.uint32(258).string(m.homeOwnerCost);
      if (
        m.disconnectFee != null &&
        Object.hasOwnProperty.call(m, "disconnectFee")
      )
        w.uint32(266).string(m.disconnectFee);
      if (m.installFee != null && Object.hasOwnProperty.call(m, "installFee"))
        w.uint32(274).string(m.installFee);
      if (m.deliveryFee != null && Object.hasOwnProperty.call(m, "deliveryFee"))
        w.uint32(282).string(m.deliveryFee);
      if (
        m.moveApplianceFee != null &&
        Object.hasOwnProperty.call(m, "moveApplianceFee")
      )
        w.uint32(290).string(m.moveApplianceFee);
      if (
        m.restockingFee != null &&
        Object.hasOwnProperty.call(m, "restockingFee")
      )
        w.uint32(298).string(m.restockingFee);
      if (m.taxes != null && Object.hasOwnProperty.call(m, "taxes"))
        w.uint32(306).string(m.taxes);
      if (
        m.serviceCodes != null &&
        Object.hasOwnProperty.call(m, "serviceCodes")
      )
        w.uint32(314).string(m.serviceCodes);
      if (m.serviceFees != null && Object.hasOwnProperty.call(m, "serviceFees"))
        w.uint32(322).string(m.serviceFees);
      if (m.recordID != null && Object.hasOwnProperty.call(m, "recordID"))
        w.uint32(330).string(m.recordID);
      return w;
    };

    /**
     * Decodes a WPApplianceOrder message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.WPApplianceOrder
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.WPApplianceOrder} WPApplianceOrder
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WPApplianceOrder.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.WPApplianceOrder();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.wpOrderNumber = r.string();
            break;
          case 2:
            m.isUpgradeOrder = r.string();
            break;
          case 3:
            m.disposalSelected = r.string();
            break;
          case 4:
            m.orderState = r.string();
            break;
          case 5:
            m.dispatchID = r.string();
            break;
          case 6:
            m.itemID = r.string();
            break;
          case 7:
            m.partRequestID = r.string();
            break;
          case 8:
            m.replacementBrand = r.string();
            break;
          case 9:
            m.contractNumber = r.string();
            break;
          case 10:
            m.recommendedModel = r.string();
            break;
          case 11:
            m.customerBoughtModel = r.string();
            break;
          case 12:
            m.replacementItem = r.string();
            break;
          case 13:
            m.orderCreatedDate = r.string();
            break;
          case 14:
            m.recommendationDate = r.string();
            break;
          case 15:
            m.phoneNumber = r.string();
            break;
          case 16:
            m.transactionAmount = r.string();
            break;
          case 17:
            m.adminFee = r.string();
            break;
          case 18:
            m.disposalFee = r.string();
            break;
          case 19:
            m.transactionID = r.string();
            break;
          case 20:
            m.transactionDate = r.string();
            break;
          case 21:
            m.companyCode = r.string();
            break;
          case 22:
            m.customerFirstName = r.string();
            break;
          case 23:
            m.customerLastName = r.string();
            break;
          case 24:
            m.email = r.string();
            break;
          case 25:
            m.billingState = r.string();
            break;
          case 26:
            m.orderedBy = r.string();
            break;
          case 27:
            m.comments = r.string();
            break;
          case 28:
            m.replacementID = r.string();
            break;
          case 29:
            m.orderStatus = r.string();
            break;
          case 30:
            m.cilValue = r.string();
            break;
          case 31:
            m.basePrice = r.string();
            break;
          case 32:
            m.homeOwnerCost = r.string();
            break;
          case 33:
            m.disconnectFee = r.string();
            break;
          case 34:
            m.installFee = r.string();
            break;
          case 35:
            m.deliveryFee = r.string();
            break;
          case 36:
            m.moveApplianceFee = r.string();
            break;
          case 37:
            m.restockingFee = r.string();
            break;
          case 38:
            m.taxes = r.string();
            break;
          case 39:
            m.serviceCodes = r.string();
            break;
          case 40:
            m.serviceFees = r.string();
            break;
          case 41:
            m.recordID = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return WPApplianceOrder;
  })();

  appliancepb.GEApplianceOrder = (function () {
    /**
     * Properties of a GEApplianceOrder.
     * @memberof appliancepb
     * @interface IGEApplianceOrder
     * @property {string|null} [geOrderNumber] GEApplianceOrder geOrderNumber
     * @property {string|null} [isUpgradeOrder] GEApplianceOrder isUpgradeOrder
     * @property {string|null} [disposalSelected] GEApplianceOrder disposalSelected
     * @property {string|null} [orderState] GEApplianceOrder orderState
     * @property {string|null} [dispatchID] GEApplianceOrder dispatchID
     * @property {string|null} [itemID] GEApplianceOrder itemID
     * @property {string|null} [partRequestID] GEApplianceOrder partRequestID
     * @property {string|null} [contractNumber] GEApplianceOrder contractNumber
     * @property {string|null} [recommendedModel] GEApplianceOrder recommendedModel
     * @property {string|null} [customerBoughtModel] GEApplianceOrder customerBoughtModel
     * @property {string|null} [replacementItem] GEApplianceOrder replacementItem
     * @property {string|null} [orderCreatedDate] GEApplianceOrder orderCreatedDate
     * @property {string|null} [recommendationDate] GEApplianceOrder recommendationDate
     * @property {string|null} [phoneNumber] GEApplianceOrder phoneNumber
     * @property {string|null} [transactionAmount] GEApplianceOrder transactionAmount
     * @property {string|null} [adminFee] GEApplianceOrder adminFee
     * @property {string|null} [disposalFee] GEApplianceOrder disposalFee
     * @property {string|null} [transactionID] GEApplianceOrder transactionID
     * @property {string|null} [transactionDate] GEApplianceOrder transactionDate
     * @property {string|null} [companyCode] GEApplianceOrder companyCode
     * @property {string|null} [customerFirstName] GEApplianceOrder customerFirstName
     * @property {string|null} [customerLastName] GEApplianceOrder customerLastName
     * @property {string|null} [email] GEApplianceOrder email
     * @property {string|null} [billingState] GEApplianceOrder billingState
     * @property {string|null} [installerName] GEApplianceOrder installerName
     * @property {string|null} [installerAddress1] GEApplianceOrder installerAddress1
     * @property {string|null} [installerCity] GEApplianceOrder installerCity
     * @property {string|null} [installerZip] GEApplianceOrder installerZip
     * @property {string|null} [installerState] GEApplianceOrder installerState
     * @property {string|null} [installerPhone] GEApplianceOrder installerPhone
     * @property {string|null} [orderedBy] GEApplianceOrder orderedBy
     * @property {string|null} [comments] GEApplianceOrder comments
     * @property {string|null} [replacementID] GEApplianceOrder replacementID
     * @property {string|null} [orderStatus] GEApplianceOrder orderStatus
     * @property {string|null} [cilValue] GEApplianceOrder cilValue
     * @property {string|null} [basePrice] GEApplianceOrder basePrice
     * @property {string|null} [homeOwnerCost] GEApplianceOrder homeOwnerCost
     * @property {string|null} [disconnectFee] GEApplianceOrder disconnectFee
     * @property {string|null} [installFee] GEApplianceOrder installFee
     * @property {string|null} [deliveryFee] GEApplianceOrder deliveryFee
     * @property {string|null} [moveApplianceFee] GEApplianceOrder moveApplianceFee
     * @property {string|null} [restockingFee] GEApplianceOrder restockingFee
     * @property {string|null} [taxes] GEApplianceOrder taxes
     * @property {string|null} [serviceCodes] GEApplianceOrder serviceCodes
     * @property {string|null} [serviceFees] GEApplianceOrder serviceFees
     * @property {string|null} [recordID] GEApplianceOrder recordID
     */

    /**
     * Constructs a new GEApplianceOrder.
     * @memberof appliancepb
     * @classdesc Represents a GEApplianceOrder.
     * @implements IGEApplianceOrder
     * @constructor
     * @param {appliancepb.IGEApplianceOrder=} [p] Properties to set
     */
    function GEApplianceOrder(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * GEApplianceOrder geOrderNumber.
     * @member {string} geOrderNumber
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.geOrderNumber = "";

    /**
     * GEApplianceOrder isUpgradeOrder.
     * @member {string} isUpgradeOrder
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.isUpgradeOrder = "";

    /**
     * GEApplianceOrder disposalSelected.
     * @member {string} disposalSelected
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.disposalSelected = "";

    /**
     * GEApplianceOrder orderState.
     * @member {string} orderState
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.orderState = "";

    /**
     * GEApplianceOrder dispatchID.
     * @member {string} dispatchID
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.dispatchID = "";

    /**
     * GEApplianceOrder itemID.
     * @member {string} itemID
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.itemID = "";

    /**
     * GEApplianceOrder partRequestID.
     * @member {string} partRequestID
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.partRequestID = "";

    /**
     * GEApplianceOrder contractNumber.
     * @member {string} contractNumber
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.contractNumber = "";

    /**
     * GEApplianceOrder recommendedModel.
     * @member {string} recommendedModel
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.recommendedModel = "";

    /**
     * GEApplianceOrder customerBoughtModel.
     * @member {string} customerBoughtModel
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.customerBoughtModel = "";

    /**
     * GEApplianceOrder replacementItem.
     * @member {string} replacementItem
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.replacementItem = "";

    /**
     * GEApplianceOrder orderCreatedDate.
     * @member {string} orderCreatedDate
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.orderCreatedDate = "";

    /**
     * GEApplianceOrder recommendationDate.
     * @member {string} recommendationDate
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.recommendationDate = "";

    /**
     * GEApplianceOrder phoneNumber.
     * @member {string} phoneNumber
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.phoneNumber = "";

    /**
     * GEApplianceOrder transactionAmount.
     * @member {string} transactionAmount
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.transactionAmount = "";

    /**
     * GEApplianceOrder adminFee.
     * @member {string} adminFee
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.adminFee = "";

    /**
     * GEApplianceOrder disposalFee.
     * @member {string} disposalFee
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.disposalFee = "";

    /**
     * GEApplianceOrder transactionID.
     * @member {string} transactionID
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.transactionID = "";

    /**
     * GEApplianceOrder transactionDate.
     * @member {string} transactionDate
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.transactionDate = "";

    /**
     * GEApplianceOrder companyCode.
     * @member {string} companyCode
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.companyCode = "";

    /**
     * GEApplianceOrder customerFirstName.
     * @member {string} customerFirstName
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.customerFirstName = "";

    /**
     * GEApplianceOrder customerLastName.
     * @member {string} customerLastName
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.customerLastName = "";

    /**
     * GEApplianceOrder email.
     * @member {string} email
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.email = "";

    /**
     * GEApplianceOrder billingState.
     * @member {string} billingState
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.billingState = "";

    /**
     * GEApplianceOrder installerName.
     * @member {string} installerName
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.installerName = "";

    /**
     * GEApplianceOrder installerAddress1.
     * @member {string} installerAddress1
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.installerAddress1 = "";

    /**
     * GEApplianceOrder installerCity.
     * @member {string} installerCity
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.installerCity = "";

    /**
     * GEApplianceOrder installerZip.
     * @member {string} installerZip
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.installerZip = "";

    /**
     * GEApplianceOrder installerState.
     * @member {string} installerState
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.installerState = "";

    /**
     * GEApplianceOrder installerPhone.
     * @member {string} installerPhone
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.installerPhone = "";

    /**
     * GEApplianceOrder orderedBy.
     * @member {string} orderedBy
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.orderedBy = "";

    /**
     * GEApplianceOrder comments.
     * @member {string} comments
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.comments = "";

    /**
     * GEApplianceOrder replacementID.
     * @member {string} replacementID
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.replacementID = "";

    /**
     * GEApplianceOrder orderStatus.
     * @member {string} orderStatus
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.orderStatus = "";

    /**
     * GEApplianceOrder cilValue.
     * @member {string} cilValue
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.cilValue = "";

    /**
     * GEApplianceOrder basePrice.
     * @member {string} basePrice
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.basePrice = "";

    /**
     * GEApplianceOrder homeOwnerCost.
     * @member {string} homeOwnerCost
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.homeOwnerCost = "";

    /**
     * GEApplianceOrder disconnectFee.
     * @member {string} disconnectFee
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.disconnectFee = "";

    /**
     * GEApplianceOrder installFee.
     * @member {string} installFee
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.installFee = "";

    /**
     * GEApplianceOrder deliveryFee.
     * @member {string} deliveryFee
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.deliveryFee = "";

    /**
     * GEApplianceOrder moveApplianceFee.
     * @member {string} moveApplianceFee
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.moveApplianceFee = "";

    /**
     * GEApplianceOrder restockingFee.
     * @member {string} restockingFee
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.restockingFee = "";

    /**
     * GEApplianceOrder taxes.
     * @member {string} taxes
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.taxes = "";

    /**
     * GEApplianceOrder serviceCodes.
     * @member {string} serviceCodes
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.serviceCodes = "";

    /**
     * GEApplianceOrder serviceFees.
     * @member {string} serviceFees
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.serviceFees = "";

    /**
     * GEApplianceOrder recordID.
     * @member {string} recordID
     * @memberof appliancepb.GEApplianceOrder
     * @instance
     */
    GEApplianceOrder.prototype.recordID = "";

    /**
     * Creates a new GEApplianceOrder instance using the specified properties.
     * @function create
     * @memberof appliancepb.GEApplianceOrder
     * @static
     * @param {appliancepb.IGEApplianceOrder=} [properties] Properties to set
     * @returns {appliancepb.GEApplianceOrder} GEApplianceOrder instance
     */
    GEApplianceOrder.create = function create(properties) {
      return new GEApplianceOrder(properties);
    };

    /**
     * Encodes the specified GEApplianceOrder message. Does not implicitly {@link appliancepb.GEApplianceOrder.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.GEApplianceOrder
     * @static
     * @param {appliancepb.IGEApplianceOrder} m GEApplianceOrder message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GEApplianceOrder.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (
        m.geOrderNumber != null &&
        Object.hasOwnProperty.call(m, "geOrderNumber")
      )
        w.uint32(10).string(m.geOrderNumber);
      if (
        m.isUpgradeOrder != null &&
        Object.hasOwnProperty.call(m, "isUpgradeOrder")
      )
        w.uint32(18).string(m.isUpgradeOrder);
      if (
        m.disposalSelected != null &&
        Object.hasOwnProperty.call(m, "disposalSelected")
      )
        w.uint32(26).string(m.disposalSelected);
      if (m.orderState != null && Object.hasOwnProperty.call(m, "orderState"))
        w.uint32(34).string(m.orderState);
      if (m.dispatchID != null && Object.hasOwnProperty.call(m, "dispatchID"))
        w.uint32(42).string(m.dispatchID);
      if (m.itemID != null && Object.hasOwnProperty.call(m, "itemID"))
        w.uint32(50).string(m.itemID);
      if (
        m.partRequestID != null &&
        Object.hasOwnProperty.call(m, "partRequestID")
      )
        w.uint32(58).string(m.partRequestID);
      if (
        m.contractNumber != null &&
        Object.hasOwnProperty.call(m, "contractNumber")
      )
        w.uint32(66).string(m.contractNumber);
      if (
        m.recommendedModel != null &&
        Object.hasOwnProperty.call(m, "recommendedModel")
      )
        w.uint32(74).string(m.recommendedModel);
      if (
        m.customerBoughtModel != null &&
        Object.hasOwnProperty.call(m, "customerBoughtModel")
      )
        w.uint32(82).string(m.customerBoughtModel);
      if (
        m.replacementItem != null &&
        Object.hasOwnProperty.call(m, "replacementItem")
      )
        w.uint32(90).string(m.replacementItem);
      if (
        m.orderCreatedDate != null &&
        Object.hasOwnProperty.call(m, "orderCreatedDate")
      )
        w.uint32(98).string(m.orderCreatedDate);
      if (
        m.recommendationDate != null &&
        Object.hasOwnProperty.call(m, "recommendationDate")
      )
        w.uint32(106).string(m.recommendationDate);
      if (m.phoneNumber != null && Object.hasOwnProperty.call(m, "phoneNumber"))
        w.uint32(114).string(m.phoneNumber);
      if (
        m.transactionAmount != null &&
        Object.hasOwnProperty.call(m, "transactionAmount")
      )
        w.uint32(122).string(m.transactionAmount);
      if (m.adminFee != null && Object.hasOwnProperty.call(m, "adminFee"))
        w.uint32(130).string(m.adminFee);
      if (m.disposalFee != null && Object.hasOwnProperty.call(m, "disposalFee"))
        w.uint32(138).string(m.disposalFee);
      if (
        m.transactionID != null &&
        Object.hasOwnProperty.call(m, "transactionID")
      )
        w.uint32(146).string(m.transactionID);
      if (
        m.transactionDate != null &&
        Object.hasOwnProperty.call(m, "transactionDate")
      )
        w.uint32(154).string(m.transactionDate);
      if (m.companyCode != null && Object.hasOwnProperty.call(m, "companyCode"))
        w.uint32(162).string(m.companyCode);
      if (
        m.customerFirstName != null &&
        Object.hasOwnProperty.call(m, "customerFirstName")
      )
        w.uint32(170).string(m.customerFirstName);
      if (
        m.customerLastName != null &&
        Object.hasOwnProperty.call(m, "customerLastName")
      )
        w.uint32(178).string(m.customerLastName);
      if (m.email != null && Object.hasOwnProperty.call(m, "email"))
        w.uint32(186).string(m.email);
      if (
        m.billingState != null &&
        Object.hasOwnProperty.call(m, "billingState")
      )
        w.uint32(194).string(m.billingState);
      if (
        m.installerName != null &&
        Object.hasOwnProperty.call(m, "installerName")
      )
        w.uint32(202).string(m.installerName);
      if (
        m.installerAddress1 != null &&
        Object.hasOwnProperty.call(m, "installerAddress1")
      )
        w.uint32(210).string(m.installerAddress1);
      if (
        m.installerCity != null &&
        Object.hasOwnProperty.call(m, "installerCity")
      )
        w.uint32(218).string(m.installerCity);
      if (
        m.installerZip != null &&
        Object.hasOwnProperty.call(m, "installerZip")
      )
        w.uint32(226).string(m.installerZip);
      if (
        m.installerState != null &&
        Object.hasOwnProperty.call(m, "installerState")
      )
        w.uint32(234).string(m.installerState);
      if (
        m.installerPhone != null &&
        Object.hasOwnProperty.call(m, "installerPhone")
      )
        w.uint32(242).string(m.installerPhone);
      if (m.orderedBy != null && Object.hasOwnProperty.call(m, "orderedBy"))
        w.uint32(250).string(m.orderedBy);
      if (m.comments != null && Object.hasOwnProperty.call(m, "comments"))
        w.uint32(258).string(m.comments);
      if (
        m.replacementID != null &&
        Object.hasOwnProperty.call(m, "replacementID")
      )
        w.uint32(266).string(m.replacementID);
      if (m.orderStatus != null && Object.hasOwnProperty.call(m, "orderStatus"))
        w.uint32(274).string(m.orderStatus);
      if (m.cilValue != null && Object.hasOwnProperty.call(m, "cilValue"))
        w.uint32(282).string(m.cilValue);
      if (m.basePrice != null && Object.hasOwnProperty.call(m, "basePrice"))
        w.uint32(290).string(m.basePrice);
      if (
        m.homeOwnerCost != null &&
        Object.hasOwnProperty.call(m, "homeOwnerCost")
      )
        w.uint32(298).string(m.homeOwnerCost);
      if (
        m.disconnectFee != null &&
        Object.hasOwnProperty.call(m, "disconnectFee")
      )
        w.uint32(306).string(m.disconnectFee);
      if (m.installFee != null && Object.hasOwnProperty.call(m, "installFee"))
        w.uint32(314).string(m.installFee);
      if (m.deliveryFee != null && Object.hasOwnProperty.call(m, "deliveryFee"))
        w.uint32(322).string(m.deliveryFee);
      if (
        m.moveApplianceFee != null &&
        Object.hasOwnProperty.call(m, "moveApplianceFee")
      )
        w.uint32(330).string(m.moveApplianceFee);
      if (
        m.restockingFee != null &&
        Object.hasOwnProperty.call(m, "restockingFee")
      )
        w.uint32(338).string(m.restockingFee);
      if (m.taxes != null && Object.hasOwnProperty.call(m, "taxes"))
        w.uint32(346).string(m.taxes);
      if (
        m.serviceCodes != null &&
        Object.hasOwnProperty.call(m, "serviceCodes")
      )
        w.uint32(354).string(m.serviceCodes);
      if (m.serviceFees != null && Object.hasOwnProperty.call(m, "serviceFees"))
        w.uint32(362).string(m.serviceFees);
      if (m.recordID != null && Object.hasOwnProperty.call(m, "recordID"))
        w.uint32(370).string(m.recordID);
      return w;
    };

    /**
     * Decodes a GEApplianceOrder message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.GEApplianceOrder
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.GEApplianceOrder} GEApplianceOrder
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GEApplianceOrder.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.GEApplianceOrder();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.geOrderNumber = r.string();
            break;
          case 2:
            m.isUpgradeOrder = r.string();
            break;
          case 3:
            m.disposalSelected = r.string();
            break;
          case 4:
            m.orderState = r.string();
            break;
          case 5:
            m.dispatchID = r.string();
            break;
          case 6:
            m.itemID = r.string();
            break;
          case 7:
            m.partRequestID = r.string();
            break;
          case 8:
            m.contractNumber = r.string();
            break;
          case 9:
            m.recommendedModel = r.string();
            break;
          case 10:
            m.customerBoughtModel = r.string();
            break;
          case 11:
            m.replacementItem = r.string();
            break;
          case 12:
            m.orderCreatedDate = r.string();
            break;
          case 13:
            m.recommendationDate = r.string();
            break;
          case 14:
            m.phoneNumber = r.string();
            break;
          case 15:
            m.transactionAmount = r.string();
            break;
          case 16:
            m.adminFee = r.string();
            break;
          case 17:
            m.disposalFee = r.string();
            break;
          case 18:
            m.transactionID = r.string();
            break;
          case 19:
            m.transactionDate = r.string();
            break;
          case 20:
            m.companyCode = r.string();
            break;
          case 21:
            m.customerFirstName = r.string();
            break;
          case 22:
            m.customerLastName = r.string();
            break;
          case 23:
            m.email = r.string();
            break;
          case 24:
            m.billingState = r.string();
            break;
          case 25:
            m.installerName = r.string();
            break;
          case 26:
            m.installerAddress1 = r.string();
            break;
          case 27:
            m.installerCity = r.string();
            break;
          case 28:
            m.installerZip = r.string();
            break;
          case 29:
            m.installerState = r.string();
            break;
          case 30:
            m.installerPhone = r.string();
            break;
          case 31:
            m.orderedBy = r.string();
            break;
          case 32:
            m.comments = r.string();
            break;
          case 33:
            m.replacementID = r.string();
            break;
          case 34:
            m.orderStatus = r.string();
            break;
          case 35:
            m.cilValue = r.string();
            break;
          case 36:
            m.basePrice = r.string();
            break;
          case 37:
            m.homeOwnerCost = r.string();
            break;
          case 38:
            m.disconnectFee = r.string();
            break;
          case 39:
            m.installFee = r.string();
            break;
          case 40:
            m.deliveryFee = r.string();
            break;
          case 41:
            m.moveApplianceFee = r.string();
            break;
          case 42:
            m.restockingFee = r.string();
            break;
          case 43:
            m.taxes = r.string();
            break;
          case 44:
            m.serviceCodes = r.string();
            break;
          case 45:
            m.serviceFees = r.string();
            break;
          case 46:
            m.recordID = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GEApplianceOrder;
  })();

  appliancepb.OrderAction = (function () {
    /**
     * Properties of an OrderAction.
     * @memberof appliancepb
     * @interface IOrderAction
     * @property {string|null} [action] OrderAction action
     * @property {string|null} [comment] OrderAction comment
     */

    /**
     * Constructs a new OrderAction.
     * @memberof appliancepb
     * @classdesc Represents an OrderAction.
     * @implements IOrderAction
     * @constructor
     * @param {appliancepb.IOrderAction=} [p] Properties to set
     */
    function OrderAction(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * OrderAction action.
     * @member {string} action
     * @memberof appliancepb.OrderAction
     * @instance
     */
    OrderAction.prototype.action = "";

    /**
     * OrderAction comment.
     * @member {string} comment
     * @memberof appliancepb.OrderAction
     * @instance
     */
    OrderAction.prototype.comment = "";

    /**
     * Creates a new OrderAction instance using the specified properties.
     * @function create
     * @memberof appliancepb.OrderAction
     * @static
     * @param {appliancepb.IOrderAction=} [properties] Properties to set
     * @returns {appliancepb.OrderAction} OrderAction instance
     */
    OrderAction.create = function create(properties) {
      return new OrderAction(properties);
    };

    /**
     * Encodes the specified OrderAction message. Does not implicitly {@link appliancepb.OrderAction.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.OrderAction
     * @static
     * @param {appliancepb.IOrderAction} m OrderAction message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OrderAction.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.action != null && Object.hasOwnProperty.call(m, "action"))
        w.uint32(10).string(m.action);
      if (m.comment != null && Object.hasOwnProperty.call(m, "comment"))
        w.uint32(18).string(m.comment);
      return w;
    };

    /**
     * Decodes an OrderAction message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.OrderAction
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.OrderAction} OrderAction
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OrderAction.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.OrderAction();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.action = r.string();
            break;
          case 2:
            m.comment = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return OrderAction;
  })();

  appliancepb.PatchReplacement = (function () {
    /**
     * Properties of a PatchReplacement.
     * @memberof appliancepb
     * @interface IPatchReplacement
     * @property {string|null} [status] PatchReplacement status
     * @property {Array.<appliancepb.IOrderAction>|null} [orderActions] PatchReplacement orderActions
     * @property {appliancepb.ICart|null} [cart] PatchReplacement cart
     */

    /**
     * Constructs a new PatchReplacement.
     * @memberof appliancepb
     * @classdesc Represents a PatchReplacement.
     * @implements IPatchReplacement
     * @constructor
     * @param {appliancepb.IPatchReplacement=} [p] Properties to set
     */
    function PatchReplacement(p) {
      this.orderActions = [];
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * PatchReplacement status.
     * @member {string} status
     * @memberof appliancepb.PatchReplacement
     * @instance
     */
    PatchReplacement.prototype.status = "";

    /**
     * PatchReplacement orderActions.
     * @member {Array.<appliancepb.IOrderAction>} orderActions
     * @memberof appliancepb.PatchReplacement
     * @instance
     */
    PatchReplacement.prototype.orderActions = $util.emptyArray;

    /**
     * PatchReplacement cart.
     * @member {appliancepb.ICart|null|undefined} cart
     * @memberof appliancepb.PatchReplacement
     * @instance
     */
    PatchReplacement.prototype.cart = null;

    /**
     * Creates a new PatchReplacement instance using the specified properties.
     * @function create
     * @memberof appliancepb.PatchReplacement
     * @static
     * @param {appliancepb.IPatchReplacement=} [properties] Properties to set
     * @returns {appliancepb.PatchReplacement} PatchReplacement instance
     */
    PatchReplacement.create = function create(properties) {
      return new PatchReplacement(properties);
    };

    /**
     * Encodes the specified PatchReplacement message. Does not implicitly {@link appliancepb.PatchReplacement.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.PatchReplacement
     * @static
     * @param {appliancepb.IPatchReplacement} m PatchReplacement message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PatchReplacement.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.status != null && Object.hasOwnProperty.call(m, "status"))
        w.uint32(10).string(m.status);
      if (m.orderActions != null && m.orderActions.length) {
        for (var i = 0; i < m.orderActions.length; ++i)
          $root.appliancepb.OrderAction.encode(
            m.orderActions[i],
            w.uint32(18).fork()
          ).ldelim();
      }
      if (m.cart != null && Object.hasOwnProperty.call(m, "cart"))
        $root.appliancepb.Cart.encode(m.cart, w.uint32(26).fork()).ldelim();
      return w;
    };

    /**
     * Decodes a PatchReplacement message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.PatchReplacement
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.PatchReplacement} PatchReplacement
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PatchReplacement.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.PatchReplacement();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.status = r.string();
            break;
          case 2:
            if (!(m.orderActions && m.orderActions.length)) m.orderActions = [];
            m.orderActions.push(
              $root.appliancepb.OrderAction.decode(r, r.uint32())
            );
            break;
          case 3:
            m.cart = $root.appliancepb.Cart.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return PatchReplacement;
  })();

  appliancepb.Categories = (function () {
    /**
     * Properties of a Categories.
     * @memberof appliancepb
     * @interface ICategories
     * @property {Array.<string>|null} [categories] Categories categories
     * @property {Array.<appliancepb.IPair>|null} [mappedItemIDs] Categories mappedItemIDs
     * @property {Array.<appliancepb.IKeyValues>|null} [subcategoriesByCategory] Categories subcategoriesByCategory
     */

    /**
     * Constructs a new Categories.
     * @memberof appliancepb
     * @classdesc Represents a Categories.
     * @implements ICategories
     * @constructor
     * @param {appliancepb.ICategories=} [p] Properties to set
     */
    function Categories(p) {
      this.categories = [];
      this.mappedItemIDs = [];
      this.subcategoriesByCategory = [];
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * Categories categories.
     * @member {Array.<string>} categories
     * @memberof appliancepb.Categories
     * @instance
     */
    Categories.prototype.categories = $util.emptyArray;

    /**
     * Categories mappedItemIDs.
     * @member {Array.<appliancepb.IPair>} mappedItemIDs
     * @memberof appliancepb.Categories
     * @instance
     */
    Categories.prototype.mappedItemIDs = $util.emptyArray;

    /**
     * Categories subcategoriesByCategory.
     * @member {Array.<appliancepb.IKeyValues>} subcategoriesByCategory
     * @memberof appliancepb.Categories
     * @instance
     */
    Categories.prototype.subcategoriesByCategory = $util.emptyArray;

    /**
     * Creates a new Categories instance using the specified properties.
     * @function create
     * @memberof appliancepb.Categories
     * @static
     * @param {appliancepb.ICategories=} [properties] Properties to set
     * @returns {appliancepb.Categories} Categories instance
     */
    Categories.create = function create(properties) {
      return new Categories(properties);
    };

    /**
     * Encodes the specified Categories message. Does not implicitly {@link appliancepb.Categories.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.Categories
     * @static
     * @param {appliancepb.ICategories} m Categories message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Categories.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.categories != null && m.categories.length) {
        for (var i = 0; i < m.categories.length; ++i)
          w.uint32(10).string(m.categories[i]);
      }
      if (m.mappedItemIDs != null && m.mappedItemIDs.length) {
        for (var i = 0; i < m.mappedItemIDs.length; ++i)
          $root.appliancepb.Pair.encode(
            m.mappedItemIDs[i],
            w.uint32(18).fork()
          ).ldelim();
      }
      if (
        m.subcategoriesByCategory != null &&
        m.subcategoriesByCategory.length
      ) {
        for (var i = 0; i < m.subcategoriesByCategory.length; ++i)
          $root.appliancepb.KeyValues.encode(
            m.subcategoriesByCategory[i],
            w.uint32(26).fork()
          ).ldelim();
      }
      return w;
    };

    /**
     * Decodes a Categories message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.Categories
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.Categories} Categories
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Categories.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.Categories();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.categories && m.categories.length)) m.categories = [];
            m.categories.push(r.string());
            break;
          case 2:
            if (!(m.mappedItemIDs && m.mappedItemIDs.length))
              m.mappedItemIDs = [];
            m.mappedItemIDs.push($root.appliancepb.Pair.decode(r, r.uint32()));
            break;
          case 3:
            if (
              !(m.subcategoriesByCategory && m.subcategoriesByCategory.length)
            )
              m.subcategoriesByCategory = [];
            m.subcategoriesByCategory.push(
              $root.appliancepb.KeyValues.decode(r, r.uint32())
            );
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return Categories;
  })();

  appliancepb.Vendors = (function () {
    /**
     * Properties of a Vendors.
     * @memberof appliancepb
     * @interface IVendors
     * @property {Array.<appliancepb.IPair>|null} [vendors] Vendors vendors
     */

    /**
     * Constructs a new Vendors.
     * @memberof appliancepb
     * @classdesc Represents a Vendors.
     * @implements IVendors
     * @constructor
     * @param {appliancepb.IVendors=} [p] Properties to set
     */
    function Vendors(p) {
      this.vendors = [];
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * Vendors vendors.
     * @member {Array.<appliancepb.IPair>} vendors
     * @memberof appliancepb.Vendors
     * @instance
     */
    Vendors.prototype.vendors = $util.emptyArray;

    /**
     * Creates a new Vendors instance using the specified properties.
     * @function create
     * @memberof appliancepb.Vendors
     * @static
     * @param {appliancepb.IVendors=} [properties] Properties to set
     * @returns {appliancepb.Vendors} Vendors instance
     */
    Vendors.create = function create(properties) {
      return new Vendors(properties);
    };

    /**
     * Encodes the specified Vendors message. Does not implicitly {@link appliancepb.Vendors.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.Vendors
     * @static
     * @param {appliancepb.IVendors} m Vendors message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Vendors.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.vendors != null && m.vendors.length) {
        for (var i = 0; i < m.vendors.length; ++i)
          $root.appliancepb.Pair.encode(
            m.vendors[i],
            w.uint32(10).fork()
          ).ldelim();
      }
      return w;
    };

    /**
     * Decodes a Vendors message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.Vendors
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.Vendors} Vendors
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Vendors.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.Vendors();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.vendors && m.vendors.length)) m.vendors = [];
            m.vendors.push($root.appliancepb.Pair.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return Vendors;
  })();

  appliancepb.OrderStatus = (function () {
    /**
     * Properties of an OrderStatus.
     * @memberof appliancepb
     * @interface IOrderStatus
     * @property {string|null} [orderID] OrderStatus orderID
     * @property {string|null} [status] OrderStatus status
     * @property {string|null} [vendorName] OrderStatus vendorName
     * @property {google.protobuf.ITimestamp|null} [orderDate] OrderStatus orderDate
     * @property {appliancepb.OrderStatus.Progress|null} [progress] OrderStatus progress
     * @property {google.protobuf.ITimestamp|null} [deliveryDate] OrderStatus deliveryDate
     * @property {appliancepb.ICustomer|null} [customer] OrderStatus customer
     * @property {appliancepb.IProduct|null} [product] OrderStatus product
     * @property {string|null} [dispatchID] OrderStatus dispatchID
     * @property {string|null} [partRequestID] OrderStatus partRequestID
     */

    /**
     * Constructs a new OrderStatus.
     * @memberof appliancepb
     * @classdesc Represents an OrderStatus.
     * @implements IOrderStatus
     * @constructor
     * @param {appliancepb.IOrderStatus=} [p] Properties to set
     */
    function OrderStatus(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * OrderStatus orderID.
     * @member {string} orderID
     * @memberof appliancepb.OrderStatus
     * @instance
     */
    OrderStatus.prototype.orderID = "";

    /**
     * OrderStatus status.
     * @member {string} status
     * @memberof appliancepb.OrderStatus
     * @instance
     */
    OrderStatus.prototype.status = "";

    /**
     * OrderStatus vendorName.
     * @member {string} vendorName
     * @memberof appliancepb.OrderStatus
     * @instance
     */
    OrderStatus.prototype.vendorName = "";

    /**
     * OrderStatus orderDate.
     * @member {google.protobuf.ITimestamp|null|undefined} orderDate
     * @memberof appliancepb.OrderStatus
     * @instance
     */
    OrderStatus.prototype.orderDate = null;

    /**
     * OrderStatus progress.
     * @member {appliancepb.OrderStatus.Progress} progress
     * @memberof appliancepb.OrderStatus
     * @instance
     */
    OrderStatus.prototype.progress = 0;

    /**
     * OrderStatus deliveryDate.
     * @member {google.protobuf.ITimestamp|null|undefined} deliveryDate
     * @memberof appliancepb.OrderStatus
     * @instance
     */
    OrderStatus.prototype.deliveryDate = null;

    /**
     * OrderStatus customer.
     * @member {appliancepb.ICustomer|null|undefined} customer
     * @memberof appliancepb.OrderStatus
     * @instance
     */
    OrderStatus.prototype.customer = null;

    /**
     * OrderStatus product.
     * @member {appliancepb.IProduct|null|undefined} product
     * @memberof appliancepb.OrderStatus
     * @instance
     */
    OrderStatus.prototype.product = null;

    /**
     * OrderStatus dispatchID.
     * @member {string} dispatchID
     * @memberof appliancepb.OrderStatus
     * @instance
     */
    OrderStatus.prototype.dispatchID = "";

    /**
     * OrderStatus partRequestID.
     * @member {string} partRequestID
     * @memberof appliancepb.OrderStatus
     * @instance
     */
    OrderStatus.prototype.partRequestID = "";

    /**
     * Creates a new OrderStatus instance using the specified properties.
     * @function create
     * @memberof appliancepb.OrderStatus
     * @static
     * @param {appliancepb.IOrderStatus=} [properties] Properties to set
     * @returns {appliancepb.OrderStatus} OrderStatus instance
     */
    OrderStatus.create = function create(properties) {
      return new OrderStatus(properties);
    };

    /**
     * Encodes the specified OrderStatus message. Does not implicitly {@link appliancepb.OrderStatus.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.OrderStatus
     * @static
     * @param {appliancepb.IOrderStatus} m OrderStatus message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OrderStatus.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.orderID != null && Object.hasOwnProperty.call(m, "orderID"))
        w.uint32(10).string(m.orderID);
      if (m.status != null && Object.hasOwnProperty.call(m, "status"))
        w.uint32(18).string(m.status);
      if (m.vendorName != null && Object.hasOwnProperty.call(m, "vendorName"))
        w.uint32(26).string(m.vendorName);
      if (m.orderDate != null && Object.hasOwnProperty.call(m, "orderDate"))
        $root.google.protobuf.Timestamp.encode(
          m.orderDate,
          w.uint32(34).fork()
        ).ldelim();
      if (m.progress != null && Object.hasOwnProperty.call(m, "progress"))
        w.uint32(40).int32(m.progress);
      if (
        m.deliveryDate != null &&
        Object.hasOwnProperty.call(m, "deliveryDate")
      )
        $root.google.protobuf.Timestamp.encode(
          m.deliveryDate,
          w.uint32(50).fork()
        ).ldelim();
      if (m.customer != null && Object.hasOwnProperty.call(m, "customer"))
        $root.appliancepb.Customer.encode(
          m.customer,
          w.uint32(58).fork()
        ).ldelim();
      if (m.product != null && Object.hasOwnProperty.call(m, "product"))
        $root.appliancepb.Product.encode(
          m.product,
          w.uint32(66).fork()
        ).ldelim();
      if (m.dispatchID != null && Object.hasOwnProperty.call(m, "dispatchID"))
        w.uint32(74).string(m.dispatchID);
      if (
        m.partRequestID != null &&
        Object.hasOwnProperty.call(m, "partRequestID")
      )
        w.uint32(82).string(m.partRequestID);
      return w;
    };

    /**
     * Decodes an OrderStatus message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.OrderStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.OrderStatus} OrderStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OrderStatus.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.OrderStatus();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.orderID = r.string();
            break;
          case 2:
            m.status = r.string();
            break;
          case 3:
            m.vendorName = r.string();
            break;
          case 4:
            m.orderDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
            break;
          case 5:
            m.progress = r.int32();
            break;
          case 6:
            m.deliveryDate = $root.google.protobuf.Timestamp.decode(
              r,
              r.uint32()
            );
            break;
          case 7:
            m.customer = $root.appliancepb.Customer.decode(r, r.uint32());
            break;
          case 8:
            m.product = $root.appliancepb.Product.decode(r, r.uint32());
            break;
          case 9:
            m.dispatchID = r.string();
            break;
          case 10:
            m.partRequestID = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    /**
     * Progress enum.
     * @name appliancepb.OrderStatus.Progress
     * @enum {number}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} ORDERED=1 ORDERED value
     * @property {number} SHIPPED=2 SHIPPED value
     * @property {number} DELIVERED=3 DELIVERED value
     */
    OrderStatus.Progress = (function () {
      const valuesById = {},
        values = Object.create(valuesById);
      values[(valuesById[0] = "UNKNOWN")] = 0;
      values[(valuesById[1] = "ORDERED")] = 1;
      values[(valuesById[2] = "SHIPPED")] = 2;
      values[(valuesById[3] = "DELIVERED")] = 3;
      return values;
    })();

    return OrderStatus;
  })();

  appliancepb.Notification = (function () {
    /**
     * Properties of a Notification.
     * @memberof appliancepb
     * @interface INotification
     * @property {boolean|null} [customerShopLink] Notification customerShopLink
     * @property {boolean|null} [customerPaymentConfirmation] Notification customerPaymentConfirmation
     * @property {boolean|null} [customerOrderConfirmation] Notification customerOrderConfirmation
     * @property {boolean|null} [customerInstallerConfirmation] Notification customerInstallerConfirmation
     */

    /**
     * Constructs a new Notification.
     * @memberof appliancepb
     * @classdesc Represents a Notification.
     * @implements INotification
     * @constructor
     * @param {appliancepb.INotification=} [p] Properties to set
     */
    function Notification(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * Notification customerShopLink.
     * @member {boolean} customerShopLink
     * @memberof appliancepb.Notification
     * @instance
     */
    Notification.prototype.customerShopLink = false;

    /**
     * Notification customerPaymentConfirmation.
     * @member {boolean} customerPaymentConfirmation
     * @memberof appliancepb.Notification
     * @instance
     */
    Notification.prototype.customerPaymentConfirmation = false;

    /**
     * Notification customerOrderConfirmation.
     * @member {boolean} customerOrderConfirmation
     * @memberof appliancepb.Notification
     * @instance
     */
    Notification.prototype.customerOrderConfirmation = false;

    /**
     * Notification customerInstallerConfirmation.
     * @member {boolean} customerInstallerConfirmation
     * @memberof appliancepb.Notification
     * @instance
     */
    Notification.prototype.customerInstallerConfirmation = false;

    /**
     * Creates a new Notification instance using the specified properties.
     * @function create
     * @memberof appliancepb.Notification
     * @static
     * @param {appliancepb.INotification=} [properties] Properties to set
     * @returns {appliancepb.Notification} Notification instance
     */
    Notification.create = function create(properties) {
      return new Notification(properties);
    };

    /**
     * Encodes the specified Notification message. Does not implicitly {@link appliancepb.Notification.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.Notification
     * @static
     * @param {appliancepb.INotification} m Notification message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Notification.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (
        m.customerShopLink != null &&
        Object.hasOwnProperty.call(m, "customerShopLink")
      )
        w.uint32(8).bool(m.customerShopLink);
      if (
        m.customerPaymentConfirmation != null &&
        Object.hasOwnProperty.call(m, "customerPaymentConfirmation")
      )
        w.uint32(16).bool(m.customerPaymentConfirmation);
      if (
        m.customerOrderConfirmation != null &&
        Object.hasOwnProperty.call(m, "customerOrderConfirmation")
      )
        w.uint32(24).bool(m.customerOrderConfirmation);
      if (
        m.customerInstallerConfirmation != null &&
        Object.hasOwnProperty.call(m, "customerInstallerConfirmation")
      )
        w.uint32(32).bool(m.customerInstallerConfirmation);
      return w;
    };

    /**
     * Decodes a Notification message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.Notification
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.Notification} Notification
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Notification.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.Notification();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.customerShopLink = r.bool();
            break;
          case 2:
            m.customerPaymentConfirmation = r.bool();
            break;
          case 3:
            m.customerOrderConfirmation = r.bool();
            break;
          case 4:
            m.customerInstallerConfirmation = r.bool();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return Notification;
  })();

  appliancepb.PostPaymentRequest = (function () {
    /**
     * Properties of a PostPaymentRequest.
     * @memberof appliancepb
     * @interface IPostPaymentRequest
     * @property {appliancepb.IPaymentDetails|null} [paymentDetails] PostPaymentRequest paymentDetails
     * @property {string|null} [replacementId] PostPaymentRequest replacementId
     * @property {appliancepb.INotification|null} [notification] PostPaymentRequest notification
     */

    /**
     * Constructs a new PostPaymentRequest.
     * @memberof appliancepb
     * @classdesc Represents a PostPaymentRequest.
     * @implements IPostPaymentRequest
     * @constructor
     * @param {appliancepb.IPostPaymentRequest=} [p] Properties to set
     */
    function PostPaymentRequest(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * PostPaymentRequest paymentDetails.
     * @member {appliancepb.IPaymentDetails|null|undefined} paymentDetails
     * @memberof appliancepb.PostPaymentRequest
     * @instance
     */
    PostPaymentRequest.prototype.paymentDetails = null;

    /**
     * PostPaymentRequest replacementId.
     * @member {string} replacementId
     * @memberof appliancepb.PostPaymentRequest
     * @instance
     */
    PostPaymentRequest.prototype.replacementId = "";

    /**
     * PostPaymentRequest notification.
     * @member {appliancepb.INotification|null|undefined} notification
     * @memberof appliancepb.PostPaymentRequest
     * @instance
     */
    PostPaymentRequest.prototype.notification = null;

    /**
     * Creates a new PostPaymentRequest instance using the specified properties.
     * @function create
     * @memberof appliancepb.PostPaymentRequest
     * @static
     * @param {appliancepb.IPostPaymentRequest=} [properties] Properties to set
     * @returns {appliancepb.PostPaymentRequest} PostPaymentRequest instance
     */
    PostPaymentRequest.create = function create(properties) {
      return new PostPaymentRequest(properties);
    };

    /**
     * Encodes the specified PostPaymentRequest message. Does not implicitly {@link appliancepb.PostPaymentRequest.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.PostPaymentRequest
     * @static
     * @param {appliancepb.IPostPaymentRequest} m PostPaymentRequest message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PostPaymentRequest.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (
        m.paymentDetails != null &&
        Object.hasOwnProperty.call(m, "paymentDetails")
      )
        $root.appliancepb.PaymentDetails.encode(
          m.paymentDetails,
          w.uint32(10).fork()
        ).ldelim();
      if (
        m.replacementId != null &&
        Object.hasOwnProperty.call(m, "replacementId")
      )
        w.uint32(18).string(m.replacementId);
      if (
        m.notification != null &&
        Object.hasOwnProperty.call(m, "notification")
      )
        $root.appliancepb.Notification.encode(
          m.notification,
          w.uint32(26).fork()
        ).ldelim();
      return w;
    };

    /**
     * Decodes a PostPaymentRequest message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.PostPaymentRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.PostPaymentRequest} PostPaymentRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PostPaymentRequest.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.PostPaymentRequest();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.paymentDetails = $root.appliancepb.PaymentDetails.decode(
              r,
              r.uint32()
            );
            break;
          case 2:
            m.replacementId = r.string();
            break;
          case 3:
            m.notification = $root.appliancepb.Notification.decode(
              r,
              r.uint32()
            );
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return PostPaymentRequest;
  })();

  appliancepb.Contract = (function () {
    /**
     * Properties of a Contract.
     * @memberof appliancepb
     * @interface IContract
     * @property {string|null} [id] Contract id
     * @property {boolean|null} [hasDisposalCoverage] Contract hasDisposalCoverage
     */

    /**
     * Constructs a new Contract.
     * @memberof appliancepb
     * @classdesc Represents a Contract.
     * @implements IContract
     * @constructor
     * @param {appliancepb.IContract=} [p] Properties to set
     */
    function Contract(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * Contract id.
     * @member {string} id
     * @memberof appliancepb.Contract
     * @instance
     */
    Contract.prototype.id = "";

    /**
     * Contract hasDisposalCoverage.
     * @member {boolean} hasDisposalCoverage
     * @memberof appliancepb.Contract
     * @instance
     */
    Contract.prototype.hasDisposalCoverage = false;

    /**
     * Creates a new Contract instance using the specified properties.
     * @function create
     * @memberof appliancepb.Contract
     * @static
     * @param {appliancepb.IContract=} [properties] Properties to set
     * @returns {appliancepb.Contract} Contract instance
     */
    Contract.create = function create(properties) {
      return new Contract(properties);
    };

    /**
     * Encodes the specified Contract message. Does not implicitly {@link appliancepb.Contract.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.Contract
     * @static
     * @param {appliancepb.IContract} m Contract message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Contract.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.id != null && Object.hasOwnProperty.call(m, "id"))
        w.uint32(10).string(m.id);
      if (
        m.hasDisposalCoverage != null &&
        Object.hasOwnProperty.call(m, "hasDisposalCoverage")
      )
        w.uint32(16).bool(m.hasDisposalCoverage);
      return w;
    };

    /**
     * Decodes a Contract message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.Contract
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.Contract} Contract
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Contract.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.Contract();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.id = r.string();
            break;
          case 2:
            m.hasDisposalCoverage = r.bool();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return Contract;
  })();

  appliancepb.PriceSetter = (function () {
    /**
     * Properties of a PriceSetter.
     * @memberof appliancepb
     * @interface IPriceSetter
     * @property {number|null} [price] PriceSetter price
     * @property {boolean|null} [apply] PriceSetter apply
     */

    /**
     * Constructs a new PriceSetter.
     * @memberof appliancepb
     * @classdesc Represents a PriceSetter.
     * @implements IPriceSetter
     * @constructor
     * @param {appliancepb.IPriceSetter=} [p] Properties to set
     */
    function PriceSetter(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * PriceSetter price.
     * @member {number} price
     * @memberof appliancepb.PriceSetter
     * @instance
     */
    PriceSetter.prototype.price = 0;

    /**
     * PriceSetter apply.
     * @member {boolean} apply
     * @memberof appliancepb.PriceSetter
     * @instance
     */
    PriceSetter.prototype.apply = false;

    /**
     * Creates a new PriceSetter instance using the specified properties.
     * @function create
     * @memberof appliancepb.PriceSetter
     * @static
     * @param {appliancepb.IPriceSetter=} [properties] Properties to set
     * @returns {appliancepb.PriceSetter} PriceSetter instance
     */
    PriceSetter.create = function create(properties) {
      return new PriceSetter(properties);
    };

    /**
     * Encodes the specified PriceSetter message. Does not implicitly {@link appliancepb.PriceSetter.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.PriceSetter
     * @static
     * @param {appliancepb.IPriceSetter} m PriceSetter message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PriceSetter.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.price != null && Object.hasOwnProperty.call(m, "price"))
        w.uint32(8).int32(m.price);
      if (m.apply != null && Object.hasOwnProperty.call(m, "apply"))
        w.uint32(16).bool(m.apply);
      return w;
    };

    /**
     * Decodes a PriceSetter message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.PriceSetter
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.PriceSetter} PriceSetter
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PriceSetter.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.PriceSetter();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.price = r.int32();
            break;
          case 2:
            m.apply = r.bool();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return PriceSetter;
  })();

  appliancepb.Order = (function () {
    /**
     * Properties of an Order.
     * @memberof appliancepb
     * @interface IOrder
     * @property {string|null} [vendorOrderNumber] Order vendorOrderNumber
     * @property {string|null} [purchaseOrderNumber] Order purchaseOrderNumber
     * @property {string|null} [orderBy] Order orderBy
     * @property {google.protobuf.ITimestamp|null} [orderDate] Order orderDate
     * @property {google.protobuf.ITimestamp|null} [deliveryDate] Order deliveryDate
     * @property {string|null} [deliveryInstructions] Order deliveryInstructions
     * @property {string|null} [vendor] Order vendor
     * @property {string|null} [status] Order status
     * @property {google.protobuf.ITimestamp|null} [statusDate] Order statusDate
     * @property {number|null} [orderAttempts] Order orderAttempts
     */

    /**
     * Constructs a new Order.
     * @memberof appliancepb
     * @classdesc Represents an Order.
     * @implements IOrder
     * @constructor
     * @param {appliancepb.IOrder=} [p] Properties to set
     */
    function Order(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * Order vendorOrderNumber.
     * @member {string} vendorOrderNumber
     * @memberof appliancepb.Order
     * @instance
     */
    Order.prototype.vendorOrderNumber = "";

    /**
     * Order purchaseOrderNumber.
     * @member {string} purchaseOrderNumber
     * @memberof appliancepb.Order
     * @instance
     */
    Order.prototype.purchaseOrderNumber = "";

    /**
     * Order orderBy.
     * @member {string} orderBy
     * @memberof appliancepb.Order
     * @instance
     */
    Order.prototype.orderBy = "";

    /**
     * Order orderDate.
     * @member {google.protobuf.ITimestamp|null|undefined} orderDate
     * @memberof appliancepb.Order
     * @instance
     */
    Order.prototype.orderDate = null;

    /**
     * Order deliveryDate.
     * @member {google.protobuf.ITimestamp|null|undefined} deliveryDate
     * @memberof appliancepb.Order
     * @instance
     */
    Order.prototype.deliveryDate = null;

    /**
     * Order deliveryInstructions.
     * @member {string} deliveryInstructions
     * @memberof appliancepb.Order
     * @instance
     */
    Order.prototype.deliveryInstructions = "";

    /**
     * Order vendor.
     * @member {string} vendor
     * @memberof appliancepb.Order
     * @instance
     */
    Order.prototype.vendor = "";

    /**
     * Order status.
     * @member {string} status
     * @memberof appliancepb.Order
     * @instance
     */
    Order.prototype.status = "";

    /**
     * Order statusDate.
     * @member {google.protobuf.ITimestamp|null|undefined} statusDate
     * @memberof appliancepb.Order
     * @instance
     */
    Order.prototype.statusDate = null;

    /**
     * Order orderAttempts.
     * @member {number} orderAttempts
     * @memberof appliancepb.Order
     * @instance
     */
    Order.prototype.orderAttempts = 0;

    /**
     * Creates a new Order instance using the specified properties.
     * @function create
     * @memberof appliancepb.Order
     * @static
     * @param {appliancepb.IOrder=} [properties] Properties to set
     * @returns {appliancepb.Order} Order instance
     */
    Order.create = function create(properties) {
      return new Order(properties);
    };

    /**
     * Encodes the specified Order message. Does not implicitly {@link appliancepb.Order.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.Order
     * @static
     * @param {appliancepb.IOrder} m Order message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Order.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (
        m.vendorOrderNumber != null &&
        Object.hasOwnProperty.call(m, "vendorOrderNumber")
      )
        w.uint32(10).string(m.vendorOrderNumber);
      if (
        m.purchaseOrderNumber != null &&
        Object.hasOwnProperty.call(m, "purchaseOrderNumber")
      )
        w.uint32(18).string(m.purchaseOrderNumber);
      if (m.orderBy != null && Object.hasOwnProperty.call(m, "orderBy"))
        w.uint32(26).string(m.orderBy);
      if (m.orderDate != null && Object.hasOwnProperty.call(m, "orderDate"))
        $root.google.protobuf.Timestamp.encode(
          m.orderDate,
          w.uint32(34).fork()
        ).ldelim();
      if (
        m.deliveryDate != null &&
        Object.hasOwnProperty.call(m, "deliveryDate")
      )
        $root.google.protobuf.Timestamp.encode(
          m.deliveryDate,
          w.uint32(42).fork()
        ).ldelim();
      if (
        m.deliveryInstructions != null &&
        Object.hasOwnProperty.call(m, "deliveryInstructions")
      )
        w.uint32(50).string(m.deliveryInstructions);
      if (m.vendor != null && Object.hasOwnProperty.call(m, "vendor"))
        w.uint32(58).string(m.vendor);
      if (m.status != null && Object.hasOwnProperty.call(m, "status"))
        w.uint32(66).string(m.status);
      if (m.statusDate != null && Object.hasOwnProperty.call(m, "statusDate"))
        $root.google.protobuf.Timestamp.encode(
          m.statusDate,
          w.uint32(74).fork()
        ).ldelim();
      if (
        m.orderAttempts != null &&
        Object.hasOwnProperty.call(m, "orderAttempts")
      )
        w.uint32(80).int32(m.orderAttempts);
      return w;
    };

    /**
     * Decodes an Order message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.Order
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.Order} Order
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Order.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.Order();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.vendorOrderNumber = r.string();
            break;
          case 2:
            m.purchaseOrderNumber = r.string();
            break;
          case 3:
            m.orderBy = r.string();
            break;
          case 4:
            m.orderDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
            break;
          case 5:
            m.deliveryDate = $root.google.protobuf.Timestamp.decode(
              r,
              r.uint32()
            );
            break;
          case 6:
            m.deliveryInstructions = r.string();
            break;
          case 7:
            m.vendor = r.string();
            break;
          case 8:
            m.status = r.string();
            break;
          case 9:
            m.statusDate = $root.google.protobuf.Timestamp.decode(
              r,
              r.uint32()
            );
            break;
          case 10:
            m.orderAttempts = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return Order;
  })();

  appliancepb.CreateReplacementRequest = (function () {
    /**
     * Properties of a CreateReplacementRequest.
     * @memberof appliancepb
     * @interface ICreateReplacementRequest
     * @property {string|null} [dispatchId] CreateReplacementRequest dispatchId
     * @property {string|null} [partRequestId] CreateReplacementRequest partRequestId
     * @property {appliancepb.IContract|null} [contract] CreateReplacementRequest contract
     * @property {string|null} [itemId] CreateReplacementRequest itemId
     * @property {appliancepb.ICustomer|null} [customer] CreateReplacementRequest customer
     * @property {appliancepb.INotification|null} [notification] CreateReplacementRequest notification
     * @property {appliancepb.IProduct|null} [likeForLike] CreateReplacementRequest likeForLike
     * @property {appliancepb.IOrder|null} [order] CreateReplacementRequest order
     * @property {appliancepb.CreateReplacementRequest.IShoppingCart|null} [shoppingCart] CreateReplacementRequest shoppingCart
     * @property {string|null} [note] CreateReplacementRequest note
     * @property {Array.<appliancepb.IProductAccessory>|null} [productAccessories] CreateReplacementRequest productAccessories
     * @property {appliancepb.IPriceSetter|null} [cashInLieu] CreateReplacementRequest cashInLieu
     * @property {appliancepb.IPriceSetter|null} [repairCredit] CreateReplacementRequest repairCredit
     */

    /**
     * Constructs a new CreateReplacementRequest.
     * @memberof appliancepb
     * @classdesc Represents a CreateReplacementRequest.
     * @implements ICreateReplacementRequest
     * @constructor
     * @param {appliancepb.ICreateReplacementRequest=} [p] Properties to set
     */
    function CreateReplacementRequest(p) {
      this.productAccessories = [];
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * CreateReplacementRequest dispatchId.
     * @member {string} dispatchId
     * @memberof appliancepb.CreateReplacementRequest
     * @instance
     */
    CreateReplacementRequest.prototype.dispatchId = "";

    /**
     * CreateReplacementRequest partRequestId.
     * @member {string} partRequestId
     * @memberof appliancepb.CreateReplacementRequest
     * @instance
     */
    CreateReplacementRequest.prototype.partRequestId = "";

    /**
     * CreateReplacementRequest contract.
     * @member {appliancepb.IContract|null|undefined} contract
     * @memberof appliancepb.CreateReplacementRequest
     * @instance
     */
    CreateReplacementRequest.prototype.contract = null;

    /**
     * CreateReplacementRequest itemId.
     * @member {string} itemId
     * @memberof appliancepb.CreateReplacementRequest
     * @instance
     */
    CreateReplacementRequest.prototype.itemId = "";

    /**
     * CreateReplacementRequest customer.
     * @member {appliancepb.ICustomer|null|undefined} customer
     * @memberof appliancepb.CreateReplacementRequest
     * @instance
     */
    CreateReplacementRequest.prototype.customer = null;

    /**
     * CreateReplacementRequest notification.
     * @member {appliancepb.INotification|null|undefined} notification
     * @memberof appliancepb.CreateReplacementRequest
     * @instance
     */
    CreateReplacementRequest.prototype.notification = null;

    /**
     * CreateReplacementRequest likeForLike.
     * @member {appliancepb.IProduct|null|undefined} likeForLike
     * @memberof appliancepb.CreateReplacementRequest
     * @instance
     */
    CreateReplacementRequest.prototype.likeForLike = null;

    /**
     * CreateReplacementRequest order.
     * @member {appliancepb.IOrder|null|undefined} order
     * @memberof appliancepb.CreateReplacementRequest
     * @instance
     */
    CreateReplacementRequest.prototype.order = null;

    /**
     * CreateReplacementRequest shoppingCart.
     * @member {appliancepb.CreateReplacementRequest.IShoppingCart|null|undefined} shoppingCart
     * @memberof appliancepb.CreateReplacementRequest
     * @instance
     */
    CreateReplacementRequest.prototype.shoppingCart = null;

    /**
     * CreateReplacementRequest note.
     * @member {string} note
     * @memberof appliancepb.CreateReplacementRequest
     * @instance
     */
    CreateReplacementRequest.prototype.note = "";

    /**
     * CreateReplacementRequest productAccessories.
     * @member {Array.<appliancepb.IProductAccessory>} productAccessories
     * @memberof appliancepb.CreateReplacementRequest
     * @instance
     */
    CreateReplacementRequest.prototype.productAccessories = $util.emptyArray;

    /**
     * CreateReplacementRequest cashInLieu.
     * @member {appliancepb.IPriceSetter|null|undefined} cashInLieu
     * @memberof appliancepb.CreateReplacementRequest
     * @instance
     */
    CreateReplacementRequest.prototype.cashInLieu = null;

    /**
     * CreateReplacementRequest repairCredit.
     * @member {appliancepb.IPriceSetter|null|undefined} repairCredit
     * @memberof appliancepb.CreateReplacementRequest
     * @instance
     */
    CreateReplacementRequest.prototype.repairCredit = null;

    /**
     * Creates a new CreateReplacementRequest instance using the specified properties.
     * @function create
     * @memberof appliancepb.CreateReplacementRequest
     * @static
     * @param {appliancepb.ICreateReplacementRequest=} [properties] Properties to set
     * @returns {appliancepb.CreateReplacementRequest} CreateReplacementRequest instance
     */
    CreateReplacementRequest.create = function create(properties) {
      return new CreateReplacementRequest(properties);
    };

    /**
     * Encodes the specified CreateReplacementRequest message. Does not implicitly {@link appliancepb.CreateReplacementRequest.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.CreateReplacementRequest
     * @static
     * @param {appliancepb.ICreateReplacementRequest} m CreateReplacementRequest message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CreateReplacementRequest.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.dispatchId != null && Object.hasOwnProperty.call(m, "dispatchId"))
        w.uint32(10).string(m.dispatchId);
      if (
        m.partRequestId != null &&
        Object.hasOwnProperty.call(m, "partRequestId")
      )
        w.uint32(18).string(m.partRequestId);
      if (m.contract != null && Object.hasOwnProperty.call(m, "contract"))
        $root.appliancepb.Contract.encode(
          m.contract,
          w.uint32(26).fork()
        ).ldelim();
      if (m.itemId != null && Object.hasOwnProperty.call(m, "itemId"))
        w.uint32(34).string(m.itemId);
      if (m.customer != null && Object.hasOwnProperty.call(m, "customer"))
        $root.appliancepb.Customer.encode(
          m.customer,
          w.uint32(42).fork()
        ).ldelim();
      if (
        m.notification != null &&
        Object.hasOwnProperty.call(m, "notification")
      )
        $root.appliancepb.Notification.encode(
          m.notification,
          w.uint32(50).fork()
        ).ldelim();
      if (m.likeForLike != null && Object.hasOwnProperty.call(m, "likeForLike"))
        $root.appliancepb.Product.encode(
          m.likeForLike,
          w.uint32(58).fork()
        ).ldelim();
      if (m.order != null && Object.hasOwnProperty.call(m, "order"))
        $root.appliancepb.Order.encode(m.order, w.uint32(66).fork()).ldelim();
      if (
        m.shoppingCart != null &&
        Object.hasOwnProperty.call(m, "shoppingCart")
      )
        $root.appliancepb.CreateReplacementRequest.ShoppingCart.encode(
          m.shoppingCart,
          w.uint32(74).fork()
        ).ldelim();
      if (m.note != null && Object.hasOwnProperty.call(m, "note"))
        w.uint32(82).string(m.note);
      if (m.productAccessories != null && m.productAccessories.length) {
        for (var i = 0; i < m.productAccessories.length; ++i)
          $root.appliancepb.ProductAccessory.encode(
            m.productAccessories[i],
            w.uint32(90).fork()
          ).ldelim();
      }
      if (m.cashInLieu != null && Object.hasOwnProperty.call(m, "cashInLieu"))
        $root.appliancepb.PriceSetter.encode(
          m.cashInLieu,
          w.uint32(98).fork()
        ).ldelim();
      if (
        m.repairCredit != null &&
        Object.hasOwnProperty.call(m, "repairCredit")
      )
        $root.appliancepb.PriceSetter.encode(
          m.repairCredit,
          w.uint32(106).fork()
        ).ldelim();
      return w;
    };

    /**
     * Decodes a CreateReplacementRequest message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.CreateReplacementRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.CreateReplacementRequest} CreateReplacementRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CreateReplacementRequest.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.CreateReplacementRequest();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.dispatchId = r.string();
            break;
          case 2:
            m.partRequestId = r.string();
            break;
          case 3:
            m.contract = $root.appliancepb.Contract.decode(r, r.uint32());
            break;
          case 4:
            m.itemId = r.string();
            break;
          case 5:
            m.customer = $root.appliancepb.Customer.decode(r, r.uint32());
            break;
          case 6:
            m.notification = $root.appliancepb.Notification.decode(
              r,
              r.uint32()
            );
            break;
          case 7:
            m.likeForLike = $root.appliancepb.Product.decode(r, r.uint32());
            break;
          case 8:
            m.order = $root.appliancepb.Order.decode(r, r.uint32());
            break;
          case 9:
            m.shoppingCart = $root.appliancepb.CreateReplacementRequest.ShoppingCart.decode(
              r,
              r.uint32()
            );
            break;
          case 10:
            m.note = r.string();
            break;
          case 11:
            if (!(m.productAccessories && m.productAccessories.length))
              m.productAccessories = [];
            m.productAccessories.push(
              $root.appliancepb.ProductAccessory.decode(r, r.uint32())
            );
            break;
          case 12:
            m.cashInLieu = $root.appliancepb.PriceSetter.decode(r, r.uint32());
            break;
          case 13:
            m.repairCredit = $root.appliancepb.PriceSetter.decode(
              r,
              r.uint32()
            );
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    CreateReplacementRequest.ShoppingCart = (function () {
      /**
       * Properties of a ShoppingCart.
       * @memberof appliancepb.CreateReplacementRequest
       * @interface IShoppingCart
       * @property {Array.<appliancepb.CreateReplacementRequest.ShoppingCart.IShoppingCartItem>|null} [shoppingCartItems] ShoppingCart shoppingCartItems
       */

      /**
       * Constructs a new ShoppingCart.
       * @memberof appliancepb.CreateReplacementRequest
       * @classdesc Represents a ShoppingCart.
       * @implements IShoppingCart
       * @constructor
       * @param {appliancepb.CreateReplacementRequest.IShoppingCart=} [p] Properties to set
       */
      function ShoppingCart(p) {
        this.shoppingCartItems = [];
        if (p)
          for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
            if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
      }

      /**
       * ShoppingCart shoppingCartItems.
       * @member {Array.<appliancepb.CreateReplacementRequest.ShoppingCart.IShoppingCartItem>} shoppingCartItems
       * @memberof appliancepb.CreateReplacementRequest.ShoppingCart
       * @instance
       */
      ShoppingCart.prototype.shoppingCartItems = $util.emptyArray;

      /**
       * Creates a new ShoppingCart instance using the specified properties.
       * @function create
       * @memberof appliancepb.CreateReplacementRequest.ShoppingCart
       * @static
       * @param {appliancepb.CreateReplacementRequest.IShoppingCart=} [properties] Properties to set
       * @returns {appliancepb.CreateReplacementRequest.ShoppingCart} ShoppingCart instance
       */
      ShoppingCart.create = function create(properties) {
        return new ShoppingCart(properties);
      };

      /**
       * Encodes the specified ShoppingCart message. Does not implicitly {@link appliancepb.CreateReplacementRequest.ShoppingCart.verify|verify} messages.
       * @function encode
       * @memberof appliancepb.CreateReplacementRequest.ShoppingCart
       * @static
       * @param {appliancepb.CreateReplacementRequest.IShoppingCart} m ShoppingCart message or plain object to encode
       * @param {$protobuf.Writer} [w] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      ShoppingCart.encode = function encode(m, w) {
        if (!w) w = $Writer.create();
        if (m.shoppingCartItems != null && m.shoppingCartItems.length) {
          for (var i = 0; i < m.shoppingCartItems.length; ++i)
            $root.appliancepb.CreateReplacementRequest.ShoppingCart.ShoppingCartItem.encode(
              m.shoppingCartItems[i],
              w.uint32(10).fork()
            ).ldelim();
        }
        return w;
      };

      /**
       * Decodes a ShoppingCart message from the specified reader or buffer.
       * @function decode
       * @memberof appliancepb.CreateReplacementRequest.ShoppingCart
       * @static
       * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
       * @param {number} [l] Message length if known beforehand
       * @returns {appliancepb.CreateReplacementRequest.ShoppingCart} ShoppingCart
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      ShoppingCart.decode = function decode(r, l) {
        if (!(r instanceof $Reader)) r = $Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l,
          m = new $root.appliancepb.CreateReplacementRequest.ShoppingCart();
        while (r.pos < c) {
          var t = r.uint32();
          switch (t >>> 3) {
            case 1:
              if (!(m.shoppingCartItems && m.shoppingCartItems.length))
                m.shoppingCartItems = [];
              m.shoppingCartItems.push(
                $root.appliancepb.CreateReplacementRequest.ShoppingCart.ShoppingCartItem.decode(
                  r,
                  r.uint32()
                )
              );
              break;
            default:
              r.skipType(t & 7);
              break;
          }
        }
        return m;
      };

      ShoppingCart.ShoppingCartItem = (function () {
        /**
         * Properties of a ShoppingCartItem.
         * @memberof appliancepb.CreateReplacementRequest.ShoppingCart
         * @interface IShoppingCartItem
         * @property {appliancepb.IProduct|null} [product] ShoppingCartItem product
         * @property {number|null} [quantity] ShoppingCartItem quantity
         * @property {appliancepb.IPriceSetter|null} [finalPrice] ShoppingCartItem finalPrice
         */

        /**
         * Constructs a new ShoppingCartItem.
         * @memberof appliancepb.CreateReplacementRequest.ShoppingCart
         * @classdesc Represents a ShoppingCartItem.
         * @implements IShoppingCartItem
         * @constructor
         * @param {appliancepb.CreateReplacementRequest.ShoppingCart.IShoppingCartItem=} [p] Properties to set
         */
        function ShoppingCartItem(p) {
          if (p)
            for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
              if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
        }

        /**
         * ShoppingCartItem product.
         * @member {appliancepb.IProduct|null|undefined} product
         * @memberof appliancepb.CreateReplacementRequest.ShoppingCart.ShoppingCartItem
         * @instance
         */
        ShoppingCartItem.prototype.product = null;

        /**
         * ShoppingCartItem quantity.
         * @member {number} quantity
         * @memberof appliancepb.CreateReplacementRequest.ShoppingCart.ShoppingCartItem
         * @instance
         */
        ShoppingCartItem.prototype.quantity = 0;

        /**
         * ShoppingCartItem finalPrice.
         * @member {appliancepb.IPriceSetter|null|undefined} finalPrice
         * @memberof appliancepb.CreateReplacementRequest.ShoppingCart.ShoppingCartItem
         * @instance
         */
        ShoppingCartItem.prototype.finalPrice = null;

        /**
         * Creates a new ShoppingCartItem instance using the specified properties.
         * @function create
         * @memberof appliancepb.CreateReplacementRequest.ShoppingCart.ShoppingCartItem
         * @static
         * @param {appliancepb.CreateReplacementRequest.ShoppingCart.IShoppingCartItem=} [properties] Properties to set
         * @returns {appliancepb.CreateReplacementRequest.ShoppingCart.ShoppingCartItem} ShoppingCartItem instance
         */
        ShoppingCartItem.create = function create(properties) {
          return new ShoppingCartItem(properties);
        };

        /**
         * Encodes the specified ShoppingCartItem message. Does not implicitly {@link appliancepb.CreateReplacementRequest.ShoppingCart.ShoppingCartItem.verify|verify} messages.
         * @function encode
         * @memberof appliancepb.CreateReplacementRequest.ShoppingCart.ShoppingCartItem
         * @static
         * @param {appliancepb.CreateReplacementRequest.ShoppingCart.IShoppingCartItem} m ShoppingCartItem message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ShoppingCartItem.encode = function encode(m, w) {
          if (!w) w = $Writer.create();
          if (m.product != null && Object.hasOwnProperty.call(m, "product"))
            $root.appliancepb.Product.encode(
              m.product,
              w.uint32(10).fork()
            ).ldelim();
          if (m.quantity != null && Object.hasOwnProperty.call(m, "quantity"))
            w.uint32(16).int32(m.quantity);
          if (
            m.finalPrice != null &&
            Object.hasOwnProperty.call(m, "finalPrice")
          )
            $root.appliancepb.PriceSetter.encode(
              m.finalPrice,
              w.uint32(26).fork()
            ).ldelim();
          return w;
        };

        /**
         * Decodes a ShoppingCartItem message from the specified reader or buffer.
         * @function decode
         * @memberof appliancepb.CreateReplacementRequest.ShoppingCart.ShoppingCartItem
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {appliancepb.CreateReplacementRequest.ShoppingCart.ShoppingCartItem} ShoppingCartItem
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ShoppingCartItem.decode = function decode(r, l) {
          if (!(r instanceof $Reader)) r = $Reader.create(r);
          var c = l === undefined ? r.len : r.pos + l,
            m = new $root.appliancepb.CreateReplacementRequest.ShoppingCart.ShoppingCartItem();
          while (r.pos < c) {
            var t = r.uint32();
            switch (t >>> 3) {
              case 1:
                m.product = $root.appliancepb.Product.decode(r, r.uint32());
                break;
              case 2:
                m.quantity = r.int32();
                break;
              case 3:
                m.finalPrice = $root.appliancepb.PriceSetter.decode(
                  r,
                  r.uint32()
                );
                break;
              default:
                r.skipType(t & 7);
                break;
            }
          }
          return m;
        };

        return ShoppingCartItem;
      })();

      return ShoppingCart;
    })();

    return CreateReplacementRequest;
  })();

  appliancepb.CreateReplacementResponse = (function () {
    /**
     * Properties of a CreateReplacementResponse.
     * @memberof appliancepb
     * @interface ICreateReplacementResponse
     * @property {string|null} [replacementId] CreateReplacementResponse replacementId
     * @property {string|null} [shopLink] CreateReplacementResponse shopLink
     */

    /**
     * Constructs a new CreateReplacementResponse.
     * @memberof appliancepb
     * @classdesc Represents a CreateReplacementResponse.
     * @implements ICreateReplacementResponse
     * @constructor
     * @param {appliancepb.ICreateReplacementResponse=} [p] Properties to set
     */
    function CreateReplacementResponse(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * CreateReplacementResponse replacementId.
     * @member {string} replacementId
     * @memberof appliancepb.CreateReplacementResponse
     * @instance
     */
    CreateReplacementResponse.prototype.replacementId = "";

    /**
     * CreateReplacementResponse shopLink.
     * @member {string} shopLink
     * @memberof appliancepb.CreateReplacementResponse
     * @instance
     */
    CreateReplacementResponse.prototype.shopLink = "";

    /**
     * Creates a new CreateReplacementResponse instance using the specified properties.
     * @function create
     * @memberof appliancepb.CreateReplacementResponse
     * @static
     * @param {appliancepb.ICreateReplacementResponse=} [properties] Properties to set
     * @returns {appliancepb.CreateReplacementResponse} CreateReplacementResponse instance
     */
    CreateReplacementResponse.create = function create(properties) {
      return new CreateReplacementResponse(properties);
    };

    /**
     * Encodes the specified CreateReplacementResponse message. Does not implicitly {@link appliancepb.CreateReplacementResponse.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.CreateReplacementResponse
     * @static
     * @param {appliancepb.ICreateReplacementResponse} m CreateReplacementResponse message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CreateReplacementResponse.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (
        m.replacementId != null &&
        Object.hasOwnProperty.call(m, "replacementId")
      )
        w.uint32(10).string(m.replacementId);
      if (m.shopLink != null && Object.hasOwnProperty.call(m, "shopLink"))
        w.uint32(18).string(m.shopLink);
      return w;
    };

    /**
     * Decodes a CreateReplacementResponse message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.CreateReplacementResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.CreateReplacementResponse} CreateReplacementResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CreateReplacementResponse.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.CreateReplacementResponse();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.replacementId = r.string();
            break;
          case 2:
            m.shopLink = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return CreateReplacementResponse;
  })();

  appliancepb.OutrightPaymentRequest = (function () {
    /**
     * Properties of an OutrightPaymentRequest.
     * @memberof appliancepb
     * @interface IOutrightPaymentRequest
     * @property {appliancepb.IContract|null} [contract] OutrightPaymentRequest contract
     * @property {appliancepb.ICustomer|null} [customer] OutrightPaymentRequest customer
     * @property {string|null} [vendor] OutrightPaymentRequest vendor
     * @property {appliancepb.IPaymentDetails|null} [paymentDetails] OutrightPaymentRequest paymentDetails
     * @property {string|null} [recordId] OutrightPaymentRequest recordId
     * @property {string|null} [modelNumber] OutrightPaymentRequest modelNumber
     * @property {google.protobuf.ITimestamp|null} [orderDate] OutrightPaymentRequest orderDate
     * @property {appliancepb.OutrightPaymentRequest.PaymentType|null} [paymentType] OutrightPaymentRequest paymentType
     * @property {string|null} [dispatchId] OutrightPaymentRequest dispatchId
     * @property {appliancepb.IOrder|null} [order] OutrightPaymentRequest order
     * @property {appliancepb.ICart|null} [cart] OutrightPaymentRequest cart
     * @property {string|null} [partRequestId] OutrightPaymentRequest partRequestId
     */

    /**
     * Constructs a new OutrightPaymentRequest.
     * @memberof appliancepb
     * @classdesc Represents an OutrightPaymentRequest.
     * @implements IOutrightPaymentRequest
     * @constructor
     * @param {appliancepb.IOutrightPaymentRequest=} [p] Properties to set
     */
    function OutrightPaymentRequest(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * OutrightPaymentRequest contract.
     * @member {appliancepb.IContract|null|undefined} contract
     * @memberof appliancepb.OutrightPaymentRequest
     * @instance
     */
    OutrightPaymentRequest.prototype.contract = null;

    /**
     * OutrightPaymentRequest customer.
     * @member {appliancepb.ICustomer|null|undefined} customer
     * @memberof appliancepb.OutrightPaymentRequest
     * @instance
     */
    OutrightPaymentRequest.prototype.customer = null;

    /**
     * OutrightPaymentRequest vendor.
     * @member {string} vendor
     * @memberof appliancepb.OutrightPaymentRequest
     * @instance
     */
    OutrightPaymentRequest.prototype.vendor = "";

    /**
     * OutrightPaymentRequest paymentDetails.
     * @member {appliancepb.IPaymentDetails|null|undefined} paymentDetails
     * @memberof appliancepb.OutrightPaymentRequest
     * @instance
     */
    OutrightPaymentRequest.prototype.paymentDetails = null;

    /**
     * OutrightPaymentRequest recordId.
     * @member {string} recordId
     * @memberof appliancepb.OutrightPaymentRequest
     * @instance
     */
    OutrightPaymentRequest.prototype.recordId = "";

    /**
     * OutrightPaymentRequest modelNumber.
     * @member {string} modelNumber
     * @memberof appliancepb.OutrightPaymentRequest
     * @instance
     */
    OutrightPaymentRequest.prototype.modelNumber = "";

    /**
     * OutrightPaymentRequest orderDate.
     * @member {google.protobuf.ITimestamp|null|undefined} orderDate
     * @memberof appliancepb.OutrightPaymentRequest
     * @instance
     */
    OutrightPaymentRequest.prototype.orderDate = null;

    /**
     * OutrightPaymentRequest paymentType.
     * @member {appliancepb.OutrightPaymentRequest.PaymentType} paymentType
     * @memberof appliancepb.OutrightPaymentRequest
     * @instance
     */
    OutrightPaymentRequest.prototype.paymentType = 0;

    /**
     * OutrightPaymentRequest dispatchId.
     * @member {string} dispatchId
     * @memberof appliancepb.OutrightPaymentRequest
     * @instance
     */
    OutrightPaymentRequest.prototype.dispatchId = "";

    /**
     * OutrightPaymentRequest order.
     * @member {appliancepb.IOrder|null|undefined} order
     * @memberof appliancepb.OutrightPaymentRequest
     * @instance
     */
    OutrightPaymentRequest.prototype.order = null;

    /**
     * OutrightPaymentRequest cart.
     * @member {appliancepb.ICart|null|undefined} cart
     * @memberof appliancepb.OutrightPaymentRequest
     * @instance
     */
    OutrightPaymentRequest.prototype.cart = null;

    /**
     * OutrightPaymentRequest partRequestId.
     * @member {string} partRequestId
     * @memberof appliancepb.OutrightPaymentRequest
     * @instance
     */
    OutrightPaymentRequest.prototype.partRequestId = "";

    /**
     * Creates a new OutrightPaymentRequest instance using the specified properties.
     * @function create
     * @memberof appliancepb.OutrightPaymentRequest
     * @static
     * @param {appliancepb.IOutrightPaymentRequest=} [properties] Properties to set
     * @returns {appliancepb.OutrightPaymentRequest} OutrightPaymentRequest instance
     */
    OutrightPaymentRequest.create = function create(properties) {
      return new OutrightPaymentRequest(properties);
    };

    /**
     * Encodes the specified OutrightPaymentRequest message. Does not implicitly {@link appliancepb.OutrightPaymentRequest.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.OutrightPaymentRequest
     * @static
     * @param {appliancepb.IOutrightPaymentRequest} m OutrightPaymentRequest message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OutrightPaymentRequest.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.contract != null && Object.hasOwnProperty.call(m, "contract"))
        $root.appliancepb.Contract.encode(
          m.contract,
          w.uint32(10).fork()
        ).ldelim();
      if (m.customer != null && Object.hasOwnProperty.call(m, "customer"))
        $root.appliancepb.Customer.encode(
          m.customer,
          w.uint32(18).fork()
        ).ldelim();
      if (m.vendor != null && Object.hasOwnProperty.call(m, "vendor"))
        w.uint32(26).string(m.vendor);
      if (
        m.paymentDetails != null &&
        Object.hasOwnProperty.call(m, "paymentDetails")
      )
        $root.appliancepb.PaymentDetails.encode(
          m.paymentDetails,
          w.uint32(34).fork()
        ).ldelim();
      if (m.recordId != null && Object.hasOwnProperty.call(m, "recordId"))
        w.uint32(42).string(m.recordId);
      if (m.modelNumber != null && Object.hasOwnProperty.call(m, "modelNumber"))
        w.uint32(50).string(m.modelNumber);
      if (m.orderDate != null && Object.hasOwnProperty.call(m, "orderDate"))
        $root.google.protobuf.Timestamp.encode(
          m.orderDate,
          w.uint32(58).fork()
        ).ldelim();
      if (m.paymentType != null && Object.hasOwnProperty.call(m, "paymentType"))
        w.uint32(64).int32(m.paymentType);
      if (m.dispatchId != null && Object.hasOwnProperty.call(m, "dispatchId"))
        w.uint32(74).string(m.dispatchId);
      if (m.order != null && Object.hasOwnProperty.call(m, "order"))
        $root.appliancepb.Order.encode(m.order, w.uint32(82).fork()).ldelim();
      if (m.cart != null && Object.hasOwnProperty.call(m, "cart"))
        $root.appliancepb.Cart.encode(m.cart, w.uint32(90).fork()).ldelim();
      if (
        m.partRequestId != null &&
        Object.hasOwnProperty.call(m, "partRequestId")
      )
        w.uint32(98).string(m.partRequestId);
      return w;
    };

    /**
     * Decodes an OutrightPaymentRequest message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.OutrightPaymentRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.OutrightPaymentRequest} OutrightPaymentRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OutrightPaymentRequest.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.OutrightPaymentRequest();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.contract = $root.appliancepb.Contract.decode(r, r.uint32());
            break;
          case 2:
            m.customer = $root.appliancepb.Customer.decode(r, r.uint32());
            break;
          case 3:
            m.vendor = r.string();
            break;
          case 4:
            m.paymentDetails = $root.appliancepb.PaymentDetails.decode(
              r,
              r.uint32()
            );
            break;
          case 5:
            m.recordId = r.string();
            break;
          case 6:
            m.modelNumber = r.string();
            break;
          case 7:
            m.orderDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
            break;
          case 8:
            m.paymentType = r.int32();
            break;
          case 9:
            m.dispatchId = r.string();
            break;
          case 10:
            m.order = $root.appliancepb.Order.decode(r, r.uint32());
            break;
          case 11:
            m.cart = $root.appliancepb.Cart.decode(r, r.uint32());
            break;
          case 12:
            m.partRequestId = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    /**
     * PaymentType enum.
     * @name appliancepb.OutrightPaymentRequest.PaymentType
     * @enum {number}
     * @property {number} PAYMENT_TYPE_UNSPECIFIED=0 PAYMENT_TYPE_UNSPECIFIED value
     * @property {number} PAYMENT_TYPE_OUTRIGHT_PAYMENT=1 PAYMENT_TYPE_OUTRIGHT_PAYMENT value
     * @property {number} PAYMENT_TYPE_EMPLOYEE_ORDER=2 PAYMENT_TYPE_EMPLOYEE_ORDER value
     * @property {number} PAYMENT_TYPE_ACCESSORIES=3 PAYMENT_TYPE_ACCESSORIES value
     * @property {number} PAYMENT_TYPE_RESTOCKING_FEE=4 PAYMENT_TYPE_RESTOCKING_FEE value
     */
    OutrightPaymentRequest.PaymentType = (function () {
      const valuesById = {},
        values = Object.create(valuesById);
      values[(valuesById[0] = "PAYMENT_TYPE_UNSPECIFIED")] = 0;
      values[(valuesById[1] = "PAYMENT_TYPE_OUTRIGHT_PAYMENT")] = 1;
      values[(valuesById[2] = "PAYMENT_TYPE_EMPLOYEE_ORDER")] = 2;
      values[(valuesById[3] = "PAYMENT_TYPE_ACCESSORIES")] = 3;
      values[(valuesById[4] = "PAYMENT_TYPE_RESTOCKING_FEE")] = 4;
      return values;
    })();

    return OutrightPaymentRequest;
  })();

  appliancepb.OutrightPaymentResponse = (function () {
    /**
     * Properties of an OutrightPaymentResponse.
     * @memberof appliancepb
     * @interface IOutrightPaymentResponse
     * @property {string|null} [outrightPaymentId] OutrightPaymentResponse outrightPaymentId
     */

    /**
     * Constructs a new OutrightPaymentResponse.
     * @memberof appliancepb
     * @classdesc Represents an OutrightPaymentResponse.
     * @implements IOutrightPaymentResponse
     * @constructor
     * @param {appliancepb.IOutrightPaymentResponse=} [p] Properties to set
     */
    function OutrightPaymentResponse(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * OutrightPaymentResponse outrightPaymentId.
     * @member {string} outrightPaymentId
     * @memberof appliancepb.OutrightPaymentResponse
     * @instance
     */
    OutrightPaymentResponse.prototype.outrightPaymentId = "";

    /**
     * Creates a new OutrightPaymentResponse instance using the specified properties.
     * @function create
     * @memberof appliancepb.OutrightPaymentResponse
     * @static
     * @param {appliancepb.IOutrightPaymentResponse=} [properties] Properties to set
     * @returns {appliancepb.OutrightPaymentResponse} OutrightPaymentResponse instance
     */
    OutrightPaymentResponse.create = function create(properties) {
      return new OutrightPaymentResponse(properties);
    };

    /**
     * Encodes the specified OutrightPaymentResponse message. Does not implicitly {@link appliancepb.OutrightPaymentResponse.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.OutrightPaymentResponse
     * @static
     * @param {appliancepb.IOutrightPaymentResponse} m OutrightPaymentResponse message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OutrightPaymentResponse.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (
        m.outrightPaymentId != null &&
        Object.hasOwnProperty.call(m, "outrightPaymentId")
      )
        w.uint32(10).string(m.outrightPaymentId);
      return w;
    };

    /**
     * Decodes an OutrightPaymentResponse message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.OutrightPaymentResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.OutrightPaymentResponse} OutrightPaymentResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OutrightPaymentResponse.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.OutrightPaymentResponse();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.outrightPaymentId = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return OutrightPaymentResponse;
  })();

  appliancepb.Agent = (function () {
    /**
     * Properties of an Agent.
     * @memberof appliancepb
     * @interface IAgent
     * @property {string|null} [uniqueName] Agent uniqueName
     */

    /**
     * Constructs a new Agent.
     * @memberof appliancepb
     * @classdesc Represents an Agent.
     * @implements IAgent
     * @constructor
     * @param {appliancepb.IAgent=} [p] Properties to set
     */
    function Agent(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * Agent uniqueName.
     * @member {string} uniqueName
     * @memberof appliancepb.Agent
     * @instance
     */
    Agent.prototype.uniqueName = "";

    /**
     * Creates a new Agent instance using the specified properties.
     * @function create
     * @memberof appliancepb.Agent
     * @static
     * @param {appliancepb.IAgent=} [properties] Properties to set
     * @returns {appliancepb.Agent} Agent instance
     */
    Agent.create = function create(properties) {
      return new Agent(properties);
    };

    /**
     * Encodes the specified Agent message. Does not implicitly {@link appliancepb.Agent.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.Agent
     * @static
     * @param {appliancepb.IAgent} m Agent message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Agent.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.uniqueName != null && Object.hasOwnProperty.call(m, "uniqueName"))
        w.uint32(10).string(m.uniqueName);
      return w;
    };

    /**
     * Decodes an Agent message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.Agent
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.Agent} Agent
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Agent.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.Agent();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.uniqueName = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return Agent;
  })();

  appliancepb.OutrightPaymentRecord = (function () {
    /**
     * Properties of an OutrightPaymentRecord.
     * @memberof appliancepb
     * @interface IOutrightPaymentRecord
     * @property {string|null} [id] OutrightPaymentRecord id
     * @property {string|null} [contractId] OutrightPaymentRecord contractId
     * @property {string|null} [paymentId] OutrightPaymentRecord paymentId
     * @property {string|null} [companyCode] OutrightPaymentRecord companyCode
     * @property {string|null} [vendor] OutrightPaymentRecord vendor
     * @property {string|null} [modelNumber] OutrightPaymentRecord modelNumber
     * @property {string|null} [billingState] OutrightPaymentRecord billingState
     * @property {number|null} [amount] OutrightPaymentRecord amount
     * @property {google.protobuf.ITimestamp|null} [orderDate] OutrightPaymentRecord orderDate
     * @property {google.protobuf.ITimestamp|null} [created] OutrightPaymentRecord created
     * @property {appliancepb.IAgent|null} [agent] OutrightPaymentRecord agent
     * @property {string|null} [paymentType] OutrightPaymentRecord paymentType
     * @property {string|null} [vendorOrderNumber] OutrightPaymentRecord vendorOrderNumber
     * @property {string|null} [dispatchId] OutrightPaymentRecord dispatchId
     * @property {appliancepb.ICart|null} [cart] OutrightPaymentRecord cart
     * @property {string|null} [partRequestId] OutrightPaymentRecord partRequestId
     * @property {appliancepb.ICustomer|null} [customer] OutrightPaymentRecord customer
     * @property {string|null} [status] OutrightPaymentRecord status
     * @property {appliancepb.IOrder|null} [order] OutrightPaymentRecord order
     * @property {google.protobuf.ITimestamp|null} [updated] OutrightPaymentRecord updated
     */

    /**
     * Constructs a new OutrightPaymentRecord.
     * @memberof appliancepb
     * @classdesc Represents an OutrightPaymentRecord.
     * @implements IOutrightPaymentRecord
     * @constructor
     * @param {appliancepb.IOutrightPaymentRecord=} [p] Properties to set
     */
    function OutrightPaymentRecord(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * OutrightPaymentRecord id.
     * @member {string} id
     * @memberof appliancepb.OutrightPaymentRecord
     * @instance
     */
    OutrightPaymentRecord.prototype.id = "";

    /**
     * OutrightPaymentRecord contractId.
     * @member {string} contractId
     * @memberof appliancepb.OutrightPaymentRecord
     * @instance
     */
    OutrightPaymentRecord.prototype.contractId = "";

    /**
     * OutrightPaymentRecord paymentId.
     * @member {string} paymentId
     * @memberof appliancepb.OutrightPaymentRecord
     * @instance
     */
    OutrightPaymentRecord.prototype.paymentId = "";

    /**
     * OutrightPaymentRecord companyCode.
     * @member {string} companyCode
     * @memberof appliancepb.OutrightPaymentRecord
     * @instance
     */
    OutrightPaymentRecord.prototype.companyCode = "";

    /**
     * OutrightPaymentRecord vendor.
     * @member {string} vendor
     * @memberof appliancepb.OutrightPaymentRecord
     * @instance
     */
    OutrightPaymentRecord.prototype.vendor = "";

    /**
     * OutrightPaymentRecord modelNumber.
     * @member {string} modelNumber
     * @memberof appliancepb.OutrightPaymentRecord
     * @instance
     */
    OutrightPaymentRecord.prototype.modelNumber = "";

    /**
     * OutrightPaymentRecord billingState.
     * @member {string} billingState
     * @memberof appliancepb.OutrightPaymentRecord
     * @instance
     */
    OutrightPaymentRecord.prototype.billingState = "";

    /**
     * OutrightPaymentRecord amount.
     * @member {number} amount
     * @memberof appliancepb.OutrightPaymentRecord
     * @instance
     */
    OutrightPaymentRecord.prototype.amount = 0;

    /**
     * OutrightPaymentRecord orderDate.
     * @member {google.protobuf.ITimestamp|null|undefined} orderDate
     * @memberof appliancepb.OutrightPaymentRecord
     * @instance
     */
    OutrightPaymentRecord.prototype.orderDate = null;

    /**
     * OutrightPaymentRecord created.
     * @member {google.protobuf.ITimestamp|null|undefined} created
     * @memberof appliancepb.OutrightPaymentRecord
     * @instance
     */
    OutrightPaymentRecord.prototype.created = null;

    /**
     * OutrightPaymentRecord agent.
     * @member {appliancepb.IAgent|null|undefined} agent
     * @memberof appliancepb.OutrightPaymentRecord
     * @instance
     */
    OutrightPaymentRecord.prototype.agent = null;

    /**
     * OutrightPaymentRecord paymentType.
     * @member {string} paymentType
     * @memberof appliancepb.OutrightPaymentRecord
     * @instance
     */
    OutrightPaymentRecord.prototype.paymentType = "";

    /**
     * OutrightPaymentRecord vendorOrderNumber.
     * @member {string} vendorOrderNumber
     * @memberof appliancepb.OutrightPaymentRecord
     * @instance
     */
    OutrightPaymentRecord.prototype.vendorOrderNumber = "";

    /**
     * OutrightPaymentRecord dispatchId.
     * @member {string} dispatchId
     * @memberof appliancepb.OutrightPaymentRecord
     * @instance
     */
    OutrightPaymentRecord.prototype.dispatchId = "";

    /**
     * OutrightPaymentRecord cart.
     * @member {appliancepb.ICart|null|undefined} cart
     * @memberof appliancepb.OutrightPaymentRecord
     * @instance
     */
    OutrightPaymentRecord.prototype.cart = null;

    /**
     * OutrightPaymentRecord partRequestId.
     * @member {string} partRequestId
     * @memberof appliancepb.OutrightPaymentRecord
     * @instance
     */
    OutrightPaymentRecord.prototype.partRequestId = "";

    /**
     * OutrightPaymentRecord customer.
     * @member {appliancepb.ICustomer|null|undefined} customer
     * @memberof appliancepb.OutrightPaymentRecord
     * @instance
     */
    OutrightPaymentRecord.prototype.customer = null;

    /**
     * OutrightPaymentRecord status.
     * @member {string} status
     * @memberof appliancepb.OutrightPaymentRecord
     * @instance
     */
    OutrightPaymentRecord.prototype.status = "";

    /**
     * OutrightPaymentRecord order.
     * @member {appliancepb.IOrder|null|undefined} order
     * @memberof appliancepb.OutrightPaymentRecord
     * @instance
     */
    OutrightPaymentRecord.prototype.order = null;

    /**
     * OutrightPaymentRecord updated.
     * @member {google.protobuf.ITimestamp|null|undefined} updated
     * @memberof appliancepb.OutrightPaymentRecord
     * @instance
     */
    OutrightPaymentRecord.prototype.updated = null;

    /**
     * Creates a new OutrightPaymentRecord instance using the specified properties.
     * @function create
     * @memberof appliancepb.OutrightPaymentRecord
     * @static
     * @param {appliancepb.IOutrightPaymentRecord=} [properties] Properties to set
     * @returns {appliancepb.OutrightPaymentRecord} OutrightPaymentRecord instance
     */
    OutrightPaymentRecord.create = function create(properties) {
      return new OutrightPaymentRecord(properties);
    };

    /**
     * Encodes the specified OutrightPaymentRecord message. Does not implicitly {@link appliancepb.OutrightPaymentRecord.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.OutrightPaymentRecord
     * @static
     * @param {appliancepb.IOutrightPaymentRecord} m OutrightPaymentRecord message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OutrightPaymentRecord.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.id != null && Object.hasOwnProperty.call(m, "id"))
        w.uint32(10).string(m.id);
      if (m.contractId != null && Object.hasOwnProperty.call(m, "contractId"))
        w.uint32(18).string(m.contractId);
      if (m.paymentId != null && Object.hasOwnProperty.call(m, "paymentId"))
        w.uint32(26).string(m.paymentId);
      if (m.companyCode != null && Object.hasOwnProperty.call(m, "companyCode"))
        w.uint32(34).string(m.companyCode);
      if (m.vendor != null && Object.hasOwnProperty.call(m, "vendor"))
        w.uint32(42).string(m.vendor);
      if (m.modelNumber != null && Object.hasOwnProperty.call(m, "modelNumber"))
        w.uint32(50).string(m.modelNumber);
      if (
        m.billingState != null &&
        Object.hasOwnProperty.call(m, "billingState")
      )
        w.uint32(58).string(m.billingState);
      if (m.amount != null && Object.hasOwnProperty.call(m, "amount"))
        w.uint32(64).int32(m.amount);
      if (m.orderDate != null && Object.hasOwnProperty.call(m, "orderDate"))
        $root.google.protobuf.Timestamp.encode(
          m.orderDate,
          w.uint32(74).fork()
        ).ldelim();
      if (m.created != null && Object.hasOwnProperty.call(m, "created"))
        $root.google.protobuf.Timestamp.encode(
          m.created,
          w.uint32(82).fork()
        ).ldelim();
      if (m.agent != null && Object.hasOwnProperty.call(m, "agent"))
        $root.appliancepb.Agent.encode(m.agent, w.uint32(90).fork()).ldelim();
      if (m.paymentType != null && Object.hasOwnProperty.call(m, "paymentType"))
        w.uint32(98).string(m.paymentType);
      if (
        m.vendorOrderNumber != null &&
        Object.hasOwnProperty.call(m, "vendorOrderNumber")
      )
        w.uint32(106).string(m.vendorOrderNumber);
      if (m.dispatchId != null && Object.hasOwnProperty.call(m, "dispatchId"))
        w.uint32(114).string(m.dispatchId);
      if (m.cart != null && Object.hasOwnProperty.call(m, "cart"))
        $root.appliancepb.Cart.encode(m.cart, w.uint32(122).fork()).ldelim();
      if (
        m.partRequestId != null &&
        Object.hasOwnProperty.call(m, "partRequestId")
      )
        w.uint32(130).string(m.partRequestId);
      if (m.customer != null && Object.hasOwnProperty.call(m, "customer"))
        $root.appliancepb.Customer.encode(
          m.customer,
          w.uint32(138).fork()
        ).ldelim();
      if (m.status != null && Object.hasOwnProperty.call(m, "status"))
        w.uint32(146).string(m.status);
      if (m.order != null && Object.hasOwnProperty.call(m, "order"))
        $root.appliancepb.Order.encode(m.order, w.uint32(154).fork()).ldelim();
      if (m.updated != null && Object.hasOwnProperty.call(m, "updated"))
        $root.google.protobuf.Timestamp.encode(
          m.updated,
          w.uint32(162).fork()
        ).ldelim();
      return w;
    };

    /**
     * Decodes an OutrightPaymentRecord message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.OutrightPaymentRecord
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.OutrightPaymentRecord} OutrightPaymentRecord
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OutrightPaymentRecord.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.OutrightPaymentRecord();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.id = r.string();
            break;
          case 2:
            m.contractId = r.string();
            break;
          case 3:
            m.paymentId = r.string();
            break;
          case 4:
            m.companyCode = r.string();
            break;
          case 5:
            m.vendor = r.string();
            break;
          case 6:
            m.modelNumber = r.string();
            break;
          case 7:
            m.billingState = r.string();
            break;
          case 8:
            m.amount = r.int32();
            break;
          case 9:
            m.orderDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
            break;
          case 10:
            m.created = $root.google.protobuf.Timestamp.decode(r, r.uint32());
            break;
          case 11:
            m.agent = $root.appliancepb.Agent.decode(r, r.uint32());
            break;
          case 12:
            m.paymentType = r.string();
            break;
          case 13:
            m.vendorOrderNumber = r.string();
            break;
          case 14:
            m.dispatchId = r.string();
            break;
          case 15:
            m.cart = $root.appliancepb.Cart.decode(r, r.uint32());
            break;
          case 16:
            m.partRequestId = r.string();
            break;
          case 17:
            m.customer = $root.appliancepb.Customer.decode(r, r.uint32());
            break;
          case 18:
            m.status = r.string();
            break;
          case 19:
            m.order = $root.appliancepb.Order.decode(r, r.uint32());
            break;
          case 20:
            m.updated = $root.google.protobuf.Timestamp.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return OutrightPaymentRecord;
  })();

  appliancepb.GetOutrightPaymentResponse = (function () {
    /**
     * Properties of a GetOutrightPaymentResponse.
     * @memberof appliancepb
     * @interface IGetOutrightPaymentResponse
     * @property {Array.<appliancepb.IOutrightPaymentRecord>|null} [outrightPayments] GetOutrightPaymentResponse outrightPayments
     * @property {appliancepb.IPagination|null} [pagination] GetOutrightPaymentResponse pagination
     */

    /**
     * Constructs a new GetOutrightPaymentResponse.
     * @memberof appliancepb
     * @classdesc Represents a GetOutrightPaymentResponse.
     * @implements IGetOutrightPaymentResponse
     * @constructor
     * @param {appliancepb.IGetOutrightPaymentResponse=} [p] Properties to set
     */
    function GetOutrightPaymentResponse(p) {
      this.outrightPayments = [];
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * GetOutrightPaymentResponse outrightPayments.
     * @member {Array.<appliancepb.IOutrightPaymentRecord>} outrightPayments
     * @memberof appliancepb.GetOutrightPaymentResponse
     * @instance
     */
    GetOutrightPaymentResponse.prototype.outrightPayments = $util.emptyArray;

    /**
     * GetOutrightPaymentResponse pagination.
     * @member {appliancepb.IPagination|null|undefined} pagination
     * @memberof appliancepb.GetOutrightPaymentResponse
     * @instance
     */
    GetOutrightPaymentResponse.prototype.pagination = null;

    /**
     * Creates a new GetOutrightPaymentResponse instance using the specified properties.
     * @function create
     * @memberof appliancepb.GetOutrightPaymentResponse
     * @static
     * @param {appliancepb.IGetOutrightPaymentResponse=} [properties] Properties to set
     * @returns {appliancepb.GetOutrightPaymentResponse} GetOutrightPaymentResponse instance
     */
    GetOutrightPaymentResponse.create = function create(properties) {
      return new GetOutrightPaymentResponse(properties);
    };

    /**
     * Encodes the specified GetOutrightPaymentResponse message. Does not implicitly {@link appliancepb.GetOutrightPaymentResponse.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.GetOutrightPaymentResponse
     * @static
     * @param {appliancepb.IGetOutrightPaymentResponse} m GetOutrightPaymentResponse message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetOutrightPaymentResponse.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.outrightPayments != null && m.outrightPayments.length) {
        for (var i = 0; i < m.outrightPayments.length; ++i)
          $root.appliancepb.OutrightPaymentRecord.encode(
            m.outrightPayments[i],
            w.uint32(10).fork()
          ).ldelim();
      }
      if (m.pagination != null && Object.hasOwnProperty.call(m, "pagination"))
        $root.appliancepb.Pagination.encode(
          m.pagination,
          w.uint32(18).fork()
        ).ldelim();
      return w;
    };

    /**
     * Decodes a GetOutrightPaymentResponse message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.GetOutrightPaymentResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.GetOutrightPaymentResponse} GetOutrightPaymentResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetOutrightPaymentResponse.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.GetOutrightPaymentResponse();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.outrightPayments && m.outrightPayments.length))
              m.outrightPayments = [];
            m.outrightPayments.push(
              $root.appliancepb.OutrightPaymentRecord.decode(r, r.uint32())
            );
            break;
          case 2:
            m.pagination = $root.appliancepb.Pagination.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetOutrightPaymentResponse;
  })();

  appliancepb.OutrightPaymentOrderResponse = (function () {
    /**
     * Properties of an OutrightPaymentOrderResponse.
     * @memberof appliancepb
     * @interface IOutrightPaymentOrderResponse
     * @property {appliancepb.IOutrightPaymentRecord|null} [outrightPayment] OutrightPaymentOrderResponse outrightPayment
     * @property {string|null} [errorMsg] OutrightPaymentOrderResponse errorMsg
     */

    /**
     * Constructs a new OutrightPaymentOrderResponse.
     * @memberof appliancepb
     * @classdesc Represents an OutrightPaymentOrderResponse.
     * @implements IOutrightPaymentOrderResponse
     * @constructor
     * @param {appliancepb.IOutrightPaymentOrderResponse=} [p] Properties to set
     */
    function OutrightPaymentOrderResponse(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * OutrightPaymentOrderResponse outrightPayment.
     * @member {appliancepb.IOutrightPaymentRecord|null|undefined} outrightPayment
     * @memberof appliancepb.OutrightPaymentOrderResponse
     * @instance
     */
    OutrightPaymentOrderResponse.prototype.outrightPayment = null;

    /**
     * OutrightPaymentOrderResponse errorMsg.
     * @member {string} errorMsg
     * @memberof appliancepb.OutrightPaymentOrderResponse
     * @instance
     */
    OutrightPaymentOrderResponse.prototype.errorMsg = "";

    /**
     * Creates a new OutrightPaymentOrderResponse instance using the specified properties.
     * @function create
     * @memberof appliancepb.OutrightPaymentOrderResponse
     * @static
     * @param {appliancepb.IOutrightPaymentOrderResponse=} [properties] Properties to set
     * @returns {appliancepb.OutrightPaymentOrderResponse} OutrightPaymentOrderResponse instance
     */
    OutrightPaymentOrderResponse.create = function create(properties) {
      return new OutrightPaymentOrderResponse(properties);
    };

    /**
     * Encodes the specified OutrightPaymentOrderResponse message. Does not implicitly {@link appliancepb.OutrightPaymentOrderResponse.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.OutrightPaymentOrderResponse
     * @static
     * @param {appliancepb.IOutrightPaymentOrderResponse} m OutrightPaymentOrderResponse message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OutrightPaymentOrderResponse.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (
        m.outrightPayment != null &&
        Object.hasOwnProperty.call(m, "outrightPayment")
      )
        $root.appliancepb.OutrightPaymentRecord.encode(
          m.outrightPayment,
          w.uint32(10).fork()
        ).ldelim();
      if (m.errorMsg != null && Object.hasOwnProperty.call(m, "errorMsg"))
        w.uint32(18).string(m.errorMsg);
      return w;
    };

    /**
     * Decodes an OutrightPaymentOrderResponse message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.OutrightPaymentOrderResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.OutrightPaymentOrderResponse} OutrightPaymentOrderResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OutrightPaymentOrderResponse.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.OutrightPaymentOrderResponse();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.outrightPayment = $root.appliancepb.OutrightPaymentRecord.decode(
              r,
              r.uint32()
            );
            break;
          case 2:
            m.errorMsg = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return OutrightPaymentOrderResponse;
  })();

  /**
   * OutrightPaymentStatus enum.
   * @name appliancepb.OutrightPaymentStatus
   * @enum {number}
   * @property {number} OUTRIGHT_PAYMENT_STATUS_UNSPECIFIED=0 OUTRIGHT_PAYMENT_STATUS_UNSPECIFIED value
   * @property {number} OUTRIGHT_PAYMENT_STATUS_PURCHASED=1 OUTRIGHT_PAYMENT_STATUS_PURCHASED value
   * @property {number} OUTRIGHT_PAYMENT_STATUS_ORDERED=2 OUTRIGHT_PAYMENT_STATUS_ORDERED value
   * @property {number} OUTRIGHT_PAYMENT_STATUS_ORDER_ERROR=3 OUTRIGHT_PAYMENT_STATUS_ORDER_ERROR value
   * @property {number} OUTRIGHT_PAYMENT_STATUS_ORDER_CANCELLED=4 OUTRIGHT_PAYMENT_STATUS_ORDER_CANCELLED value
   * @property {number} OUTRIGHT_PAYMENT_STATUS_DELIVERED=5 OUTRIGHT_PAYMENT_STATUS_DELIVERED value
   */
  appliancepb.OutrightPaymentStatus = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = "OUTRIGHT_PAYMENT_STATUS_UNSPECIFIED")] = 0;
    values[(valuesById[1] = "OUTRIGHT_PAYMENT_STATUS_PURCHASED")] = 1;
    values[(valuesById[2] = "OUTRIGHT_PAYMENT_STATUS_ORDERED")] = 2;
    values[(valuesById[3] = "OUTRIGHT_PAYMENT_STATUS_ORDER_ERROR")] = 3;
    values[(valuesById[4] = "OUTRIGHT_PAYMENT_STATUS_ORDER_CANCELLED")] = 4;
    values[(valuesById[5] = "OUTRIGHT_PAYMENT_STATUS_DELIVERED")] = 5;
    return values;
  })();

  appliancepb.OutrightPaymentPatchRequest = (function () {
    /**
     * Properties of an OutrightPaymentPatchRequest.
     * @memberof appliancepb
     * @interface IOutrightPaymentPatchRequest
     * @property {appliancepb.OutrightPaymentStatus|null} [status] OutrightPaymentPatchRequest status
     * @property {string|null} [vendorOrderNumber] OutrightPaymentPatchRequest vendorOrderNumber
     */

    /**
     * Constructs a new OutrightPaymentPatchRequest.
     * @memberof appliancepb
     * @classdesc Represents an OutrightPaymentPatchRequest.
     * @implements IOutrightPaymentPatchRequest
     * @constructor
     * @param {appliancepb.IOutrightPaymentPatchRequest=} [p] Properties to set
     */
    function OutrightPaymentPatchRequest(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * OutrightPaymentPatchRequest status.
     * @member {appliancepb.OutrightPaymentStatus} status
     * @memberof appliancepb.OutrightPaymentPatchRequest
     * @instance
     */
    OutrightPaymentPatchRequest.prototype.status = 0;

    /**
     * OutrightPaymentPatchRequest vendorOrderNumber.
     * @member {string} vendorOrderNumber
     * @memberof appliancepb.OutrightPaymentPatchRequest
     * @instance
     */
    OutrightPaymentPatchRequest.prototype.vendorOrderNumber = "";

    /**
     * Creates a new OutrightPaymentPatchRequest instance using the specified properties.
     * @function create
     * @memberof appliancepb.OutrightPaymentPatchRequest
     * @static
     * @param {appliancepb.IOutrightPaymentPatchRequest=} [properties] Properties to set
     * @returns {appliancepb.OutrightPaymentPatchRequest} OutrightPaymentPatchRequest instance
     */
    OutrightPaymentPatchRequest.create = function create(properties) {
      return new OutrightPaymentPatchRequest(properties);
    };

    /**
     * Encodes the specified OutrightPaymentPatchRequest message. Does not implicitly {@link appliancepb.OutrightPaymentPatchRequest.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.OutrightPaymentPatchRequest
     * @static
     * @param {appliancepb.IOutrightPaymentPatchRequest} m OutrightPaymentPatchRequest message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OutrightPaymentPatchRequest.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.status != null && Object.hasOwnProperty.call(m, "status"))
        w.uint32(8).int32(m.status);
      if (
        m.vendorOrderNumber != null &&
        Object.hasOwnProperty.call(m, "vendorOrderNumber")
      )
        w.uint32(18).string(m.vendorOrderNumber);
      return w;
    };

    /**
     * Decodes an OutrightPaymentPatchRequest message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.OutrightPaymentPatchRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.OutrightPaymentPatchRequest} OutrightPaymentPatchRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OutrightPaymentPatchRequest.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.OutrightPaymentPatchRequest();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.status = r.int32();
            break;
          case 2:
            m.vendorOrderNumber = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return OutrightPaymentPatchRequest;
  })();

  appliancepb.Banner = (function () {
    /**
     * Properties of a Banner.
     * @memberof appliancepb
     * @interface IBanner
     * @property {string|null} [id] Banner id
     * @property {string|null} [message] Banner message
     * @property {appliancepb.Banner.Severity|null} [severity] Banner severity
     * @property {google.protobuf.ITimestamp|null} [activate] Banner activate
     * @property {google.protobuf.ITimestamp|null} [expire] Banner expire
     */

    /**
     * Constructs a new Banner.
     * @memberof appliancepb
     * @classdesc Represents a Banner.
     * @implements IBanner
     * @constructor
     * @param {appliancepb.IBanner=} [p] Properties to set
     */
    function Banner(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * Banner id.
     * @member {string} id
     * @memberof appliancepb.Banner
     * @instance
     */
    Banner.prototype.id = "";

    /**
     * Banner message.
     * @member {string} message
     * @memberof appliancepb.Banner
     * @instance
     */
    Banner.prototype.message = "";

    /**
     * Banner severity.
     * @member {appliancepb.Banner.Severity} severity
     * @memberof appliancepb.Banner
     * @instance
     */
    Banner.prototype.severity = 0;

    /**
     * Banner activate.
     * @member {google.protobuf.ITimestamp|null|undefined} activate
     * @memberof appliancepb.Banner
     * @instance
     */
    Banner.prototype.activate = null;

    /**
     * Banner expire.
     * @member {google.protobuf.ITimestamp|null|undefined} expire
     * @memberof appliancepb.Banner
     * @instance
     */
    Banner.prototype.expire = null;

    /**
     * Creates a new Banner instance using the specified properties.
     * @function create
     * @memberof appliancepb.Banner
     * @static
     * @param {appliancepb.IBanner=} [properties] Properties to set
     * @returns {appliancepb.Banner} Banner instance
     */
    Banner.create = function create(properties) {
      return new Banner(properties);
    };

    /**
     * Encodes the specified Banner message. Does not implicitly {@link appliancepb.Banner.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.Banner
     * @static
     * @param {appliancepb.IBanner} m Banner message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Banner.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.id != null && Object.hasOwnProperty.call(m, "id"))
        w.uint32(10).string(m.id);
      if (m.message != null && Object.hasOwnProperty.call(m, "message"))
        w.uint32(18).string(m.message);
      if (m.severity != null && Object.hasOwnProperty.call(m, "severity"))
        w.uint32(24).int32(m.severity);
      if (m.activate != null && Object.hasOwnProperty.call(m, "activate"))
        $root.google.protobuf.Timestamp.encode(
          m.activate,
          w.uint32(34).fork()
        ).ldelim();
      if (m.expire != null && Object.hasOwnProperty.call(m, "expire"))
        $root.google.protobuf.Timestamp.encode(
          m.expire,
          w.uint32(42).fork()
        ).ldelim();
      return w;
    };

    /**
     * Decodes a Banner message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.Banner
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.Banner} Banner
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Banner.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.Banner();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.id = r.string();
            break;
          case 2:
            m.message = r.string();
            break;
          case 3:
            m.severity = r.int32();
            break;
          case 4:
            m.activate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
            break;
          case 5:
            m.expire = $root.google.protobuf.Timestamp.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    /**
     * Severity enum.
     * @name appliancepb.Banner.Severity
     * @enum {number}
     * @property {number} SEVERITY_UNSPECIFIED=0 SEVERITY_UNSPECIFIED value
     * @property {number} SEVERITY_INFO=1 SEVERITY_INFO value
     * @property {number} SEVERITY_CAUTION=2 SEVERITY_CAUTION value
     * @property {number} SEVERITY_WARNING=3 SEVERITY_WARNING value
     */
    Banner.Severity = (function () {
      const valuesById = {},
        values = Object.create(valuesById);
      values[(valuesById[0] = "SEVERITY_UNSPECIFIED")] = 0;
      values[(valuesById[1] = "SEVERITY_INFO")] = 1;
      values[(valuesById[2] = "SEVERITY_CAUTION")] = 2;
      values[(valuesById[3] = "SEVERITY_WARNING")] = 3;
      return values;
    })();

    return Banner;
  })();

  appliancepb.GetBannerResponse = (function () {
    /**
     * Properties of a GetBannerResponse.
     * @memberof appliancepb
     * @interface IGetBannerResponse
     * @property {Array.<appliancepb.IBanner>|null} [banners] GetBannerResponse banners
     */

    /**
     * Constructs a new GetBannerResponse.
     * @memberof appliancepb
     * @classdesc Represents a GetBannerResponse.
     * @implements IGetBannerResponse
     * @constructor
     * @param {appliancepb.IGetBannerResponse=} [p] Properties to set
     */
    function GetBannerResponse(p) {
      this.banners = [];
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * GetBannerResponse banners.
     * @member {Array.<appliancepb.IBanner>} banners
     * @memberof appliancepb.GetBannerResponse
     * @instance
     */
    GetBannerResponse.prototype.banners = $util.emptyArray;

    /**
     * Creates a new GetBannerResponse instance using the specified properties.
     * @function create
     * @memberof appliancepb.GetBannerResponse
     * @static
     * @param {appliancepb.IGetBannerResponse=} [properties] Properties to set
     * @returns {appliancepb.GetBannerResponse} GetBannerResponse instance
     */
    GetBannerResponse.create = function create(properties) {
      return new GetBannerResponse(properties);
    };

    /**
     * Encodes the specified GetBannerResponse message. Does not implicitly {@link appliancepb.GetBannerResponse.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.GetBannerResponse
     * @static
     * @param {appliancepb.IGetBannerResponse} m GetBannerResponse message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetBannerResponse.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.banners != null && m.banners.length) {
        for (var i = 0; i < m.banners.length; ++i)
          $root.appliancepb.Banner.encode(
            m.banners[i],
            w.uint32(10).fork()
          ).ldelim();
      }
      return w;
    };

    /**
     * Decodes a GetBannerResponse message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.GetBannerResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.GetBannerResponse} GetBannerResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetBannerResponse.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.GetBannerResponse();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.banners && m.banners.length)) m.banners = [];
            m.banners.push($root.appliancepb.Banner.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetBannerResponse;
  })();

  appliancepb.UpdateBannersRequest = (function () {
    /**
     * Properties of an UpdateBannersRequest.
     * @memberof appliancepb
     * @interface IUpdateBannersRequest
     * @property {Array.<appliancepb.IBanner>|null} [banners] UpdateBannersRequest banners
     */

    /**
     * Constructs a new UpdateBannersRequest.
     * @memberof appliancepb
     * @classdesc Represents an UpdateBannersRequest.
     * @implements IUpdateBannersRequest
     * @constructor
     * @param {appliancepb.IUpdateBannersRequest=} [p] Properties to set
     */
    function UpdateBannersRequest(p) {
      this.banners = [];
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * UpdateBannersRequest banners.
     * @member {Array.<appliancepb.IBanner>} banners
     * @memberof appliancepb.UpdateBannersRequest
     * @instance
     */
    UpdateBannersRequest.prototype.banners = $util.emptyArray;

    /**
     * Creates a new UpdateBannersRequest instance using the specified properties.
     * @function create
     * @memberof appliancepb.UpdateBannersRequest
     * @static
     * @param {appliancepb.IUpdateBannersRequest=} [properties] Properties to set
     * @returns {appliancepb.UpdateBannersRequest} UpdateBannersRequest instance
     */
    UpdateBannersRequest.create = function create(properties) {
      return new UpdateBannersRequest(properties);
    };

    /**
     * Encodes the specified UpdateBannersRequest message. Does not implicitly {@link appliancepb.UpdateBannersRequest.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.UpdateBannersRequest
     * @static
     * @param {appliancepb.IUpdateBannersRequest} m UpdateBannersRequest message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdateBannersRequest.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.banners != null && m.banners.length) {
        for (var i = 0; i < m.banners.length; ++i)
          $root.appliancepb.Banner.encode(
            m.banners[i],
            w.uint32(10).fork()
          ).ldelim();
      }
      return w;
    };

    /**
     * Decodes an UpdateBannersRequest message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.UpdateBannersRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.UpdateBannersRequest} UpdateBannersRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdateBannersRequest.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.UpdateBannersRequest();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.banners && m.banners.length)) m.banners = [];
            m.banners.push($root.appliancepb.Banner.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return UpdateBannersRequest;
  })();

  appliancepb.UpdateBannersResponse = (function () {
    /**
     * Properties of an UpdateBannersResponse.
     * @memberof appliancepb
     * @interface IUpdateBannersResponse
     * @property {Array.<appliancepb.IBanner>|null} [failedBanners] UpdateBannersResponse failedBanners
     * @property {string|null} [failureMessage] UpdateBannersResponse failureMessage
     */

    /**
     * Constructs a new UpdateBannersResponse.
     * @memberof appliancepb
     * @classdesc Represents an UpdateBannersResponse.
     * @implements IUpdateBannersResponse
     * @constructor
     * @param {appliancepb.IUpdateBannersResponse=} [p] Properties to set
     */
    function UpdateBannersResponse(p) {
      this.failedBanners = [];
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * UpdateBannersResponse failedBanners.
     * @member {Array.<appliancepb.IBanner>} failedBanners
     * @memberof appliancepb.UpdateBannersResponse
     * @instance
     */
    UpdateBannersResponse.prototype.failedBanners = $util.emptyArray;

    /**
     * UpdateBannersResponse failureMessage.
     * @member {string} failureMessage
     * @memberof appliancepb.UpdateBannersResponse
     * @instance
     */
    UpdateBannersResponse.prototype.failureMessage = "";

    /**
     * Creates a new UpdateBannersResponse instance using the specified properties.
     * @function create
     * @memberof appliancepb.UpdateBannersResponse
     * @static
     * @param {appliancepb.IUpdateBannersResponse=} [properties] Properties to set
     * @returns {appliancepb.UpdateBannersResponse} UpdateBannersResponse instance
     */
    UpdateBannersResponse.create = function create(properties) {
      return new UpdateBannersResponse(properties);
    };

    /**
     * Encodes the specified UpdateBannersResponse message. Does not implicitly {@link appliancepb.UpdateBannersResponse.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.UpdateBannersResponse
     * @static
     * @param {appliancepb.IUpdateBannersResponse} m UpdateBannersResponse message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdateBannersResponse.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.failedBanners != null && m.failedBanners.length) {
        for (var i = 0; i < m.failedBanners.length; ++i)
          $root.appliancepb.Banner.encode(
            m.failedBanners[i],
            w.uint32(10).fork()
          ).ldelim();
      }
      if (
        m.failureMessage != null &&
        Object.hasOwnProperty.call(m, "failureMessage")
      )
        w.uint32(18).string(m.failureMessage);
      return w;
    };

    /**
     * Decodes an UpdateBannersResponse message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.UpdateBannersResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.UpdateBannersResponse} UpdateBannersResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdateBannersResponse.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.UpdateBannersResponse();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.failedBanners && m.failedBanners.length))
              m.failedBanners = [];
            m.failedBanners.push(
              $root.appliancepb.Banner.decode(r, r.uint32())
            );
            break;
          case 2:
            m.failureMessage = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return UpdateBannersResponse;
  })();

  appliancepb.ReplacementStatus = (function () {
    /**
     * Properties of a ReplacementStatus.
     * @memberof appliancepb
     * @interface IReplacementStatus
     * @property {string|null} [status] ReplacementStatus status
     * @property {string|null} [meaning] ReplacementStatus meaning
     */

    /**
     * Constructs a new ReplacementStatus.
     * @memberof appliancepb
     * @classdesc Represents a ReplacementStatus.
     * @implements IReplacementStatus
     * @constructor
     * @param {appliancepb.IReplacementStatus=} [p] Properties to set
     */
    function ReplacementStatus(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * ReplacementStatus status.
     * @member {string} status
     * @memberof appliancepb.ReplacementStatus
     * @instance
     */
    ReplacementStatus.prototype.status = "";

    /**
     * ReplacementStatus meaning.
     * @member {string} meaning
     * @memberof appliancepb.ReplacementStatus
     * @instance
     */
    ReplacementStatus.prototype.meaning = "";

    /**
     * Creates a new ReplacementStatus instance using the specified properties.
     * @function create
     * @memberof appliancepb.ReplacementStatus
     * @static
     * @param {appliancepb.IReplacementStatus=} [properties] Properties to set
     * @returns {appliancepb.ReplacementStatus} ReplacementStatus instance
     */
    ReplacementStatus.create = function create(properties) {
      return new ReplacementStatus(properties);
    };

    /**
     * Encodes the specified ReplacementStatus message. Does not implicitly {@link appliancepb.ReplacementStatus.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.ReplacementStatus
     * @static
     * @param {appliancepb.IReplacementStatus} m ReplacementStatus message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ReplacementStatus.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.status != null && Object.hasOwnProperty.call(m, "status"))
        w.uint32(10).string(m.status);
      if (m.meaning != null && Object.hasOwnProperty.call(m, "meaning"))
        w.uint32(18).string(m.meaning);
      return w;
    };

    /**
     * Decodes a ReplacementStatus message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.ReplacementStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.ReplacementStatus} ReplacementStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ReplacementStatus.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.ReplacementStatus();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.status = r.string();
            break;
          case 2:
            m.meaning = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ReplacementStatus;
  })();

  appliancepb.GetReplacementStatusesResponse = (function () {
    /**
     * Properties of a GetReplacementStatusesResponse.
     * @memberof appliancepb
     * @interface IGetReplacementStatusesResponse
     * @property {Array.<appliancepb.IReplacementStatus>|null} [statuses] GetReplacementStatusesResponse statuses
     */

    /**
     * Constructs a new GetReplacementStatusesResponse.
     * @memberof appliancepb
     * @classdesc Represents a GetReplacementStatusesResponse.
     * @implements IGetReplacementStatusesResponse
     * @constructor
     * @param {appliancepb.IGetReplacementStatusesResponse=} [p] Properties to set
     */
    function GetReplacementStatusesResponse(p) {
      this.statuses = [];
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * GetReplacementStatusesResponse statuses.
     * @member {Array.<appliancepb.IReplacementStatus>} statuses
     * @memberof appliancepb.GetReplacementStatusesResponse
     * @instance
     */
    GetReplacementStatusesResponse.prototype.statuses = $util.emptyArray;

    /**
     * Creates a new GetReplacementStatusesResponse instance using the specified properties.
     * @function create
     * @memberof appliancepb.GetReplacementStatusesResponse
     * @static
     * @param {appliancepb.IGetReplacementStatusesResponse=} [properties] Properties to set
     * @returns {appliancepb.GetReplacementStatusesResponse} GetReplacementStatusesResponse instance
     */
    GetReplacementStatusesResponse.create = function create(properties) {
      return new GetReplacementStatusesResponse(properties);
    };

    /**
     * Encodes the specified GetReplacementStatusesResponse message. Does not implicitly {@link appliancepb.GetReplacementStatusesResponse.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.GetReplacementStatusesResponse
     * @static
     * @param {appliancepb.IGetReplacementStatusesResponse} m GetReplacementStatusesResponse message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetReplacementStatusesResponse.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.statuses != null && m.statuses.length) {
        for (var i = 0; i < m.statuses.length; ++i)
          $root.appliancepb.ReplacementStatus.encode(
            m.statuses[i],
            w.uint32(10).fork()
          ).ldelim();
      }
      return w;
    };

    /**
     * Decodes a GetReplacementStatusesResponse message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.GetReplacementStatusesResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.GetReplacementStatusesResponse} GetReplacementStatusesResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetReplacementStatusesResponse.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.GetReplacementStatusesResponse();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.statuses && m.statuses.length)) m.statuses = [];
            m.statuses.push(
              $root.appliancepb.ReplacementStatus.decode(r, r.uint32())
            );
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetReplacementStatusesResponse;
  })();

  appliancepb.ProductAccessory = (function () {
    /**
     * Properties of a ProductAccessory.
     * @memberof appliancepb
     * @interface IProductAccessory
     * @property {appliancepb.ProductAccessory.ProductCategory|null} [productCategory] ProductAccessory productCategory
     * @property {appliancepb.ProductAccessory.ProductSubcategory|null} [productSubcategory] ProductAccessory productSubcategory
     * @property {appliancepb.IDimensions|null} [dimensions] ProductAccessory dimensions
     */

    /**
     * Constructs a new ProductAccessory.
     * @memberof appliancepb
     * @classdesc Represents a ProductAccessory.
     * @implements IProductAccessory
     * @constructor
     * @param {appliancepb.IProductAccessory=} [p] Properties to set
     */
    function ProductAccessory(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * ProductAccessory productCategory.
     * @member {appliancepb.ProductAccessory.ProductCategory} productCategory
     * @memberof appliancepb.ProductAccessory
     * @instance
     */
    ProductAccessory.prototype.productCategory = 0;

    /**
     * ProductAccessory productSubcategory.
     * @member {appliancepb.ProductAccessory.ProductSubcategory} productSubcategory
     * @memberof appliancepb.ProductAccessory
     * @instance
     */
    ProductAccessory.prototype.productSubcategory = 0;

    /**
     * ProductAccessory dimensions.
     * @member {appliancepb.IDimensions|null|undefined} dimensions
     * @memberof appliancepb.ProductAccessory
     * @instance
     */
    ProductAccessory.prototype.dimensions = null;

    /**
     * Creates a new ProductAccessory instance using the specified properties.
     * @function create
     * @memberof appliancepb.ProductAccessory
     * @static
     * @param {appliancepb.IProductAccessory=} [properties] Properties to set
     * @returns {appliancepb.ProductAccessory} ProductAccessory instance
     */
    ProductAccessory.create = function create(properties) {
      return new ProductAccessory(properties);
    };

    /**
     * Encodes the specified ProductAccessory message. Does not implicitly {@link appliancepb.ProductAccessory.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.ProductAccessory
     * @static
     * @param {appliancepb.IProductAccessory} m ProductAccessory message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ProductAccessory.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (
        m.productCategory != null &&
        Object.hasOwnProperty.call(m, "productCategory")
      )
        w.uint32(8).int32(m.productCategory);
      if (
        m.productSubcategory != null &&
        Object.hasOwnProperty.call(m, "productSubcategory")
      )
        w.uint32(16).int32(m.productSubcategory);
      if (m.dimensions != null && Object.hasOwnProperty.call(m, "dimensions"))
        $root.appliancepb.Dimensions.encode(
          m.dimensions,
          w.uint32(26).fork()
        ).ldelim();
      return w;
    };

    /**
     * Decodes a ProductAccessory message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.ProductAccessory
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.ProductAccessory} ProductAccessory
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ProductAccessory.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.ProductAccessory();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.productCategory = r.int32();
            break;
          case 2:
            m.productSubcategory = r.int32();
            break;
          case 3:
            m.dimensions = $root.appliancepb.Dimensions.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    /**
     * ProductCategory enum.
     * @name appliancepb.ProductAccessory.ProductCategory
     * @enum {number}
     * @property {number} PRODUCT_CATEGORY_UNSPECIFIED=0 PRODUCT_CATEGORY_UNSPECIFIED value
     * @property {number} PRODUCT_CATEGORY_MICROWAVE_ACCESSORIES=1 PRODUCT_CATEGORY_MICROWAVE_ACCESSORIES value
     * @property {number} PRODUCT_CATEGORY_REFRIGERATOR_ACCESSORIES=2 PRODUCT_CATEGORY_REFRIGERATOR_ACCESSORIES value
     */
    ProductAccessory.ProductCategory = (function () {
      const valuesById = {},
        values = Object.create(valuesById);
      values[(valuesById[0] = "PRODUCT_CATEGORY_UNSPECIFIED")] = 0;
      values[(valuesById[1] = "PRODUCT_CATEGORY_MICROWAVE_ACCESSORIES")] = 1;
      values[(valuesById[2] = "PRODUCT_CATEGORY_REFRIGERATOR_ACCESSORIES")] = 2;
      return values;
    })();

    /**
     * ProductSubcategory enum.
     * @name appliancepb.ProductAccessory.ProductSubcategory
     * @enum {number}
     * @property {number} PRODUCT_SUBCATEGORY_UNSPECIFIED=0 PRODUCT_SUBCATEGORY_UNSPECIFIED value
     * @property {number} PRODUCT_SUBCATEGORY_TRIM_KIT=1 PRODUCT_SUBCATEGORY_TRIM_KIT value
     * @property {number} PRODUCT_SUBCATEGORY_ICEMAKER=2 PRODUCT_SUBCATEGORY_ICEMAKER value
     */
    ProductAccessory.ProductSubcategory = (function () {
      const valuesById = {},
        values = Object.create(valuesById);
      values[(valuesById[0] = "PRODUCT_SUBCATEGORY_UNSPECIFIED")] = 0;
      values[(valuesById[1] = "PRODUCT_SUBCATEGORY_TRIM_KIT")] = 1;
      values[(valuesById[2] = "PRODUCT_SUBCATEGORY_ICEMAKER")] = 2;
      return values;
    })();

    return ProductAccessory;
  })();

  appliancepb.FAQ = (function () {
    /**
     * Properties of a FAQ.
     * @memberof appliancepb
     * @interface IFAQ
     * @property {string|null} [ID] FAQ ID
     * @property {string|null} [question] FAQ question
     * @property {string|null} [answer] FAQ answer
     * @property {number|null} [sortOrder] FAQ sortOrder
     */

    /**
     * Constructs a new FAQ.
     * @memberof appliancepb
     * @classdesc Represents a FAQ.
     * @implements IFAQ
     * @constructor
     * @param {appliancepb.IFAQ=} [p] Properties to set
     */
    function FAQ(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * FAQ ID.
     * @member {string} ID
     * @memberof appliancepb.FAQ
     * @instance
     */
    FAQ.prototype.ID = "";

    /**
     * FAQ question.
     * @member {string} question
     * @memberof appliancepb.FAQ
     * @instance
     */
    FAQ.prototype.question = "";

    /**
     * FAQ answer.
     * @member {string} answer
     * @memberof appliancepb.FAQ
     * @instance
     */
    FAQ.prototype.answer = "";

    /**
     * FAQ sortOrder.
     * @member {number} sortOrder
     * @memberof appliancepb.FAQ
     * @instance
     */
    FAQ.prototype.sortOrder = 0;

    /**
     * Creates a new FAQ instance using the specified properties.
     * @function create
     * @memberof appliancepb.FAQ
     * @static
     * @param {appliancepb.IFAQ=} [properties] Properties to set
     * @returns {appliancepb.FAQ} FAQ instance
     */
    FAQ.create = function create(properties) {
      return new FAQ(properties);
    };

    /**
     * Encodes the specified FAQ message. Does not implicitly {@link appliancepb.FAQ.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.FAQ
     * @static
     * @param {appliancepb.IFAQ} m FAQ message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FAQ.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
        w.uint32(10).string(m.ID);
      if (m.question != null && Object.hasOwnProperty.call(m, "question"))
        w.uint32(18).string(m.question);
      if (m.answer != null && Object.hasOwnProperty.call(m, "answer"))
        w.uint32(26).string(m.answer);
      if (m.sortOrder != null && Object.hasOwnProperty.call(m, "sortOrder"))
        w.uint32(32).int32(m.sortOrder);
      return w;
    };

    /**
     * Decodes a FAQ message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.FAQ
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.FAQ} FAQ
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FAQ.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.FAQ();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.ID = r.string();
            break;
          case 2:
            m.question = r.string();
            break;
          case 3:
            m.answer = r.string();
            break;
          case 4:
            m.sortOrder = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return FAQ;
  })();

  appliancepb.GetFAQResponse = (function () {
    /**
     * Properties of a GetFAQResponse.
     * @memberof appliancepb
     * @interface IGetFAQResponse
     * @property {Array.<appliancepb.IFAQ>|null} [faqs] GetFAQResponse faqs
     */

    /**
     * Constructs a new GetFAQResponse.
     * @memberof appliancepb
     * @classdesc Represents a GetFAQResponse.
     * @implements IGetFAQResponse
     * @constructor
     * @param {appliancepb.IGetFAQResponse=} [p] Properties to set
     */
    function GetFAQResponse(p) {
      this.faqs = [];
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * GetFAQResponse faqs.
     * @member {Array.<appliancepb.IFAQ>} faqs
     * @memberof appliancepb.GetFAQResponse
     * @instance
     */
    GetFAQResponse.prototype.faqs = $util.emptyArray;

    /**
     * Creates a new GetFAQResponse instance using the specified properties.
     * @function create
     * @memberof appliancepb.GetFAQResponse
     * @static
     * @param {appliancepb.IGetFAQResponse=} [properties] Properties to set
     * @returns {appliancepb.GetFAQResponse} GetFAQResponse instance
     */
    GetFAQResponse.create = function create(properties) {
      return new GetFAQResponse(properties);
    };

    /**
     * Encodes the specified GetFAQResponse message. Does not implicitly {@link appliancepb.GetFAQResponse.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.GetFAQResponse
     * @static
     * @param {appliancepb.IGetFAQResponse} m GetFAQResponse message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetFAQResponse.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.faqs != null && m.faqs.length) {
        for (var i = 0; i < m.faqs.length; ++i)
          $root.appliancepb.FAQ.encode(m.faqs[i], w.uint32(10).fork()).ldelim();
      }
      return w;
    };

    /**
     * Decodes a GetFAQResponse message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.GetFAQResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.GetFAQResponse} GetFAQResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetFAQResponse.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.GetFAQResponse();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.faqs && m.faqs.length)) m.faqs = [];
            m.faqs.push($root.appliancepb.FAQ.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GetFAQResponse;
  })();

  appliancepb.UpdateFAQsRequest = (function () {
    /**
     * Properties of an UpdateFAQsRequest.
     * @memberof appliancepb
     * @interface IUpdateFAQsRequest
     * @property {Array.<appliancepb.IFAQ>|null} [faqs] UpdateFAQsRequest faqs
     */

    /**
     * Constructs a new UpdateFAQsRequest.
     * @memberof appliancepb
     * @classdesc Represents an UpdateFAQsRequest.
     * @implements IUpdateFAQsRequest
     * @constructor
     * @param {appliancepb.IUpdateFAQsRequest=} [p] Properties to set
     */
    function UpdateFAQsRequest(p) {
      this.faqs = [];
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * UpdateFAQsRequest faqs.
     * @member {Array.<appliancepb.IFAQ>} faqs
     * @memberof appliancepb.UpdateFAQsRequest
     * @instance
     */
    UpdateFAQsRequest.prototype.faqs = $util.emptyArray;

    /**
     * Creates a new UpdateFAQsRequest instance using the specified properties.
     * @function create
     * @memberof appliancepb.UpdateFAQsRequest
     * @static
     * @param {appliancepb.IUpdateFAQsRequest=} [properties] Properties to set
     * @returns {appliancepb.UpdateFAQsRequest} UpdateFAQsRequest instance
     */
    UpdateFAQsRequest.create = function create(properties) {
      return new UpdateFAQsRequest(properties);
    };

    /**
     * Encodes the specified UpdateFAQsRequest message. Does not implicitly {@link appliancepb.UpdateFAQsRequest.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.UpdateFAQsRequest
     * @static
     * @param {appliancepb.IUpdateFAQsRequest} m UpdateFAQsRequest message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdateFAQsRequest.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.faqs != null && m.faqs.length) {
        for (var i = 0; i < m.faqs.length; ++i)
          $root.appliancepb.FAQ.encode(m.faqs[i], w.uint32(10).fork()).ldelim();
      }
      return w;
    };

    /**
     * Decodes an UpdateFAQsRequest message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.UpdateFAQsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.UpdateFAQsRequest} UpdateFAQsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdateFAQsRequest.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.UpdateFAQsRequest();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.faqs && m.faqs.length)) m.faqs = [];
            m.faqs.push($root.appliancepb.FAQ.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return UpdateFAQsRequest;
  })();

  appliancepb.UpdateFAQsResponse = (function () {
    /**
     * Properties of an UpdateFAQsResponse.
     * @memberof appliancepb
     * @interface IUpdateFAQsResponse
     * @property {Array.<appliancepb.IFAQ>|null} [faqs] UpdateFAQsResponse faqs
     * @property {string|null} [failureMessage] UpdateFAQsResponse failureMessage
     */

    /**
     * Constructs a new UpdateFAQsResponse.
     * @memberof appliancepb
     * @classdesc Represents an UpdateFAQsResponse.
     * @implements IUpdateFAQsResponse
     * @constructor
     * @param {appliancepb.IUpdateFAQsResponse=} [p] Properties to set
     */
    function UpdateFAQsResponse(p) {
      this.faqs = [];
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * UpdateFAQsResponse faqs.
     * @member {Array.<appliancepb.IFAQ>} faqs
     * @memberof appliancepb.UpdateFAQsResponse
     * @instance
     */
    UpdateFAQsResponse.prototype.faqs = $util.emptyArray;

    /**
     * UpdateFAQsResponse failureMessage.
     * @member {string} failureMessage
     * @memberof appliancepb.UpdateFAQsResponse
     * @instance
     */
    UpdateFAQsResponse.prototype.failureMessage = "";

    /**
     * Creates a new UpdateFAQsResponse instance using the specified properties.
     * @function create
     * @memberof appliancepb.UpdateFAQsResponse
     * @static
     * @param {appliancepb.IUpdateFAQsResponse=} [properties] Properties to set
     * @returns {appliancepb.UpdateFAQsResponse} UpdateFAQsResponse instance
     */
    UpdateFAQsResponse.create = function create(properties) {
      return new UpdateFAQsResponse(properties);
    };

    /**
     * Encodes the specified UpdateFAQsResponse message. Does not implicitly {@link appliancepb.UpdateFAQsResponse.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.UpdateFAQsResponse
     * @static
     * @param {appliancepb.IUpdateFAQsResponse} m UpdateFAQsResponse message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdateFAQsResponse.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.faqs != null && m.faqs.length) {
        for (var i = 0; i < m.faqs.length; ++i)
          $root.appliancepb.FAQ.encode(m.faqs[i], w.uint32(10).fork()).ldelim();
      }
      if (
        m.failureMessage != null &&
        Object.hasOwnProperty.call(m, "failureMessage")
      )
        w.uint32(18).string(m.failureMessage);
      return w;
    };

    /**
     * Decodes an UpdateFAQsResponse message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.UpdateFAQsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.UpdateFAQsResponse} UpdateFAQsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdateFAQsResponse.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.UpdateFAQsResponse();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.faqs && m.faqs.length)) m.faqs = [];
            m.faqs.push($root.appliancepb.FAQ.decode(r, r.uint32()));
            break;
          case 2:
            m.failureMessage = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return UpdateFAQsResponse;
  })();

  appliancepb.ReplacementOfferReport = (function () {
    /**
     * Properties of a ReplacementOfferReport.
     * @memberof appliancepb
     * @interface IReplacementOfferReport
     * @property {string|null} [replacementId] ReplacementOfferReport replacementId
     * @property {string|null} [dispatchId] ReplacementOfferReport dispatchId
     * @property {string|null} [partRequestId] ReplacementOfferReport partRequestId
     * @property {appliancepb.IAgent|null} [agent] ReplacementOfferReport agent
     * @property {number|null} [cashInLieu] ReplacementOfferReport cashInLieu
     * @property {appliancepb.ICartItem|null} [recommendedModel] ReplacementOfferReport recommendedModel
     * @property {appliancepb.ICart|null} [recommendedAccessories] ReplacementOfferReport recommendedAccessories
     * @property {google.protobuf.ITimestamp|null} [offerDate] ReplacementOfferReport offerDate
     * @property {string|null} [actionType] ReplacementOfferReport actionType
     */

    /**
     * Constructs a new ReplacementOfferReport.
     * @memberof appliancepb
     * @classdesc Represents a ReplacementOfferReport.
     * @implements IReplacementOfferReport
     * @constructor
     * @param {appliancepb.IReplacementOfferReport=} [p] Properties to set
     */
    function ReplacementOfferReport(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * ReplacementOfferReport replacementId.
     * @member {string} replacementId
     * @memberof appliancepb.ReplacementOfferReport
     * @instance
     */
    ReplacementOfferReport.prototype.replacementId = "";

    /**
     * ReplacementOfferReport dispatchId.
     * @member {string} dispatchId
     * @memberof appliancepb.ReplacementOfferReport
     * @instance
     */
    ReplacementOfferReport.prototype.dispatchId = "";

    /**
     * ReplacementOfferReport partRequestId.
     * @member {string} partRequestId
     * @memberof appliancepb.ReplacementOfferReport
     * @instance
     */
    ReplacementOfferReport.prototype.partRequestId = "";

    /**
     * ReplacementOfferReport agent.
     * @member {appliancepb.IAgent|null|undefined} agent
     * @memberof appliancepb.ReplacementOfferReport
     * @instance
     */
    ReplacementOfferReport.prototype.agent = null;

    /**
     * ReplacementOfferReport cashInLieu.
     * @member {number} cashInLieu
     * @memberof appliancepb.ReplacementOfferReport
     * @instance
     */
    ReplacementOfferReport.prototype.cashInLieu = 0;

    /**
     * ReplacementOfferReport recommendedModel.
     * @member {appliancepb.ICartItem|null|undefined} recommendedModel
     * @memberof appliancepb.ReplacementOfferReport
     * @instance
     */
    ReplacementOfferReport.prototype.recommendedModel = null;

    /**
     * ReplacementOfferReport recommendedAccessories.
     * @member {appliancepb.ICart|null|undefined} recommendedAccessories
     * @memberof appliancepb.ReplacementOfferReport
     * @instance
     */
    ReplacementOfferReport.prototype.recommendedAccessories = null;

    /**
     * ReplacementOfferReport offerDate.
     * @member {google.protobuf.ITimestamp|null|undefined} offerDate
     * @memberof appliancepb.ReplacementOfferReport
     * @instance
     */
    ReplacementOfferReport.prototype.offerDate = null;

    /**
     * ReplacementOfferReport actionType.
     * @member {string} actionType
     * @memberof appliancepb.ReplacementOfferReport
     * @instance
     */
    ReplacementOfferReport.prototype.actionType = "";

    /**
     * Creates a new ReplacementOfferReport instance using the specified properties.
     * @function create
     * @memberof appliancepb.ReplacementOfferReport
     * @static
     * @param {appliancepb.IReplacementOfferReport=} [properties] Properties to set
     * @returns {appliancepb.ReplacementOfferReport} ReplacementOfferReport instance
     */
    ReplacementOfferReport.create = function create(properties) {
      return new ReplacementOfferReport(properties);
    };

    /**
     * Encodes the specified ReplacementOfferReport message. Does not implicitly {@link appliancepb.ReplacementOfferReport.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.ReplacementOfferReport
     * @static
     * @param {appliancepb.IReplacementOfferReport} m ReplacementOfferReport message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ReplacementOfferReport.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (
        m.replacementId != null &&
        Object.hasOwnProperty.call(m, "replacementId")
      )
        w.uint32(10).string(m.replacementId);
      if (m.dispatchId != null && Object.hasOwnProperty.call(m, "dispatchId"))
        w.uint32(18).string(m.dispatchId);
      if (
        m.partRequestId != null &&
        Object.hasOwnProperty.call(m, "partRequestId")
      )
        w.uint32(26).string(m.partRequestId);
      if (m.agent != null && Object.hasOwnProperty.call(m, "agent"))
        $root.appliancepb.Agent.encode(m.agent, w.uint32(34).fork()).ldelim();
      if (m.cashInLieu != null && Object.hasOwnProperty.call(m, "cashInLieu"))
        w.uint32(40).int32(m.cashInLieu);
      if (
        m.recommendedModel != null &&
        Object.hasOwnProperty.call(m, "recommendedModel")
      )
        $root.appliancepb.CartItem.encode(
          m.recommendedModel,
          w.uint32(50).fork()
        ).ldelim();
      if (
        m.recommendedAccessories != null &&
        Object.hasOwnProperty.call(m, "recommendedAccessories")
      )
        $root.appliancepb.Cart.encode(
          m.recommendedAccessories,
          w.uint32(58).fork()
        ).ldelim();
      if (m.offerDate != null && Object.hasOwnProperty.call(m, "offerDate"))
        $root.google.protobuf.Timestamp.encode(
          m.offerDate,
          w.uint32(66).fork()
        ).ldelim();
      if (m.actionType != null && Object.hasOwnProperty.call(m, "actionType"))
        w.uint32(74).string(m.actionType);
      return w;
    };

    /**
     * Decodes a ReplacementOfferReport message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.ReplacementOfferReport
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.ReplacementOfferReport} ReplacementOfferReport
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ReplacementOfferReport.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.ReplacementOfferReport();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.replacementId = r.string();
            break;
          case 2:
            m.dispatchId = r.string();
            break;
          case 3:
            m.partRequestId = r.string();
            break;
          case 4:
            m.agent = $root.appliancepb.Agent.decode(r, r.uint32());
            break;
          case 5:
            m.cashInLieu = r.int32();
            break;
          case 6:
            m.recommendedModel = $root.appliancepb.CartItem.decode(
              r,
              r.uint32()
            );
            break;
          case 7:
            m.recommendedAccessories = $root.appliancepb.Cart.decode(
              r,
              r.uint32()
            );
            break;
          case 8:
            m.offerDate = $root.google.protobuf.Timestamp.decode(r, r.uint32());
            break;
          case 9:
            m.actionType = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ReplacementOfferReport;
  })();

  appliancepb.TaxDetail = (function () {
    /**
     * Properties of a TaxDetail.
     * @memberof appliancepb
     * @interface ITaxDetail
     * @property {Array.<appliancepb.TaxDetail.ITaxRate>|null} [taxRates] TaxDetail taxRates
     * @property {string|null} [taxTotal] TaxDetail taxTotal
     */

    /**
     * Constructs a new TaxDetail.
     * @memberof appliancepb
     * @classdesc Represents a TaxDetail.
     * @implements ITaxDetail
     * @constructor
     * @param {appliancepb.ITaxDetail=} [p] Properties to set
     */
    function TaxDetail(p) {
      this.taxRates = [];
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * TaxDetail taxRates.
     * @member {Array.<appliancepb.TaxDetail.ITaxRate>} taxRates
     * @memberof appliancepb.TaxDetail
     * @instance
     */
    TaxDetail.prototype.taxRates = $util.emptyArray;

    /**
     * TaxDetail taxTotal.
     * @member {string} taxTotal
     * @memberof appliancepb.TaxDetail
     * @instance
     */
    TaxDetail.prototype.taxTotal = "";

    /**
     * Creates a new TaxDetail instance using the specified properties.
     * @function create
     * @memberof appliancepb.TaxDetail
     * @static
     * @param {appliancepb.ITaxDetail=} [properties] Properties to set
     * @returns {appliancepb.TaxDetail} TaxDetail instance
     */
    TaxDetail.create = function create(properties) {
      return new TaxDetail(properties);
    };

    /**
     * Encodes the specified TaxDetail message. Does not implicitly {@link appliancepb.TaxDetail.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.TaxDetail
     * @static
     * @param {appliancepb.ITaxDetail} m TaxDetail message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TaxDetail.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.taxRates != null && m.taxRates.length) {
        for (var i = 0; i < m.taxRates.length; ++i)
          $root.appliancepb.TaxDetail.TaxRate.encode(
            m.taxRates[i],
            w.uint32(10).fork()
          ).ldelim();
      }
      if (m.taxTotal != null && Object.hasOwnProperty.call(m, "taxTotal"))
        w.uint32(18).string(m.taxTotal);
      return w;
    };

    /**
     * Decodes a TaxDetail message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.TaxDetail
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.TaxDetail} TaxDetail
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TaxDetail.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.TaxDetail();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.taxRates && m.taxRates.length)) m.taxRates = [];
            m.taxRates.push(
              $root.appliancepb.TaxDetail.TaxRate.decode(r, r.uint32())
            );
            break;
          case 2:
            m.taxTotal = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    TaxDetail.TaxRate = (function () {
      /**
       * Properties of a TaxRate.
       * @memberof appliancepb.TaxDetail
       * @interface ITaxRate
       * @property {string|null} [jurisdiction] TaxRate jurisdiction
       * @property {string|null} [taxRate] TaxRate taxRate
       * @property {string|null} [taxType] TaxRate taxType
       */

      /**
       * Constructs a new TaxRate.
       * @memberof appliancepb.TaxDetail
       * @classdesc Represents a TaxRate.
       * @implements ITaxRate
       * @constructor
       * @param {appliancepb.TaxDetail.ITaxRate=} [p] Properties to set
       */
      function TaxRate(p) {
        if (p)
          for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
            if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
      }

      /**
       * TaxRate jurisdiction.
       * @member {string} jurisdiction
       * @memberof appliancepb.TaxDetail.TaxRate
       * @instance
       */
      TaxRate.prototype.jurisdiction = "";

      /**
       * TaxRate taxRate.
       * @member {string} taxRate
       * @memberof appliancepb.TaxDetail.TaxRate
       * @instance
       */
      TaxRate.prototype.taxRate = "";

      /**
       * TaxRate taxType.
       * @member {string} taxType
       * @memberof appliancepb.TaxDetail.TaxRate
       * @instance
       */
      TaxRate.prototype.taxType = "";

      /**
       * Creates a new TaxRate instance using the specified properties.
       * @function create
       * @memberof appliancepb.TaxDetail.TaxRate
       * @static
       * @param {appliancepb.TaxDetail.ITaxRate=} [properties] Properties to set
       * @returns {appliancepb.TaxDetail.TaxRate} TaxRate instance
       */
      TaxRate.create = function create(properties) {
        return new TaxRate(properties);
      };

      /**
       * Encodes the specified TaxRate message. Does not implicitly {@link appliancepb.TaxDetail.TaxRate.verify|verify} messages.
       * @function encode
       * @memberof appliancepb.TaxDetail.TaxRate
       * @static
       * @param {appliancepb.TaxDetail.ITaxRate} m TaxRate message or plain object to encode
       * @param {$protobuf.Writer} [w] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      TaxRate.encode = function encode(m, w) {
        if (!w) w = $Writer.create();
        if (
          m.jurisdiction != null &&
          Object.hasOwnProperty.call(m, "jurisdiction")
        )
          w.uint32(10).string(m.jurisdiction);
        if (m.taxRate != null && Object.hasOwnProperty.call(m, "taxRate"))
          w.uint32(18).string(m.taxRate);
        if (m.taxType != null && Object.hasOwnProperty.call(m, "taxType"))
          w.uint32(26).string(m.taxType);
        return w;
      };

      /**
       * Decodes a TaxRate message from the specified reader or buffer.
       * @function decode
       * @memberof appliancepb.TaxDetail.TaxRate
       * @static
       * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
       * @param {number} [l] Message length if known beforehand
       * @returns {appliancepb.TaxDetail.TaxRate} TaxRate
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      TaxRate.decode = function decode(r, l) {
        if (!(r instanceof $Reader)) r = $Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l,
          m = new $root.appliancepb.TaxDetail.TaxRate();
        while (r.pos < c) {
          var t = r.uint32();
          switch (t >>> 3) {
            case 1:
              m.jurisdiction = r.string();
              break;
            case 2:
              m.taxRate = r.string();
              break;
            case 3:
              m.taxType = r.string();
              break;
            default:
              r.skipType(t & 7);
              break;
          }
        }
        return m;
      };

      return TaxRate;
    })();

    return TaxDetail;
  })();

  appliancepb.Media = (function () {
    /**
     * Properties of a Media.
     * @memberof appliancepb
     * @interface IMedia
     * @property {string|null} [url] Media url
     * @property {string|null} [displayText] Media displayText
     */

    /**
     * Constructs a new Media.
     * @memberof appliancepb
     * @classdesc Represents a Media.
     * @implements IMedia
     * @constructor
     * @param {appliancepb.IMedia=} [p] Properties to set
     */
    function Media(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * Media url.
     * @member {string} url
     * @memberof appliancepb.Media
     * @instance
     */
    Media.prototype.url = "";

    /**
     * Media displayText.
     * @member {string} displayText
     * @memberof appliancepb.Media
     * @instance
     */
    Media.prototype.displayText = "";

    /**
     * Creates a new Media instance using the specified properties.
     * @function create
     * @memberof appliancepb.Media
     * @static
     * @param {appliancepb.IMedia=} [properties] Properties to set
     * @returns {appliancepb.Media} Media instance
     */
    Media.create = function create(properties) {
      return new Media(properties);
    };

    /**
     * Encodes the specified Media message. Does not implicitly {@link appliancepb.Media.verify|verify} messages.
     * @function encode
     * @memberof appliancepb.Media
     * @static
     * @param {appliancepb.IMedia} m Media message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Media.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.url != null && Object.hasOwnProperty.call(m, "url"))
        w.uint32(10).string(m.url);
      if (m.displayText != null && Object.hasOwnProperty.call(m, "displayText"))
        w.uint32(18).string(m.displayText);
      return w;
    };

    /**
     * Decodes a Media message from the specified reader or buffer.
     * @function decode
     * @memberof appliancepb.Media
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {appliancepb.Media} Media
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Media.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.appliancepb.Media();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.url = r.string();
            break;
          case 2:
            m.displayText = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return Media;
  })();

  appliancepb.CreateReplacement = (function () {
    /**
     * Constructs a new CreateReplacement service.
     * @memberof appliancepb
     * @classdesc Represents a CreateReplacement
     * @extends $protobuf.rpc.Service
     * @constructor
     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
     */
    function CreateReplacement(rpcImpl, requestDelimited, responseDelimited) {
      $protobuf.rpc.Service.call(
        this,
        rpcImpl,
        requestDelimited,
        responseDelimited
      );
    }

    (CreateReplacement.prototype = Object.create(
      $protobuf.rpc.Service.prototype
    )).constructor = CreateReplacement;

    /**
     * Creates new CreateReplacement service using the specified rpc implementation.
     * @function create
     * @memberof appliancepb.CreateReplacement
     * @static
     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
     * @returns {CreateReplacement} RPC service. Useful where requests and/or responses are streamed.
     */
    CreateReplacement.create = function create(
      rpcImpl,
      requestDelimited,
      responseDelimited
    ) {
      return new this(rpcImpl, requestDelimited, responseDelimited);
    };

    /**
     * Callback as used by {@link appliancepb.CreateReplacement#createReplacement}.
     * @memberof appliancepb.CreateReplacement
     * @typedef createReplacementCallback
     * @type {function}
     * @param {Error|null} error Error, if any
     * @param {appliancepb.CreateReplacementResponse} [response] CreateReplacementResponse
     */

    /**
     * Calls createReplacement.
     * @function createReplacement
     * @memberof appliancepb.CreateReplacement
     * @instance
     * @param {appliancepb.ICreateReplacementRequest} request CreateReplacementRequest message or plain object
     * @param {appliancepb.CreateReplacement.createReplacementCallback} callback Node-style callback called with the error, if any, and CreateReplacementResponse
     * @returns {undefined}
     * @variation 1
     */
    Object.defineProperty(
      (CreateReplacement.prototype.createReplacement = function createReplacement(
        request,
        callback
      ) {
        return this.rpcCall(
          createReplacement,
          $root.appliancepb.CreateReplacementRequest,
          $root.appliancepb.CreateReplacementResponse,
          request,
          callback
        );
      }),
      "name",
      { value: "createReplacement" }
    );

    /**
     * Calls createReplacement.
     * @function createReplacement
     * @memberof appliancepb.CreateReplacement
     * @instance
     * @param {appliancepb.ICreateReplacementRequest} request CreateReplacementRequest message or plain object
     * @returns {Promise<appliancepb.CreateReplacementResponse>} Promise
     * @variation 2
     */

    return CreateReplacement;
  })();

  appliancepb.CreateReplacementOffer = (function () {
    /**
     * Constructs a new CreateReplacementOffer service.
     * @memberof appliancepb
     * @classdesc Represents a CreateReplacementOffer
     * @extends $protobuf.rpc.Service
     * @constructor
     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
     */
    function CreateReplacementOffer(
      rpcImpl,
      requestDelimited,
      responseDelimited
    ) {
      $protobuf.rpc.Service.call(
        this,
        rpcImpl,
        requestDelimited,
        responseDelimited
      );
    }

    (CreateReplacementOffer.prototype = Object.create(
      $protobuf.rpc.Service.prototype
    )).constructor = CreateReplacementOffer;

    /**
     * Creates new CreateReplacementOffer service using the specified rpc implementation.
     * @function create
     * @memberof appliancepb.CreateReplacementOffer
     * @static
     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
     * @returns {CreateReplacementOffer} RPC service. Useful where requests and/or responses are streamed.
     */
    CreateReplacementOffer.create = function create(
      rpcImpl,
      requestDelimited,
      responseDelimited
    ) {
      return new this(rpcImpl, requestDelimited, responseDelimited);
    };

    /**
     * Callback as used by {@link appliancepb.CreateReplacementOffer#createReplacementOffer}.
     * @memberof appliancepb.CreateReplacementOffer
     * @typedef createReplacementOfferCallback
     * @type {function}
     * @param {Error|null} error Error, if any
     * @param {appliancepb.CreateReplacementResponse} [response] CreateReplacementResponse
     */

    /**
     * Calls createReplacementOffer.
     * @function createReplacementOffer
     * @memberof appliancepb.CreateReplacementOffer
     * @instance
     * @param {appliancepb.IReplacementOfferRequest} request ReplacementOfferRequest message or plain object
     * @param {appliancepb.CreateReplacementOffer.createReplacementOfferCallback} callback Node-style callback called with the error, if any, and CreateReplacementResponse
     * @returns {undefined}
     * @variation 1
     */
    Object.defineProperty(
      (CreateReplacementOffer.prototype.createReplacementOffer = function createReplacementOffer(
        request,
        callback
      ) {
        return this.rpcCall(
          createReplacementOffer,
          $root.appliancepb.ReplacementOfferRequest,
          $root.appliancepb.CreateReplacementResponse,
          request,
          callback
        );
      }),
      "name",
      { value: "createReplacementOffer" }
    );

    /**
     * Calls createReplacementOffer.
     * @function createReplacementOffer
     * @memberof appliancepb.CreateReplacementOffer
     * @instance
     * @param {appliancepb.IReplacementOfferRequest} request ReplacementOfferRequest message or plain object
     * @returns {Promise<appliancepb.CreateReplacementResponse>} Promise
     * @variation 2
     */

    return CreateReplacementOffer;
  })();

  appliancepb.GetBanners = (function () {
    /**
     * Constructs a new GetBanners service.
     * @memberof appliancepb
     * @classdesc Represents a GetBanners
     * @extends $protobuf.rpc.Service
     * @constructor
     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
     */
    function GetBanners(rpcImpl, requestDelimited, responseDelimited) {
      $protobuf.rpc.Service.call(
        this,
        rpcImpl,
        requestDelimited,
        responseDelimited
      );
    }

    (GetBanners.prototype = Object.create(
      $protobuf.rpc.Service.prototype
    )).constructor = GetBanners;

    /**
     * Creates new GetBanners service using the specified rpc implementation.
     * @function create
     * @memberof appliancepb.GetBanners
     * @static
     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
     * @returns {GetBanners} RPC service. Useful where requests and/or responses are streamed.
     */
    GetBanners.create = function create(
      rpcImpl,
      requestDelimited,
      responseDelimited
    ) {
      return new this(rpcImpl, requestDelimited, responseDelimited);
    };

    /**
     * Callback as used by {@link appliancepb.GetBanners#getBanners}.
     * @memberof appliancepb.GetBanners
     * @typedef getBannersCallback
     * @type {function}
     * @param {Error|null} error Error, if any
     * @param {appliancepb.GetBannerResponse} [response] GetBannerResponse
     */

    /**
     * Calls getBanners.
     * @function getBanners
     * @memberof appliancepb.GetBanners
     * @instance
     * @param {google.protobuf.IEmpty} request Empty message or plain object
     * @param {appliancepb.GetBanners.getBannersCallback} callback Node-style callback called with the error, if any, and GetBannerResponse
     * @returns {undefined}
     * @variation 1
     */
    Object.defineProperty(
      (GetBanners.prototype.getBanners = function getBanners(
        request,
        callback
      ) {
        return this.rpcCall(
          getBanners,
          $root.google.protobuf.Empty,
          $root.appliancepb.GetBannerResponse,
          request,
          callback
        );
      }),
      "name",
      { value: "getBanners" }
    );

    /**
     * Calls getBanners.
     * @function getBanners
     * @memberof appliancepb.GetBanners
     * @instance
     * @param {google.protobuf.IEmpty} request Empty message or plain object
     * @returns {Promise<appliancepb.GetBannerResponse>} Promise
     * @variation 2
     */

    return GetBanners;
  })();

  appliancepb.CreateReplacementNote = (function () {
    /**
     * Constructs a new CreateReplacementNote service.
     * @memberof appliancepb
     * @classdesc Represents a CreateReplacementNote
     * @extends $protobuf.rpc.Service
     * @constructor
     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
     */
    function CreateReplacementNote(
      rpcImpl,
      requestDelimited,
      responseDelimited
    ) {
      $protobuf.rpc.Service.call(
        this,
        rpcImpl,
        requestDelimited,
        responseDelimited
      );
    }

    (CreateReplacementNote.prototype = Object.create(
      $protobuf.rpc.Service.prototype
    )).constructor = CreateReplacementNote;

    /**
     * Creates new CreateReplacementNote service using the specified rpc implementation.
     * @function create
     * @memberof appliancepb.CreateReplacementNote
     * @static
     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
     * @returns {CreateReplacementNote} RPC service. Useful where requests and/or responses are streamed.
     */
    CreateReplacementNote.create = function create(
      rpcImpl,
      requestDelimited,
      responseDelimited
    ) {
      return new this(rpcImpl, requestDelimited, responseDelimited);
    };

    /**
     * Callback as used by {@link appliancepb.CreateReplacementNote#createReplacementNote}.
     * @memberof appliancepb.CreateReplacementNote
     * @typedef createReplacementNoteCallback
     * @type {function}
     * @param {Error|null} error Error, if any
     * @param {google.protobuf.Empty} [response] Empty
     */

    /**
     * Calls createReplacementNote.
     * @function createReplacementNote
     * @memberof appliancepb.CreateReplacementNote
     * @instance
     * @param {appliancepb.ICreateReplacementNoteRequest} request CreateReplacementNoteRequest message or plain object
     * @param {appliancepb.CreateReplacementNote.createReplacementNoteCallback} callback Node-style callback called with the error, if any, and Empty
     * @returns {undefined}
     * @variation 1
     */
    Object.defineProperty(
      (CreateReplacementNote.prototype.createReplacementNote = function createReplacementNote(
        request,
        callback
      ) {
        return this.rpcCall(
          createReplacementNote,
          $root.appliancepb.CreateReplacementNoteRequest,
          $root.google.protobuf.Empty,
          request,
          callback
        );
      }),
      "name",
      { value: "createReplacementNote" }
    );

    /**
     * Calls createReplacementNote.
     * @function createReplacementNote
     * @memberof appliancepb.CreateReplacementNote
     * @instance
     * @param {appliancepb.ICreateReplacementNoteRequest} request CreateReplacementNoteRequest message or plain object
     * @returns {Promise<google.protobuf.Empty>} Promise
     * @variation 2
     */

    return CreateReplacementNote;
  })();

  return appliancepb;
})());

export const common = ($root.common = (() => {
  /**
   * Namespace common.
   * @exports common
   * @namespace
   */
  const common = {};

  /**
   * Tenant enum.
   * @name common.Tenant
   * @enum {number}
   * @property {number} TENANT_UNDEFINED=0 TENANT_UNDEFINED value
   * @property {number} TEST=1 TEST value
   * @property {number} AHS=2 AHS value
   * @property {number} CD=3 CD value
   * @property {number} HSA=4 HSA value
   * @property {number} OG=5 OG value
   * @property {number} LM=6 LM value
   * @property {number} FRONTDOOR=7 FRONTDOOR value
   * @property {number} AHSPC=8 AHSPC value
   * @property {number} HSAPC=9 HSAPC value
   * @property {number} FTDR=10 FTDR value
   * @property {number} HBW210=11 HBW210 value
   */
  common.Tenant = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = "TENANT_UNDEFINED")] = 0;
    values[(valuesById[1] = "TEST")] = 1;
    values[(valuesById[2] = "AHS")] = 2;
    values[(valuesById[3] = "CD")] = 3;
    values[(valuesById[4] = "HSA")] = 4;
    values[(valuesById[5] = "OG")] = 5;
    values[(valuesById[6] = "LM")] = 6;
    values[(valuesById[7] = "FRONTDOOR")] = 7;
    values[(valuesById[8] = "AHSPC")] = 8;
    values[(valuesById[9] = "HSAPC")] = 9;
    values[(valuesById[10] = "FTDR")] = 10;
    values[(valuesById[11] = "HBW210")] = 11;
    return values;
  })();

  /**
   * Alert enum.
   * @name common.Alert
   * @enum {number}
   * @property {number} ALERTS_UNDEFINED=0 ALERTS_UNDEFINED value
   * @property {number} ALERTS_UNSCHEDULED=1 ALERTS_UNSCHEDULED value
   * @property {number} ALERTS_NEED_STATUS_UPDATE=2 ALERTS_NEED_STATUS_UPDATE value
   * @property {number} ALERTS_OPEN_LONGER_THAN_AVERAGE=3 ALERTS_OPEN_LONGER_THAN_AVERAGE value
   * @property {number} ALERTS_SCHEDULE_NEXT_APPOINTMENT=4 ALERTS_SCHEDULE_NEXT_APPOINTMENT value
   * @property {number} ALERTS_RESUBMIT_REQUEST=5 ALERTS_RESUBMIT_REQUEST value
   * @property {number} ALERTS_TODAYS_APPOINTMENT=6 ALERTS_TODAYS_APPOINTMENT value
   * @property {number} ALERTS_AUTHO_STATUS_UPDATED=7 ALERTS_AUTHO_STATUS_UPDATED value
   */
  common.Alert = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = "ALERTS_UNDEFINED")] = 0;
    values[(valuesById[1] = "ALERTS_UNSCHEDULED")] = 1;
    values[(valuesById[2] = "ALERTS_NEED_STATUS_UPDATE")] = 2;
    values[(valuesById[3] = "ALERTS_OPEN_LONGER_THAN_AVERAGE")] = 3;
    values[(valuesById[4] = "ALERTS_SCHEDULE_NEXT_APPOINTMENT")] = 4;
    values[(valuesById[5] = "ALERTS_RESUBMIT_REQUEST")] = 5;
    values[(valuesById[6] = "ALERTS_TODAYS_APPOINTMENT")] = 6;
    values[(valuesById[7] = "ALERTS_AUTHO_STATUS_UPDATED")] = 7;
    return values;
  })();

  /**
   * Status enum.
   * @name common.Status
   * @enum {number}
   * @property {number} STATUS_UNDEFINED=0 STATUS_UNDEFINED value
   * @property {number} SUCCESS=1 SUCCESS value
   * @property {number} FAIL=2 FAIL value
   */
  common.Status = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = "STATUS_UNDEFINED")] = 0;
    values[(valuesById[1] = "SUCCESS")] = 1;
    values[(valuesById[2] = "FAIL")] = 2;
    return values;
  })();

  /**
   * UserRole enum.
   * @name common.UserRole
   * @enum {number}
   * @property {number} USER_ROLE_UNDEFINED=0 USER_ROLE_UNDEFINED value
   * @property {number} CONTRACTOR=1 CONTRACTOR value
   * @property {number} AGENT=2 AGENT value
   * @property {number} ADMIN=3 ADMIN value
   * @property {number} TECHNICIAN=4 TECHNICIAN value
   * @property {number} PARTNER=5 PARTNER value
   * @property {number} CUSTOMER=6 CUSTOMER value
   * @property {number} DEVELOPER=7 DEVELOPER value
   * @property {number} EXTERNAL_PARTNER=8 EXTERNAL_PARTNER value
   */
  common.UserRole = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = "USER_ROLE_UNDEFINED")] = 0;
    values[(valuesById[1] = "CONTRACTOR")] = 1;
    values[(valuesById[2] = "AGENT")] = 2;
    values[(valuesById[3] = "ADMIN")] = 3;
    values[(valuesById[4] = "TECHNICIAN")] = 4;
    values[(valuesById[5] = "PARTNER")] = 5;
    values[(valuesById[6] = "CUSTOMER")] = 6;
    values[(valuesById[7] = "DEVELOPER")] = 7;
    values[(valuesById[8] = "EXTERNAL_PARTNER")] = 8;
    return values;
  })();

  /**
   * Application enum.
   * @name common.Application
   * @enum {number}
   * @property {number} Application_UNKNOWN=0 Application_UNKNOWN value
   * @property {number} Application_CNTRTRPRTL=1 Application_CNTRTRPRTL value
   * @property {number} Application_MYACCOUNT=2 Application_MYACCOUNT value
   * @property {number} Application_CSC=3 Application_CSC value
   * @property {number} Application_MOBILEAPP=4 Application_MOBILEAPP value
   * @property {number} Application_ESTREVIEW=5 Application_ESTREVIEW value
   * @property {number} Application_DISTHRDPRT=6 Application_DISTHRDPRT value
   * @property {number} Application_DPCONN=7 Application_DPCONN value
   * @property {number} Application_DISPATCHME=8 Application_DISPATCHME value
   * @property {number} Application_DISPMEPRTL=9 Application_DISPMEPRTL value
   * @property {number} Application_SC=10 Application_SC value
   * @property {number} Application_SC_RENEWALS=11 Application_SC_RENEWALS value
   * @property {number} Application_MA_RENEWALS=12 Application_MA_RENEWALS value
   * @property {number} Application_CONTRACT_MS=13 Application_CONTRACT_MS value
   * @property {number} Application_RENEWAL_ORCHESTRATOR=14 Application_RENEWAL_ORCHESTRATOR value
   * @property {number} Application_WEBSERVICE=15 Application_WEBSERVICE value
   * @property {number} Application_CL=16 Application_CL value
   * @property {number} Application_SC_DTC=17 Application_SC_DTC value
   * @property {number} Application_SC_RE=18 Application_SC_RE value
   * @property {number} Application_RENEWALS_BATCH_JOB=19 Application_RENEWALS_BATCH_JOB value
   */
  common.Application = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = "Application_UNKNOWN")] = 0;
    values[(valuesById[1] = "Application_CNTRTRPRTL")] = 1;
    values[(valuesById[2] = "Application_MYACCOUNT")] = 2;
    values[(valuesById[3] = "Application_CSC")] = 3;
    values[(valuesById[4] = "Application_MOBILEAPP")] = 4;
    values[(valuesById[5] = "Application_ESTREVIEW")] = 5;
    values[(valuesById[6] = "Application_DISTHRDPRT")] = 6;
    values[(valuesById[7] = "Application_DPCONN")] = 7;
    values[(valuesById[8] = "Application_DISPATCHME")] = 8;
    values[(valuesById[9] = "Application_DISPMEPRTL")] = 9;
    values[(valuesById[10] = "Application_SC")] = 10;
    values[(valuesById[11] = "Application_SC_RENEWALS")] = 11;
    values[(valuesById[12] = "Application_MA_RENEWALS")] = 12;
    values[(valuesById[13] = "Application_CONTRACT_MS")] = 13;
    values[(valuesById[14] = "Application_RENEWAL_ORCHESTRATOR")] = 14;
    values[(valuesById[15] = "Application_WEBSERVICE")] = 15;
    values[(valuesById[16] = "Application_CL")] = 16;
    values[(valuesById[17] = "Application_SC_DTC")] = 17;
    values[(valuesById[18] = "Application_SC_RE")] = 18;
    values[(valuesById[19] = "Application_RENEWALS_BATCH_JOB")] = 19;
    return values;
  })();

  common.HealthCheckDetail = (function () {
    /**
     * Properties of a HealthCheckDetail.
     * @memberof common
     * @interface IHealthCheckDetail
     * @property {string|null} [componentID] HealthCheckDetail componentID
     * @property {string|null} [type] HealthCheckDetail type
     * @property {number|null} [observedValue] HealthCheckDetail observedValue
     * @property {string|null} [observedUnit] HealthCheckDetail observedUnit
     * @property {string|null} [status] HealthCheckDetail status
     * @property {google.protobuf.ITimestamp|null} [time] HealthCheckDetail time
     * @property {string|null} [output] HealthCheckDetail output
     */

    /**
     * Constructs a new HealthCheckDetail.
     * @memberof common
     * @classdesc Represents a HealthCheckDetail.
     * @implements IHealthCheckDetail
     * @constructor
     * @param {common.IHealthCheckDetail=} [p] Properties to set
     */
    function HealthCheckDetail(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * HealthCheckDetail componentID.
     * @member {string} componentID
     * @memberof common.HealthCheckDetail
     * @instance
     */
    HealthCheckDetail.prototype.componentID = "";

    /**
     * HealthCheckDetail type.
     * @member {string} type
     * @memberof common.HealthCheckDetail
     * @instance
     */
    HealthCheckDetail.prototype.type = "";

    /**
     * HealthCheckDetail observedValue.
     * @member {number} observedValue
     * @memberof common.HealthCheckDetail
     * @instance
     */
    HealthCheckDetail.prototype.observedValue = 0;

    /**
     * HealthCheckDetail observedUnit.
     * @member {string} observedUnit
     * @memberof common.HealthCheckDetail
     * @instance
     */
    HealthCheckDetail.prototype.observedUnit = "";

    /**
     * HealthCheckDetail status.
     * @member {string} status
     * @memberof common.HealthCheckDetail
     * @instance
     */
    HealthCheckDetail.prototype.status = "";

    /**
     * HealthCheckDetail time.
     * @member {google.protobuf.ITimestamp|null|undefined} time
     * @memberof common.HealthCheckDetail
     * @instance
     */
    HealthCheckDetail.prototype.time = null;

    /**
     * HealthCheckDetail output.
     * @member {string} output
     * @memberof common.HealthCheckDetail
     * @instance
     */
    HealthCheckDetail.prototype.output = "";

    /**
     * Creates a new HealthCheckDetail instance using the specified properties.
     * @function create
     * @memberof common.HealthCheckDetail
     * @static
     * @param {common.IHealthCheckDetail=} [properties] Properties to set
     * @returns {common.HealthCheckDetail} HealthCheckDetail instance
     */
    HealthCheckDetail.create = function create(properties) {
      return new HealthCheckDetail(properties);
    };

    /**
     * Encodes the specified HealthCheckDetail message. Does not implicitly {@link common.HealthCheckDetail.verify|verify} messages.
     * @function encode
     * @memberof common.HealthCheckDetail
     * @static
     * @param {common.IHealthCheckDetail} m HealthCheckDetail message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    HealthCheckDetail.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.componentID != null && Object.hasOwnProperty.call(m, "componentID"))
        w.uint32(10).string(m.componentID);
      if (m.type != null && Object.hasOwnProperty.call(m, "type"))
        w.uint32(18).string(m.type);
      if (
        m.observedValue != null &&
        Object.hasOwnProperty.call(m, "observedValue")
      )
        w.uint32(25).double(m.observedValue);
      if (
        m.observedUnit != null &&
        Object.hasOwnProperty.call(m, "observedUnit")
      )
        w.uint32(34).string(m.observedUnit);
      if (m.status != null && Object.hasOwnProperty.call(m, "status"))
        w.uint32(42).string(m.status);
      if (m.time != null && Object.hasOwnProperty.call(m, "time"))
        $root.google.protobuf.Timestamp.encode(
          m.time,
          w.uint32(50).fork()
        ).ldelim();
      if (m.output != null && Object.hasOwnProperty.call(m, "output"))
        w.uint32(58).string(m.output);
      return w;
    };

    /**
     * Decodes a HealthCheckDetail message from the specified reader or buffer.
     * @function decode
     * @memberof common.HealthCheckDetail
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {common.HealthCheckDetail} HealthCheckDetail
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    HealthCheckDetail.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.common.HealthCheckDetail();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.componentID = r.string();
            break;
          case 2:
            m.type = r.string();
            break;
          case 3:
            m.observedValue = r.double();
            break;
          case 4:
            m.observedUnit = r.string();
            break;
          case 5:
            m.status = r.string();
            break;
          case 6:
            m.time = $root.google.protobuf.Timestamp.decode(r, r.uint32());
            break;
          case 7:
            m.output = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return HealthCheckDetail;
  })();

  common.NamedHealthCheckDetail = (function () {
    /**
     * Properties of a NamedHealthCheckDetail.
     * @memberof common
     * @interface INamedHealthCheckDetail
     * @property {string|null} [name] NamedHealthCheckDetail name
     * @property {Array.<common.IHealthCheckDetail>|null} [details] NamedHealthCheckDetail details
     */

    /**
     * Constructs a new NamedHealthCheckDetail.
     * @memberof common
     * @classdesc Represents a NamedHealthCheckDetail.
     * @implements INamedHealthCheckDetail
     * @constructor
     * @param {common.INamedHealthCheckDetail=} [p] Properties to set
     */
    function NamedHealthCheckDetail(p) {
      this.details = [];
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * NamedHealthCheckDetail name.
     * @member {string} name
     * @memberof common.NamedHealthCheckDetail
     * @instance
     */
    NamedHealthCheckDetail.prototype.name = "";

    /**
     * NamedHealthCheckDetail details.
     * @member {Array.<common.IHealthCheckDetail>} details
     * @memberof common.NamedHealthCheckDetail
     * @instance
     */
    NamedHealthCheckDetail.prototype.details = $util.emptyArray;

    /**
     * Creates a new NamedHealthCheckDetail instance using the specified properties.
     * @function create
     * @memberof common.NamedHealthCheckDetail
     * @static
     * @param {common.INamedHealthCheckDetail=} [properties] Properties to set
     * @returns {common.NamedHealthCheckDetail} NamedHealthCheckDetail instance
     */
    NamedHealthCheckDetail.create = function create(properties) {
      return new NamedHealthCheckDetail(properties);
    };

    /**
     * Encodes the specified NamedHealthCheckDetail message. Does not implicitly {@link common.NamedHealthCheckDetail.verify|verify} messages.
     * @function encode
     * @memberof common.NamedHealthCheckDetail
     * @static
     * @param {common.INamedHealthCheckDetail} m NamedHealthCheckDetail message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    NamedHealthCheckDetail.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.name != null && Object.hasOwnProperty.call(m, "name"))
        w.uint32(10).string(m.name);
      if (m.details != null && m.details.length) {
        for (var i = 0; i < m.details.length; ++i)
          $root.common.HealthCheckDetail.encode(
            m.details[i],
            w.uint32(18).fork()
          ).ldelim();
      }
      return w;
    };

    /**
     * Decodes a NamedHealthCheckDetail message from the specified reader or buffer.
     * @function decode
     * @memberof common.NamedHealthCheckDetail
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {common.NamedHealthCheckDetail} NamedHealthCheckDetail
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    NamedHealthCheckDetail.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.common.NamedHealthCheckDetail();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.name = r.string();
            break;
          case 2:
            if (!(m.details && m.details.length)) m.details = [];
            m.details.push(
              $root.common.HealthCheckDetail.decode(r, r.uint32())
            );
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return NamedHealthCheckDetail;
  })();

  common.HealthCheck = (function () {
    /**
     * Properties of a HealthCheck.
     * @memberof common
     * @interface IHealthCheck
     * @property {string|null} [status] HealthCheck status
     * @property {string|null} [version] HealthCheck version
     * @property {string|null} [releaseID] HealthCheck releaseID
     * @property {Array.<string>|null} [notes] HealthCheck notes
     * @property {string|null} [output] HealthCheck output
     * @property {Array.<common.INamedHealthCheckDetail>|null} [details] HealthCheck details
     */

    /**
     * Constructs a new HealthCheck.
     * @memberof common
     * @classdesc Represents a HealthCheck.
     * @implements IHealthCheck
     * @constructor
     * @param {common.IHealthCheck=} [p] Properties to set
     */
    function HealthCheck(p) {
      this.notes = [];
      this.details = [];
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * HealthCheck status.
     * @member {string} status
     * @memberof common.HealthCheck
     * @instance
     */
    HealthCheck.prototype.status = "";

    /**
     * HealthCheck version.
     * @member {string} version
     * @memberof common.HealthCheck
     * @instance
     */
    HealthCheck.prototype.version = "";

    /**
     * HealthCheck releaseID.
     * @member {string} releaseID
     * @memberof common.HealthCheck
     * @instance
     */
    HealthCheck.prototype.releaseID = "";

    /**
     * HealthCheck notes.
     * @member {Array.<string>} notes
     * @memberof common.HealthCheck
     * @instance
     */
    HealthCheck.prototype.notes = $util.emptyArray;

    /**
     * HealthCheck output.
     * @member {string} output
     * @memberof common.HealthCheck
     * @instance
     */
    HealthCheck.prototype.output = "";

    /**
     * HealthCheck details.
     * @member {Array.<common.INamedHealthCheckDetail>} details
     * @memberof common.HealthCheck
     * @instance
     */
    HealthCheck.prototype.details = $util.emptyArray;

    /**
     * Creates a new HealthCheck instance using the specified properties.
     * @function create
     * @memberof common.HealthCheck
     * @static
     * @param {common.IHealthCheck=} [properties] Properties to set
     * @returns {common.HealthCheck} HealthCheck instance
     */
    HealthCheck.create = function create(properties) {
      return new HealthCheck(properties);
    };

    /**
     * Encodes the specified HealthCheck message. Does not implicitly {@link common.HealthCheck.verify|verify} messages.
     * @function encode
     * @memberof common.HealthCheck
     * @static
     * @param {common.IHealthCheck} m HealthCheck message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    HealthCheck.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.status != null && Object.hasOwnProperty.call(m, "status"))
        w.uint32(10).string(m.status);
      if (m.version != null && Object.hasOwnProperty.call(m, "version"))
        w.uint32(18).string(m.version);
      if (m.releaseID != null && Object.hasOwnProperty.call(m, "releaseID"))
        w.uint32(26).string(m.releaseID);
      if (m.notes != null && m.notes.length) {
        for (var i = 0; i < m.notes.length; ++i)
          w.uint32(34).string(m.notes[i]);
      }
      if (m.output != null && Object.hasOwnProperty.call(m, "output"))
        w.uint32(42).string(m.output);
      if (m.details != null && m.details.length) {
        for (var i = 0; i < m.details.length; ++i)
          $root.common.NamedHealthCheckDetail.encode(
            m.details[i],
            w.uint32(50).fork()
          ).ldelim();
      }
      return w;
    };

    /**
     * Decodes a HealthCheck message from the specified reader or buffer.
     * @function decode
     * @memberof common.HealthCheck
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {common.HealthCheck} HealthCheck
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    HealthCheck.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.common.HealthCheck();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.status = r.string();
            break;
          case 2:
            m.version = r.string();
            break;
          case 3:
            m.releaseID = r.string();
            break;
          case 4:
            if (!(m.notes && m.notes.length)) m.notes = [];
            m.notes.push(r.string());
            break;
          case 5:
            m.output = r.string();
            break;
          case 6:
            if (!(m.details && m.details.length)) m.details = [];
            m.details.push(
              $root.common.NamedHealthCheckDetail.decode(r, r.uint32())
            );
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return HealthCheck;
  })();

  common.HealthCheckResponse = (function () {
    /**
     * Properties of a HealthCheckResponse.
     * @memberof common
     * @interface IHealthCheckResponse
     * @property {common.IHealthCheck|null} [health] HealthCheckResponse health
     */

    /**
     * Constructs a new HealthCheckResponse.
     * @memberof common
     * @classdesc Represents a HealthCheckResponse.
     * @implements IHealthCheckResponse
     * @constructor
     * @param {common.IHealthCheckResponse=} [p] Properties to set
     */
    function HealthCheckResponse(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * HealthCheckResponse health.
     * @member {common.IHealthCheck|null|undefined} health
     * @memberof common.HealthCheckResponse
     * @instance
     */
    HealthCheckResponse.prototype.health = null;

    /**
     * Creates a new HealthCheckResponse instance using the specified properties.
     * @function create
     * @memberof common.HealthCheckResponse
     * @static
     * @param {common.IHealthCheckResponse=} [properties] Properties to set
     * @returns {common.HealthCheckResponse} HealthCheckResponse instance
     */
    HealthCheckResponse.create = function create(properties) {
      return new HealthCheckResponse(properties);
    };

    /**
     * Encodes the specified HealthCheckResponse message. Does not implicitly {@link common.HealthCheckResponse.verify|verify} messages.
     * @function encode
     * @memberof common.HealthCheckResponse
     * @static
     * @param {common.IHealthCheckResponse} m HealthCheckResponse message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    HealthCheckResponse.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.health != null && Object.hasOwnProperty.call(m, "health"))
        $root.common.HealthCheck.encode(m.health, w.uint32(10).fork()).ldelim();
      return w;
    };

    /**
     * Decodes a HealthCheckResponse message from the specified reader or buffer.
     * @function decode
     * @memberof common.HealthCheckResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {common.HealthCheckResponse} HealthCheckResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    HealthCheckResponse.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.common.HealthCheckResponse();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.health = $root.common.HealthCheck.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return HealthCheckResponse;
  })();

  common.Timeslot = (function () {
    /**
     * Properties of a Timeslot.
     * @memberof common
     * @interface ITimeslot
     * @property {google.protobuf.ITimestamp|null} [start] Timeslot start
     * @property {google.protobuf.ITimestamp|null} [end] Timeslot end
     */

    /**
     * Constructs a new Timeslot.
     * @memberof common
     * @classdesc Represents a Timeslot.
     * @implements ITimeslot
     * @constructor
     * @param {common.ITimeslot=} [p] Properties to set
     */
    function Timeslot(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * Timeslot start.
     * @member {google.protobuf.ITimestamp|null|undefined} start
     * @memberof common.Timeslot
     * @instance
     */
    Timeslot.prototype.start = null;

    /**
     * Timeslot end.
     * @member {google.protobuf.ITimestamp|null|undefined} end
     * @memberof common.Timeslot
     * @instance
     */
    Timeslot.prototype.end = null;

    /**
     * Creates a new Timeslot instance using the specified properties.
     * @function create
     * @memberof common.Timeslot
     * @static
     * @param {common.ITimeslot=} [properties] Properties to set
     * @returns {common.Timeslot} Timeslot instance
     */
    Timeslot.create = function create(properties) {
      return new Timeslot(properties);
    };

    /**
     * Encodes the specified Timeslot message. Does not implicitly {@link common.Timeslot.verify|verify} messages.
     * @function encode
     * @memberof common.Timeslot
     * @static
     * @param {common.ITimeslot} m Timeslot message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Timeslot.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.start != null && Object.hasOwnProperty.call(m, "start"))
        $root.google.protobuf.Timestamp.encode(
          m.start,
          w.uint32(10).fork()
        ).ldelim();
      if (m.end != null && Object.hasOwnProperty.call(m, "end"))
        $root.google.protobuf.Timestamp.encode(
          m.end,
          w.uint32(18).fork()
        ).ldelim();
      return w;
    };

    /**
     * Decodes a Timeslot message from the specified reader or buffer.
     * @function decode
     * @memberof common.Timeslot
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {common.Timeslot} Timeslot
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Timeslot.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.common.Timeslot();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.start = $root.google.protobuf.Timestamp.decode(r, r.uint32());
            break;
          case 2:
            m.end = $root.google.protobuf.Timestamp.decode(r, r.uint32());
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return Timeslot;
  })();

  common.ErrorResponse = (function () {
    /**
     * Properties of an ErrorResponse.
     * @memberof common
     * @interface IErrorResponse
     * @property {Array.<common.IError>|null} [errors] ErrorResponse errors
     */

    /**
     * Constructs a new ErrorResponse.
     * @memberof common
     * @classdesc Represents an ErrorResponse.
     * @implements IErrorResponse
     * @constructor
     * @param {common.IErrorResponse=} [p] Properties to set
     */
    function ErrorResponse(p) {
      this.errors = [];
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * ErrorResponse errors.
     * @member {Array.<common.IError>} errors
     * @memberof common.ErrorResponse
     * @instance
     */
    ErrorResponse.prototype.errors = $util.emptyArray;

    /**
     * Creates a new ErrorResponse instance using the specified properties.
     * @function create
     * @memberof common.ErrorResponse
     * @static
     * @param {common.IErrorResponse=} [properties] Properties to set
     * @returns {common.ErrorResponse} ErrorResponse instance
     */
    ErrorResponse.create = function create(properties) {
      return new ErrorResponse(properties);
    };

    /**
     * Encodes the specified ErrorResponse message. Does not implicitly {@link common.ErrorResponse.verify|verify} messages.
     * @function encode
     * @memberof common.ErrorResponse
     * @static
     * @param {common.IErrorResponse} m ErrorResponse message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ErrorResponse.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.errors != null && m.errors.length) {
        for (var i = 0; i < m.errors.length; ++i)
          $root.common.Error.encode(m.errors[i], w.uint32(10).fork()).ldelim();
      }
      return w;
    };

    /**
     * Decodes an ErrorResponse message from the specified reader or buffer.
     * @function decode
     * @memberof common.ErrorResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {common.ErrorResponse} ErrorResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ErrorResponse.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.common.ErrorResponse();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            if (!(m.errors && m.errors.length)) m.errors = [];
            m.errors.push($root.common.Error.decode(r, r.uint32()));
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ErrorResponse;
  })();

  common.Error = (function () {
    /**
     * Properties of an Error.
     * @memberof common
     * @interface IError
     * @property {string|null} [message] Error message
     * @property {string|null} [code] Error code
     */

    /**
     * Constructs a new Error.
     * @memberof common
     * @classdesc Represents an Error.
     * @implements IError
     * @constructor
     * @param {common.IError=} [p] Properties to set
     */
    function Error(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * Error message.
     * @member {string} message
     * @memberof common.Error
     * @instance
     */
    Error.prototype.message = "";

    /**
     * Error code.
     * @member {string} code
     * @memberof common.Error
     * @instance
     */
    Error.prototype.code = "";

    /**
     * Creates a new Error instance using the specified properties.
     * @function create
     * @memberof common.Error
     * @static
     * @param {common.IError=} [properties] Properties to set
     * @returns {common.Error} Error instance
     */
    Error.create = function create(properties) {
      return new Error(properties);
    };

    /**
     * Encodes the specified Error message. Does not implicitly {@link common.Error.verify|verify} messages.
     * @function encode
     * @memberof common.Error
     * @static
     * @param {common.IError} m Error message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Error.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.message != null && Object.hasOwnProperty.call(m, "message"))
        w.uint32(10).string(m.message);
      if (m.code != null && Object.hasOwnProperty.call(m, "code"))
        w.uint32(18).string(m.code);
      return w;
    };

    /**
     * Decodes an Error message from the specified reader or buffer.
     * @function decode
     * @memberof common.Error
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {common.Error} Error
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Error.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.common.Error();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.message = r.string();
            break;
          case 2:
            m.code = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return Error;
  })();

  common.Money = (function () {
    /**
     * Properties of a Money.
     * @memberof common
     * @interface IMoney
     * @property {string|null} [currencyCode] Money currencyCode
     * @property {number|Long|null} [units] Money units
     * @property {number|null} [nanos] Money nanos
     */

    /**
     * Constructs a new Money.
     * @memberof common
     * @classdesc Represents a Money.
     * @implements IMoney
     * @constructor
     * @param {common.IMoney=} [p] Properties to set
     */
    function Money(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * Money currencyCode.
     * @member {string} currencyCode
     * @memberof common.Money
     * @instance
     */
    Money.prototype.currencyCode = "";

    /**
     * Money units.
     * @member {number|Long} units
     * @memberof common.Money
     * @instance
     */
    Money.prototype.units = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Money nanos.
     * @member {number} nanos
     * @memberof common.Money
     * @instance
     */
    Money.prototype.nanos = 0;

    /**
     * Creates a new Money instance using the specified properties.
     * @function create
     * @memberof common.Money
     * @static
     * @param {common.IMoney=} [properties] Properties to set
     * @returns {common.Money} Money instance
     */
    Money.create = function create(properties) {
      return new Money(properties);
    };

    /**
     * Encodes the specified Money message. Does not implicitly {@link common.Money.verify|verify} messages.
     * @function encode
     * @memberof common.Money
     * @static
     * @param {common.IMoney} m Money message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Money.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (
        m.currencyCode != null &&
        Object.hasOwnProperty.call(m, "currencyCode")
      )
        w.uint32(10).string(m.currencyCode);
      if (m.units != null && Object.hasOwnProperty.call(m, "units"))
        w.uint32(16).int64(m.units);
      if (m.nanos != null && Object.hasOwnProperty.call(m, "nanos"))
        w.uint32(24).int32(m.nanos);
      return w;
    };

    /**
     * Decodes a Money message from the specified reader or buffer.
     * @function decode
     * @memberof common.Money
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {common.Money} Money
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Money.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.common.Money();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.currencyCode = r.string();
            break;
          case 2:
            m.units = r.int64();
            break;
          case 3:
            m.nanos = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return Money;
  })();

  common.Date = (function () {
    /**
     * Properties of a Date.
     * @memberof common
     * @interface IDate
     * @property {number|null} [year] Date year
     * @property {number|null} [month] Date month
     * @property {number|null} [day] Date day
     */

    /**
     * Constructs a new Date.
     * @memberof common
     * @classdesc Represents a Date.
     * @implements IDate
     * @constructor
     * @param {common.IDate=} [p] Properties to set
     */
    function Date(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * Date year.
     * @member {number} year
     * @memberof common.Date
     * @instance
     */
    Date.prototype.year = 0;

    /**
     * Date month.
     * @member {number} month
     * @memberof common.Date
     * @instance
     */
    Date.prototype.month = 0;

    /**
     * Date day.
     * @member {number} day
     * @memberof common.Date
     * @instance
     */
    Date.prototype.day = 0;

    /**
     * Creates a new Date instance using the specified properties.
     * @function create
     * @memberof common.Date
     * @static
     * @param {common.IDate=} [properties] Properties to set
     * @returns {common.Date} Date instance
     */
    Date.create = function create(properties) {
      return new Date(properties);
    };

    /**
     * Encodes the specified Date message. Does not implicitly {@link common.Date.verify|verify} messages.
     * @function encode
     * @memberof common.Date
     * @static
     * @param {common.IDate} m Date message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Date.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.year != null && Object.hasOwnProperty.call(m, "year"))
        w.uint32(8).int32(m.year);
      if (m.month != null && Object.hasOwnProperty.call(m, "month"))
        w.uint32(16).int32(m.month);
      if (m.day != null && Object.hasOwnProperty.call(m, "day"))
        w.uint32(24).int32(m.day);
      return w;
    };

    /**
     * Decodes a Date message from the specified reader or buffer.
     * @function decode
     * @memberof common.Date
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {common.Date} Date
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Date.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.common.Date();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.year = r.int32();
            break;
          case 2:
            m.month = r.int32();
            break;
          case 3:
            m.day = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return Date;
  })();

  common.GeoLocation = (function () {
    /**
     * Properties of a GeoLocation.
     * @memberof common
     * @interface IGeoLocation
     * @property {number|null} [latitude] GeoLocation latitude
     * @property {number|null} [longitude] GeoLocation longitude
     */

    /**
     * Constructs a new GeoLocation.
     * @memberof common
     * @classdesc Represents a GeoLocation.
     * @implements IGeoLocation
     * @constructor
     * @param {common.IGeoLocation=} [p] Properties to set
     */
    function GeoLocation(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * GeoLocation latitude.
     * @member {number} latitude
     * @memberof common.GeoLocation
     * @instance
     */
    GeoLocation.prototype.latitude = 0;

    /**
     * GeoLocation longitude.
     * @member {number} longitude
     * @memberof common.GeoLocation
     * @instance
     */
    GeoLocation.prototype.longitude = 0;

    /**
     * Creates a new GeoLocation instance using the specified properties.
     * @function create
     * @memberof common.GeoLocation
     * @static
     * @param {common.IGeoLocation=} [properties] Properties to set
     * @returns {common.GeoLocation} GeoLocation instance
     */
    GeoLocation.create = function create(properties) {
      return new GeoLocation(properties);
    };

    /**
     * Encodes the specified GeoLocation message. Does not implicitly {@link common.GeoLocation.verify|verify} messages.
     * @function encode
     * @memberof common.GeoLocation
     * @static
     * @param {common.IGeoLocation} m GeoLocation message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GeoLocation.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.latitude != null && Object.hasOwnProperty.call(m, "latitude"))
        w.uint32(13).float(m.latitude);
      if (m.longitude != null && Object.hasOwnProperty.call(m, "longitude"))
        w.uint32(21).float(m.longitude);
      return w;
    };

    /**
     * Decodes a GeoLocation message from the specified reader or buffer.
     * @function decode
     * @memberof common.GeoLocation
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {common.GeoLocation} GeoLocation
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GeoLocation.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.common.GeoLocation();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.latitude = r.float();
            break;
          case 2:
            m.longitude = r.float();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return GeoLocation;
  })();

  /**
   * Locale enum.
   * @name common.Locale
   * @enum {number}
   * @property {number} EN=0 EN value
   * @property {number} ES=1 ES value
   */
  common.Locale = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = "EN")] = 0;
    values[(valuesById[1] = "ES")] = 1;
    return values;
  })();

  common.Range_U32 = (function () {
    /**
     * Properties of a Range_U32.
     * @memberof common
     * @interface IRange_U32
     * @property {number|null} [min] Range_U32 min
     * @property {number|null} [max] Range_U32 max
     */

    /**
     * Constructs a new Range_U32.
     * @memberof common
     * @classdesc Represents a Range_U32.
     * @implements IRange_U32
     * @constructor
     * @param {common.IRange_U32=} [p] Properties to set
     */
    function Range_U32(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * Range_U32 min.
     * @member {number} min
     * @memberof common.Range_U32
     * @instance
     */
    Range_U32.prototype.min = 0;

    /**
     * Range_U32 max.
     * @member {number} max
     * @memberof common.Range_U32
     * @instance
     */
    Range_U32.prototype.max = 0;

    /**
     * Creates a new Range_U32 instance using the specified properties.
     * @function create
     * @memberof common.Range_U32
     * @static
     * @param {common.IRange_U32=} [properties] Properties to set
     * @returns {common.Range_U32} Range_U32 instance
     */
    Range_U32.create = function create(properties) {
      return new Range_U32(properties);
    };

    /**
     * Encodes the specified Range_U32 message. Does not implicitly {@link common.Range_U32.verify|verify} messages.
     * @function encode
     * @memberof common.Range_U32
     * @static
     * @param {common.IRange_U32} m Range_U32 message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Range_U32.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.min != null && Object.hasOwnProperty.call(m, "min"))
        w.uint32(8).uint32(m.min);
      if (m.max != null && Object.hasOwnProperty.call(m, "max"))
        w.uint32(16).uint32(m.max);
      return w;
    };

    /**
     * Decodes a Range_U32 message from the specified reader or buffer.
     * @function decode
     * @memberof common.Range_U32
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {common.Range_U32} Range_U32
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Range_U32.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.common.Range_U32();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.min = r.uint32();
            break;
          case 2:
            m.max = r.uint32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return Range_U32;
  })();

  common.ApplicationSource = (function () {
    /**
     * Properties of an ApplicationSource.
     * @memberof common
     * @interface IApplicationSource
     * @property {string|null} [name] ApplicationSource name
     * @property {string|null} [version] ApplicationSource version
     * @property {string|null} [authorVersion] ApplicationSource authorVersion
     */

    /**
     * Constructs a new ApplicationSource.
     * @memberof common
     * @classdesc Represents an ApplicationSource.
     * @implements IApplicationSource
     * @constructor
     * @param {common.IApplicationSource=} [p] Properties to set
     */
    function ApplicationSource(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * ApplicationSource name.
     * @member {string} name
     * @memberof common.ApplicationSource
     * @instance
     */
    ApplicationSource.prototype.name = "";

    /**
     * ApplicationSource version.
     * @member {string} version
     * @memberof common.ApplicationSource
     * @instance
     */
    ApplicationSource.prototype.version = "";

    /**
     * ApplicationSource authorVersion.
     * @member {string} authorVersion
     * @memberof common.ApplicationSource
     * @instance
     */
    ApplicationSource.prototype.authorVersion = "";

    /**
     * Creates a new ApplicationSource instance using the specified properties.
     * @function create
     * @memberof common.ApplicationSource
     * @static
     * @param {common.IApplicationSource=} [properties] Properties to set
     * @returns {common.ApplicationSource} ApplicationSource instance
     */
    ApplicationSource.create = function create(properties) {
      return new ApplicationSource(properties);
    };

    /**
     * Encodes the specified ApplicationSource message. Does not implicitly {@link common.ApplicationSource.verify|verify} messages.
     * @function encode
     * @memberof common.ApplicationSource
     * @static
     * @param {common.IApplicationSource} m ApplicationSource message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ApplicationSource.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.name != null && Object.hasOwnProperty.call(m, "name"))
        w.uint32(10).string(m.name);
      if (m.version != null && Object.hasOwnProperty.call(m, "version"))
        w.uint32(18).string(m.version);
      if (
        m.authorVersion != null &&
        Object.hasOwnProperty.call(m, "authorVersion")
      )
        w.uint32(26).string(m.authorVersion);
      return w;
    };

    /**
     * Decodes an ApplicationSource message from the specified reader or buffer.
     * @function decode
     * @memberof common.ApplicationSource
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {common.ApplicationSource} ApplicationSource
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ApplicationSource.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.common.ApplicationSource();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.name = r.string();
            break;
          case 2:
            m.version = r.string();
            break;
          case 3:
            m.authorVersion = r.string();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return ApplicationSource;
  })();

  common.Pagination = (function () {
    /**
     * Properties of a Pagination.
     * @memberof common
     * @interface IPagination
     * @property {number|null} [currentPage] Pagination currentPage
     * @property {number|null} [itemsPerPage] Pagination itemsPerPage
     * @property {number|null} [totalPages] Pagination totalPages
     * @property {number|null} [totalRecords] Pagination totalRecords
     */

    /**
     * Constructs a new Pagination.
     * @memberof common
     * @classdesc Represents a Pagination.
     * @implements IPagination
     * @constructor
     * @param {common.IPagination=} [p] Properties to set
     */
    function Pagination(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * Pagination currentPage.
     * @member {number} currentPage
     * @memberof common.Pagination
     * @instance
     */
    Pagination.prototype.currentPage = 0;

    /**
     * Pagination itemsPerPage.
     * @member {number} itemsPerPage
     * @memberof common.Pagination
     * @instance
     */
    Pagination.prototype.itemsPerPage = 0;

    /**
     * Pagination totalPages.
     * @member {number} totalPages
     * @memberof common.Pagination
     * @instance
     */
    Pagination.prototype.totalPages = 0;

    /**
     * Pagination totalRecords.
     * @member {number} totalRecords
     * @memberof common.Pagination
     * @instance
     */
    Pagination.prototype.totalRecords = 0;

    /**
     * Creates a new Pagination instance using the specified properties.
     * @function create
     * @memberof common.Pagination
     * @static
     * @param {common.IPagination=} [properties] Properties to set
     * @returns {common.Pagination} Pagination instance
     */
    Pagination.create = function create(properties) {
      return new Pagination(properties);
    };

    /**
     * Encodes the specified Pagination message. Does not implicitly {@link common.Pagination.verify|verify} messages.
     * @function encode
     * @memberof common.Pagination
     * @static
     * @param {common.IPagination} m Pagination message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Pagination.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.currentPage != null && Object.hasOwnProperty.call(m, "currentPage"))
        w.uint32(8).int32(m.currentPage);
      if (
        m.itemsPerPage != null &&
        Object.hasOwnProperty.call(m, "itemsPerPage")
      )
        w.uint32(16).int32(m.itemsPerPage);
      if (m.totalPages != null && Object.hasOwnProperty.call(m, "totalPages"))
        w.uint32(24).int32(m.totalPages);
      if (
        m.totalRecords != null &&
        Object.hasOwnProperty.call(m, "totalRecords")
      )
        w.uint32(32).int32(m.totalRecords);
      return w;
    };

    /**
     * Decodes a Pagination message from the specified reader or buffer.
     * @function decode
     * @memberof common.Pagination
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {common.Pagination} Pagination
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Pagination.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.common.Pagination();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.currentPage = r.int32();
            break;
          case 2:
            m.itemsPerPage = r.int32();
            break;
          case 3:
            m.totalPages = r.int32();
            break;
          case 4:
            m.totalRecords = r.int32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return Pagination;
  })();

  common.PaginationRequest = (function () {
    /**
     * Properties of a PaginationRequest.
     * @memberof common
     * @interface IPaginationRequest
     * @property {number|null} [currentPage] PaginationRequest currentPage
     * @property {number|null} [itemsPerPage] PaginationRequest itemsPerPage
     */

    /**
     * Constructs a new PaginationRequest.
     * @memberof common
     * @classdesc Represents a PaginationRequest.
     * @implements IPaginationRequest
     * @constructor
     * @param {common.IPaginationRequest=} [p] Properties to set
     */
    function PaginationRequest(p) {
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * PaginationRequest currentPage.
     * @member {number} currentPage
     * @memberof common.PaginationRequest
     * @instance
     */
    PaginationRequest.prototype.currentPage = 0;

    /**
     * PaginationRequest itemsPerPage.
     * @member {number} itemsPerPage
     * @memberof common.PaginationRequest
     * @instance
     */
    PaginationRequest.prototype.itemsPerPage = 0;

    /**
     * Creates a new PaginationRequest instance using the specified properties.
     * @function create
     * @memberof common.PaginationRequest
     * @static
     * @param {common.IPaginationRequest=} [properties] Properties to set
     * @returns {common.PaginationRequest} PaginationRequest instance
     */
    PaginationRequest.create = function create(properties) {
      return new PaginationRequest(properties);
    };

    /**
     * Encodes the specified PaginationRequest message. Does not implicitly {@link common.PaginationRequest.verify|verify} messages.
     * @function encode
     * @memberof common.PaginationRequest
     * @static
     * @param {common.IPaginationRequest} m PaginationRequest message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PaginationRequest.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.currentPage != null && Object.hasOwnProperty.call(m, "currentPage"))
        w.uint32(8).uint32(m.currentPage);
      if (
        m.itemsPerPage != null &&
        Object.hasOwnProperty.call(m, "itemsPerPage")
      )
        w.uint32(16).uint32(m.itemsPerPage);
      return w;
    };

    /**
     * Decodes a PaginationRequest message from the specified reader or buffer.
     * @function decode
     * @memberof common.PaginationRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {common.PaginationRequest} PaginationRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PaginationRequest.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.common.PaginationRequest();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.currentPage = r.uint32();
            break;
          case 2:
            m.itemsPerPage = r.uint32();
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    return PaginationRequest;
  })();

  /**
   * USStateAlphaCode enum.
   * @name common.USStateAlphaCode
   * @enum {number}
   * @property {number} UnknownState=0 UnknownState value
   * @property {number} AL=1 AL value
   * @property {number} AK=2 AK value
   * @property {number} AZ=3 AZ value
   * @property {number} AR=4 AR value
   * @property {number} CA=5 CA value
   * @property {number} CO=6 CO value
   * @property {number} CT=7 CT value
   * @property {number} DE=11 DE value
   * @property {number} DC=12 DC value
   * @property {number} FL=13 FL value
   * @property {number} GA=21 GA value
   * @property {number} HI=22 HI value
   * @property {number} ID=23 ID value
   * @property {number} IL=24 IL value
   * @property {number} IN=25 IN value
   * @property {number} IA=26 IA value
   * @property {number} KS=31 KS value
   * @property {number} KY=32 KY value
   * @property {number} LA=33 LA value
   * @property {number} ME=41 ME value
   * @property {number} MD=42 MD value
   * @property {number} MA=43 MA value
   * @property {number} MI=44 MI value
   * @property {number} MN=45 MN value
   * @property {number} MS=46 MS value
   * @property {number} MO=47 MO value
   * @property {number} MT=48 MT value
   * @property {number} NE=51 NE value
   * @property {number} NV=52 NV value
   * @property {number} NH=53 NH value
   * @property {number} NJ=54 NJ value
   * @property {number} NM=55 NM value
   * @property {number} NY=56 NY value
   * @property {number} NC=57 NC value
   * @property {number} ND=58 ND value
   * @property {number} OH=61 OH value
   * @property {number} OK=62 OK value
   * @property {number} OR=63 OR value
   * @property {number} PA=64 PA value
   * @property {number} RI=65 RI value
   * @property {number} SC=66 SC value
   * @property {number} SD=67 SD value
   * @property {number} TN=71 TN value
   * @property {number} TX=72 TX value
   * @property {number} UT=73 UT value
   * @property {number} VT=74 VT value
   * @property {number} VA=75 VA value
   * @property {number} WA=76 WA value
   * @property {number} WV=77 WV value
   * @property {number} WI=78 WI value
   * @property {number} WY=79 WY value
   */
  common.USStateAlphaCode = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = "UnknownState")] = 0;
    values[(valuesById[1] = "AL")] = 1;
    values[(valuesById[2] = "AK")] = 2;
    values[(valuesById[3] = "AZ")] = 3;
    values[(valuesById[4] = "AR")] = 4;
    values[(valuesById[5] = "CA")] = 5;
    values[(valuesById[6] = "CO")] = 6;
    values[(valuesById[7] = "CT")] = 7;
    values[(valuesById[11] = "DE")] = 11;
    values[(valuesById[12] = "DC")] = 12;
    values[(valuesById[13] = "FL")] = 13;
    values[(valuesById[21] = "GA")] = 21;
    values[(valuesById[22] = "HI")] = 22;
    values[(valuesById[23] = "ID")] = 23;
    values[(valuesById[24] = "IL")] = 24;
    values[(valuesById[25] = "IN")] = 25;
    values[(valuesById[26] = "IA")] = 26;
    values[(valuesById[31] = "KS")] = 31;
    values[(valuesById[32] = "KY")] = 32;
    values[(valuesById[33] = "LA")] = 33;
    values[(valuesById[41] = "ME")] = 41;
    values[(valuesById[42] = "MD")] = 42;
    values[(valuesById[43] = "MA")] = 43;
    values[(valuesById[44] = "MI")] = 44;
    values[(valuesById[45] = "MN")] = 45;
    values[(valuesById[46] = "MS")] = 46;
    values[(valuesById[47] = "MO")] = 47;
    values[(valuesById[48] = "MT")] = 48;
    values[(valuesById[51] = "NE")] = 51;
    values[(valuesById[52] = "NV")] = 52;
    values[(valuesById[53] = "NH")] = 53;
    values[(valuesById[54] = "NJ")] = 54;
    values[(valuesById[55] = "NM")] = 55;
    values[(valuesById[56] = "NY")] = 56;
    values[(valuesById[57] = "NC")] = 57;
    values[(valuesById[58] = "ND")] = 58;
    values[(valuesById[61] = "OH")] = 61;
    values[(valuesById[62] = "OK")] = 62;
    values[(valuesById[63] = "OR")] = 63;
    values[(valuesById[64] = "PA")] = 64;
    values[(valuesById[65] = "RI")] = 65;
    values[(valuesById[66] = "SC")] = 66;
    values[(valuesById[67] = "SD")] = 67;
    values[(valuesById[71] = "TN")] = 71;
    values[(valuesById[72] = "TX")] = 72;
    values[(valuesById[73] = "UT")] = 73;
    values[(valuesById[74] = "VT")] = 74;
    values[(valuesById[75] = "VA")] = 75;
    values[(valuesById[76] = "WA")] = 76;
    values[(valuesById[77] = "WV")] = 77;
    values[(valuesById[78] = "WI")] = 78;
    values[(valuesById[79] = "WY")] = 79;
    return values;
  })();

  common.AuditTrailEntry = (function () {
    /**
     * Properties of an AuditTrailEntry.
     * @memberof common
     * @interface IAuditTrailEntry
     * @property {google.protobuf.ITimestamp|null} [createdOn] AuditTrailEntry createdOn
     * @property {string|null} [createdBy] AuditTrailEntry createdBy
     * @property {Array.<common.AuditTrailEntry.IAuditTrailEntryDetail>|null} [details] AuditTrailEntry details
     */

    /**
     * Constructs a new AuditTrailEntry.
     * @memberof common
     * @classdesc Represents an AuditTrailEntry.
     * @implements IAuditTrailEntry
     * @constructor
     * @param {common.IAuditTrailEntry=} [p] Properties to set
     */
    function AuditTrailEntry(p) {
      this.details = [];
      if (p)
        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
          if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
    }

    /**
     * AuditTrailEntry createdOn.
     * @member {google.protobuf.ITimestamp|null|undefined} createdOn
     * @memberof common.AuditTrailEntry
     * @instance
     */
    AuditTrailEntry.prototype.createdOn = null;

    /**
     * AuditTrailEntry createdBy.
     * @member {string} createdBy
     * @memberof common.AuditTrailEntry
     * @instance
     */
    AuditTrailEntry.prototype.createdBy = "";

    /**
     * AuditTrailEntry details.
     * @member {Array.<common.AuditTrailEntry.IAuditTrailEntryDetail>} details
     * @memberof common.AuditTrailEntry
     * @instance
     */
    AuditTrailEntry.prototype.details = $util.emptyArray;

    /**
     * Creates a new AuditTrailEntry instance using the specified properties.
     * @function create
     * @memberof common.AuditTrailEntry
     * @static
     * @param {common.IAuditTrailEntry=} [properties] Properties to set
     * @returns {common.AuditTrailEntry} AuditTrailEntry instance
     */
    AuditTrailEntry.create = function create(properties) {
      return new AuditTrailEntry(properties);
    };

    /**
     * Encodes the specified AuditTrailEntry message. Does not implicitly {@link common.AuditTrailEntry.verify|verify} messages.
     * @function encode
     * @memberof common.AuditTrailEntry
     * @static
     * @param {common.IAuditTrailEntry} m AuditTrailEntry message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AuditTrailEntry.encode = function encode(m, w) {
      if (!w) w = $Writer.create();
      if (m.createdOn != null && Object.hasOwnProperty.call(m, "createdOn"))
        $root.google.protobuf.Timestamp.encode(
          m.createdOn,
          w.uint32(10).fork()
        ).ldelim();
      if (m.createdBy != null && Object.hasOwnProperty.call(m, "createdBy"))
        w.uint32(18).string(m.createdBy);
      if (m.details != null && m.details.length) {
        for (var i = 0; i < m.details.length; ++i)
          $root.common.AuditTrailEntry.AuditTrailEntryDetail.encode(
            m.details[i],
            w.uint32(26).fork()
          ).ldelim();
      }
      return w;
    };

    /**
     * Decodes an AuditTrailEntry message from the specified reader or buffer.
     * @function decode
     * @memberof common.AuditTrailEntry
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {common.AuditTrailEntry} AuditTrailEntry
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AuditTrailEntry.decode = function decode(r, l) {
      if (!(r instanceof $Reader)) r = $Reader.create(r);
      var c = l === undefined ? r.len : r.pos + l,
        m = new $root.common.AuditTrailEntry();
      while (r.pos < c) {
        var t = r.uint32();
        switch (t >>> 3) {
          case 1:
            m.createdOn = $root.google.protobuf.Timestamp.decode(r, r.uint32());
            break;
          case 2:
            m.createdBy = r.string();
            break;
          case 3:
            if (!(m.details && m.details.length)) m.details = [];
            m.details.push(
              $root.common.AuditTrailEntry.AuditTrailEntryDetail.decode(
                r,
                r.uint32()
              )
            );
            break;
          default:
            r.skipType(t & 7);
            break;
        }
      }
      return m;
    };

    AuditTrailEntry.AuditTrailEntryDetail = (function () {
      /**
       * Properties of an AuditTrailEntryDetail.
       * @memberof common.AuditTrailEntry
       * @interface IAuditTrailEntryDetail
       * @property {string|null} [type] AuditTrailEntryDetail type
       * @property {Object.<string,string>|null} [old] AuditTrailEntryDetail old
       * @property {Object.<string,string>|null} ["new"] AuditTrailEntryDetail new
       */

      /**
       * Constructs a new AuditTrailEntryDetail.
       * @memberof common.AuditTrailEntry
       * @classdesc Represents an AuditTrailEntryDetail.
       * @implements IAuditTrailEntryDetail
       * @constructor
       * @param {common.AuditTrailEntry.IAuditTrailEntryDetail=} [p] Properties to set
       */
      function AuditTrailEntryDetail(p) {
        this.old = {};
        this["new"] = {};
        if (p)
          for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
            if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
      }

      /**
       * AuditTrailEntryDetail type.
       * @member {string} type
       * @memberof common.AuditTrailEntry.AuditTrailEntryDetail
       * @instance
       */
      AuditTrailEntryDetail.prototype.type = "";

      /**
       * AuditTrailEntryDetail old.
       * @member {Object.<string,string>} old
       * @memberof common.AuditTrailEntry.AuditTrailEntryDetail
       * @instance
       */
      AuditTrailEntryDetail.prototype.old = $util.emptyObject;

      /**
       * AuditTrailEntryDetail new.
       * @member {Object.<string,string>} new
       * @memberof common.AuditTrailEntry.AuditTrailEntryDetail
       * @instance
       */
      AuditTrailEntryDetail.prototype["new"] = $util.emptyObject;

      /**
       * Creates a new AuditTrailEntryDetail instance using the specified properties.
       * @function create
       * @memberof common.AuditTrailEntry.AuditTrailEntryDetail
       * @static
       * @param {common.AuditTrailEntry.IAuditTrailEntryDetail=} [properties] Properties to set
       * @returns {common.AuditTrailEntry.AuditTrailEntryDetail} AuditTrailEntryDetail instance
       */
      AuditTrailEntryDetail.create = function create(properties) {
        return new AuditTrailEntryDetail(properties);
      };

      /**
       * Encodes the specified AuditTrailEntryDetail message. Does not implicitly {@link common.AuditTrailEntry.AuditTrailEntryDetail.verify|verify} messages.
       * @function encode
       * @memberof common.AuditTrailEntry.AuditTrailEntryDetail
       * @static
       * @param {common.AuditTrailEntry.IAuditTrailEntryDetail} m AuditTrailEntryDetail message or plain object to encode
       * @param {$protobuf.Writer} [w] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      AuditTrailEntryDetail.encode = function encode(m, w) {
        if (!w) w = $Writer.create();
        if (m.type != null && Object.hasOwnProperty.call(m, "type"))
          w.uint32(10).string(m.type);
        if (m.old != null && Object.hasOwnProperty.call(m, "old")) {
          for (var ks = Object.keys(m.old), i = 0; i < ks.length; ++i) {
            w.uint32(18)
              .fork()
              .uint32(10)
              .string(ks[i])
              .uint32(18)
              .string(m.old[ks[i]])
              .ldelim();
          }
        }
        if (m["new"] != null && Object.hasOwnProperty.call(m, "new")) {
          for (var ks = Object.keys(m["new"]), i = 0; i < ks.length; ++i) {
            w.uint32(26)
              .fork()
              .uint32(10)
              .string(ks[i])
              .uint32(18)
              .string(m["new"][ks[i]])
              .ldelim();
          }
        }
        return w;
      };

      /**
       * Decodes an AuditTrailEntryDetail message from the specified reader or buffer.
       * @function decode
       * @memberof common.AuditTrailEntry.AuditTrailEntryDetail
       * @static
       * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
       * @param {number} [l] Message length if known beforehand
       * @returns {common.AuditTrailEntry.AuditTrailEntryDetail} AuditTrailEntryDetail
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      AuditTrailEntryDetail.decode = function decode(r, l) {
        if (!(r instanceof $Reader)) r = $Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l,
          m = new $root.common.AuditTrailEntry.AuditTrailEntryDetail(),
          k;
        while (r.pos < c) {
          var t = r.uint32();
          switch (t >>> 3) {
            case 1:
              m.type = r.string();
              break;
            case 2:
              r.skip().pos++;
              if (m.old === $util.emptyObject) m.old = {};
              k = r.string();
              r.pos++;
              m.old[k] = r.string();
              break;
            case 3:
              r.skip().pos++;
              if (m["new"] === $util.emptyObject) m["new"] = {};
              k = r.string();
              r.pos++;
              m["new"][k] = r.string();
              break;
            default:
              r.skipType(t & 7);
              break;
          }
        }
        return m;
      };

      return AuditTrailEntryDetail;
    })();

    return AuditTrailEntry;
  })();

  return common;
})());

export const google = ($root.google = (() => {
  /**
   * Namespace google.
   * @exports google
   * @namespace
   */
  const google = {};

  google.protobuf = (function () {
    /**
     * Namespace protobuf.
     * @memberof google
     * @namespace
     */
    const protobuf = {};

    protobuf.FileDescriptorSet = (function () {
      /**
       * Properties of a FileDescriptorSet.
       * @memberof google.protobuf
       * @interface IFileDescriptorSet
       * @property {Array.<google.protobuf.IFileDescriptorProto>|null} [file] FileDescriptorSet file
       */

      /**
       * Constructs a new FileDescriptorSet.
       * @memberof google.protobuf
       * @classdesc Represents a FileDescriptorSet.
       * @implements IFileDescriptorSet
       * @constructor
       * @param {google.protobuf.IFileDescriptorSet=} [p] Properties to set
       */
      function FileDescriptorSet(p) {
        this.file = [];
        if (p)
          for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
            if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
      }

      /**
       * FileDescriptorSet file.
       * @member {Array.<google.protobuf.IFileDescriptorProto>} file
       * @memberof google.protobuf.FileDescriptorSet
       * @instance
       */
      FileDescriptorSet.prototype.file = $util.emptyArray;

      /**
       * Creates a new FileDescriptorSet instance using the specified properties.
       * @function create
       * @memberof google.protobuf.FileDescriptorSet
       * @static
       * @param {google.protobuf.IFileDescriptorSet=} [properties] Properties to set
       * @returns {google.protobuf.FileDescriptorSet} FileDescriptorSet instance
       */
      FileDescriptorSet.create = function create(properties) {
        return new FileDescriptorSet(properties);
      };

      /**
       * Encodes the specified FileDescriptorSet message. Does not implicitly {@link google.protobuf.FileDescriptorSet.verify|verify} messages.
       * @function encode
       * @memberof google.protobuf.FileDescriptorSet
       * @static
       * @param {google.protobuf.IFileDescriptorSet} m FileDescriptorSet message or plain object to encode
       * @param {$protobuf.Writer} [w] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      FileDescriptorSet.encode = function encode(m, w) {
        if (!w) w = $Writer.create();
        if (m.file != null && m.file.length) {
          for (var i = 0; i < m.file.length; ++i)
            $root.google.protobuf.FileDescriptorProto.encode(
              m.file[i],
              w.uint32(10).fork()
            ).ldelim();
        }
        return w;
      };

      /**
       * Decodes a FileDescriptorSet message from the specified reader or buffer.
       * @function decode
       * @memberof google.protobuf.FileDescriptorSet
       * @static
       * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
       * @param {number} [l] Message length if known beforehand
       * @returns {google.protobuf.FileDescriptorSet} FileDescriptorSet
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      FileDescriptorSet.decode = function decode(r, l) {
        if (!(r instanceof $Reader)) r = $Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l,
          m = new $root.google.protobuf.FileDescriptorSet();
        while (r.pos < c) {
          var t = r.uint32();
          switch (t >>> 3) {
            case 1:
              if (!(m.file && m.file.length)) m.file = [];
              m.file.push(
                $root.google.protobuf.FileDescriptorProto.decode(r, r.uint32())
              );
              break;
            default:
              r.skipType(t & 7);
              break;
          }
        }
        return m;
      };

      return FileDescriptorSet;
    })();

    protobuf.FileDescriptorProto = (function () {
      /**
       * Properties of a FileDescriptorProto.
       * @memberof google.protobuf
       * @interface IFileDescriptorProto
       * @property {string|null} [name] FileDescriptorProto name
       * @property {string|null} ["package"] FileDescriptorProto package
       * @property {Array.<string>|null} [dependency] FileDescriptorProto dependency
       * @property {Array.<number>|null} [publicDependency] FileDescriptorProto publicDependency
       * @property {Array.<number>|null} [weakDependency] FileDescriptorProto weakDependency
       * @property {Array.<google.protobuf.IDescriptorProto>|null} [messageType] FileDescriptorProto messageType
       * @property {Array.<google.protobuf.IEnumDescriptorProto>|null} [enumType] FileDescriptorProto enumType
       * @property {Array.<google.protobuf.IServiceDescriptorProto>|null} [service] FileDescriptorProto service
       * @property {Array.<google.protobuf.IFieldDescriptorProto>|null} [extension] FileDescriptorProto extension
       * @property {google.protobuf.IFileOptions|null} [options] FileDescriptorProto options
       * @property {google.protobuf.ISourceCodeInfo|null} [sourceCodeInfo] FileDescriptorProto sourceCodeInfo
       * @property {string|null} [syntax] FileDescriptorProto syntax
       */

      /**
       * Constructs a new FileDescriptorProto.
       * @memberof google.protobuf
       * @classdesc Represents a FileDescriptorProto.
       * @implements IFileDescriptorProto
       * @constructor
       * @param {google.protobuf.IFileDescriptorProto=} [p] Properties to set
       */
      function FileDescriptorProto(p) {
        this.dependency = [];
        this.publicDependency = [];
        this.weakDependency = [];
        this.messageType = [];
        this.enumType = [];
        this.service = [];
        this.extension = [];
        if (p)
          for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
            if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
      }

      /**
       * FileDescriptorProto name.
       * @member {string} name
       * @memberof google.protobuf.FileDescriptorProto
       * @instance
       */
      FileDescriptorProto.prototype.name = "";

      /**
       * FileDescriptorProto package.
       * @member {string} package
       * @memberof google.protobuf.FileDescriptorProto
       * @instance
       */
      FileDescriptorProto.prototype["package"] = "";

      /**
       * FileDescriptorProto dependency.
       * @member {Array.<string>} dependency
       * @memberof google.protobuf.FileDescriptorProto
       * @instance
       */
      FileDescriptorProto.prototype.dependency = $util.emptyArray;

      /**
       * FileDescriptorProto publicDependency.
       * @member {Array.<number>} publicDependency
       * @memberof google.protobuf.FileDescriptorProto
       * @instance
       */
      FileDescriptorProto.prototype.publicDependency = $util.emptyArray;

      /**
       * FileDescriptorProto weakDependency.
       * @member {Array.<number>} weakDependency
       * @memberof google.protobuf.FileDescriptorProto
       * @instance
       */
      FileDescriptorProto.prototype.weakDependency = $util.emptyArray;

      /**
       * FileDescriptorProto messageType.
       * @member {Array.<google.protobuf.IDescriptorProto>} messageType
       * @memberof google.protobuf.FileDescriptorProto
       * @instance
       */
      FileDescriptorProto.prototype.messageType = $util.emptyArray;

      /**
       * FileDescriptorProto enumType.
       * @member {Array.<google.protobuf.IEnumDescriptorProto>} enumType
       * @memberof google.protobuf.FileDescriptorProto
       * @instance
       */
      FileDescriptorProto.prototype.enumType = $util.emptyArray;

      /**
       * FileDescriptorProto service.
       * @member {Array.<google.protobuf.IServiceDescriptorProto>} service
       * @memberof google.protobuf.FileDescriptorProto
       * @instance
       */
      FileDescriptorProto.prototype.service = $util.emptyArray;

      /**
       * FileDescriptorProto extension.
       * @member {Array.<google.protobuf.IFieldDescriptorProto>} extension
       * @memberof google.protobuf.FileDescriptorProto
       * @instance
       */
      FileDescriptorProto.prototype.extension = $util.emptyArray;

      /**
       * FileDescriptorProto options.
       * @member {google.protobuf.IFileOptions|null|undefined} options
       * @memberof google.protobuf.FileDescriptorProto
       * @instance
       */
      FileDescriptorProto.prototype.options = null;

      /**
       * FileDescriptorProto sourceCodeInfo.
       * @member {google.protobuf.ISourceCodeInfo|null|undefined} sourceCodeInfo
       * @memberof google.protobuf.FileDescriptorProto
       * @instance
       */
      FileDescriptorProto.prototype.sourceCodeInfo = null;

      /**
       * FileDescriptorProto syntax.
       * @member {string} syntax
       * @memberof google.protobuf.FileDescriptorProto
       * @instance
       */
      FileDescriptorProto.prototype.syntax = "";

      /**
       * Creates a new FileDescriptorProto instance using the specified properties.
       * @function create
       * @memberof google.protobuf.FileDescriptorProto
       * @static
       * @param {google.protobuf.IFileDescriptorProto=} [properties] Properties to set
       * @returns {google.protobuf.FileDescriptorProto} FileDescriptorProto instance
       */
      FileDescriptorProto.create = function create(properties) {
        return new FileDescriptorProto(properties);
      };

      /**
       * Encodes the specified FileDescriptorProto message. Does not implicitly {@link google.protobuf.FileDescriptorProto.verify|verify} messages.
       * @function encode
       * @memberof google.protobuf.FileDescriptorProto
       * @static
       * @param {google.protobuf.IFileDescriptorProto} m FileDescriptorProto message or plain object to encode
       * @param {$protobuf.Writer} [w] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      FileDescriptorProto.encode = function encode(m, w) {
        if (!w) w = $Writer.create();
        if (m.name != null && Object.hasOwnProperty.call(m, "name"))
          w.uint32(10).string(m.name);
        if (m["package"] != null && Object.hasOwnProperty.call(m, "package"))
          w.uint32(18).string(m["package"]);
        if (m.dependency != null && m.dependency.length) {
          for (var i = 0; i < m.dependency.length; ++i)
            w.uint32(26).string(m.dependency[i]);
        }
        if (m.messageType != null && m.messageType.length) {
          for (var i = 0; i < m.messageType.length; ++i)
            $root.google.protobuf.DescriptorProto.encode(
              m.messageType[i],
              w.uint32(34).fork()
            ).ldelim();
        }
        if (m.enumType != null && m.enumType.length) {
          for (var i = 0; i < m.enumType.length; ++i)
            $root.google.protobuf.EnumDescriptorProto.encode(
              m.enumType[i],
              w.uint32(42).fork()
            ).ldelim();
        }
        if (m.service != null && m.service.length) {
          for (var i = 0; i < m.service.length; ++i)
            $root.google.protobuf.ServiceDescriptorProto.encode(
              m.service[i],
              w.uint32(50).fork()
            ).ldelim();
        }
        if (m.extension != null && m.extension.length) {
          for (var i = 0; i < m.extension.length; ++i)
            $root.google.protobuf.FieldDescriptorProto.encode(
              m.extension[i],
              w.uint32(58).fork()
            ).ldelim();
        }
        if (m.options != null && Object.hasOwnProperty.call(m, "options"))
          $root.google.protobuf.FileOptions.encode(
            m.options,
            w.uint32(66).fork()
          ).ldelim();
        if (
          m.sourceCodeInfo != null &&
          Object.hasOwnProperty.call(m, "sourceCodeInfo")
        )
          $root.google.protobuf.SourceCodeInfo.encode(
            m.sourceCodeInfo,
            w.uint32(74).fork()
          ).ldelim();
        if (m.publicDependency != null && m.publicDependency.length) {
          for (var i = 0; i < m.publicDependency.length; ++i)
            w.uint32(80).int32(m.publicDependency[i]);
        }
        if (m.weakDependency != null && m.weakDependency.length) {
          for (var i = 0; i < m.weakDependency.length; ++i)
            w.uint32(88).int32(m.weakDependency[i]);
        }
        if (m.syntax != null && Object.hasOwnProperty.call(m, "syntax"))
          w.uint32(98).string(m.syntax);
        return w;
      };

      /**
       * Decodes a FileDescriptorProto message from the specified reader or buffer.
       * @function decode
       * @memberof google.protobuf.FileDescriptorProto
       * @static
       * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
       * @param {number} [l] Message length if known beforehand
       * @returns {google.protobuf.FileDescriptorProto} FileDescriptorProto
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      FileDescriptorProto.decode = function decode(r, l) {
        if (!(r instanceof $Reader)) r = $Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l,
          m = new $root.google.protobuf.FileDescriptorProto();
        while (r.pos < c) {
          var t = r.uint32();
          switch (t >>> 3) {
            case 1:
              m.name = r.string();
              break;
            case 2:
              m["package"] = r.string();
              break;
            case 3:
              if (!(m.dependency && m.dependency.length)) m.dependency = [];
              m.dependency.push(r.string());
              break;
            case 10:
              if (!(m.publicDependency && m.publicDependency.length))
                m.publicDependency = [];
              if ((t & 7) === 2) {
                var c2 = r.uint32() + r.pos;
                while (r.pos < c2) m.publicDependency.push(r.int32());
              } else m.publicDependency.push(r.int32());
              break;
            case 11:
              if (!(m.weakDependency && m.weakDependency.length))
                m.weakDependency = [];
              if ((t & 7) === 2) {
                var c2 = r.uint32() + r.pos;
                while (r.pos < c2) m.weakDependency.push(r.int32());
              } else m.weakDependency.push(r.int32());
              break;
            case 4:
              if (!(m.messageType && m.messageType.length)) m.messageType = [];
              m.messageType.push(
                $root.google.protobuf.DescriptorProto.decode(r, r.uint32())
              );
              break;
            case 5:
              if (!(m.enumType && m.enumType.length)) m.enumType = [];
              m.enumType.push(
                $root.google.protobuf.EnumDescriptorProto.decode(r, r.uint32())
              );
              break;
            case 6:
              if (!(m.service && m.service.length)) m.service = [];
              m.service.push(
                $root.google.protobuf.ServiceDescriptorProto.decode(
                  r,
                  r.uint32()
                )
              );
              break;
            case 7:
              if (!(m.extension && m.extension.length)) m.extension = [];
              m.extension.push(
                $root.google.protobuf.FieldDescriptorProto.decode(r, r.uint32())
              );
              break;
            case 8:
              m.options = $root.google.protobuf.FileOptions.decode(
                r,
                r.uint32()
              );
              break;
            case 9:
              m.sourceCodeInfo = $root.google.protobuf.SourceCodeInfo.decode(
                r,
                r.uint32()
              );
              break;
            case 12:
              m.syntax = r.string();
              break;
            default:
              r.skipType(t & 7);
              break;
          }
        }
        return m;
      };

      return FileDescriptorProto;
    })();

    protobuf.DescriptorProto = (function () {
      /**
       * Properties of a DescriptorProto.
       * @memberof google.protobuf
       * @interface IDescriptorProto
       * @property {string|null} [name] DescriptorProto name
       * @property {Array.<google.protobuf.IFieldDescriptorProto>|null} [field] DescriptorProto field
       * @property {Array.<google.protobuf.IFieldDescriptorProto>|null} [extension] DescriptorProto extension
       * @property {Array.<google.protobuf.IDescriptorProto>|null} [nestedType] DescriptorProto nestedType
       * @property {Array.<google.protobuf.IEnumDescriptorProto>|null} [enumType] DescriptorProto enumType
       * @property {Array.<google.protobuf.DescriptorProto.IExtensionRange>|null} [extensionRange] DescriptorProto extensionRange
       * @property {Array.<google.protobuf.IOneofDescriptorProto>|null} [oneofDecl] DescriptorProto oneofDecl
       * @property {google.protobuf.IMessageOptions|null} [options] DescriptorProto options
       * @property {Array.<google.protobuf.DescriptorProto.IReservedRange>|null} [reservedRange] DescriptorProto reservedRange
       * @property {Array.<string>|null} [reservedName] DescriptorProto reservedName
       */

      /**
       * Constructs a new DescriptorProto.
       * @memberof google.protobuf
       * @classdesc Represents a DescriptorProto.
       * @implements IDescriptorProto
       * @constructor
       * @param {google.protobuf.IDescriptorProto=} [p] Properties to set
       */
      function DescriptorProto(p) {
        this.field = [];
        this.extension = [];
        this.nestedType = [];
        this.enumType = [];
        this.extensionRange = [];
        this.oneofDecl = [];
        this.reservedRange = [];
        this.reservedName = [];
        if (p)
          for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
            if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
      }

      /**
       * DescriptorProto name.
       * @member {string} name
       * @memberof google.protobuf.DescriptorProto
       * @instance
       */
      DescriptorProto.prototype.name = "";

      /**
       * DescriptorProto field.
       * @member {Array.<google.protobuf.IFieldDescriptorProto>} field
       * @memberof google.protobuf.DescriptorProto
       * @instance
       */
      DescriptorProto.prototype.field = $util.emptyArray;

      /**
       * DescriptorProto extension.
       * @member {Array.<google.protobuf.IFieldDescriptorProto>} extension
       * @memberof google.protobuf.DescriptorProto
       * @instance
       */
      DescriptorProto.prototype.extension = $util.emptyArray;

      /**
       * DescriptorProto nestedType.
       * @member {Array.<google.protobuf.IDescriptorProto>} nestedType
       * @memberof google.protobuf.DescriptorProto
       * @instance
       */
      DescriptorProto.prototype.nestedType = $util.emptyArray;

      /**
       * DescriptorProto enumType.
       * @member {Array.<google.protobuf.IEnumDescriptorProto>} enumType
       * @memberof google.protobuf.DescriptorProto
       * @instance
       */
      DescriptorProto.prototype.enumType = $util.emptyArray;

      /**
       * DescriptorProto extensionRange.
       * @member {Array.<google.protobuf.DescriptorProto.IExtensionRange>} extensionRange
       * @memberof google.protobuf.DescriptorProto
       * @instance
       */
      DescriptorProto.prototype.extensionRange = $util.emptyArray;

      /**
       * DescriptorProto oneofDecl.
       * @member {Array.<google.protobuf.IOneofDescriptorProto>} oneofDecl
       * @memberof google.protobuf.DescriptorProto
       * @instance
       */
      DescriptorProto.prototype.oneofDecl = $util.emptyArray;

      /**
       * DescriptorProto options.
       * @member {google.protobuf.IMessageOptions|null|undefined} options
       * @memberof google.protobuf.DescriptorProto
       * @instance
       */
      DescriptorProto.prototype.options = null;

      /**
       * DescriptorProto reservedRange.
       * @member {Array.<google.protobuf.DescriptorProto.IReservedRange>} reservedRange
       * @memberof google.protobuf.DescriptorProto
       * @instance
       */
      DescriptorProto.prototype.reservedRange = $util.emptyArray;

      /**
       * DescriptorProto reservedName.
       * @member {Array.<string>} reservedName
       * @memberof google.protobuf.DescriptorProto
       * @instance
       */
      DescriptorProto.prototype.reservedName = $util.emptyArray;

      /**
       * Creates a new DescriptorProto instance using the specified properties.
       * @function create
       * @memberof google.protobuf.DescriptorProto
       * @static
       * @param {google.protobuf.IDescriptorProto=} [properties] Properties to set
       * @returns {google.protobuf.DescriptorProto} DescriptorProto instance
       */
      DescriptorProto.create = function create(properties) {
        return new DescriptorProto(properties);
      };

      /**
       * Encodes the specified DescriptorProto message. Does not implicitly {@link google.protobuf.DescriptorProto.verify|verify} messages.
       * @function encode
       * @memberof google.protobuf.DescriptorProto
       * @static
       * @param {google.protobuf.IDescriptorProto} m DescriptorProto message or plain object to encode
       * @param {$protobuf.Writer} [w] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      DescriptorProto.encode = function encode(m, w) {
        if (!w) w = $Writer.create();
        if (m.name != null && Object.hasOwnProperty.call(m, "name"))
          w.uint32(10).string(m.name);
        if (m.field != null && m.field.length) {
          for (var i = 0; i < m.field.length; ++i)
            $root.google.protobuf.FieldDescriptorProto.encode(
              m.field[i],
              w.uint32(18).fork()
            ).ldelim();
        }
        if (m.nestedType != null && m.nestedType.length) {
          for (var i = 0; i < m.nestedType.length; ++i)
            $root.google.protobuf.DescriptorProto.encode(
              m.nestedType[i],
              w.uint32(26).fork()
            ).ldelim();
        }
        if (m.enumType != null && m.enumType.length) {
          for (var i = 0; i < m.enumType.length; ++i)
            $root.google.protobuf.EnumDescriptorProto.encode(
              m.enumType[i],
              w.uint32(34).fork()
            ).ldelim();
        }
        if (m.extensionRange != null && m.extensionRange.length) {
          for (var i = 0; i < m.extensionRange.length; ++i)
            $root.google.protobuf.DescriptorProto.ExtensionRange.encode(
              m.extensionRange[i],
              w.uint32(42).fork()
            ).ldelim();
        }
        if (m.extension != null && m.extension.length) {
          for (var i = 0; i < m.extension.length; ++i)
            $root.google.protobuf.FieldDescriptorProto.encode(
              m.extension[i],
              w.uint32(50).fork()
            ).ldelim();
        }
        if (m.options != null && Object.hasOwnProperty.call(m, "options"))
          $root.google.protobuf.MessageOptions.encode(
            m.options,
            w.uint32(58).fork()
          ).ldelim();
        if (m.oneofDecl != null && m.oneofDecl.length) {
          for (var i = 0; i < m.oneofDecl.length; ++i)
            $root.google.protobuf.OneofDescriptorProto.encode(
              m.oneofDecl[i],
              w.uint32(66).fork()
            ).ldelim();
        }
        if (m.reservedRange != null && m.reservedRange.length) {
          for (var i = 0; i < m.reservedRange.length; ++i)
            $root.google.protobuf.DescriptorProto.ReservedRange.encode(
              m.reservedRange[i],
              w.uint32(74).fork()
            ).ldelim();
        }
        if (m.reservedName != null && m.reservedName.length) {
          for (var i = 0; i < m.reservedName.length; ++i)
            w.uint32(82).string(m.reservedName[i]);
        }
        return w;
      };

      /**
       * Decodes a DescriptorProto message from the specified reader or buffer.
       * @function decode
       * @memberof google.protobuf.DescriptorProto
       * @static
       * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
       * @param {number} [l] Message length if known beforehand
       * @returns {google.protobuf.DescriptorProto} DescriptorProto
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      DescriptorProto.decode = function decode(r, l) {
        if (!(r instanceof $Reader)) r = $Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l,
          m = new $root.google.protobuf.DescriptorProto();
        while (r.pos < c) {
          var t = r.uint32();
          switch (t >>> 3) {
            case 1:
              m.name = r.string();
              break;
            case 2:
              if (!(m.field && m.field.length)) m.field = [];
              m.field.push(
                $root.google.protobuf.FieldDescriptorProto.decode(r, r.uint32())
              );
              break;
            case 6:
              if (!(m.extension && m.extension.length)) m.extension = [];
              m.extension.push(
                $root.google.protobuf.FieldDescriptorProto.decode(r, r.uint32())
              );
              break;
            case 3:
              if (!(m.nestedType && m.nestedType.length)) m.nestedType = [];
              m.nestedType.push(
                $root.google.protobuf.DescriptorProto.decode(r, r.uint32())
              );
              break;
            case 4:
              if (!(m.enumType && m.enumType.length)) m.enumType = [];
              m.enumType.push(
                $root.google.protobuf.EnumDescriptorProto.decode(r, r.uint32())
              );
              break;
            case 5:
              if (!(m.extensionRange && m.extensionRange.length))
                m.extensionRange = [];
              m.extensionRange.push(
                $root.google.protobuf.DescriptorProto.ExtensionRange.decode(
                  r,
                  r.uint32()
                )
              );
              break;
            case 8:
              if (!(m.oneofDecl && m.oneofDecl.length)) m.oneofDecl = [];
              m.oneofDecl.push(
                $root.google.protobuf.OneofDescriptorProto.decode(r, r.uint32())
              );
              break;
            case 7:
              m.options = $root.google.protobuf.MessageOptions.decode(
                r,
                r.uint32()
              );
              break;
            case 9:
              if (!(m.reservedRange && m.reservedRange.length))
                m.reservedRange = [];
              m.reservedRange.push(
                $root.google.protobuf.DescriptorProto.ReservedRange.decode(
                  r,
                  r.uint32()
                )
              );
              break;
            case 10:
              if (!(m.reservedName && m.reservedName.length))
                m.reservedName = [];
              m.reservedName.push(r.string());
              break;
            default:
              r.skipType(t & 7);
              break;
          }
        }
        return m;
      };

      DescriptorProto.ExtensionRange = (function () {
        /**
         * Properties of an ExtensionRange.
         * @memberof google.protobuf.DescriptorProto
         * @interface IExtensionRange
         * @property {number|null} [start] ExtensionRange start
         * @property {number|null} [end] ExtensionRange end
         */

        /**
         * Constructs a new ExtensionRange.
         * @memberof google.protobuf.DescriptorProto
         * @classdesc Represents an ExtensionRange.
         * @implements IExtensionRange
         * @constructor
         * @param {google.protobuf.DescriptorProto.IExtensionRange=} [p] Properties to set
         */
        function ExtensionRange(p) {
          if (p)
            for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
              if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
        }

        /**
         * ExtensionRange start.
         * @member {number} start
         * @memberof google.protobuf.DescriptorProto.ExtensionRange
         * @instance
         */
        ExtensionRange.prototype.start = 0;

        /**
         * ExtensionRange end.
         * @member {number} end
         * @memberof google.protobuf.DescriptorProto.ExtensionRange
         * @instance
         */
        ExtensionRange.prototype.end = 0;

        /**
         * Creates a new ExtensionRange instance using the specified properties.
         * @function create
         * @memberof google.protobuf.DescriptorProto.ExtensionRange
         * @static
         * @param {google.protobuf.DescriptorProto.IExtensionRange=} [properties] Properties to set
         * @returns {google.protobuf.DescriptorProto.ExtensionRange} ExtensionRange instance
         */
        ExtensionRange.create = function create(properties) {
          return new ExtensionRange(properties);
        };

        /**
         * Encodes the specified ExtensionRange message. Does not implicitly {@link google.protobuf.DescriptorProto.ExtensionRange.verify|verify} messages.
         * @function encode
         * @memberof google.protobuf.DescriptorProto.ExtensionRange
         * @static
         * @param {google.protobuf.DescriptorProto.IExtensionRange} m ExtensionRange message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ExtensionRange.encode = function encode(m, w) {
          if (!w) w = $Writer.create();
          if (m.start != null && Object.hasOwnProperty.call(m, "start"))
            w.uint32(8).int32(m.start);
          if (m.end != null && Object.hasOwnProperty.call(m, "end"))
            w.uint32(16).int32(m.end);
          return w;
        };

        /**
         * Decodes an ExtensionRange message from the specified reader or buffer.
         * @function decode
         * @memberof google.protobuf.DescriptorProto.ExtensionRange
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {google.protobuf.DescriptorProto.ExtensionRange} ExtensionRange
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ExtensionRange.decode = function decode(r, l) {
          if (!(r instanceof $Reader)) r = $Reader.create(r);
          var c = l === undefined ? r.len : r.pos + l,
            m = new $root.google.protobuf.DescriptorProto.ExtensionRange();
          while (r.pos < c) {
            var t = r.uint32();
            switch (t >>> 3) {
              case 1:
                m.start = r.int32();
                break;
              case 2:
                m.end = r.int32();
                break;
              default:
                r.skipType(t & 7);
                break;
            }
          }
          return m;
        };

        return ExtensionRange;
      })();

      DescriptorProto.ReservedRange = (function () {
        /**
         * Properties of a ReservedRange.
         * @memberof google.protobuf.DescriptorProto
         * @interface IReservedRange
         * @property {number|null} [start] ReservedRange start
         * @property {number|null} [end] ReservedRange end
         */

        /**
         * Constructs a new ReservedRange.
         * @memberof google.protobuf.DescriptorProto
         * @classdesc Represents a ReservedRange.
         * @implements IReservedRange
         * @constructor
         * @param {google.protobuf.DescriptorProto.IReservedRange=} [p] Properties to set
         */
        function ReservedRange(p) {
          if (p)
            for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
              if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
        }

        /**
         * ReservedRange start.
         * @member {number} start
         * @memberof google.protobuf.DescriptorProto.ReservedRange
         * @instance
         */
        ReservedRange.prototype.start = 0;

        /**
         * ReservedRange end.
         * @member {number} end
         * @memberof google.protobuf.DescriptorProto.ReservedRange
         * @instance
         */
        ReservedRange.prototype.end = 0;

        /**
         * Creates a new ReservedRange instance using the specified properties.
         * @function create
         * @memberof google.protobuf.DescriptorProto.ReservedRange
         * @static
         * @param {google.protobuf.DescriptorProto.IReservedRange=} [properties] Properties to set
         * @returns {google.protobuf.DescriptorProto.ReservedRange} ReservedRange instance
         */
        ReservedRange.create = function create(properties) {
          return new ReservedRange(properties);
        };

        /**
         * Encodes the specified ReservedRange message. Does not implicitly {@link google.protobuf.DescriptorProto.ReservedRange.verify|verify} messages.
         * @function encode
         * @memberof google.protobuf.DescriptorProto.ReservedRange
         * @static
         * @param {google.protobuf.DescriptorProto.IReservedRange} m ReservedRange message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReservedRange.encode = function encode(m, w) {
          if (!w) w = $Writer.create();
          if (m.start != null && Object.hasOwnProperty.call(m, "start"))
            w.uint32(8).int32(m.start);
          if (m.end != null && Object.hasOwnProperty.call(m, "end"))
            w.uint32(16).int32(m.end);
          return w;
        };

        /**
         * Decodes a ReservedRange message from the specified reader or buffer.
         * @function decode
         * @memberof google.protobuf.DescriptorProto.ReservedRange
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {google.protobuf.DescriptorProto.ReservedRange} ReservedRange
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReservedRange.decode = function decode(r, l) {
          if (!(r instanceof $Reader)) r = $Reader.create(r);
          var c = l === undefined ? r.len : r.pos + l,
            m = new $root.google.protobuf.DescriptorProto.ReservedRange();
          while (r.pos < c) {
            var t = r.uint32();
            switch (t >>> 3) {
              case 1:
                m.start = r.int32();
                break;
              case 2:
                m.end = r.int32();
                break;
              default:
                r.skipType(t & 7);
                break;
            }
          }
          return m;
        };

        return ReservedRange;
      })();

      return DescriptorProto;
    })();

    protobuf.FieldDescriptorProto = (function () {
      /**
       * Properties of a FieldDescriptorProto.
       * @memberof google.protobuf
       * @interface IFieldDescriptorProto
       * @property {string|null} [name] FieldDescriptorProto name
       * @property {number|null} [number] FieldDescriptorProto number
       * @property {google.protobuf.FieldDescriptorProto.Label|null} [label] FieldDescriptorProto label
       * @property {google.protobuf.FieldDescriptorProto.Type|null} [type] FieldDescriptorProto type
       * @property {string|null} [typeName] FieldDescriptorProto typeName
       * @property {string|null} [extendee] FieldDescriptorProto extendee
       * @property {string|null} [defaultValue] FieldDescriptorProto defaultValue
       * @property {number|null} [oneofIndex] FieldDescriptorProto oneofIndex
       * @property {string|null} [jsonName] FieldDescriptorProto jsonName
       * @property {google.protobuf.IFieldOptions|null} [options] FieldDescriptorProto options
       */

      /**
       * Constructs a new FieldDescriptorProto.
       * @memberof google.protobuf
       * @classdesc Represents a FieldDescriptorProto.
       * @implements IFieldDescriptorProto
       * @constructor
       * @param {google.protobuf.IFieldDescriptorProto=} [p] Properties to set
       */
      function FieldDescriptorProto(p) {
        if (p)
          for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
            if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
      }

      /**
       * FieldDescriptorProto name.
       * @member {string} name
       * @memberof google.protobuf.FieldDescriptorProto
       * @instance
       */
      FieldDescriptorProto.prototype.name = "";

      /**
       * FieldDescriptorProto number.
       * @member {number} number
       * @memberof google.protobuf.FieldDescriptorProto
       * @instance
       */
      FieldDescriptorProto.prototype.number = 0;

      /**
       * FieldDescriptorProto label.
       * @member {google.protobuf.FieldDescriptorProto.Label} label
       * @memberof google.protobuf.FieldDescriptorProto
       * @instance
       */
      FieldDescriptorProto.prototype.label = 1;

      /**
       * FieldDescriptorProto type.
       * @member {google.protobuf.FieldDescriptorProto.Type} type
       * @memberof google.protobuf.FieldDescriptorProto
       * @instance
       */
      FieldDescriptorProto.prototype.type = 1;

      /**
       * FieldDescriptorProto typeName.
       * @member {string} typeName
       * @memberof google.protobuf.FieldDescriptorProto
       * @instance
       */
      FieldDescriptorProto.prototype.typeName = "";

      /**
       * FieldDescriptorProto extendee.
       * @member {string} extendee
       * @memberof google.protobuf.FieldDescriptorProto
       * @instance
       */
      FieldDescriptorProto.prototype.extendee = "";

      /**
       * FieldDescriptorProto defaultValue.
       * @member {string} defaultValue
       * @memberof google.protobuf.FieldDescriptorProto
       * @instance
       */
      FieldDescriptorProto.prototype.defaultValue = "";

      /**
       * FieldDescriptorProto oneofIndex.
       * @member {number} oneofIndex
       * @memberof google.protobuf.FieldDescriptorProto
       * @instance
       */
      FieldDescriptorProto.prototype.oneofIndex = 0;

      /**
       * FieldDescriptorProto jsonName.
       * @member {string} jsonName
       * @memberof google.protobuf.FieldDescriptorProto
       * @instance
       */
      FieldDescriptorProto.prototype.jsonName = "";

      /**
       * FieldDescriptorProto options.
       * @member {google.protobuf.IFieldOptions|null|undefined} options
       * @memberof google.protobuf.FieldDescriptorProto
       * @instance
       */
      FieldDescriptorProto.prototype.options = null;

      /**
       * Creates a new FieldDescriptorProto instance using the specified properties.
       * @function create
       * @memberof google.protobuf.FieldDescriptorProto
       * @static
       * @param {google.protobuf.IFieldDescriptorProto=} [properties] Properties to set
       * @returns {google.protobuf.FieldDescriptorProto} FieldDescriptorProto instance
       */
      FieldDescriptorProto.create = function create(properties) {
        return new FieldDescriptorProto(properties);
      };

      /**
       * Encodes the specified FieldDescriptorProto message. Does not implicitly {@link google.protobuf.FieldDescriptorProto.verify|verify} messages.
       * @function encode
       * @memberof google.protobuf.FieldDescriptorProto
       * @static
       * @param {google.protobuf.IFieldDescriptorProto} m FieldDescriptorProto message or plain object to encode
       * @param {$protobuf.Writer} [w] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      FieldDescriptorProto.encode = function encode(m, w) {
        if (!w) w = $Writer.create();
        if (m.name != null && Object.hasOwnProperty.call(m, "name"))
          w.uint32(10).string(m.name);
        if (m.extendee != null && Object.hasOwnProperty.call(m, "extendee"))
          w.uint32(18).string(m.extendee);
        if (m.number != null && Object.hasOwnProperty.call(m, "number"))
          w.uint32(24).int32(m.number);
        if (m.label != null && Object.hasOwnProperty.call(m, "label"))
          w.uint32(32).int32(m.label);
        if (m.type != null && Object.hasOwnProperty.call(m, "type"))
          w.uint32(40).int32(m.type);
        if (m.typeName != null && Object.hasOwnProperty.call(m, "typeName"))
          w.uint32(50).string(m.typeName);
        if (
          m.defaultValue != null &&
          Object.hasOwnProperty.call(m, "defaultValue")
        )
          w.uint32(58).string(m.defaultValue);
        if (m.options != null && Object.hasOwnProperty.call(m, "options"))
          $root.google.protobuf.FieldOptions.encode(
            m.options,
            w.uint32(66).fork()
          ).ldelim();
        if (m.oneofIndex != null && Object.hasOwnProperty.call(m, "oneofIndex"))
          w.uint32(72).int32(m.oneofIndex);
        if (m.jsonName != null && Object.hasOwnProperty.call(m, "jsonName"))
          w.uint32(82).string(m.jsonName);
        return w;
      };

      /**
       * Decodes a FieldDescriptorProto message from the specified reader or buffer.
       * @function decode
       * @memberof google.protobuf.FieldDescriptorProto
       * @static
       * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
       * @param {number} [l] Message length if known beforehand
       * @returns {google.protobuf.FieldDescriptorProto} FieldDescriptorProto
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      FieldDescriptorProto.decode = function decode(r, l) {
        if (!(r instanceof $Reader)) r = $Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l,
          m = new $root.google.protobuf.FieldDescriptorProto();
        while (r.pos < c) {
          var t = r.uint32();
          switch (t >>> 3) {
            case 1:
              m.name = r.string();
              break;
            case 3:
              m.number = r.int32();
              break;
            case 4:
              m.label = r.int32();
              break;
            case 5:
              m.type = r.int32();
              break;
            case 6:
              m.typeName = r.string();
              break;
            case 2:
              m.extendee = r.string();
              break;
            case 7:
              m.defaultValue = r.string();
              break;
            case 9:
              m.oneofIndex = r.int32();
              break;
            case 10:
              m.jsonName = r.string();
              break;
            case 8:
              m.options = $root.google.protobuf.FieldOptions.decode(
                r,
                r.uint32()
              );
              break;
            default:
              r.skipType(t & 7);
              break;
          }
        }
        return m;
      };

      /**
       * Type enum.
       * @name google.protobuf.FieldDescriptorProto.Type
       * @enum {number}
       * @property {number} TYPE_DOUBLE=1 TYPE_DOUBLE value
       * @property {number} TYPE_FLOAT=2 TYPE_FLOAT value
       * @property {number} TYPE_INT64=3 TYPE_INT64 value
       * @property {number} TYPE_UINT64=4 TYPE_UINT64 value
       * @property {number} TYPE_INT32=5 TYPE_INT32 value
       * @property {number} TYPE_FIXED64=6 TYPE_FIXED64 value
       * @property {number} TYPE_FIXED32=7 TYPE_FIXED32 value
       * @property {number} TYPE_BOOL=8 TYPE_BOOL value
       * @property {number} TYPE_STRING=9 TYPE_STRING value
       * @property {number} TYPE_GROUP=10 TYPE_GROUP value
       * @property {number} TYPE_MESSAGE=11 TYPE_MESSAGE value
       * @property {number} TYPE_BYTES=12 TYPE_BYTES value
       * @property {number} TYPE_UINT32=13 TYPE_UINT32 value
       * @property {number} TYPE_ENUM=14 TYPE_ENUM value
       * @property {number} TYPE_SFIXED32=15 TYPE_SFIXED32 value
       * @property {number} TYPE_SFIXED64=16 TYPE_SFIXED64 value
       * @property {number} TYPE_SINT32=17 TYPE_SINT32 value
       * @property {number} TYPE_SINT64=18 TYPE_SINT64 value
       */
      FieldDescriptorProto.Type = (function () {
        const valuesById = {},
          values = Object.create(valuesById);
        values[(valuesById[1] = "TYPE_DOUBLE")] = 1;
        values[(valuesById[2] = "TYPE_FLOAT")] = 2;
        values[(valuesById[3] = "TYPE_INT64")] = 3;
        values[(valuesById[4] = "TYPE_UINT64")] = 4;
        values[(valuesById[5] = "TYPE_INT32")] = 5;
        values[(valuesById[6] = "TYPE_FIXED64")] = 6;
        values[(valuesById[7] = "TYPE_FIXED32")] = 7;
        values[(valuesById[8] = "TYPE_BOOL")] = 8;
        values[(valuesById[9] = "TYPE_STRING")] = 9;
        values[(valuesById[10] = "TYPE_GROUP")] = 10;
        values[(valuesById[11] = "TYPE_MESSAGE")] = 11;
        values[(valuesById[12] = "TYPE_BYTES")] = 12;
        values[(valuesById[13] = "TYPE_UINT32")] = 13;
        values[(valuesById[14] = "TYPE_ENUM")] = 14;
        values[(valuesById[15] = "TYPE_SFIXED32")] = 15;
        values[(valuesById[16] = "TYPE_SFIXED64")] = 16;
        values[(valuesById[17] = "TYPE_SINT32")] = 17;
        values[(valuesById[18] = "TYPE_SINT64")] = 18;
        return values;
      })();

      /**
       * Label enum.
       * @name google.protobuf.FieldDescriptorProto.Label
       * @enum {number}
       * @property {number} LABEL_OPTIONAL=1 LABEL_OPTIONAL value
       * @property {number} LABEL_REQUIRED=2 LABEL_REQUIRED value
       * @property {number} LABEL_REPEATED=3 LABEL_REPEATED value
       */
      FieldDescriptorProto.Label = (function () {
        const valuesById = {},
          values = Object.create(valuesById);
        values[(valuesById[1] = "LABEL_OPTIONAL")] = 1;
        values[(valuesById[2] = "LABEL_REQUIRED")] = 2;
        values[(valuesById[3] = "LABEL_REPEATED")] = 3;
        return values;
      })();

      return FieldDescriptorProto;
    })();

    protobuf.OneofDescriptorProto = (function () {
      /**
       * Properties of an OneofDescriptorProto.
       * @memberof google.protobuf
       * @interface IOneofDescriptorProto
       * @property {string|null} [name] OneofDescriptorProto name
       * @property {google.protobuf.IOneofOptions|null} [options] OneofDescriptorProto options
       */

      /**
       * Constructs a new OneofDescriptorProto.
       * @memberof google.protobuf
       * @classdesc Represents an OneofDescriptorProto.
       * @implements IOneofDescriptorProto
       * @constructor
       * @param {google.protobuf.IOneofDescriptorProto=} [p] Properties to set
       */
      function OneofDescriptorProto(p) {
        if (p)
          for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
            if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
      }

      /**
       * OneofDescriptorProto name.
       * @member {string} name
       * @memberof google.protobuf.OneofDescriptorProto
       * @instance
       */
      OneofDescriptorProto.prototype.name = "";

      /**
       * OneofDescriptorProto options.
       * @member {google.protobuf.IOneofOptions|null|undefined} options
       * @memberof google.protobuf.OneofDescriptorProto
       * @instance
       */
      OneofDescriptorProto.prototype.options = null;

      /**
       * Creates a new OneofDescriptorProto instance using the specified properties.
       * @function create
       * @memberof google.protobuf.OneofDescriptorProto
       * @static
       * @param {google.protobuf.IOneofDescriptorProto=} [properties] Properties to set
       * @returns {google.protobuf.OneofDescriptorProto} OneofDescriptorProto instance
       */
      OneofDescriptorProto.create = function create(properties) {
        return new OneofDescriptorProto(properties);
      };

      /**
       * Encodes the specified OneofDescriptorProto message. Does not implicitly {@link google.protobuf.OneofDescriptorProto.verify|verify} messages.
       * @function encode
       * @memberof google.protobuf.OneofDescriptorProto
       * @static
       * @param {google.protobuf.IOneofDescriptorProto} m OneofDescriptorProto message or plain object to encode
       * @param {$protobuf.Writer} [w] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      OneofDescriptorProto.encode = function encode(m, w) {
        if (!w) w = $Writer.create();
        if (m.name != null && Object.hasOwnProperty.call(m, "name"))
          w.uint32(10).string(m.name);
        if (m.options != null && Object.hasOwnProperty.call(m, "options"))
          $root.google.protobuf.OneofOptions.encode(
            m.options,
            w.uint32(18).fork()
          ).ldelim();
        return w;
      };

      /**
       * Decodes an OneofDescriptorProto message from the specified reader or buffer.
       * @function decode
       * @memberof google.protobuf.OneofDescriptorProto
       * @static
       * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
       * @param {number} [l] Message length if known beforehand
       * @returns {google.protobuf.OneofDescriptorProto} OneofDescriptorProto
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      OneofDescriptorProto.decode = function decode(r, l) {
        if (!(r instanceof $Reader)) r = $Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l,
          m = new $root.google.protobuf.OneofDescriptorProto();
        while (r.pos < c) {
          var t = r.uint32();
          switch (t >>> 3) {
            case 1:
              m.name = r.string();
              break;
            case 2:
              m.options = $root.google.protobuf.OneofOptions.decode(
                r,
                r.uint32()
              );
              break;
            default:
              r.skipType(t & 7);
              break;
          }
        }
        return m;
      };

      return OneofDescriptorProto;
    })();

    protobuf.EnumDescriptorProto = (function () {
      /**
       * Properties of an EnumDescriptorProto.
       * @memberof google.protobuf
       * @interface IEnumDescriptorProto
       * @property {string|null} [name] EnumDescriptorProto name
       * @property {Array.<google.protobuf.IEnumValueDescriptorProto>|null} [value] EnumDescriptorProto value
       * @property {google.protobuf.IEnumOptions|null} [options] EnumDescriptorProto options
       */

      /**
       * Constructs a new EnumDescriptorProto.
       * @memberof google.protobuf
       * @classdesc Represents an EnumDescriptorProto.
       * @implements IEnumDescriptorProto
       * @constructor
       * @param {google.protobuf.IEnumDescriptorProto=} [p] Properties to set
       */
      function EnumDescriptorProto(p) {
        this.value = [];
        if (p)
          for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
            if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
      }

      /**
       * EnumDescriptorProto name.
       * @member {string} name
       * @memberof google.protobuf.EnumDescriptorProto
       * @instance
       */
      EnumDescriptorProto.prototype.name = "";

      /**
       * EnumDescriptorProto value.
       * @member {Array.<google.protobuf.IEnumValueDescriptorProto>} value
       * @memberof google.protobuf.EnumDescriptorProto
       * @instance
       */
      EnumDescriptorProto.prototype.value = $util.emptyArray;

      /**
       * EnumDescriptorProto options.
       * @member {google.protobuf.IEnumOptions|null|undefined} options
       * @memberof google.protobuf.EnumDescriptorProto
       * @instance
       */
      EnumDescriptorProto.prototype.options = null;

      /**
       * Creates a new EnumDescriptorProto instance using the specified properties.
       * @function create
       * @memberof google.protobuf.EnumDescriptorProto
       * @static
       * @param {google.protobuf.IEnumDescriptorProto=} [properties] Properties to set
       * @returns {google.protobuf.EnumDescriptorProto} EnumDescriptorProto instance
       */
      EnumDescriptorProto.create = function create(properties) {
        return new EnumDescriptorProto(properties);
      };

      /**
       * Encodes the specified EnumDescriptorProto message. Does not implicitly {@link google.protobuf.EnumDescriptorProto.verify|verify} messages.
       * @function encode
       * @memberof google.protobuf.EnumDescriptorProto
       * @static
       * @param {google.protobuf.IEnumDescriptorProto} m EnumDescriptorProto message or plain object to encode
       * @param {$protobuf.Writer} [w] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      EnumDescriptorProto.encode = function encode(m, w) {
        if (!w) w = $Writer.create();
        if (m.name != null && Object.hasOwnProperty.call(m, "name"))
          w.uint32(10).string(m.name);
        if (m.value != null && m.value.length) {
          for (var i = 0; i < m.value.length; ++i)
            $root.google.protobuf.EnumValueDescriptorProto.encode(
              m.value[i],
              w.uint32(18).fork()
            ).ldelim();
        }
        if (m.options != null && Object.hasOwnProperty.call(m, "options"))
          $root.google.protobuf.EnumOptions.encode(
            m.options,
            w.uint32(26).fork()
          ).ldelim();
        return w;
      };

      /**
       * Decodes an EnumDescriptorProto message from the specified reader or buffer.
       * @function decode
       * @memberof google.protobuf.EnumDescriptorProto
       * @static
       * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
       * @param {number} [l] Message length if known beforehand
       * @returns {google.protobuf.EnumDescriptorProto} EnumDescriptorProto
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      EnumDescriptorProto.decode = function decode(r, l) {
        if (!(r instanceof $Reader)) r = $Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l,
          m = new $root.google.protobuf.EnumDescriptorProto();
        while (r.pos < c) {
          var t = r.uint32();
          switch (t >>> 3) {
            case 1:
              m.name = r.string();
              break;
            case 2:
              if (!(m.value && m.value.length)) m.value = [];
              m.value.push(
                $root.google.protobuf.EnumValueDescriptorProto.decode(
                  r,
                  r.uint32()
                )
              );
              break;
            case 3:
              m.options = $root.google.protobuf.EnumOptions.decode(
                r,
                r.uint32()
              );
              break;
            default:
              r.skipType(t & 7);
              break;
          }
        }
        return m;
      };

      return EnumDescriptorProto;
    })();

    protobuf.EnumValueDescriptorProto = (function () {
      /**
       * Properties of an EnumValueDescriptorProto.
       * @memberof google.protobuf
       * @interface IEnumValueDescriptorProto
       * @property {string|null} [name] EnumValueDescriptorProto name
       * @property {number|null} [number] EnumValueDescriptorProto number
       * @property {google.protobuf.IEnumValueOptions|null} [options] EnumValueDescriptorProto options
       */

      /**
       * Constructs a new EnumValueDescriptorProto.
       * @memberof google.protobuf
       * @classdesc Represents an EnumValueDescriptorProto.
       * @implements IEnumValueDescriptorProto
       * @constructor
       * @param {google.protobuf.IEnumValueDescriptorProto=} [p] Properties to set
       */
      function EnumValueDescriptorProto(p) {
        if (p)
          for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
            if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
      }

      /**
       * EnumValueDescriptorProto name.
       * @member {string} name
       * @memberof google.protobuf.EnumValueDescriptorProto
       * @instance
       */
      EnumValueDescriptorProto.prototype.name = "";

      /**
       * EnumValueDescriptorProto number.
       * @member {number} number
       * @memberof google.protobuf.EnumValueDescriptorProto
       * @instance
       */
      EnumValueDescriptorProto.prototype.number = 0;

      /**
       * EnumValueDescriptorProto options.
       * @member {google.protobuf.IEnumValueOptions|null|undefined} options
       * @memberof google.protobuf.EnumValueDescriptorProto
       * @instance
       */
      EnumValueDescriptorProto.prototype.options = null;

      /**
       * Creates a new EnumValueDescriptorProto instance using the specified properties.
       * @function create
       * @memberof google.protobuf.EnumValueDescriptorProto
       * @static
       * @param {google.protobuf.IEnumValueDescriptorProto=} [properties] Properties to set
       * @returns {google.protobuf.EnumValueDescriptorProto} EnumValueDescriptorProto instance
       */
      EnumValueDescriptorProto.create = function create(properties) {
        return new EnumValueDescriptorProto(properties);
      };

      /**
       * Encodes the specified EnumValueDescriptorProto message. Does not implicitly {@link google.protobuf.EnumValueDescriptorProto.verify|verify} messages.
       * @function encode
       * @memberof google.protobuf.EnumValueDescriptorProto
       * @static
       * @param {google.protobuf.IEnumValueDescriptorProto} m EnumValueDescriptorProto message or plain object to encode
       * @param {$protobuf.Writer} [w] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      EnumValueDescriptorProto.encode = function encode(m, w) {
        if (!w) w = $Writer.create();
        if (m.name != null && Object.hasOwnProperty.call(m, "name"))
          w.uint32(10).string(m.name);
        if (m.number != null && Object.hasOwnProperty.call(m, "number"))
          w.uint32(16).int32(m.number);
        if (m.options != null && Object.hasOwnProperty.call(m, "options"))
          $root.google.protobuf.EnumValueOptions.encode(
            m.options,
            w.uint32(26).fork()
          ).ldelim();
        return w;
      };

      /**
       * Decodes an EnumValueDescriptorProto message from the specified reader or buffer.
       * @function decode
       * @memberof google.protobuf.EnumValueDescriptorProto
       * @static
       * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
       * @param {number} [l] Message length if known beforehand
       * @returns {google.protobuf.EnumValueDescriptorProto} EnumValueDescriptorProto
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      EnumValueDescriptorProto.decode = function decode(r, l) {
        if (!(r instanceof $Reader)) r = $Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l,
          m = new $root.google.protobuf.EnumValueDescriptorProto();
        while (r.pos < c) {
          var t = r.uint32();
          switch (t >>> 3) {
            case 1:
              m.name = r.string();
              break;
            case 2:
              m.number = r.int32();
              break;
            case 3:
              m.options = $root.google.protobuf.EnumValueOptions.decode(
                r,
                r.uint32()
              );
              break;
            default:
              r.skipType(t & 7);
              break;
          }
        }
        return m;
      };

      return EnumValueDescriptorProto;
    })();

    protobuf.ServiceDescriptorProto = (function () {
      /**
       * Properties of a ServiceDescriptorProto.
       * @memberof google.protobuf
       * @interface IServiceDescriptorProto
       * @property {string|null} [name] ServiceDescriptorProto name
       * @property {Array.<google.protobuf.IMethodDescriptorProto>|null} [method] ServiceDescriptorProto method
       * @property {google.protobuf.IServiceOptions|null} [options] ServiceDescriptorProto options
       */

      /**
       * Constructs a new ServiceDescriptorProto.
       * @memberof google.protobuf
       * @classdesc Represents a ServiceDescriptorProto.
       * @implements IServiceDescriptorProto
       * @constructor
       * @param {google.protobuf.IServiceDescriptorProto=} [p] Properties to set
       */
      function ServiceDescriptorProto(p) {
        this.method = [];
        if (p)
          for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
            if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
      }

      /**
       * ServiceDescriptorProto name.
       * @member {string} name
       * @memberof google.protobuf.ServiceDescriptorProto
       * @instance
       */
      ServiceDescriptorProto.prototype.name = "";

      /**
       * ServiceDescriptorProto method.
       * @member {Array.<google.protobuf.IMethodDescriptorProto>} method
       * @memberof google.protobuf.ServiceDescriptorProto
       * @instance
       */
      ServiceDescriptorProto.prototype.method = $util.emptyArray;

      /**
       * ServiceDescriptorProto options.
       * @member {google.protobuf.IServiceOptions|null|undefined} options
       * @memberof google.protobuf.ServiceDescriptorProto
       * @instance
       */
      ServiceDescriptorProto.prototype.options = null;

      /**
       * Creates a new ServiceDescriptorProto instance using the specified properties.
       * @function create
       * @memberof google.protobuf.ServiceDescriptorProto
       * @static
       * @param {google.protobuf.IServiceDescriptorProto=} [properties] Properties to set
       * @returns {google.protobuf.ServiceDescriptorProto} ServiceDescriptorProto instance
       */
      ServiceDescriptorProto.create = function create(properties) {
        return new ServiceDescriptorProto(properties);
      };

      /**
       * Encodes the specified ServiceDescriptorProto message. Does not implicitly {@link google.protobuf.ServiceDescriptorProto.verify|verify} messages.
       * @function encode
       * @memberof google.protobuf.ServiceDescriptorProto
       * @static
       * @param {google.protobuf.IServiceDescriptorProto} m ServiceDescriptorProto message or plain object to encode
       * @param {$protobuf.Writer} [w] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      ServiceDescriptorProto.encode = function encode(m, w) {
        if (!w) w = $Writer.create();
        if (m.name != null && Object.hasOwnProperty.call(m, "name"))
          w.uint32(10).string(m.name);
        if (m.method != null && m.method.length) {
          for (var i = 0; i < m.method.length; ++i)
            $root.google.protobuf.MethodDescriptorProto.encode(
              m.method[i],
              w.uint32(18).fork()
            ).ldelim();
        }
        if (m.options != null && Object.hasOwnProperty.call(m, "options"))
          $root.google.protobuf.ServiceOptions.encode(
            m.options,
            w.uint32(26).fork()
          ).ldelim();
        return w;
      };

      /**
       * Decodes a ServiceDescriptorProto message from the specified reader or buffer.
       * @function decode
       * @memberof google.protobuf.ServiceDescriptorProto
       * @static
       * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
       * @param {number} [l] Message length if known beforehand
       * @returns {google.protobuf.ServiceDescriptorProto} ServiceDescriptorProto
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      ServiceDescriptorProto.decode = function decode(r, l) {
        if (!(r instanceof $Reader)) r = $Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l,
          m = new $root.google.protobuf.ServiceDescriptorProto();
        while (r.pos < c) {
          var t = r.uint32();
          switch (t >>> 3) {
            case 1:
              m.name = r.string();
              break;
            case 2:
              if (!(m.method && m.method.length)) m.method = [];
              m.method.push(
                $root.google.protobuf.MethodDescriptorProto.decode(
                  r,
                  r.uint32()
                )
              );
              break;
            case 3:
              m.options = $root.google.protobuf.ServiceOptions.decode(
                r,
                r.uint32()
              );
              break;
            default:
              r.skipType(t & 7);
              break;
          }
        }
        return m;
      };

      return ServiceDescriptorProto;
    })();

    protobuf.MethodDescriptorProto = (function () {
      /**
       * Properties of a MethodDescriptorProto.
       * @memberof google.protobuf
       * @interface IMethodDescriptorProto
       * @property {string|null} [name] MethodDescriptorProto name
       * @property {string|null} [inputType] MethodDescriptorProto inputType
       * @property {string|null} [outputType] MethodDescriptorProto outputType
       * @property {google.protobuf.IMethodOptions|null} [options] MethodDescriptorProto options
       * @property {boolean|null} [clientStreaming] MethodDescriptorProto clientStreaming
       * @property {boolean|null} [serverStreaming] MethodDescriptorProto serverStreaming
       */

      /**
       * Constructs a new MethodDescriptorProto.
       * @memberof google.protobuf
       * @classdesc Represents a MethodDescriptorProto.
       * @implements IMethodDescriptorProto
       * @constructor
       * @param {google.protobuf.IMethodDescriptorProto=} [p] Properties to set
       */
      function MethodDescriptorProto(p) {
        if (p)
          for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
            if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
      }

      /**
       * MethodDescriptorProto name.
       * @member {string} name
       * @memberof google.protobuf.MethodDescriptorProto
       * @instance
       */
      MethodDescriptorProto.prototype.name = "";

      /**
       * MethodDescriptorProto inputType.
       * @member {string} inputType
       * @memberof google.protobuf.MethodDescriptorProto
       * @instance
       */
      MethodDescriptorProto.prototype.inputType = "";

      /**
       * MethodDescriptorProto outputType.
       * @member {string} outputType
       * @memberof google.protobuf.MethodDescriptorProto
       * @instance
       */
      MethodDescriptorProto.prototype.outputType = "";

      /**
       * MethodDescriptorProto options.
       * @member {google.protobuf.IMethodOptions|null|undefined} options
       * @memberof google.protobuf.MethodDescriptorProto
       * @instance
       */
      MethodDescriptorProto.prototype.options = null;

      /**
       * MethodDescriptorProto clientStreaming.
       * @member {boolean} clientStreaming
       * @memberof google.protobuf.MethodDescriptorProto
       * @instance
       */
      MethodDescriptorProto.prototype.clientStreaming = false;

      /**
       * MethodDescriptorProto serverStreaming.
       * @member {boolean} serverStreaming
       * @memberof google.protobuf.MethodDescriptorProto
       * @instance
       */
      MethodDescriptorProto.prototype.serverStreaming = false;

      /**
       * Creates a new MethodDescriptorProto instance using the specified properties.
       * @function create
       * @memberof google.protobuf.MethodDescriptorProto
       * @static
       * @param {google.protobuf.IMethodDescriptorProto=} [properties] Properties to set
       * @returns {google.protobuf.MethodDescriptorProto} MethodDescriptorProto instance
       */
      MethodDescriptorProto.create = function create(properties) {
        return new MethodDescriptorProto(properties);
      };

      /**
       * Encodes the specified MethodDescriptorProto message. Does not implicitly {@link google.protobuf.MethodDescriptorProto.verify|verify} messages.
       * @function encode
       * @memberof google.protobuf.MethodDescriptorProto
       * @static
       * @param {google.protobuf.IMethodDescriptorProto} m MethodDescriptorProto message or plain object to encode
       * @param {$protobuf.Writer} [w] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      MethodDescriptorProto.encode = function encode(m, w) {
        if (!w) w = $Writer.create();
        if (m.name != null && Object.hasOwnProperty.call(m, "name"))
          w.uint32(10).string(m.name);
        if (m.inputType != null && Object.hasOwnProperty.call(m, "inputType"))
          w.uint32(18).string(m.inputType);
        if (m.outputType != null && Object.hasOwnProperty.call(m, "outputType"))
          w.uint32(26).string(m.outputType);
        if (m.options != null && Object.hasOwnProperty.call(m, "options"))
          $root.google.protobuf.MethodOptions.encode(
            m.options,
            w.uint32(34).fork()
          ).ldelim();
        if (
          m.clientStreaming != null &&
          Object.hasOwnProperty.call(m, "clientStreaming")
        )
          w.uint32(40).bool(m.clientStreaming);
        if (
          m.serverStreaming != null &&
          Object.hasOwnProperty.call(m, "serverStreaming")
        )
          w.uint32(48).bool(m.serverStreaming);
        return w;
      };

      /**
       * Decodes a MethodDescriptorProto message from the specified reader or buffer.
       * @function decode
       * @memberof google.protobuf.MethodDescriptorProto
       * @static
       * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
       * @param {number} [l] Message length if known beforehand
       * @returns {google.protobuf.MethodDescriptorProto} MethodDescriptorProto
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      MethodDescriptorProto.decode = function decode(r, l) {
        if (!(r instanceof $Reader)) r = $Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l,
          m = new $root.google.protobuf.MethodDescriptorProto();
        while (r.pos < c) {
          var t = r.uint32();
          switch (t >>> 3) {
            case 1:
              m.name = r.string();
              break;
            case 2:
              m.inputType = r.string();
              break;
            case 3:
              m.outputType = r.string();
              break;
            case 4:
              m.options = $root.google.protobuf.MethodOptions.decode(
                r,
                r.uint32()
              );
              break;
            case 5:
              m.clientStreaming = r.bool();
              break;
            case 6:
              m.serverStreaming = r.bool();
              break;
            default:
              r.skipType(t & 7);
              break;
          }
        }
        return m;
      };

      return MethodDescriptorProto;
    })();

    protobuf.FileOptions = (function () {
      /**
       * Properties of a FileOptions.
       * @memberof google.protobuf
       * @interface IFileOptions
       * @property {string|null} [javaPackage] FileOptions javaPackage
       * @property {string|null} [javaOuterClassname] FileOptions javaOuterClassname
       * @property {boolean|null} [javaMultipleFiles] FileOptions javaMultipleFiles
       * @property {boolean|null} [javaGenerateEqualsAndHash] FileOptions javaGenerateEqualsAndHash
       * @property {boolean|null} [javaStringCheckUtf8] FileOptions javaStringCheckUtf8
       * @property {google.protobuf.FileOptions.OptimizeMode|null} [optimizeFor] FileOptions optimizeFor
       * @property {string|null} [goPackage] FileOptions goPackage
       * @property {boolean|null} [ccGenericServices] FileOptions ccGenericServices
       * @property {boolean|null} [javaGenericServices] FileOptions javaGenericServices
       * @property {boolean|null} [pyGenericServices] FileOptions pyGenericServices
       * @property {boolean|null} [deprecated] FileOptions deprecated
       * @property {boolean|null} [ccEnableArenas] FileOptions ccEnableArenas
       * @property {string|null} [objcClassPrefix] FileOptions objcClassPrefix
       * @property {string|null} [csharpNamespace] FileOptions csharpNamespace
       * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] FileOptions uninterpretedOption
       * @property {string|null} [".common.serviceCalls"] FileOptions .common.serviceCalls
       */

      /**
       * Constructs a new FileOptions.
       * @memberof google.protobuf
       * @classdesc Represents a FileOptions.
       * @implements IFileOptions
       * @constructor
       * @param {google.protobuf.IFileOptions=} [p] Properties to set
       */
      function FileOptions(p) {
        this.uninterpretedOption = [];
        if (p)
          for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
            if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
      }

      /**
       * FileOptions javaPackage.
       * @member {string} javaPackage
       * @memberof google.protobuf.FileOptions
       * @instance
       */
      FileOptions.prototype.javaPackage = "";

      /**
       * FileOptions javaOuterClassname.
       * @member {string} javaOuterClassname
       * @memberof google.protobuf.FileOptions
       * @instance
       */
      FileOptions.prototype.javaOuterClassname = "";

      /**
       * FileOptions javaMultipleFiles.
       * @member {boolean} javaMultipleFiles
       * @memberof google.protobuf.FileOptions
       * @instance
       */
      FileOptions.prototype.javaMultipleFiles = false;

      /**
       * FileOptions javaGenerateEqualsAndHash.
       * @member {boolean} javaGenerateEqualsAndHash
       * @memberof google.protobuf.FileOptions
       * @instance
       */
      FileOptions.prototype.javaGenerateEqualsAndHash = false;

      /**
       * FileOptions javaStringCheckUtf8.
       * @member {boolean} javaStringCheckUtf8
       * @memberof google.protobuf.FileOptions
       * @instance
       */
      FileOptions.prototype.javaStringCheckUtf8 = false;

      /**
       * FileOptions optimizeFor.
       * @member {google.protobuf.FileOptions.OptimizeMode} optimizeFor
       * @memberof google.protobuf.FileOptions
       * @instance
       */
      FileOptions.prototype.optimizeFor = 1;

      /**
       * FileOptions goPackage.
       * @member {string} goPackage
       * @memberof google.protobuf.FileOptions
       * @instance
       */
      FileOptions.prototype.goPackage = "";

      /**
       * FileOptions ccGenericServices.
       * @member {boolean} ccGenericServices
       * @memberof google.protobuf.FileOptions
       * @instance
       */
      FileOptions.prototype.ccGenericServices = false;

      /**
       * FileOptions javaGenericServices.
       * @member {boolean} javaGenericServices
       * @memberof google.protobuf.FileOptions
       * @instance
       */
      FileOptions.prototype.javaGenericServices = false;

      /**
       * FileOptions pyGenericServices.
       * @member {boolean} pyGenericServices
       * @memberof google.protobuf.FileOptions
       * @instance
       */
      FileOptions.prototype.pyGenericServices = false;

      /**
       * FileOptions deprecated.
       * @member {boolean} deprecated
       * @memberof google.protobuf.FileOptions
       * @instance
       */
      FileOptions.prototype.deprecated = false;

      /**
       * FileOptions ccEnableArenas.
       * @member {boolean} ccEnableArenas
       * @memberof google.protobuf.FileOptions
       * @instance
       */
      FileOptions.prototype.ccEnableArenas = false;

      /**
       * FileOptions objcClassPrefix.
       * @member {string} objcClassPrefix
       * @memberof google.protobuf.FileOptions
       * @instance
       */
      FileOptions.prototype.objcClassPrefix = "";

      /**
       * FileOptions csharpNamespace.
       * @member {string} csharpNamespace
       * @memberof google.protobuf.FileOptions
       * @instance
       */
      FileOptions.prototype.csharpNamespace = "";

      /**
       * FileOptions uninterpretedOption.
       * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
       * @memberof google.protobuf.FileOptions
       * @instance
       */
      FileOptions.prototype.uninterpretedOption = $util.emptyArray;

      /**
       * FileOptions .common.serviceCalls.
       * @member {string} .common.serviceCalls
       * @memberof google.protobuf.FileOptions
       * @instance
       */
      FileOptions.prototype[".common.serviceCalls"] = "";

      /**
       * Creates a new FileOptions instance using the specified properties.
       * @function create
       * @memberof google.protobuf.FileOptions
       * @static
       * @param {google.protobuf.IFileOptions=} [properties] Properties to set
       * @returns {google.protobuf.FileOptions} FileOptions instance
       */
      FileOptions.create = function create(properties) {
        return new FileOptions(properties);
      };

      /**
       * Encodes the specified FileOptions message. Does not implicitly {@link google.protobuf.FileOptions.verify|verify} messages.
       * @function encode
       * @memberof google.protobuf.FileOptions
       * @static
       * @param {google.protobuf.IFileOptions} m FileOptions message or plain object to encode
       * @param {$protobuf.Writer} [w] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      FileOptions.encode = function encode(m, w) {
        if (!w) w = $Writer.create();
        if (
          m.javaPackage != null &&
          Object.hasOwnProperty.call(m, "javaPackage")
        )
          w.uint32(10).string(m.javaPackage);
        if (
          m.javaOuterClassname != null &&
          Object.hasOwnProperty.call(m, "javaOuterClassname")
        )
          w.uint32(66).string(m.javaOuterClassname);
        if (
          m.optimizeFor != null &&
          Object.hasOwnProperty.call(m, "optimizeFor")
        )
          w.uint32(72).int32(m.optimizeFor);
        if (
          m.javaMultipleFiles != null &&
          Object.hasOwnProperty.call(m, "javaMultipleFiles")
        )
          w.uint32(80).bool(m.javaMultipleFiles);
        if (m.goPackage != null && Object.hasOwnProperty.call(m, "goPackage"))
          w.uint32(90).string(m.goPackage);
        if (
          m.ccGenericServices != null &&
          Object.hasOwnProperty.call(m, "ccGenericServices")
        )
          w.uint32(128).bool(m.ccGenericServices);
        if (
          m.javaGenericServices != null &&
          Object.hasOwnProperty.call(m, "javaGenericServices")
        )
          w.uint32(136).bool(m.javaGenericServices);
        if (
          m.pyGenericServices != null &&
          Object.hasOwnProperty.call(m, "pyGenericServices")
        )
          w.uint32(144).bool(m.pyGenericServices);
        if (
          m.javaGenerateEqualsAndHash != null &&
          Object.hasOwnProperty.call(m, "javaGenerateEqualsAndHash")
        )
          w.uint32(160).bool(m.javaGenerateEqualsAndHash);
        if (m.deprecated != null && Object.hasOwnProperty.call(m, "deprecated"))
          w.uint32(184).bool(m.deprecated);
        if (
          m.javaStringCheckUtf8 != null &&
          Object.hasOwnProperty.call(m, "javaStringCheckUtf8")
        )
          w.uint32(216).bool(m.javaStringCheckUtf8);
        if (
          m.ccEnableArenas != null &&
          Object.hasOwnProperty.call(m, "ccEnableArenas")
        )
          w.uint32(248).bool(m.ccEnableArenas);
        if (
          m.objcClassPrefix != null &&
          Object.hasOwnProperty.call(m, "objcClassPrefix")
        )
          w.uint32(290).string(m.objcClassPrefix);
        if (
          m.csharpNamespace != null &&
          Object.hasOwnProperty.call(m, "csharpNamespace")
        )
          w.uint32(298).string(m.csharpNamespace);
        if (m.uninterpretedOption != null && m.uninterpretedOption.length) {
          for (var i = 0; i < m.uninterpretedOption.length; ++i)
            $root.google.protobuf.UninterpretedOption.encode(
              m.uninterpretedOption[i],
              w.uint32(7994).fork()
            ).ldelim();
        }
        if (
          m[".common.serviceCalls"] != null &&
          Object.hasOwnProperty.call(m, ".common.serviceCalls")
        )
          w.uint32(400034).string(m[".common.serviceCalls"]);
        return w;
      };

      /**
       * Decodes a FileOptions message from the specified reader or buffer.
       * @function decode
       * @memberof google.protobuf.FileOptions
       * @static
       * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
       * @param {number} [l] Message length if known beforehand
       * @returns {google.protobuf.FileOptions} FileOptions
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      FileOptions.decode = function decode(r, l) {
        if (!(r instanceof $Reader)) r = $Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l,
          m = new $root.google.protobuf.FileOptions();
        while (r.pos < c) {
          var t = r.uint32();
          switch (t >>> 3) {
            case 1:
              m.javaPackage = r.string();
              break;
            case 8:
              m.javaOuterClassname = r.string();
              break;
            case 10:
              m.javaMultipleFiles = r.bool();
              break;
            case 20:
              m.javaGenerateEqualsAndHash = r.bool();
              break;
            case 27:
              m.javaStringCheckUtf8 = r.bool();
              break;
            case 9:
              m.optimizeFor = r.int32();
              break;
            case 11:
              m.goPackage = r.string();
              break;
            case 16:
              m.ccGenericServices = r.bool();
              break;
            case 17:
              m.javaGenericServices = r.bool();
              break;
            case 18:
              m.pyGenericServices = r.bool();
              break;
            case 23:
              m.deprecated = r.bool();
              break;
            case 31:
              m.ccEnableArenas = r.bool();
              break;
            case 36:
              m.objcClassPrefix = r.string();
              break;
            case 37:
              m.csharpNamespace = r.string();
              break;
            case 999:
              if (!(m.uninterpretedOption && m.uninterpretedOption.length))
                m.uninterpretedOption = [];
              m.uninterpretedOption.push(
                $root.google.protobuf.UninterpretedOption.decode(r, r.uint32())
              );
              break;
            case 50004:
              m[".common.serviceCalls"] = r.string();
              break;
            default:
              r.skipType(t & 7);
              break;
          }
        }
        return m;
      };

      /**
       * OptimizeMode enum.
       * @name google.protobuf.FileOptions.OptimizeMode
       * @enum {number}
       * @property {number} SPEED=1 SPEED value
       * @property {number} CODE_SIZE=2 CODE_SIZE value
       * @property {number} LITE_RUNTIME=3 LITE_RUNTIME value
       */
      FileOptions.OptimizeMode = (function () {
        const valuesById = {},
          values = Object.create(valuesById);
        values[(valuesById[1] = "SPEED")] = 1;
        values[(valuesById[2] = "CODE_SIZE")] = 2;
        values[(valuesById[3] = "LITE_RUNTIME")] = 3;
        return values;
      })();

      return FileOptions;
    })();

    protobuf.MessageOptions = (function () {
      /**
       * Properties of a MessageOptions.
       * @memberof google.protobuf
       * @interface IMessageOptions
       * @property {boolean|null} [messageSetWireFormat] MessageOptions messageSetWireFormat
       * @property {boolean|null} [noStandardDescriptorAccessor] MessageOptions noStandardDescriptorAccessor
       * @property {boolean|null} [deprecated] MessageOptions deprecated
       * @property {boolean|null} [mapEntry] MessageOptions mapEntry
       * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] MessageOptions uninterpretedOption
       */

      /**
       * Constructs a new MessageOptions.
       * @memberof google.protobuf
       * @classdesc Represents a MessageOptions.
       * @implements IMessageOptions
       * @constructor
       * @param {google.protobuf.IMessageOptions=} [p] Properties to set
       */
      function MessageOptions(p) {
        this.uninterpretedOption = [];
        if (p)
          for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
            if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
      }

      /**
       * MessageOptions messageSetWireFormat.
       * @member {boolean} messageSetWireFormat
       * @memberof google.protobuf.MessageOptions
       * @instance
       */
      MessageOptions.prototype.messageSetWireFormat = false;

      /**
       * MessageOptions noStandardDescriptorAccessor.
       * @member {boolean} noStandardDescriptorAccessor
       * @memberof google.protobuf.MessageOptions
       * @instance
       */
      MessageOptions.prototype.noStandardDescriptorAccessor = false;

      /**
       * MessageOptions deprecated.
       * @member {boolean} deprecated
       * @memberof google.protobuf.MessageOptions
       * @instance
       */
      MessageOptions.prototype.deprecated = false;

      /**
       * MessageOptions mapEntry.
       * @member {boolean} mapEntry
       * @memberof google.protobuf.MessageOptions
       * @instance
       */
      MessageOptions.prototype.mapEntry = false;

      /**
       * MessageOptions uninterpretedOption.
       * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
       * @memberof google.protobuf.MessageOptions
       * @instance
       */
      MessageOptions.prototype.uninterpretedOption = $util.emptyArray;

      /**
       * Creates a new MessageOptions instance using the specified properties.
       * @function create
       * @memberof google.protobuf.MessageOptions
       * @static
       * @param {google.protobuf.IMessageOptions=} [properties] Properties to set
       * @returns {google.protobuf.MessageOptions} MessageOptions instance
       */
      MessageOptions.create = function create(properties) {
        return new MessageOptions(properties);
      };

      /**
       * Encodes the specified MessageOptions message. Does not implicitly {@link google.protobuf.MessageOptions.verify|verify} messages.
       * @function encode
       * @memberof google.protobuf.MessageOptions
       * @static
       * @param {google.protobuf.IMessageOptions} m MessageOptions message or plain object to encode
       * @param {$protobuf.Writer} [w] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      MessageOptions.encode = function encode(m, w) {
        if (!w) w = $Writer.create();
        if (
          m.messageSetWireFormat != null &&
          Object.hasOwnProperty.call(m, "messageSetWireFormat")
        )
          w.uint32(8).bool(m.messageSetWireFormat);
        if (
          m.noStandardDescriptorAccessor != null &&
          Object.hasOwnProperty.call(m, "noStandardDescriptorAccessor")
        )
          w.uint32(16).bool(m.noStandardDescriptorAccessor);
        if (m.deprecated != null && Object.hasOwnProperty.call(m, "deprecated"))
          w.uint32(24).bool(m.deprecated);
        if (m.mapEntry != null && Object.hasOwnProperty.call(m, "mapEntry"))
          w.uint32(56).bool(m.mapEntry);
        if (m.uninterpretedOption != null && m.uninterpretedOption.length) {
          for (var i = 0; i < m.uninterpretedOption.length; ++i)
            $root.google.protobuf.UninterpretedOption.encode(
              m.uninterpretedOption[i],
              w.uint32(7994).fork()
            ).ldelim();
        }
        return w;
      };

      /**
       * Decodes a MessageOptions message from the specified reader or buffer.
       * @function decode
       * @memberof google.protobuf.MessageOptions
       * @static
       * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
       * @param {number} [l] Message length if known beforehand
       * @returns {google.protobuf.MessageOptions} MessageOptions
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      MessageOptions.decode = function decode(r, l) {
        if (!(r instanceof $Reader)) r = $Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l,
          m = new $root.google.protobuf.MessageOptions();
        while (r.pos < c) {
          var t = r.uint32();
          switch (t >>> 3) {
            case 1:
              m.messageSetWireFormat = r.bool();
              break;
            case 2:
              m.noStandardDescriptorAccessor = r.bool();
              break;
            case 3:
              m.deprecated = r.bool();
              break;
            case 7:
              m.mapEntry = r.bool();
              break;
            case 999:
              if (!(m.uninterpretedOption && m.uninterpretedOption.length))
                m.uninterpretedOption = [];
              m.uninterpretedOption.push(
                $root.google.protobuf.UninterpretedOption.decode(r, r.uint32())
              );
              break;
            default:
              r.skipType(t & 7);
              break;
          }
        }
        return m;
      };

      return MessageOptions;
    })();

    protobuf.FieldOptions = (function () {
      /**
       * Properties of a FieldOptions.
       * @memberof google.protobuf
       * @interface IFieldOptions
       * @property {google.protobuf.FieldOptions.CType|null} [ctype] FieldOptions ctype
       * @property {boolean|null} [packed] FieldOptions packed
       * @property {google.protobuf.FieldOptions.JSType|null} [jstype] FieldOptions jstype
       * @property {boolean|null} [lazy] FieldOptions lazy
       * @property {boolean|null} [deprecated] FieldOptions deprecated
       * @property {boolean|null} [weak] FieldOptions weak
       * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] FieldOptions uninterpretedOption
       * @property {boolean|null} [".common.doNotLog"] FieldOptions .common.doNotLog
       * @property {boolean|null} [".common.internal"] FieldOptions .common.internal
       */

      /**
       * Constructs a new FieldOptions.
       * @memberof google.protobuf
       * @classdesc Represents a FieldOptions.
       * @implements IFieldOptions
       * @constructor
       * @param {google.protobuf.IFieldOptions=} [p] Properties to set
       */
      function FieldOptions(p) {
        this.uninterpretedOption = [];
        if (p)
          for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
            if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
      }

      /**
       * FieldOptions ctype.
       * @member {google.protobuf.FieldOptions.CType} ctype
       * @memberof google.protobuf.FieldOptions
       * @instance
       */
      FieldOptions.prototype.ctype = 0;

      /**
       * FieldOptions packed.
       * @member {boolean} packed
       * @memberof google.protobuf.FieldOptions
       * @instance
       */
      FieldOptions.prototype.packed = false;

      /**
       * FieldOptions jstype.
       * @member {google.protobuf.FieldOptions.JSType} jstype
       * @memberof google.protobuf.FieldOptions
       * @instance
       */
      FieldOptions.prototype.jstype = 0;

      /**
       * FieldOptions lazy.
       * @member {boolean} lazy
       * @memberof google.protobuf.FieldOptions
       * @instance
       */
      FieldOptions.prototype.lazy = false;

      /**
       * FieldOptions deprecated.
       * @member {boolean} deprecated
       * @memberof google.protobuf.FieldOptions
       * @instance
       */
      FieldOptions.prototype.deprecated = false;

      /**
       * FieldOptions weak.
       * @member {boolean} weak
       * @memberof google.protobuf.FieldOptions
       * @instance
       */
      FieldOptions.prototype.weak = false;

      /**
       * FieldOptions uninterpretedOption.
       * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
       * @memberof google.protobuf.FieldOptions
       * @instance
       */
      FieldOptions.prototype.uninterpretedOption = $util.emptyArray;

      /**
       * FieldOptions .common.doNotLog.
       * @member {boolean} .common.doNotLog
       * @memberof google.protobuf.FieldOptions
       * @instance
       */
      FieldOptions.prototype[".common.doNotLog"] = false;

      /**
       * FieldOptions .common.internal.
       * @member {boolean} .common.internal
       * @memberof google.protobuf.FieldOptions
       * @instance
       */
      FieldOptions.prototype[".common.internal"] = false;

      /**
       * Creates a new FieldOptions instance using the specified properties.
       * @function create
       * @memberof google.protobuf.FieldOptions
       * @static
       * @param {google.protobuf.IFieldOptions=} [properties] Properties to set
       * @returns {google.protobuf.FieldOptions} FieldOptions instance
       */
      FieldOptions.create = function create(properties) {
        return new FieldOptions(properties);
      };

      /**
       * Encodes the specified FieldOptions message. Does not implicitly {@link google.protobuf.FieldOptions.verify|verify} messages.
       * @function encode
       * @memberof google.protobuf.FieldOptions
       * @static
       * @param {google.protobuf.IFieldOptions} m FieldOptions message or plain object to encode
       * @param {$protobuf.Writer} [w] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      FieldOptions.encode = function encode(m, w) {
        if (!w) w = $Writer.create();
        if (m.ctype != null && Object.hasOwnProperty.call(m, "ctype"))
          w.uint32(8).int32(m.ctype);
        if (m.packed != null && Object.hasOwnProperty.call(m, "packed"))
          w.uint32(16).bool(m.packed);
        if (m.deprecated != null && Object.hasOwnProperty.call(m, "deprecated"))
          w.uint32(24).bool(m.deprecated);
        if (m.lazy != null && Object.hasOwnProperty.call(m, "lazy"))
          w.uint32(40).bool(m.lazy);
        if (m.jstype != null && Object.hasOwnProperty.call(m, "jstype"))
          w.uint32(48).int32(m.jstype);
        if (m.weak != null && Object.hasOwnProperty.call(m, "weak"))
          w.uint32(80).bool(m.weak);
        if (m.uninterpretedOption != null && m.uninterpretedOption.length) {
          for (var i = 0; i < m.uninterpretedOption.length; ++i)
            $root.google.protobuf.UninterpretedOption.encode(
              m.uninterpretedOption[i],
              w.uint32(7994).fork()
            ).ldelim();
        }
        if (
          m[".common.doNotLog"] != null &&
          Object.hasOwnProperty.call(m, ".common.doNotLog")
        )
          w.uint32(400800).bool(m[".common.doNotLog"]);
        if (
          m[".common.internal"] != null &&
          Object.hasOwnProperty.call(m, ".common.internal")
        )
          w.uint32(401600).bool(m[".common.internal"]);
        return w;
      };

      /**
       * Decodes a FieldOptions message from the specified reader or buffer.
       * @function decode
       * @memberof google.protobuf.FieldOptions
       * @static
       * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
       * @param {number} [l] Message length if known beforehand
       * @returns {google.protobuf.FieldOptions} FieldOptions
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      FieldOptions.decode = function decode(r, l) {
        if (!(r instanceof $Reader)) r = $Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l,
          m = new $root.google.protobuf.FieldOptions();
        while (r.pos < c) {
          var t = r.uint32();
          switch (t >>> 3) {
            case 1:
              m.ctype = r.int32();
              break;
            case 2:
              m.packed = r.bool();
              break;
            case 6:
              m.jstype = r.int32();
              break;
            case 5:
              m.lazy = r.bool();
              break;
            case 3:
              m.deprecated = r.bool();
              break;
            case 10:
              m.weak = r.bool();
              break;
            case 999:
              if (!(m.uninterpretedOption && m.uninterpretedOption.length))
                m.uninterpretedOption = [];
              m.uninterpretedOption.push(
                $root.google.protobuf.UninterpretedOption.decode(r, r.uint32())
              );
              break;
            case 50100:
              m[".common.doNotLog"] = r.bool();
              break;
            case 50200:
              m[".common.internal"] = r.bool();
              break;
            default:
              r.skipType(t & 7);
              break;
          }
        }
        return m;
      };

      /**
       * CType enum.
       * @name google.protobuf.FieldOptions.CType
       * @enum {number}
       * @property {number} STRING=0 STRING value
       * @property {number} CORD=1 CORD value
       * @property {number} STRING_PIECE=2 STRING_PIECE value
       */
      FieldOptions.CType = (function () {
        const valuesById = {},
          values = Object.create(valuesById);
        values[(valuesById[0] = "STRING")] = 0;
        values[(valuesById[1] = "CORD")] = 1;
        values[(valuesById[2] = "STRING_PIECE")] = 2;
        return values;
      })();

      /**
       * JSType enum.
       * @name google.protobuf.FieldOptions.JSType
       * @enum {number}
       * @property {number} JS_NORMAL=0 JS_NORMAL value
       * @property {number} JS_STRING=1 JS_STRING value
       * @property {number} JS_NUMBER=2 JS_NUMBER value
       */
      FieldOptions.JSType = (function () {
        const valuesById = {},
          values = Object.create(valuesById);
        values[(valuesById[0] = "JS_NORMAL")] = 0;
        values[(valuesById[1] = "JS_STRING")] = 1;
        values[(valuesById[2] = "JS_NUMBER")] = 2;
        return values;
      })();

      return FieldOptions;
    })();

    protobuf.OneofOptions = (function () {
      /**
       * Properties of an OneofOptions.
       * @memberof google.protobuf
       * @interface IOneofOptions
       * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] OneofOptions uninterpretedOption
       */

      /**
       * Constructs a new OneofOptions.
       * @memberof google.protobuf
       * @classdesc Represents an OneofOptions.
       * @implements IOneofOptions
       * @constructor
       * @param {google.protobuf.IOneofOptions=} [p] Properties to set
       */
      function OneofOptions(p) {
        this.uninterpretedOption = [];
        if (p)
          for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
            if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
      }

      /**
       * OneofOptions uninterpretedOption.
       * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
       * @memberof google.protobuf.OneofOptions
       * @instance
       */
      OneofOptions.prototype.uninterpretedOption = $util.emptyArray;

      /**
       * Creates a new OneofOptions instance using the specified properties.
       * @function create
       * @memberof google.protobuf.OneofOptions
       * @static
       * @param {google.protobuf.IOneofOptions=} [properties] Properties to set
       * @returns {google.protobuf.OneofOptions} OneofOptions instance
       */
      OneofOptions.create = function create(properties) {
        return new OneofOptions(properties);
      };

      /**
       * Encodes the specified OneofOptions message. Does not implicitly {@link google.protobuf.OneofOptions.verify|verify} messages.
       * @function encode
       * @memberof google.protobuf.OneofOptions
       * @static
       * @param {google.protobuf.IOneofOptions} m OneofOptions message or plain object to encode
       * @param {$protobuf.Writer} [w] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      OneofOptions.encode = function encode(m, w) {
        if (!w) w = $Writer.create();
        if (m.uninterpretedOption != null && m.uninterpretedOption.length) {
          for (var i = 0; i < m.uninterpretedOption.length; ++i)
            $root.google.protobuf.UninterpretedOption.encode(
              m.uninterpretedOption[i],
              w.uint32(7994).fork()
            ).ldelim();
        }
        return w;
      };

      /**
       * Decodes an OneofOptions message from the specified reader or buffer.
       * @function decode
       * @memberof google.protobuf.OneofOptions
       * @static
       * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
       * @param {number} [l] Message length if known beforehand
       * @returns {google.protobuf.OneofOptions} OneofOptions
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      OneofOptions.decode = function decode(r, l) {
        if (!(r instanceof $Reader)) r = $Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l,
          m = new $root.google.protobuf.OneofOptions();
        while (r.pos < c) {
          var t = r.uint32();
          switch (t >>> 3) {
            case 999:
              if (!(m.uninterpretedOption && m.uninterpretedOption.length))
                m.uninterpretedOption = [];
              m.uninterpretedOption.push(
                $root.google.protobuf.UninterpretedOption.decode(r, r.uint32())
              );
              break;
            default:
              r.skipType(t & 7);
              break;
          }
        }
        return m;
      };

      return OneofOptions;
    })();

    protobuf.EnumOptions = (function () {
      /**
       * Properties of an EnumOptions.
       * @memberof google.protobuf
       * @interface IEnumOptions
       * @property {boolean|null} [allowAlias] EnumOptions allowAlias
       * @property {boolean|null} [deprecated] EnumOptions deprecated
       * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] EnumOptions uninterpretedOption
       */

      /**
       * Constructs a new EnumOptions.
       * @memberof google.protobuf
       * @classdesc Represents an EnumOptions.
       * @implements IEnumOptions
       * @constructor
       * @param {google.protobuf.IEnumOptions=} [p] Properties to set
       */
      function EnumOptions(p) {
        this.uninterpretedOption = [];
        if (p)
          for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
            if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
      }

      /**
       * EnumOptions allowAlias.
       * @member {boolean} allowAlias
       * @memberof google.protobuf.EnumOptions
       * @instance
       */
      EnumOptions.prototype.allowAlias = false;

      /**
       * EnumOptions deprecated.
       * @member {boolean} deprecated
       * @memberof google.protobuf.EnumOptions
       * @instance
       */
      EnumOptions.prototype.deprecated = false;

      /**
       * EnumOptions uninterpretedOption.
       * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
       * @memberof google.protobuf.EnumOptions
       * @instance
       */
      EnumOptions.prototype.uninterpretedOption = $util.emptyArray;

      /**
       * Creates a new EnumOptions instance using the specified properties.
       * @function create
       * @memberof google.protobuf.EnumOptions
       * @static
       * @param {google.protobuf.IEnumOptions=} [properties] Properties to set
       * @returns {google.protobuf.EnumOptions} EnumOptions instance
       */
      EnumOptions.create = function create(properties) {
        return new EnumOptions(properties);
      };

      /**
       * Encodes the specified EnumOptions message. Does not implicitly {@link google.protobuf.EnumOptions.verify|verify} messages.
       * @function encode
       * @memberof google.protobuf.EnumOptions
       * @static
       * @param {google.protobuf.IEnumOptions} m EnumOptions message or plain object to encode
       * @param {$protobuf.Writer} [w] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      EnumOptions.encode = function encode(m, w) {
        if (!w) w = $Writer.create();
        if (m.allowAlias != null && Object.hasOwnProperty.call(m, "allowAlias"))
          w.uint32(16).bool(m.allowAlias);
        if (m.deprecated != null && Object.hasOwnProperty.call(m, "deprecated"))
          w.uint32(24).bool(m.deprecated);
        if (m.uninterpretedOption != null && m.uninterpretedOption.length) {
          for (var i = 0; i < m.uninterpretedOption.length; ++i)
            $root.google.protobuf.UninterpretedOption.encode(
              m.uninterpretedOption[i],
              w.uint32(7994).fork()
            ).ldelim();
        }
        return w;
      };

      /**
       * Decodes an EnumOptions message from the specified reader or buffer.
       * @function decode
       * @memberof google.protobuf.EnumOptions
       * @static
       * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
       * @param {number} [l] Message length if known beforehand
       * @returns {google.protobuf.EnumOptions} EnumOptions
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      EnumOptions.decode = function decode(r, l) {
        if (!(r instanceof $Reader)) r = $Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l,
          m = new $root.google.protobuf.EnumOptions();
        while (r.pos < c) {
          var t = r.uint32();
          switch (t >>> 3) {
            case 2:
              m.allowAlias = r.bool();
              break;
            case 3:
              m.deprecated = r.bool();
              break;
            case 999:
              if (!(m.uninterpretedOption && m.uninterpretedOption.length))
                m.uninterpretedOption = [];
              m.uninterpretedOption.push(
                $root.google.protobuf.UninterpretedOption.decode(r, r.uint32())
              );
              break;
            default:
              r.skipType(t & 7);
              break;
          }
        }
        return m;
      };

      return EnumOptions;
    })();

    protobuf.EnumValueOptions = (function () {
      /**
       * Properties of an EnumValueOptions.
       * @memberof google.protobuf
       * @interface IEnumValueOptions
       * @property {boolean|null} [deprecated] EnumValueOptions deprecated
       * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] EnumValueOptions uninterpretedOption
       */

      /**
       * Constructs a new EnumValueOptions.
       * @memberof google.protobuf
       * @classdesc Represents an EnumValueOptions.
       * @implements IEnumValueOptions
       * @constructor
       * @param {google.protobuf.IEnumValueOptions=} [p] Properties to set
       */
      function EnumValueOptions(p) {
        this.uninterpretedOption = [];
        if (p)
          for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
            if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
      }

      /**
       * EnumValueOptions deprecated.
       * @member {boolean} deprecated
       * @memberof google.protobuf.EnumValueOptions
       * @instance
       */
      EnumValueOptions.prototype.deprecated = false;

      /**
       * EnumValueOptions uninterpretedOption.
       * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
       * @memberof google.protobuf.EnumValueOptions
       * @instance
       */
      EnumValueOptions.prototype.uninterpretedOption = $util.emptyArray;

      /**
       * Creates a new EnumValueOptions instance using the specified properties.
       * @function create
       * @memberof google.protobuf.EnumValueOptions
       * @static
       * @param {google.protobuf.IEnumValueOptions=} [properties] Properties to set
       * @returns {google.protobuf.EnumValueOptions} EnumValueOptions instance
       */
      EnumValueOptions.create = function create(properties) {
        return new EnumValueOptions(properties);
      };

      /**
       * Encodes the specified EnumValueOptions message. Does not implicitly {@link google.protobuf.EnumValueOptions.verify|verify} messages.
       * @function encode
       * @memberof google.protobuf.EnumValueOptions
       * @static
       * @param {google.protobuf.IEnumValueOptions} m EnumValueOptions message or plain object to encode
       * @param {$protobuf.Writer} [w] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      EnumValueOptions.encode = function encode(m, w) {
        if (!w) w = $Writer.create();
        if (m.deprecated != null && Object.hasOwnProperty.call(m, "deprecated"))
          w.uint32(8).bool(m.deprecated);
        if (m.uninterpretedOption != null && m.uninterpretedOption.length) {
          for (var i = 0; i < m.uninterpretedOption.length; ++i)
            $root.google.protobuf.UninterpretedOption.encode(
              m.uninterpretedOption[i],
              w.uint32(7994).fork()
            ).ldelim();
        }
        return w;
      };

      /**
       * Decodes an EnumValueOptions message from the specified reader or buffer.
       * @function decode
       * @memberof google.protobuf.EnumValueOptions
       * @static
       * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
       * @param {number} [l] Message length if known beforehand
       * @returns {google.protobuf.EnumValueOptions} EnumValueOptions
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      EnumValueOptions.decode = function decode(r, l) {
        if (!(r instanceof $Reader)) r = $Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l,
          m = new $root.google.protobuf.EnumValueOptions();
        while (r.pos < c) {
          var t = r.uint32();
          switch (t >>> 3) {
            case 1:
              m.deprecated = r.bool();
              break;
            case 999:
              if (!(m.uninterpretedOption && m.uninterpretedOption.length))
                m.uninterpretedOption = [];
              m.uninterpretedOption.push(
                $root.google.protobuf.UninterpretedOption.decode(r, r.uint32())
              );
              break;
            default:
              r.skipType(t & 7);
              break;
          }
        }
        return m;
      };

      return EnumValueOptions;
    })();

    protobuf.ServiceOptions = (function () {
      /**
       * Properties of a ServiceOptions.
       * @memberof google.protobuf
       * @interface IServiceOptions
       * @property {boolean|null} [deprecated] ServiceOptions deprecated
       * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] ServiceOptions uninterpretedOption
       * @property {string|null} [".common.URI"] ServiceOptions .common.URI
       */

      /**
       * Constructs a new ServiceOptions.
       * @memberof google.protobuf
       * @classdesc Represents a ServiceOptions.
       * @implements IServiceOptions
       * @constructor
       * @param {google.protobuf.IServiceOptions=} [p] Properties to set
       */
      function ServiceOptions(p) {
        this.uninterpretedOption = [];
        if (p)
          for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
            if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
      }

      /**
       * ServiceOptions deprecated.
       * @member {boolean} deprecated
       * @memberof google.protobuf.ServiceOptions
       * @instance
       */
      ServiceOptions.prototype.deprecated = false;

      /**
       * ServiceOptions uninterpretedOption.
       * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
       * @memberof google.protobuf.ServiceOptions
       * @instance
       */
      ServiceOptions.prototype.uninterpretedOption = $util.emptyArray;

      /**
       * ServiceOptions .common.URI.
       * @member {string} .common.URI
       * @memberof google.protobuf.ServiceOptions
       * @instance
       */
      ServiceOptions.prototype[".common.URI"] = "";

      /**
       * Creates a new ServiceOptions instance using the specified properties.
       * @function create
       * @memberof google.protobuf.ServiceOptions
       * @static
       * @param {google.protobuf.IServiceOptions=} [properties] Properties to set
       * @returns {google.protobuf.ServiceOptions} ServiceOptions instance
       */
      ServiceOptions.create = function create(properties) {
        return new ServiceOptions(properties);
      };

      /**
       * Encodes the specified ServiceOptions message. Does not implicitly {@link google.protobuf.ServiceOptions.verify|verify} messages.
       * @function encode
       * @memberof google.protobuf.ServiceOptions
       * @static
       * @param {google.protobuf.IServiceOptions} m ServiceOptions message or plain object to encode
       * @param {$protobuf.Writer} [w] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      ServiceOptions.encode = function encode(m, w) {
        if (!w) w = $Writer.create();
        if (m.deprecated != null && Object.hasOwnProperty.call(m, "deprecated"))
          w.uint32(264).bool(m.deprecated);
        if (m.uninterpretedOption != null && m.uninterpretedOption.length) {
          for (var i = 0; i < m.uninterpretedOption.length; ++i)
            $root.google.protobuf.UninterpretedOption.encode(
              m.uninterpretedOption[i],
              w.uint32(7994).fork()
            ).ldelim();
        }
        if (
          m[".common.URI"] != null &&
          Object.hasOwnProperty.call(m, ".common.URI")
        )
          w.uint32(400010).string(m[".common.URI"]);
        return w;
      };

      /**
       * Decodes a ServiceOptions message from the specified reader or buffer.
       * @function decode
       * @memberof google.protobuf.ServiceOptions
       * @static
       * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
       * @param {number} [l] Message length if known beforehand
       * @returns {google.protobuf.ServiceOptions} ServiceOptions
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      ServiceOptions.decode = function decode(r, l) {
        if (!(r instanceof $Reader)) r = $Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l,
          m = new $root.google.protobuf.ServiceOptions();
        while (r.pos < c) {
          var t = r.uint32();
          switch (t >>> 3) {
            case 33:
              m.deprecated = r.bool();
              break;
            case 999:
              if (!(m.uninterpretedOption && m.uninterpretedOption.length))
                m.uninterpretedOption = [];
              m.uninterpretedOption.push(
                $root.google.protobuf.UninterpretedOption.decode(r, r.uint32())
              );
              break;
            case 50001:
              m[".common.URI"] = r.string();
              break;
            default:
              r.skipType(t & 7);
              break;
          }
        }
        return m;
      };

      return ServiceOptions;
    })();

    protobuf.MethodOptions = (function () {
      /**
       * Properties of a MethodOptions.
       * @memberof google.protobuf
       * @interface IMethodOptions
       * @property {boolean|null} [deprecated] MethodOptions deprecated
       * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] MethodOptions uninterpretedOption
       * @property {boolean|null} [".common.allowJson"] MethodOptions .common.allowJson
       * @property {string|null} [".common.methodCalls"] MethodOptions .common.methodCalls
       * @property {string|null} [".common.httpMethod"] MethodOptions .common.httpMethod
       * @property {string|null} [".common.methodURI"] MethodOptions .common.methodURI
       */

      /**
       * Constructs a new MethodOptions.
       * @memberof google.protobuf
       * @classdesc Represents a MethodOptions.
       * @implements IMethodOptions
       * @constructor
       * @param {google.protobuf.IMethodOptions=} [p] Properties to set
       */
      function MethodOptions(p) {
        this.uninterpretedOption = [];
        if (p)
          for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
            if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
      }

      /**
       * MethodOptions deprecated.
       * @member {boolean} deprecated
       * @memberof google.protobuf.MethodOptions
       * @instance
       */
      MethodOptions.prototype.deprecated = false;

      /**
       * MethodOptions uninterpretedOption.
       * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
       * @memberof google.protobuf.MethodOptions
       * @instance
       */
      MethodOptions.prototype.uninterpretedOption = $util.emptyArray;

      /**
       * MethodOptions .common.allowJson.
       * @member {boolean} .common.allowJson
       * @memberof google.protobuf.MethodOptions
       * @instance
       */
      MethodOptions.prototype[".common.allowJson"] = false;

      /**
       * MethodOptions .common.methodCalls.
       * @member {string} .common.methodCalls
       * @memberof google.protobuf.MethodOptions
       * @instance
       */
      MethodOptions.prototype[".common.methodCalls"] = "";

      /**
       * MethodOptions .common.httpMethod.
       * @member {string} .common.httpMethod
       * @memberof google.protobuf.MethodOptions
       * @instance
       */
      MethodOptions.prototype[".common.httpMethod"] = "";

      /**
       * MethodOptions .common.methodURI.
       * @member {string} .common.methodURI
       * @memberof google.protobuf.MethodOptions
       * @instance
       */
      MethodOptions.prototype[".common.methodURI"] = "";

      /**
       * Creates a new MethodOptions instance using the specified properties.
       * @function create
       * @memberof google.protobuf.MethodOptions
       * @static
       * @param {google.protobuf.IMethodOptions=} [properties] Properties to set
       * @returns {google.protobuf.MethodOptions} MethodOptions instance
       */
      MethodOptions.create = function create(properties) {
        return new MethodOptions(properties);
      };

      /**
       * Encodes the specified MethodOptions message. Does not implicitly {@link google.protobuf.MethodOptions.verify|verify} messages.
       * @function encode
       * @memberof google.protobuf.MethodOptions
       * @static
       * @param {google.protobuf.IMethodOptions} m MethodOptions message or plain object to encode
       * @param {$protobuf.Writer} [w] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      MethodOptions.encode = function encode(m, w) {
        if (!w) w = $Writer.create();
        if (m.deprecated != null && Object.hasOwnProperty.call(m, "deprecated"))
          w.uint32(264).bool(m.deprecated);
        if (m.uninterpretedOption != null && m.uninterpretedOption.length) {
          for (var i = 0; i < m.uninterpretedOption.length; ++i)
            $root.google.protobuf.UninterpretedOption.encode(
              m.uninterpretedOption[i],
              w.uint32(7994).fork()
            ).ldelim();
        }
        if (
          m[".common.allowJson"] != null &&
          Object.hasOwnProperty.call(m, ".common.allowJson")
        )
          w.uint32(400000).bool(m[".common.allowJson"]);
        if (
          m[".common.methodCalls"] != null &&
          Object.hasOwnProperty.call(m, ".common.methodCalls")
        )
          w.uint32(400018).string(m[".common.methodCalls"]);
        if (
          m[".common.httpMethod"] != null &&
          Object.hasOwnProperty.call(m, ".common.httpMethod")
        )
          w.uint32(400026).string(m[".common.httpMethod"]);
        if (
          m[".common.methodURI"] != null &&
          Object.hasOwnProperty.call(m, ".common.methodURI")
        )
          w.uint32(400042).string(m[".common.methodURI"]);
        return w;
      };

      /**
       * Decodes a MethodOptions message from the specified reader or buffer.
       * @function decode
       * @memberof google.protobuf.MethodOptions
       * @static
       * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
       * @param {number} [l] Message length if known beforehand
       * @returns {google.protobuf.MethodOptions} MethodOptions
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      MethodOptions.decode = function decode(r, l) {
        if (!(r instanceof $Reader)) r = $Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l,
          m = new $root.google.protobuf.MethodOptions();
        while (r.pos < c) {
          var t = r.uint32();
          switch (t >>> 3) {
            case 33:
              m.deprecated = r.bool();
              break;
            case 999:
              if (!(m.uninterpretedOption && m.uninterpretedOption.length))
                m.uninterpretedOption = [];
              m.uninterpretedOption.push(
                $root.google.protobuf.UninterpretedOption.decode(r, r.uint32())
              );
              break;
            case 50000:
              m[".common.allowJson"] = r.bool();
              break;
            case 50002:
              m[".common.methodCalls"] = r.string();
              break;
            case 50003:
              m[".common.httpMethod"] = r.string();
              break;
            case 50005:
              m[".common.methodURI"] = r.string();
              break;
            default:
              r.skipType(t & 7);
              break;
          }
        }
        return m;
      };

      return MethodOptions;
    })();

    protobuf.UninterpretedOption = (function () {
      /**
       * Properties of an UninterpretedOption.
       * @memberof google.protobuf
       * @interface IUninterpretedOption
       * @property {Array.<google.protobuf.UninterpretedOption.INamePart>|null} [name] UninterpretedOption name
       * @property {string|null} [identifierValue] UninterpretedOption identifierValue
       * @property {number|Long|null} [positiveIntValue] UninterpretedOption positiveIntValue
       * @property {number|Long|null} [negativeIntValue] UninterpretedOption negativeIntValue
       * @property {number|null} [doubleValue] UninterpretedOption doubleValue
       * @property {Uint8Array|null} [stringValue] UninterpretedOption stringValue
       * @property {string|null} [aggregateValue] UninterpretedOption aggregateValue
       */

      /**
       * Constructs a new UninterpretedOption.
       * @memberof google.protobuf
       * @classdesc Represents an UninterpretedOption.
       * @implements IUninterpretedOption
       * @constructor
       * @param {google.protobuf.IUninterpretedOption=} [p] Properties to set
       */
      function UninterpretedOption(p) {
        this.name = [];
        if (p)
          for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
            if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
      }

      /**
       * UninterpretedOption name.
       * @member {Array.<google.protobuf.UninterpretedOption.INamePart>} name
       * @memberof google.protobuf.UninterpretedOption
       * @instance
       */
      UninterpretedOption.prototype.name = $util.emptyArray;

      /**
       * UninterpretedOption identifierValue.
       * @member {string} identifierValue
       * @memberof google.protobuf.UninterpretedOption
       * @instance
       */
      UninterpretedOption.prototype.identifierValue = "";

      /**
       * UninterpretedOption positiveIntValue.
       * @member {number|Long} positiveIntValue
       * @memberof google.protobuf.UninterpretedOption
       * @instance
       */
      UninterpretedOption.prototype.positiveIntValue = $util.Long
        ? $util.Long.fromBits(0, 0, true)
        : 0;

      /**
       * UninterpretedOption negativeIntValue.
       * @member {number|Long} negativeIntValue
       * @memberof google.protobuf.UninterpretedOption
       * @instance
       */
      UninterpretedOption.prototype.negativeIntValue = $util.Long
        ? $util.Long.fromBits(0, 0, false)
        : 0;

      /**
       * UninterpretedOption doubleValue.
       * @member {number} doubleValue
       * @memberof google.protobuf.UninterpretedOption
       * @instance
       */
      UninterpretedOption.prototype.doubleValue = 0;

      /**
       * UninterpretedOption stringValue.
       * @member {Uint8Array} stringValue
       * @memberof google.protobuf.UninterpretedOption
       * @instance
       */
      UninterpretedOption.prototype.stringValue = $util.newBuffer([]);

      /**
       * UninterpretedOption aggregateValue.
       * @member {string} aggregateValue
       * @memberof google.protobuf.UninterpretedOption
       * @instance
       */
      UninterpretedOption.prototype.aggregateValue = "";

      /**
       * Creates a new UninterpretedOption instance using the specified properties.
       * @function create
       * @memberof google.protobuf.UninterpretedOption
       * @static
       * @param {google.protobuf.IUninterpretedOption=} [properties] Properties to set
       * @returns {google.protobuf.UninterpretedOption} UninterpretedOption instance
       */
      UninterpretedOption.create = function create(properties) {
        return new UninterpretedOption(properties);
      };

      /**
       * Encodes the specified UninterpretedOption message. Does not implicitly {@link google.protobuf.UninterpretedOption.verify|verify} messages.
       * @function encode
       * @memberof google.protobuf.UninterpretedOption
       * @static
       * @param {google.protobuf.IUninterpretedOption} m UninterpretedOption message or plain object to encode
       * @param {$protobuf.Writer} [w] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      UninterpretedOption.encode = function encode(m, w) {
        if (!w) w = $Writer.create();
        if (m.name != null && m.name.length) {
          for (var i = 0; i < m.name.length; ++i)
            $root.google.protobuf.UninterpretedOption.NamePart.encode(
              m.name[i],
              w.uint32(18).fork()
            ).ldelim();
        }
        if (
          m.identifierValue != null &&
          Object.hasOwnProperty.call(m, "identifierValue")
        )
          w.uint32(26).string(m.identifierValue);
        if (
          m.positiveIntValue != null &&
          Object.hasOwnProperty.call(m, "positiveIntValue")
        )
          w.uint32(32).uint64(m.positiveIntValue);
        if (
          m.negativeIntValue != null &&
          Object.hasOwnProperty.call(m, "negativeIntValue")
        )
          w.uint32(40).int64(m.negativeIntValue);
        if (
          m.doubleValue != null &&
          Object.hasOwnProperty.call(m, "doubleValue")
        )
          w.uint32(49).double(m.doubleValue);
        if (
          m.stringValue != null &&
          Object.hasOwnProperty.call(m, "stringValue")
        )
          w.uint32(58).bytes(m.stringValue);
        if (
          m.aggregateValue != null &&
          Object.hasOwnProperty.call(m, "aggregateValue")
        )
          w.uint32(66).string(m.aggregateValue);
        return w;
      };

      /**
       * Decodes an UninterpretedOption message from the specified reader or buffer.
       * @function decode
       * @memberof google.protobuf.UninterpretedOption
       * @static
       * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
       * @param {number} [l] Message length if known beforehand
       * @returns {google.protobuf.UninterpretedOption} UninterpretedOption
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      UninterpretedOption.decode = function decode(r, l) {
        if (!(r instanceof $Reader)) r = $Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l,
          m = new $root.google.protobuf.UninterpretedOption();
        while (r.pos < c) {
          var t = r.uint32();
          switch (t >>> 3) {
            case 2:
              if (!(m.name && m.name.length)) m.name = [];
              m.name.push(
                $root.google.protobuf.UninterpretedOption.NamePart.decode(
                  r,
                  r.uint32()
                )
              );
              break;
            case 3:
              m.identifierValue = r.string();
              break;
            case 4:
              m.positiveIntValue = r.uint64();
              break;
            case 5:
              m.negativeIntValue = r.int64();
              break;
            case 6:
              m.doubleValue = r.double();
              break;
            case 7:
              m.stringValue = r.bytes();
              break;
            case 8:
              m.aggregateValue = r.string();
              break;
            default:
              r.skipType(t & 7);
              break;
          }
        }
        return m;
      };

      UninterpretedOption.NamePart = (function () {
        /**
         * Properties of a NamePart.
         * @memberof google.protobuf.UninterpretedOption
         * @interface INamePart
         * @property {string} namePart NamePart namePart
         * @property {boolean} isExtension NamePart isExtension
         */

        /**
         * Constructs a new NamePart.
         * @memberof google.protobuf.UninterpretedOption
         * @classdesc Represents a NamePart.
         * @implements INamePart
         * @constructor
         * @param {google.protobuf.UninterpretedOption.INamePart=} [p] Properties to set
         */
        function NamePart(p) {
          if (p)
            for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
              if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
        }

        /**
         * NamePart namePart.
         * @member {string} namePart
         * @memberof google.protobuf.UninterpretedOption.NamePart
         * @instance
         */
        NamePart.prototype.namePart = "";

        /**
         * NamePart isExtension.
         * @member {boolean} isExtension
         * @memberof google.protobuf.UninterpretedOption.NamePart
         * @instance
         */
        NamePart.prototype.isExtension = false;

        /**
         * Creates a new NamePart instance using the specified properties.
         * @function create
         * @memberof google.protobuf.UninterpretedOption.NamePart
         * @static
         * @param {google.protobuf.UninterpretedOption.INamePart=} [properties] Properties to set
         * @returns {google.protobuf.UninterpretedOption.NamePart} NamePart instance
         */
        NamePart.create = function create(properties) {
          return new NamePart(properties);
        };

        /**
         * Encodes the specified NamePart message. Does not implicitly {@link google.protobuf.UninterpretedOption.NamePart.verify|verify} messages.
         * @function encode
         * @memberof google.protobuf.UninterpretedOption.NamePart
         * @static
         * @param {google.protobuf.UninterpretedOption.INamePart} m NamePart message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NamePart.encode = function encode(m, w) {
          if (!w) w = $Writer.create();
          w.uint32(10).string(m.namePart);
          w.uint32(16).bool(m.isExtension);
          return w;
        };

        /**
         * Decodes a NamePart message from the specified reader or buffer.
         * @function decode
         * @memberof google.protobuf.UninterpretedOption.NamePart
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {google.protobuf.UninterpretedOption.NamePart} NamePart
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NamePart.decode = function decode(r, l) {
          if (!(r instanceof $Reader)) r = $Reader.create(r);
          var c = l === undefined ? r.len : r.pos + l,
            m = new $root.google.protobuf.UninterpretedOption.NamePart();
          while (r.pos < c) {
            var t = r.uint32();
            switch (t >>> 3) {
              case 1:
                m.namePart = r.string();
                break;
              case 2:
                m.isExtension = r.bool();
                break;
              default:
                r.skipType(t & 7);
                break;
            }
          }
          if (!m.hasOwnProperty("namePart"))
            throw $util.ProtocolError("missing required 'namePart'", {
              instance: m,
            });
          if (!m.hasOwnProperty("isExtension"))
            throw $util.ProtocolError("missing required 'isExtension'", {
              instance: m,
            });
          return m;
        };

        return NamePart;
      })();

      return UninterpretedOption;
    })();

    protobuf.SourceCodeInfo = (function () {
      /**
       * Properties of a SourceCodeInfo.
       * @memberof google.protobuf
       * @interface ISourceCodeInfo
       * @property {Array.<google.protobuf.SourceCodeInfo.ILocation>|null} [location] SourceCodeInfo location
       */

      /**
       * Constructs a new SourceCodeInfo.
       * @memberof google.protobuf
       * @classdesc Represents a SourceCodeInfo.
       * @implements ISourceCodeInfo
       * @constructor
       * @param {google.protobuf.ISourceCodeInfo=} [p] Properties to set
       */
      function SourceCodeInfo(p) {
        this.location = [];
        if (p)
          for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
            if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
      }

      /**
       * SourceCodeInfo location.
       * @member {Array.<google.protobuf.SourceCodeInfo.ILocation>} location
       * @memberof google.protobuf.SourceCodeInfo
       * @instance
       */
      SourceCodeInfo.prototype.location = $util.emptyArray;

      /**
       * Creates a new SourceCodeInfo instance using the specified properties.
       * @function create
       * @memberof google.protobuf.SourceCodeInfo
       * @static
       * @param {google.protobuf.ISourceCodeInfo=} [properties] Properties to set
       * @returns {google.protobuf.SourceCodeInfo} SourceCodeInfo instance
       */
      SourceCodeInfo.create = function create(properties) {
        return new SourceCodeInfo(properties);
      };

      /**
       * Encodes the specified SourceCodeInfo message. Does not implicitly {@link google.protobuf.SourceCodeInfo.verify|verify} messages.
       * @function encode
       * @memberof google.protobuf.SourceCodeInfo
       * @static
       * @param {google.protobuf.ISourceCodeInfo} m SourceCodeInfo message or plain object to encode
       * @param {$protobuf.Writer} [w] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      SourceCodeInfo.encode = function encode(m, w) {
        if (!w) w = $Writer.create();
        if (m.location != null && m.location.length) {
          for (var i = 0; i < m.location.length; ++i)
            $root.google.protobuf.SourceCodeInfo.Location.encode(
              m.location[i],
              w.uint32(10).fork()
            ).ldelim();
        }
        return w;
      };

      /**
       * Decodes a SourceCodeInfo message from the specified reader or buffer.
       * @function decode
       * @memberof google.protobuf.SourceCodeInfo
       * @static
       * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
       * @param {number} [l] Message length if known beforehand
       * @returns {google.protobuf.SourceCodeInfo} SourceCodeInfo
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      SourceCodeInfo.decode = function decode(r, l) {
        if (!(r instanceof $Reader)) r = $Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l,
          m = new $root.google.protobuf.SourceCodeInfo();
        while (r.pos < c) {
          var t = r.uint32();
          switch (t >>> 3) {
            case 1:
              if (!(m.location && m.location.length)) m.location = [];
              m.location.push(
                $root.google.protobuf.SourceCodeInfo.Location.decode(
                  r,
                  r.uint32()
                )
              );
              break;
            default:
              r.skipType(t & 7);
              break;
          }
        }
        return m;
      };

      SourceCodeInfo.Location = (function () {
        /**
         * Properties of a Location.
         * @memberof google.protobuf.SourceCodeInfo
         * @interface ILocation
         * @property {Array.<number>|null} [path] Location path
         * @property {Array.<number>|null} [span] Location span
         * @property {string|null} [leadingComments] Location leadingComments
         * @property {string|null} [trailingComments] Location trailingComments
         * @property {Array.<string>|null} [leadingDetachedComments] Location leadingDetachedComments
         */

        /**
         * Constructs a new Location.
         * @memberof google.protobuf.SourceCodeInfo
         * @classdesc Represents a Location.
         * @implements ILocation
         * @constructor
         * @param {google.protobuf.SourceCodeInfo.ILocation=} [p] Properties to set
         */
        function Location(p) {
          this.path = [];
          this.span = [];
          this.leadingDetachedComments = [];
          if (p)
            for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
              if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
        }

        /**
         * Location path.
         * @member {Array.<number>} path
         * @memberof google.protobuf.SourceCodeInfo.Location
         * @instance
         */
        Location.prototype.path = $util.emptyArray;

        /**
         * Location span.
         * @member {Array.<number>} span
         * @memberof google.protobuf.SourceCodeInfo.Location
         * @instance
         */
        Location.prototype.span = $util.emptyArray;

        /**
         * Location leadingComments.
         * @member {string} leadingComments
         * @memberof google.protobuf.SourceCodeInfo.Location
         * @instance
         */
        Location.prototype.leadingComments = "";

        /**
         * Location trailingComments.
         * @member {string} trailingComments
         * @memberof google.protobuf.SourceCodeInfo.Location
         * @instance
         */
        Location.prototype.trailingComments = "";

        /**
         * Location leadingDetachedComments.
         * @member {Array.<string>} leadingDetachedComments
         * @memberof google.protobuf.SourceCodeInfo.Location
         * @instance
         */
        Location.prototype.leadingDetachedComments = $util.emptyArray;

        /**
         * Creates a new Location instance using the specified properties.
         * @function create
         * @memberof google.protobuf.SourceCodeInfo.Location
         * @static
         * @param {google.protobuf.SourceCodeInfo.ILocation=} [properties] Properties to set
         * @returns {google.protobuf.SourceCodeInfo.Location} Location instance
         */
        Location.create = function create(properties) {
          return new Location(properties);
        };

        /**
         * Encodes the specified Location message. Does not implicitly {@link google.protobuf.SourceCodeInfo.Location.verify|verify} messages.
         * @function encode
         * @memberof google.protobuf.SourceCodeInfo.Location
         * @static
         * @param {google.protobuf.SourceCodeInfo.ILocation} m Location message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Location.encode = function encode(m, w) {
          if (!w) w = $Writer.create();
          if (m.path != null && m.path.length) {
            w.uint32(10).fork();
            for (var i = 0; i < m.path.length; ++i) w.int32(m.path[i]);
            w.ldelim();
          }
          if (m.span != null && m.span.length) {
            w.uint32(18).fork();
            for (var i = 0; i < m.span.length; ++i) w.int32(m.span[i]);
            w.ldelim();
          }
          if (
            m.leadingComments != null &&
            Object.hasOwnProperty.call(m, "leadingComments")
          )
            w.uint32(26).string(m.leadingComments);
          if (
            m.trailingComments != null &&
            Object.hasOwnProperty.call(m, "trailingComments")
          )
            w.uint32(34).string(m.trailingComments);
          if (
            m.leadingDetachedComments != null &&
            m.leadingDetachedComments.length
          ) {
            for (var i = 0; i < m.leadingDetachedComments.length; ++i)
              w.uint32(50).string(m.leadingDetachedComments[i]);
          }
          return w;
        };

        /**
         * Decodes a Location message from the specified reader or buffer.
         * @function decode
         * @memberof google.protobuf.SourceCodeInfo.Location
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {google.protobuf.SourceCodeInfo.Location} Location
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Location.decode = function decode(r, l) {
          if (!(r instanceof $Reader)) r = $Reader.create(r);
          var c = l === undefined ? r.len : r.pos + l,
            m = new $root.google.protobuf.SourceCodeInfo.Location();
          while (r.pos < c) {
            var t = r.uint32();
            switch (t >>> 3) {
              case 1:
                if (!(m.path && m.path.length)) m.path = [];
                if ((t & 7) === 2) {
                  var c2 = r.uint32() + r.pos;
                  while (r.pos < c2) m.path.push(r.int32());
                } else m.path.push(r.int32());
                break;
              case 2:
                if (!(m.span && m.span.length)) m.span = [];
                if ((t & 7) === 2) {
                  var c2 = r.uint32() + r.pos;
                  while (r.pos < c2) m.span.push(r.int32());
                } else m.span.push(r.int32());
                break;
              case 3:
                m.leadingComments = r.string();
                break;
              case 4:
                m.trailingComments = r.string();
                break;
              case 6:
                if (
                  !(
                    m.leadingDetachedComments &&
                    m.leadingDetachedComments.length
                  )
                )
                  m.leadingDetachedComments = [];
                m.leadingDetachedComments.push(r.string());
                break;
              default:
                r.skipType(t & 7);
                break;
            }
          }
          return m;
        };

        return Location;
      })();

      return SourceCodeInfo;
    })();

    protobuf.GeneratedCodeInfo = (function () {
      /**
       * Properties of a GeneratedCodeInfo.
       * @memberof google.protobuf
       * @interface IGeneratedCodeInfo
       * @property {Array.<google.protobuf.GeneratedCodeInfo.IAnnotation>|null} [annotation] GeneratedCodeInfo annotation
       */

      /**
       * Constructs a new GeneratedCodeInfo.
       * @memberof google.protobuf
       * @classdesc Represents a GeneratedCodeInfo.
       * @implements IGeneratedCodeInfo
       * @constructor
       * @param {google.protobuf.IGeneratedCodeInfo=} [p] Properties to set
       */
      function GeneratedCodeInfo(p) {
        this.annotation = [];
        if (p)
          for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
            if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
      }

      /**
       * GeneratedCodeInfo annotation.
       * @member {Array.<google.protobuf.GeneratedCodeInfo.IAnnotation>} annotation
       * @memberof google.protobuf.GeneratedCodeInfo
       * @instance
       */
      GeneratedCodeInfo.prototype.annotation = $util.emptyArray;

      /**
       * Creates a new GeneratedCodeInfo instance using the specified properties.
       * @function create
       * @memberof google.protobuf.GeneratedCodeInfo
       * @static
       * @param {google.protobuf.IGeneratedCodeInfo=} [properties] Properties to set
       * @returns {google.protobuf.GeneratedCodeInfo} GeneratedCodeInfo instance
       */
      GeneratedCodeInfo.create = function create(properties) {
        return new GeneratedCodeInfo(properties);
      };

      /**
       * Encodes the specified GeneratedCodeInfo message. Does not implicitly {@link google.protobuf.GeneratedCodeInfo.verify|verify} messages.
       * @function encode
       * @memberof google.protobuf.GeneratedCodeInfo
       * @static
       * @param {google.protobuf.IGeneratedCodeInfo} m GeneratedCodeInfo message or plain object to encode
       * @param {$protobuf.Writer} [w] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      GeneratedCodeInfo.encode = function encode(m, w) {
        if (!w) w = $Writer.create();
        if (m.annotation != null && m.annotation.length) {
          for (var i = 0; i < m.annotation.length; ++i)
            $root.google.protobuf.GeneratedCodeInfo.Annotation.encode(
              m.annotation[i],
              w.uint32(10).fork()
            ).ldelim();
        }
        return w;
      };

      /**
       * Decodes a GeneratedCodeInfo message from the specified reader or buffer.
       * @function decode
       * @memberof google.protobuf.GeneratedCodeInfo
       * @static
       * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
       * @param {number} [l] Message length if known beforehand
       * @returns {google.protobuf.GeneratedCodeInfo} GeneratedCodeInfo
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      GeneratedCodeInfo.decode = function decode(r, l) {
        if (!(r instanceof $Reader)) r = $Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l,
          m = new $root.google.protobuf.GeneratedCodeInfo();
        while (r.pos < c) {
          var t = r.uint32();
          switch (t >>> 3) {
            case 1:
              if (!(m.annotation && m.annotation.length)) m.annotation = [];
              m.annotation.push(
                $root.google.protobuf.GeneratedCodeInfo.Annotation.decode(
                  r,
                  r.uint32()
                )
              );
              break;
            default:
              r.skipType(t & 7);
              break;
          }
        }
        return m;
      };

      GeneratedCodeInfo.Annotation = (function () {
        /**
         * Properties of an Annotation.
         * @memberof google.protobuf.GeneratedCodeInfo
         * @interface IAnnotation
         * @property {Array.<number>|null} [path] Annotation path
         * @property {string|null} [sourceFile] Annotation sourceFile
         * @property {number|null} [begin] Annotation begin
         * @property {number|null} [end] Annotation end
         */

        /**
         * Constructs a new Annotation.
         * @memberof google.protobuf.GeneratedCodeInfo
         * @classdesc Represents an Annotation.
         * @implements IAnnotation
         * @constructor
         * @param {google.protobuf.GeneratedCodeInfo.IAnnotation=} [p] Properties to set
         */
        function Annotation(p) {
          this.path = [];
          if (p)
            for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
              if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
        }

        /**
         * Annotation path.
         * @member {Array.<number>} path
         * @memberof google.protobuf.GeneratedCodeInfo.Annotation
         * @instance
         */
        Annotation.prototype.path = $util.emptyArray;

        /**
         * Annotation sourceFile.
         * @member {string} sourceFile
         * @memberof google.protobuf.GeneratedCodeInfo.Annotation
         * @instance
         */
        Annotation.prototype.sourceFile = "";

        /**
         * Annotation begin.
         * @member {number} begin
         * @memberof google.protobuf.GeneratedCodeInfo.Annotation
         * @instance
         */
        Annotation.prototype.begin = 0;

        /**
         * Annotation end.
         * @member {number} end
         * @memberof google.protobuf.GeneratedCodeInfo.Annotation
         * @instance
         */
        Annotation.prototype.end = 0;

        /**
         * Creates a new Annotation instance using the specified properties.
         * @function create
         * @memberof google.protobuf.GeneratedCodeInfo.Annotation
         * @static
         * @param {google.protobuf.GeneratedCodeInfo.IAnnotation=} [properties] Properties to set
         * @returns {google.protobuf.GeneratedCodeInfo.Annotation} Annotation instance
         */
        Annotation.create = function create(properties) {
          return new Annotation(properties);
        };

        /**
         * Encodes the specified Annotation message. Does not implicitly {@link google.protobuf.GeneratedCodeInfo.Annotation.verify|verify} messages.
         * @function encode
         * @memberof google.protobuf.GeneratedCodeInfo.Annotation
         * @static
         * @param {google.protobuf.GeneratedCodeInfo.IAnnotation} m Annotation message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Annotation.encode = function encode(m, w) {
          if (!w) w = $Writer.create();
          if (m.path != null && m.path.length) {
            w.uint32(10).fork();
            for (var i = 0; i < m.path.length; ++i) w.int32(m.path[i]);
            w.ldelim();
          }
          if (
            m.sourceFile != null &&
            Object.hasOwnProperty.call(m, "sourceFile")
          )
            w.uint32(18).string(m.sourceFile);
          if (m.begin != null && Object.hasOwnProperty.call(m, "begin"))
            w.uint32(24).int32(m.begin);
          if (m.end != null && Object.hasOwnProperty.call(m, "end"))
            w.uint32(32).int32(m.end);
          return w;
        };

        /**
         * Decodes an Annotation message from the specified reader or buffer.
         * @function decode
         * @memberof google.protobuf.GeneratedCodeInfo.Annotation
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {google.protobuf.GeneratedCodeInfo.Annotation} Annotation
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Annotation.decode = function decode(r, l) {
          if (!(r instanceof $Reader)) r = $Reader.create(r);
          var c = l === undefined ? r.len : r.pos + l,
            m = new $root.google.protobuf.GeneratedCodeInfo.Annotation();
          while (r.pos < c) {
            var t = r.uint32();
            switch (t >>> 3) {
              case 1:
                if (!(m.path && m.path.length)) m.path = [];
                if ((t & 7) === 2) {
                  var c2 = r.uint32() + r.pos;
                  while (r.pos < c2) m.path.push(r.int32());
                } else m.path.push(r.int32());
                break;
              case 2:
                m.sourceFile = r.string();
                break;
              case 3:
                m.begin = r.int32();
                break;
              case 4:
                m.end = r.int32();
                break;
              default:
                r.skipType(t & 7);
                break;
            }
          }
          return m;
        };

        return Annotation;
      })();

      return GeneratedCodeInfo;
    })();

    protobuf.Timestamp = (function () {
      /**
       * Properties of a Timestamp.
       * @memberof google.protobuf
       * @interface ITimestamp
       * @property {number|Long|null} [seconds] Timestamp seconds
       * @property {number|null} [nanos] Timestamp nanos
       */

      /**
       * Constructs a new Timestamp.
       * @memberof google.protobuf
       * @classdesc Represents a Timestamp.
       * @implements ITimestamp
       * @constructor
       * @param {google.protobuf.ITimestamp=} [p] Properties to set
       */
      function Timestamp(p) {
        if (p)
          for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
            if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
      }

      /**
       * Timestamp seconds.
       * @member {number|Long} seconds
       * @memberof google.protobuf.Timestamp
       * @instance
       */
      Timestamp.prototype.seconds = $util.Long
        ? $util.Long.fromBits(0, 0, false)
        : 0;

      /**
       * Timestamp nanos.
       * @member {number} nanos
       * @memberof google.protobuf.Timestamp
       * @instance
       */
      Timestamp.prototype.nanos = 0;

      /**
       * Creates a new Timestamp instance using the specified properties.
       * @function create
       * @memberof google.protobuf.Timestamp
       * @static
       * @param {google.protobuf.ITimestamp=} [properties] Properties to set
       * @returns {google.protobuf.Timestamp} Timestamp instance
       */
      Timestamp.create = function create(properties) {
        return new Timestamp(properties);
      };

      /**
       * Encodes the specified Timestamp message. Does not implicitly {@link google.protobuf.Timestamp.verify|verify} messages.
       * @function encode
       * @memberof google.protobuf.Timestamp
       * @static
       * @param {google.protobuf.ITimestamp} m Timestamp message or plain object to encode
       * @param {$protobuf.Writer} [w] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Timestamp.encode = function encode(m, w) {
        if (!w) w = $Writer.create();
        if (m.seconds != null && Object.hasOwnProperty.call(m, "seconds"))
          w.uint32(8).int64(m.seconds);
        if (m.nanos != null && Object.hasOwnProperty.call(m, "nanos"))
          w.uint32(16).int32(m.nanos);
        return w;
      };

      /**
       * Decodes a Timestamp message from the specified reader or buffer.
       * @function decode
       * @memberof google.protobuf.Timestamp
       * @static
       * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
       * @param {number} [l] Message length if known beforehand
       * @returns {google.protobuf.Timestamp} Timestamp
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Timestamp.decode = function decode(r, l) {
        if (!(r instanceof $Reader)) r = $Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l,
          m = new $root.google.protobuf.Timestamp();
        while (r.pos < c) {
          var t = r.uint32();
          switch (t >>> 3) {
            case 1:
              m.seconds = r.int64();
              break;
            case 2:
              m.nanos = r.int32();
              break;
            default:
              r.skipType(t & 7);
              break;
          }
        }
        return m;
      };

      return Timestamp;
    })();

    protobuf.Empty = (function () {
      /**
       * Properties of an Empty.
       * @memberof google.protobuf
       * @interface IEmpty
       */

      /**
       * Constructs a new Empty.
       * @memberof google.protobuf
       * @classdesc Represents an Empty.
       * @implements IEmpty
       * @constructor
       * @param {google.protobuf.IEmpty=} [p] Properties to set
       */
      function Empty(p) {
        if (p)
          for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
            if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
      }

      /**
       * Creates a new Empty instance using the specified properties.
       * @function create
       * @memberof google.protobuf.Empty
       * @static
       * @param {google.protobuf.IEmpty=} [properties] Properties to set
       * @returns {google.protobuf.Empty} Empty instance
       */
      Empty.create = function create(properties) {
        return new Empty(properties);
      };

      /**
       * Encodes the specified Empty message. Does not implicitly {@link google.protobuf.Empty.verify|verify} messages.
       * @function encode
       * @memberof google.protobuf.Empty
       * @static
       * @param {google.protobuf.IEmpty} m Empty message or plain object to encode
       * @param {$protobuf.Writer} [w] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Empty.encode = function encode(m, w) {
        if (!w) w = $Writer.create();
        return w;
      };

      /**
       * Decodes an Empty message from the specified reader or buffer.
       * @function decode
       * @memberof google.protobuf.Empty
       * @static
       * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
       * @param {number} [l] Message length if known beforehand
       * @returns {google.protobuf.Empty} Empty
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Empty.decode = function decode(r, l) {
        if (!(r instanceof $Reader)) r = $Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l,
          m = new $root.google.protobuf.Empty();
        while (r.pos < c) {
          var t = r.uint32();
          switch (t >>> 3) {
            default:
              r.skipType(t & 7);
              break;
          }
        }
        return m;
      };

      return Empty;
    })();

    return protobuf;
  })();

  return google;
})());

export { $root as default };
